
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire228e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire228e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hIGkg", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ce6760bdd1271d6c$export$ffb0004e005737fa; }, function (v) { return $ce6760bdd1271d6c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ce6760bdd1271d6c$export$34b9dba7ce09269b; }, function (v) { return $ce6760bdd1271d6c$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ce6760bdd1271d6c$export$25062201e9e25d76; }, function (v) { return $ce6760bdd1271d6c$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ce6760bdd1271d6c$export$ffb0004e005737fa;
var $ce6760bdd1271d6c$export$34b9dba7ce09269b;
var $ce6760bdd1271d6c$export$25062201e9e25d76;
"use strict";
var $ce6760bdd1271d6c$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ce6760bdd1271d6c$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $ce6760bdd1271d6c$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $ce6760bdd1271d6c$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$ce6760bdd1271d6c$export$ffb0004e005737fa = $ce6760bdd1271d6c$var$REACT_FRAGMENT_TYPE;
$ce6760bdd1271d6c$export$34b9dba7ce09269b = $ce6760bdd1271d6c$var$jsxProd;
$ce6760bdd1271d6c$export$25062201e9e25d76 = $ce6760bdd1271d6c$var$jsxProd;

});

parcelRegister("DDZit", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $0772a9597d10e7e2$export$dca3b0875bd9a954; }, function (v) { return $0772a9597d10e7e2$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0772a9597d10e7e2$export$16fa2f45be04daa8; }, function (v) { return $0772a9597d10e7e2$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0772a9597d10e7e2$export$ffb0004e005737fa; }, function (v) { return $0772a9597d10e7e2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $0772a9597d10e7e2$export$e2c29f18771995cb; }, function (v) { return $0772a9597d10e7e2$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0772a9597d10e7e2$export$221d75b3f55bb0bd; }, function (v) { return $0772a9597d10e7e2$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0772a9597d10e7e2$export$5f8d39834fd61797; }, function (v) { return $0772a9597d10e7e2$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0772a9597d10e7e2$export$74bf444e3cd11ea5; }, function (v) { return $0772a9597d10e7e2$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $0772a9597d10e7e2$export$1ced07cd6b1985ce; }, function (v) { return $0772a9597d10e7e2$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $0772a9597d10e7e2$export$abd8e32b826d7ea7; }, function (v) { return $0772a9597d10e7e2$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $0772a9597d10e7e2$export$69a3209f1a06c04d; }, function (v) { return $0772a9597d10e7e2$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0772a9597d10e7e2$export$e530037191fcd5d7; }, function (v) { return $0772a9597d10e7e2$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0772a9597d10e7e2$export$fd42f52fd3ae1109; }, function (v) { return $0772a9597d10e7e2$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0772a9597d10e7e2$export$c8a8987d4410bf2d; }, function (v) { return $0772a9597d10e7e2$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $0772a9597d10e7e2$export$7d1e3a5e95ceca43; }, function (v) { return $0772a9597d10e7e2$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0772a9597d10e7e2$export$257a8862b851cb5b; }, function (v) { return $0772a9597d10e7e2$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0772a9597d10e7e2$export$a8257692ac88316c; }, function (v) { return $0772a9597d10e7e2$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0772a9597d10e7e2$export$488013bae63b21da; }, function (v) { return $0772a9597d10e7e2$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0772a9597d10e7e2$export$7c73462e0d25e514; }, function (v) { return $0772a9597d10e7e2$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $0772a9597d10e7e2$export$7568632d0d33d16d; }, function (v) { return $0772a9597d10e7e2$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $0772a9597d10e7e2$export$f93f40ac0ca7e3a8; }, function (v) { return $0772a9597d10e7e2$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $0772a9597d10e7e2$export$1f96ae73734a86cc; }, function (v) { return $0772a9597d10e7e2$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $0772a9597d10e7e2$export$9a47ced3238df325; }, function (v) { return $0772a9597d10e7e2$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0772a9597d10e7e2$export$35808ee640e87ca7; }, function (v) { return $0772a9597d10e7e2$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0772a9597d10e7e2$export$fae74005e78b1a27; }, function (v) { return $0772a9597d10e7e2$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0772a9597d10e7e2$export$dc8fbce3eb94dc1e; }, function (v) { return $0772a9597d10e7e2$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $0772a9597d10e7e2$export$6a7bc4e911dc01cf; }, function (v) { return $0772a9597d10e7e2$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $0772a9597d10e7e2$export$6d9c69b0de29b591; }, function (v) { return $0772a9597d10e7e2$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $0772a9597d10e7e2$export$f680877a34711e37; }, function (v) { return $0772a9597d10e7e2$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0772a9597d10e7e2$export$d5a552a76deda3c2; }, function (v) { return $0772a9597d10e7e2$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $0772a9597d10e7e2$export$aaabe4eda9ed9969; }, function (v) { return $0772a9597d10e7e2$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0772a9597d10e7e2$export$e5c5a5f917a5871c; }, function (v) { return $0772a9597d10e7e2$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0772a9597d10e7e2$export$1538c33de8887b59; }, function (v) { return $0772a9597d10e7e2$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $0772a9597d10e7e2$export$fca7f784ae7a249a; }, function (v) { return $0772a9597d10e7e2$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $0772a9597d10e7e2$export$13e3392192263954; }, function (v) { return $0772a9597d10e7e2$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0772a9597d10e7e2$export$b8f5890fc79d6aca; }, function (v) { return $0772a9597d10e7e2$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0772a9597d10e7e2$export$60241385465d0a34; }, function (v) { return $0772a9597d10e7e2$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $0772a9597d10e7e2$export$306c0aa65ff9ec16; }, function (v) { return $0772a9597d10e7e2$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $0772a9597d10e7e2$export$7b286972b8d8ccbf; }, function (v) { return $0772a9597d10e7e2$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $0772a9597d10e7e2$export$83d89fbfd8236492; }, function (v) { return $0772a9597d10e7e2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0772a9597d10e7e2$export$dca3b0875bd9a954;
var $0772a9597d10e7e2$export$16fa2f45be04daa8;
var $0772a9597d10e7e2$export$ffb0004e005737fa;
var $0772a9597d10e7e2$export$e2c29f18771995cb;
var $0772a9597d10e7e2$export$221d75b3f55bb0bd;
var $0772a9597d10e7e2$export$5f8d39834fd61797;
var $0772a9597d10e7e2$export$74bf444e3cd11ea5;
var $0772a9597d10e7e2$export$1ced07cd6b1985ce;
var $0772a9597d10e7e2$export$abd8e32b826d7ea7;
var $0772a9597d10e7e2$export$69a3209f1a06c04d;
var $0772a9597d10e7e2$export$e530037191fcd5d7;
var $0772a9597d10e7e2$export$fd42f52fd3ae1109;
var $0772a9597d10e7e2$export$c8a8987d4410bf2d;
var $0772a9597d10e7e2$export$7d1e3a5e95ceca43;
var $0772a9597d10e7e2$export$257a8862b851cb5b;
var $0772a9597d10e7e2$export$a8257692ac88316c;
var $0772a9597d10e7e2$export$488013bae63b21da;
var $0772a9597d10e7e2$export$7c73462e0d25e514;
var $0772a9597d10e7e2$export$7568632d0d33d16d;
var $0772a9597d10e7e2$export$f93f40ac0ca7e3a8;
var $0772a9597d10e7e2$export$1f96ae73734a86cc;
var $0772a9597d10e7e2$export$9a47ced3238df325;
var $0772a9597d10e7e2$export$35808ee640e87ca7;
var $0772a9597d10e7e2$export$fae74005e78b1a27;
var $0772a9597d10e7e2$export$dc8fbce3eb94dc1e;
var $0772a9597d10e7e2$export$6a7bc4e911dc01cf;
var $0772a9597d10e7e2$export$6d9c69b0de29b591;
var $0772a9597d10e7e2$export$f680877a34711e37;
var $0772a9597d10e7e2$export$d5a552a76deda3c2;
var $0772a9597d10e7e2$export$aaabe4eda9ed9969;
var $0772a9597d10e7e2$export$e5c5a5f917a5871c;
var $0772a9597d10e7e2$export$1538c33de8887b59;
var $0772a9597d10e7e2$export$fca7f784ae7a249a;
var $0772a9597d10e7e2$export$13e3392192263954;
var $0772a9597d10e7e2$export$b8f5890fc79d6aca;
var $0772a9597d10e7e2$export$60241385465d0a34;
var $0772a9597d10e7e2$export$306c0aa65ff9ec16;
var $0772a9597d10e7e2$export$7b286972b8d8ccbf;
var $0772a9597d10e7e2$export$83d89fbfd8236492;
"use strict";
var $0772a9597d10e7e2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0772a9597d10e7e2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $0772a9597d10e7e2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $0772a9597d10e7e2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $0772a9597d10e7e2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $0772a9597d10e7e2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $0772a9597d10e7e2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $0772a9597d10e7e2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $0772a9597d10e7e2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $0772a9597d10e7e2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $0772a9597d10e7e2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $0772a9597d10e7e2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $0772a9597d10e7e2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $0772a9597d10e7e2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$0772a9597d10e7e2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $0772a9597d10e7e2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0772a9597d10e7e2$var$assign = Object.assign, $0772a9597d10e7e2$var$emptyObject = {};
function $0772a9597d10e7e2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $0772a9597d10e7e2$var$emptyObject;
    this.updater = updater || $0772a9597d10e7e2$var$ReactNoopUpdateQueue;
}
$0772a9597d10e7e2$var$Component.prototype.isReactComponent = {};
$0772a9597d10e7e2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$0772a9597d10e7e2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $0772a9597d10e7e2$var$ComponentDummy() {}
$0772a9597d10e7e2$var$ComponentDummy.prototype = $0772a9597d10e7e2$var$Component.prototype;
function $0772a9597d10e7e2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $0772a9597d10e7e2$var$emptyObject;
    this.updater = updater || $0772a9597d10e7e2$var$ReactNoopUpdateQueue;
}
var $0772a9597d10e7e2$var$pureComponentPrototype = $0772a9597d10e7e2$var$PureComponent.prototype = new $0772a9597d10e7e2$var$ComponentDummy();
$0772a9597d10e7e2$var$pureComponentPrototype.constructor = $0772a9597d10e7e2$var$PureComponent;
$0772a9597d10e7e2$var$assign($0772a9597d10e7e2$var$pureComponentPrototype, $0772a9597d10e7e2$var$Component.prototype);
$0772a9597d10e7e2$var$pureComponentPrototype.isPureReactComponent = !0;
var $0772a9597d10e7e2$var$isArrayImpl = Array.isArray, $0772a9597d10e7e2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $0772a9597d10e7e2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0772a9597d10e7e2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $0772a9597d10e7e2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $0772a9597d10e7e2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $0772a9597d10e7e2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $0772a9597d10e7e2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $0772a9597d10e7e2$var$REACT_ELEMENT_TYPE;
}
function $0772a9597d10e7e2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $0772a9597d10e7e2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $0772a9597d10e7e2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $0772a9597d10e7e2$var$escape("" + element.key) : index.toString(36);
}
function $0772a9597d10e7e2$var$noop$1() {}
function $0772a9597d10e7e2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($0772a9597d10e7e2$var$noop$1, $0772a9597d10e7e2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $0772a9597d10e7e2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $0772a9597d10e7e2$var$REACT_ELEMENT_TYPE:
                case $0772a9597d10e7e2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $0772a9597d10e7e2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $0772a9597d10e7e2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $0772a9597d10e7e2$var$getElementKey(children, 0) : nameSoFar, $0772a9597d10e7e2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($0772a9597d10e7e2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $0772a9597d10e7e2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($0772a9597d10e7e2$var$isValidElement(callback) && (callback = $0772a9597d10e7e2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($0772a9597d10e7e2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($0772a9597d10e7e2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $0772a9597d10e7e2$var$getElementKey(nameSoFar, i), invokeCallback += $0772a9597d10e7e2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $0772a9597d10e7e2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $0772a9597d10e7e2$var$getElementKey(nameSoFar, i++), invokeCallback += $0772a9597d10e7e2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $0772a9597d10e7e2$var$mapIntoArray($0772a9597d10e7e2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $0772a9597d10e7e2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $0772a9597d10e7e2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $0772a9597d10e7e2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $0772a9597d10e7e2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $0772a9597d10e7e2$var$noop() {}
$0772a9597d10e7e2$export$dca3b0875bd9a954 = {
    map: $0772a9597d10e7e2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $0772a9597d10e7e2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $0772a9597d10e7e2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $0772a9597d10e7e2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$0772a9597d10e7e2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$0772a9597d10e7e2$export$16fa2f45be04daa8 = $0772a9597d10e7e2$var$Component;
$0772a9597d10e7e2$export$ffb0004e005737fa = $0772a9597d10e7e2$var$REACT_FRAGMENT_TYPE;
$0772a9597d10e7e2$export$e2c29f18771995cb = $0772a9597d10e7e2$var$REACT_PROFILER_TYPE;
$0772a9597d10e7e2$export$221d75b3f55bb0bd = $0772a9597d10e7e2$var$PureComponent;
$0772a9597d10e7e2$export$5f8d39834fd61797 = $0772a9597d10e7e2$var$REACT_STRICT_MODE_TYPE;
$0772a9597d10e7e2$export$74bf444e3cd11ea5 = $0772a9597d10e7e2$var$REACT_SUSPENSE_TYPE;
$0772a9597d10e7e2$export$1ced07cd6b1985ce = $0772a9597d10e7e2$var$ReactSharedInternals;
$0772a9597d10e7e2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $0772a9597d10e7e2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$0772a9597d10e7e2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$0772a9597d10e7e2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $0772a9597d10e7e2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$0772a9597d10e7e2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $0772a9597d10e7e2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$0772a9597d10e7e2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $0772a9597d10e7e2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $0772a9597d10e7e2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$0772a9597d10e7e2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$0772a9597d10e7e2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $0772a9597d10e7e2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$0772a9597d10e7e2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0772a9597d10e7e2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $0772a9597d10e7e2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$0772a9597d10e7e2$export$a8257692ac88316c = $0772a9597d10e7e2$var$isValidElement;
$0772a9597d10e7e2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $0772a9597d10e7e2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $0772a9597d10e7e2$var$lazyInitializer
    };
};
$0772a9597d10e7e2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $0772a9597d10e7e2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$0772a9597d10e7e2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $0772a9597d10e7e2$var$ReactSharedInternals.T, currentTransition = {};
    $0772a9597d10e7e2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $0772a9597d10e7e2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($0772a9597d10e7e2$var$noop, $0772a9597d10e7e2$var$reportGlobalError);
    } catch (error) {
        $0772a9597d10e7e2$var$reportGlobalError(error);
    } finally{
        $0772a9597d10e7e2$var$ReactSharedInternals.T = prevTransition;
    }
};
$0772a9597d10e7e2$export$f93f40ac0ca7e3a8 = function() {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useCacheRefresh();
};
$0772a9597d10e7e2$export$1f96ae73734a86cc = function(usable) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.use(usable);
};
$0772a9597d10e7e2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$0772a9597d10e7e2$export$35808ee640e87ca7 = function(callback, deps) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$0772a9597d10e7e2$export$fae74005e78b1a27 = function(Context) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useContext(Context);
};
$0772a9597d10e7e2$export$dc8fbce3eb94dc1e = function() {};
$0772a9597d10e7e2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$0772a9597d10e7e2$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $0772a9597d10e7e2$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$0772a9597d10e7e2$export$f680877a34711e37 = function() {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useId();
};
$0772a9597d10e7e2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$0772a9597d10e7e2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$0772a9597d10e7e2$export$e5c5a5f917a5871c = function(create, deps) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$0772a9597d10e7e2$export$1538c33de8887b59 = function(create, deps) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$0772a9597d10e7e2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$0772a9597d10e7e2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$0772a9597d10e7e2$export$b8f5890fc79d6aca = function(initialValue) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useRef(initialValue);
};
$0772a9597d10e7e2$export$60241385465d0a34 = function(initialState) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useState(initialState);
};
$0772a9597d10e7e2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$0772a9597d10e7e2$export$7b286972b8d8ccbf = function() {
    return $0772a9597d10e7e2$var$ReactSharedInternals.H.useTransition();
};
$0772a9597d10e7e2$export$83d89fbfd8236492 = "19.1.1";

});

parcelRegister("aVay2", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $7f3768da1ed50fcb$export$882461b6382ed46c; }, function (v) { return $7f3768da1ed50fcb$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $7f3768da1ed50fcb$export$757ceba2d55c277e; }, function (v) { return $7f3768da1ed50fcb$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $7f3768da1ed50fcb$export$83d89fbfd8236492; }, function (v) { return $7f3768da1ed50fcb$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $7f3768da1ed50fcb$export$882461b6382ed46c;
var $7f3768da1ed50fcb$export$757ceba2d55c277e;
var $7f3768da1ed50fcb$export$83d89fbfd8236492;
"use strict";

var $2ixDp = parcelRequire("2ixDp");

var $h96tf = parcelRequire("h96tf");

var $70Ozn = parcelRequire("70Ozn");
function $7f3768da1ed50fcb$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $7f3768da1ed50fcb$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $7f3768da1ed50fcb$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $7f3768da1ed50fcb$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $7f3768da1ed50fcb$var$assertIsMounted(fiber) {
    if ($7f3768da1ed50fcb$var$getNearestMountedFiber(fiber) !== fiber) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(188));
}
function $7f3768da1ed50fcb$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $7f3768da1ed50fcb$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $7f3768da1ed50fcb$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $7f3768da1ed50fcb$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $7f3768da1ed50fcb$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $7f3768da1ed50fcb$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $7f3768da1ed50fcb$var$assign = Object.assign, $7f3768da1ed50fcb$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $7f3768da1ed50fcb$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $7f3768da1ed50fcb$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $7f3768da1ed50fcb$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $7f3768da1ed50fcb$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $7f3768da1ed50fcb$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $7f3768da1ed50fcb$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $7f3768da1ed50fcb$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $7f3768da1ed50fcb$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $7f3768da1ed50fcb$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $7f3768da1ed50fcb$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $7f3768da1ed50fcb$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $7f3768da1ed50fcb$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $7f3768da1ed50fcb$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $7f3768da1ed50fcb$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $7f3768da1ed50fcb$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $7f3768da1ed50fcb$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $7f3768da1ed50fcb$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $7f3768da1ed50fcb$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$7f3768da1ed50fcb$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $7f3768da1ed50fcb$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $7f3768da1ed50fcb$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $7f3768da1ed50fcb$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $7f3768da1ed50fcb$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $7f3768da1ed50fcb$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $7f3768da1ed50fcb$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $7f3768da1ed50fcb$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $7f3768da1ed50fcb$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $7f3768da1ed50fcb$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $7f3768da1ed50fcb$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $7f3768da1ed50fcb$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $7f3768da1ed50fcb$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $7f3768da1ed50fcb$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $7f3768da1ed50fcb$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $7f3768da1ed50fcb$var$getComponentNameFromType(type.type) || "Memo";
        case $7f3768da1ed50fcb$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $7f3768da1ed50fcb$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $7f3768da1ed50fcb$var$isArrayImpl = Array.isArray, $7f3768da1ed50fcb$var$ReactSharedInternals = $h96tf.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $7f3768da1ed50fcb$var$ReactDOMSharedInternals = $70Ozn.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $7f3768da1ed50fcb$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $7f3768da1ed50fcb$var$valueStack = [], $7f3768da1ed50fcb$var$index = -1;
function $7f3768da1ed50fcb$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $7f3768da1ed50fcb$var$pop(cursor) {
    0 > $7f3768da1ed50fcb$var$index || (cursor.current = $7f3768da1ed50fcb$var$valueStack[$7f3768da1ed50fcb$var$index], $7f3768da1ed50fcb$var$valueStack[$7f3768da1ed50fcb$var$index] = null, $7f3768da1ed50fcb$var$index--);
}
function $7f3768da1ed50fcb$var$push(cursor, value) {
    $7f3768da1ed50fcb$var$index++;
    $7f3768da1ed50fcb$var$valueStack[$7f3768da1ed50fcb$var$index] = cursor.current;
    cursor.current = value;
}
var $7f3768da1ed50fcb$var$contextStackCursor = $7f3768da1ed50fcb$var$createCursor(null), $7f3768da1ed50fcb$var$contextFiberStackCursor = $7f3768da1ed50fcb$var$createCursor(null), $7f3768da1ed50fcb$var$rootInstanceStackCursor = $7f3768da1ed50fcb$var$createCursor(null), $7f3768da1ed50fcb$var$hostTransitionProviderCursor = $7f3768da1ed50fcb$var$createCursor(null);
function $7f3768da1ed50fcb$var$pushHostContainer(fiber, nextRootInstance) {
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$rootInstanceStackCursor, nextRootInstance);
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$contextFiberStackCursor, fiber);
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $7f3768da1ed50fcb$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $7f3768da1ed50fcb$var$getOwnHostContext(nextRootInstance), fiber = $7f3768da1ed50fcb$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$contextStackCursor);
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$contextStackCursor, fiber);
}
function $7f3768da1ed50fcb$var$popHostContainer() {
    $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$contextStackCursor);
    $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$contextFiberStackCursor);
    $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$rootInstanceStackCursor);
}
function $7f3768da1ed50fcb$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$hostTransitionProviderCursor, fiber);
    var context = $7f3768da1ed50fcb$var$contextStackCursor.current;
    var JSCompiler_inline_result = $7f3768da1ed50fcb$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$contextFiberStackCursor, fiber), $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$contextStackCursor, JSCompiler_inline_result));
}
function $7f3768da1ed50fcb$var$popHostContext(fiber) {
    $7f3768da1ed50fcb$var$contextFiberStackCursor.current === fiber && ($7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$contextStackCursor), $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$contextFiberStackCursor));
    $7f3768da1ed50fcb$var$hostTransitionProviderCursor.current === fiber && ($7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$hostTransitionProviderCursor), $7f3768da1ed50fcb$var$HostTransitionContext._currentValue = $7f3768da1ed50fcb$var$sharedNotPendingObject);
}
var $7f3768da1ed50fcb$var$hasOwnProperty = Object.prototype.hasOwnProperty, $7f3768da1ed50fcb$var$scheduleCallback$3 = $2ixDp.unstable_scheduleCallback, $7f3768da1ed50fcb$var$cancelCallback$1 = $2ixDp.unstable_cancelCallback, $7f3768da1ed50fcb$var$shouldYield = $2ixDp.unstable_shouldYield, $7f3768da1ed50fcb$var$requestPaint = $2ixDp.unstable_requestPaint, $7f3768da1ed50fcb$var$now = $2ixDp.unstable_now, $7f3768da1ed50fcb$var$getCurrentPriorityLevel = $2ixDp.unstable_getCurrentPriorityLevel, $7f3768da1ed50fcb$var$ImmediatePriority = $2ixDp.unstable_ImmediatePriority, $7f3768da1ed50fcb$var$UserBlockingPriority = $2ixDp.unstable_UserBlockingPriority, $7f3768da1ed50fcb$var$NormalPriority$1 = $2ixDp.unstable_NormalPriority, $7f3768da1ed50fcb$var$LowPriority = $2ixDp.unstable_LowPriority, $7f3768da1ed50fcb$var$IdlePriority = $2ixDp.unstable_IdlePriority, $7f3768da1ed50fcb$var$log$1 = $2ixDp.log, $7f3768da1ed50fcb$var$unstable_setDisableYieldValue = $2ixDp.unstable_setDisableYieldValue, $7f3768da1ed50fcb$var$rendererID = null, $7f3768da1ed50fcb$var$injectedHook = null;
function $7f3768da1ed50fcb$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $7f3768da1ed50fcb$var$log$1 && $7f3768da1ed50fcb$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($7f3768da1ed50fcb$var$injectedHook && "function" === typeof $7f3768da1ed50fcb$var$injectedHook.setStrictMode) try {
        $7f3768da1ed50fcb$var$injectedHook.setStrictMode($7f3768da1ed50fcb$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $7f3768da1ed50fcb$var$clz32 = Math.clz32 ? Math.clz32 : $7f3768da1ed50fcb$var$clz32Fallback, $7f3768da1ed50fcb$var$log = Math.log, $7f3768da1ed50fcb$var$LN2 = Math.LN2;
function $7f3768da1ed50fcb$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($7f3768da1ed50fcb$var$log(x) / $7f3768da1ed50fcb$var$LN2 | 0) | 0;
}
var $7f3768da1ed50fcb$var$nextTransitionLane = 256, $7f3768da1ed50fcb$var$nextRetryLane = 4194304;
function $7f3768da1ed50fcb$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $7f3768da1ed50fcb$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $7f3768da1ed50fcb$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $7f3768da1ed50fcb$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $7f3768da1ed50fcb$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $7f3768da1ed50fcb$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $7f3768da1ed50fcb$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $7f3768da1ed50fcb$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $7f3768da1ed50fcb$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $7f3768da1ed50fcb$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $7f3768da1ed50fcb$var$claimNextTransitionLane() {
    var lane = $7f3768da1ed50fcb$var$nextTransitionLane;
    $7f3768da1ed50fcb$var$nextTransitionLane <<= 1;
    0 === ($7f3768da1ed50fcb$var$nextTransitionLane & 4194048) && ($7f3768da1ed50fcb$var$nextTransitionLane = 256);
    return lane;
}
function $7f3768da1ed50fcb$var$claimNextRetryLane() {
    var lane = $7f3768da1ed50fcb$var$nextRetryLane;
    $7f3768da1ed50fcb$var$nextRetryLane <<= 1;
    0 === ($7f3768da1ed50fcb$var$nextRetryLane & 62914560) && ($7f3768da1ed50fcb$var$nextRetryLane = 4194304);
    return lane;
}
function $7f3768da1ed50fcb$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $7f3768da1ed50fcb$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $7f3768da1ed50fcb$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $7f3768da1ed50fcb$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $7f3768da1ed50fcb$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $7f3768da1ed50fcb$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $7f3768da1ed50fcb$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $7f3768da1ed50fcb$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $7f3768da1ed50fcb$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $7f3768da1ed50fcb$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $7f3768da1ed50fcb$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $7f3768da1ed50fcb$var$resolveUpdatePriority() {
    var updatePriority = $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $7f3768da1ed50fcb$var$getEventPriority(updatePriority.type);
}
function $7f3768da1ed50fcb$var$runWithPriority(priority, fn) {
    var previousPriority = $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p;
    try {
        return $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $7f3768da1ed50fcb$var$randomKey = Math.random().toString(36).slice(2), $7f3768da1ed50fcb$var$internalInstanceKey = "__reactFiber$" + $7f3768da1ed50fcb$var$randomKey, $7f3768da1ed50fcb$var$internalPropsKey = "__reactProps$" + $7f3768da1ed50fcb$var$randomKey, $7f3768da1ed50fcb$var$internalContainerInstanceKey = "__reactContainer$" + $7f3768da1ed50fcb$var$randomKey, $7f3768da1ed50fcb$var$internalEventHandlersKey = "__reactEvents$" + $7f3768da1ed50fcb$var$randomKey, $7f3768da1ed50fcb$var$internalEventHandlerListenersKey = "__reactListeners$" + $7f3768da1ed50fcb$var$randomKey, $7f3768da1ed50fcb$var$internalEventHandlesSetKey = "__reactHandles$" + $7f3768da1ed50fcb$var$randomKey, $7f3768da1ed50fcb$var$internalRootNodeResourcesKey = "__reactResources$" + $7f3768da1ed50fcb$var$randomKey, $7f3768da1ed50fcb$var$internalHoistableMarker = "__reactMarker$" + $7f3768da1ed50fcb$var$randomKey;
function $7f3768da1ed50fcb$var$detachDeletedInstance(node) {
    delete node[$7f3768da1ed50fcb$var$internalInstanceKey];
    delete node[$7f3768da1ed50fcb$var$internalPropsKey];
    delete node[$7f3768da1ed50fcb$var$internalEventHandlersKey];
    delete node[$7f3768da1ed50fcb$var$internalEventHandlerListenersKey];
    delete node[$7f3768da1ed50fcb$var$internalEventHandlesSetKey];
}
function $7f3768da1ed50fcb$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$7f3768da1ed50fcb$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$7f3768da1ed50fcb$var$internalContainerInstanceKey] || parentNode[$7f3768da1ed50fcb$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $7f3768da1ed50fcb$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$7f3768da1ed50fcb$var$internalInstanceKey]) return parentNode;
                targetNode = $7f3768da1ed50fcb$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $7f3768da1ed50fcb$var$getInstanceFromNode(node) {
    if (node = node[$7f3768da1ed50fcb$var$internalInstanceKey] || node[$7f3768da1ed50fcb$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $7f3768da1ed50fcb$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(33));
}
function $7f3768da1ed50fcb$var$getResourcesFromRoot(root) {
    var resources = root[$7f3768da1ed50fcb$var$internalRootNodeResourcesKey];
    resources || (resources = root[$7f3768da1ed50fcb$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $7f3768da1ed50fcb$var$markNodeAsHoistable(node) {
    node[$7f3768da1ed50fcb$var$internalHoistableMarker] = !0;
}
var $7f3768da1ed50fcb$var$allNativeEvents = new Set(), $7f3768da1ed50fcb$var$registrationNameDependencies = {};
function $7f3768da1ed50fcb$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $7f3768da1ed50fcb$var$registerDirectEvent(registrationName, dependencies);
    $7f3768da1ed50fcb$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $7f3768da1ed50fcb$var$registerDirectEvent(registrationName, dependencies) {
    $7f3768da1ed50fcb$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$7f3768da1ed50fcb$var$allNativeEvents.add(dependencies[registrationName]);
}
var $7f3768da1ed50fcb$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $7f3768da1ed50fcb$var$illegalAttributeNameCache = {}, $7f3768da1ed50fcb$var$validatedAttributeNameCache = {};
function $7f3768da1ed50fcb$var$isAttributeNameSafe(attributeName) {
    if ($7f3768da1ed50fcb$var$hasOwnProperty.call($7f3768da1ed50fcb$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($7f3768da1ed50fcb$var$hasOwnProperty.call($7f3768da1ed50fcb$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($7f3768da1ed50fcb$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $7f3768da1ed50fcb$var$validatedAttributeNameCache[attributeName] = !0;
    $7f3768da1ed50fcb$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $7f3768da1ed50fcb$var$setValueForAttribute(node, name, value) {
    if ($7f3768da1ed50fcb$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $7f3768da1ed50fcb$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $7f3768da1ed50fcb$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $7f3768da1ed50fcb$var$prefix, $7f3768da1ed50fcb$var$suffix;
function $7f3768da1ed50fcb$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $7f3768da1ed50fcb$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $7f3768da1ed50fcb$var$prefix = match && match[1] || "";
        $7f3768da1ed50fcb$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $7f3768da1ed50fcb$var$prefix + name + $7f3768da1ed50fcb$var$suffix;
}
var $7f3768da1ed50fcb$var$reentry = !1;
function $7f3768da1ed50fcb$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $7f3768da1ed50fcb$var$reentry) return "";
    $7f3768da1ed50fcb$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $7f3768da1ed50fcb$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $7f3768da1ed50fcb$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $7f3768da1ed50fcb$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $7f3768da1ed50fcb$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $7f3768da1ed50fcb$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $7f3768da1ed50fcb$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $7f3768da1ed50fcb$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $7f3768da1ed50fcb$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $7f3768da1ed50fcb$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $7f3768da1ed50fcb$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $7f3768da1ed50fcb$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $7f3768da1ed50fcb$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $7f3768da1ed50fcb$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $7f3768da1ed50fcb$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $7f3768da1ed50fcb$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $7f3768da1ed50fcb$var$trackValueOnNode(node) {
    var valueField = $7f3768da1ed50fcb$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $7f3768da1ed50fcb$var$track(node) {
    node._valueTracker || (node._valueTracker = $7f3768da1ed50fcb$var$trackValueOnNode(node));
}
function $7f3768da1ed50fcb$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $7f3768da1ed50fcb$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $7f3768da1ed50fcb$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $7f3768da1ed50fcb$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $7f3768da1ed50fcb$var$getToStringValue(value);
        } else element.value !== "" + $7f3768da1ed50fcb$var$getToStringValue(value) && (element.value = "" + $7f3768da1ed50fcb$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $7f3768da1ed50fcb$var$setDefaultValue(element, type, $7f3768da1ed50fcb$var$getToStringValue(value)) : null != defaultValue ? $7f3768da1ed50fcb$var$setDefaultValue(element, type, $7f3768da1ed50fcb$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $7f3768da1ed50fcb$var$getToStringValue(name) : element.removeAttribute("name");
}
function $7f3768da1ed50fcb$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $7f3768da1ed50fcb$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $7f3768da1ed50fcb$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $7f3768da1ed50fcb$var$setDefaultValue(node, type, value) {
    "number" === type && $7f3768da1ed50fcb$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $7f3768da1ed50fcb$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $7f3768da1ed50fcb$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $7f3768da1ed50fcb$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $7f3768da1ed50fcb$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $7f3768da1ed50fcb$var$getToStringValue(defaultValue) : "";
}
function $7f3768da1ed50fcb$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(92));
            if ($7f3768da1ed50fcb$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $7f3768da1ed50fcb$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $7f3768da1ed50fcb$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $7f3768da1ed50fcb$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $7f3768da1ed50fcb$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $7f3768da1ed50fcb$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $7f3768da1ed50fcb$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $7f3768da1ed50fcb$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $7f3768da1ed50fcb$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $7f3768da1ed50fcb$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $7f3768da1ed50fcb$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $7f3768da1ed50fcb$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $7f3768da1ed50fcb$var$sanitizeURL(url) {
    return $7f3768da1ed50fcb$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $7f3768da1ed50fcb$var$currentReplayingEvent = null;
function $7f3768da1ed50fcb$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $7f3768da1ed50fcb$var$restoreTarget = null, $7f3768da1ed50fcb$var$restoreQueue = null;
function $7f3768da1ed50fcb$var$restoreStateOfTarget(target) {
    var internalInstance = $7f3768da1ed50fcb$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$7f3768da1ed50fcb$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $7f3768da1ed50fcb$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$7f3768da1ed50fcb$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(90));
                            $7f3768da1ed50fcb$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $7f3768da1ed50fcb$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $7f3768da1ed50fcb$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $7f3768da1ed50fcb$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $7f3768da1ed50fcb$var$isInsideEventHandler = !1;
function $7f3768da1ed50fcb$var$batchedUpdates$1(fn, a, b) {
    if ($7f3768da1ed50fcb$var$isInsideEventHandler) return fn(a, b);
    $7f3768da1ed50fcb$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($7f3768da1ed50fcb$var$isInsideEventHandler = !1, null !== $7f3768da1ed50fcb$var$restoreTarget || null !== $7f3768da1ed50fcb$var$restoreQueue) {
            if ($7f3768da1ed50fcb$var$flushSyncWork$1(), $7f3768da1ed50fcb$var$restoreTarget && (a = $7f3768da1ed50fcb$var$restoreTarget, fn = $7f3768da1ed50fcb$var$restoreQueue, $7f3768da1ed50fcb$var$restoreQueue = $7f3768da1ed50fcb$var$restoreTarget = null, $7f3768da1ed50fcb$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$7f3768da1ed50fcb$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $7f3768da1ed50fcb$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$7f3768da1ed50fcb$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $7f3768da1ed50fcb$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $7f3768da1ed50fcb$var$passiveBrowserEventsSupported = !1;
if ($7f3768da1ed50fcb$var$canUseDOM) try {
    var $7f3768da1ed50fcb$var$options = {};
    Object.defineProperty($7f3768da1ed50fcb$var$options, "passive", {
        get: function() {
            $7f3768da1ed50fcb$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $7f3768da1ed50fcb$var$options, $7f3768da1ed50fcb$var$options);
    window.removeEventListener("test", $7f3768da1ed50fcb$var$options, $7f3768da1ed50fcb$var$options);
} catch (e) {
    $7f3768da1ed50fcb$var$passiveBrowserEventsSupported = !1;
}
var $7f3768da1ed50fcb$var$root = null, $7f3768da1ed50fcb$var$startText = null, $7f3768da1ed50fcb$var$fallbackText = null;
function $7f3768da1ed50fcb$var$getData() {
    if ($7f3768da1ed50fcb$var$fallbackText) return $7f3768da1ed50fcb$var$fallbackText;
    var start, startValue = $7f3768da1ed50fcb$var$startText, startLength = startValue.length, end, endValue = "value" in $7f3768da1ed50fcb$var$root ? $7f3768da1ed50fcb$var$root.value : $7f3768da1ed50fcb$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $7f3768da1ed50fcb$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $7f3768da1ed50fcb$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $7f3768da1ed50fcb$var$functionThatReturnsTrue() {
    return !0;
}
function $7f3768da1ed50fcb$var$functionThatReturnsFalse() {
    return !1;
}
function $7f3768da1ed50fcb$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $7f3768da1ed50fcb$var$functionThatReturnsTrue : $7f3768da1ed50fcb$var$functionThatReturnsFalse;
        this.isPropagationStopped = $7f3768da1ed50fcb$var$functionThatReturnsFalse;
        return this;
    }
    $7f3768da1ed50fcb$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $7f3768da1ed50fcb$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $7f3768da1ed50fcb$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $7f3768da1ed50fcb$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $7f3768da1ed50fcb$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $7f3768da1ed50fcb$var$SyntheticEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$EventInterface), $7f3768da1ed50fcb$var$UIEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$EventInterface, {
    view: 0,
    detail: 0
}), $7f3768da1ed50fcb$var$SyntheticUIEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$UIEventInterface), $7f3768da1ed50fcb$var$lastMovementX, $7f3768da1ed50fcb$var$lastMovementY, $7f3768da1ed50fcb$var$lastMouseEvent, $7f3768da1ed50fcb$var$MouseEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $7f3768da1ed50fcb$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $7f3768da1ed50fcb$var$lastMouseEvent && ($7f3768da1ed50fcb$var$lastMouseEvent && "mousemove" === event.type ? ($7f3768da1ed50fcb$var$lastMovementX = event.screenX - $7f3768da1ed50fcb$var$lastMouseEvent.screenX, $7f3768da1ed50fcb$var$lastMovementY = event.screenY - $7f3768da1ed50fcb$var$lastMouseEvent.screenY) : $7f3768da1ed50fcb$var$lastMovementY = $7f3768da1ed50fcb$var$lastMovementX = 0, $7f3768da1ed50fcb$var$lastMouseEvent = event);
        return $7f3768da1ed50fcb$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $7f3768da1ed50fcb$var$lastMovementY;
    }
}), $7f3768da1ed50fcb$var$SyntheticMouseEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$MouseEventInterface), $7f3768da1ed50fcb$var$DragEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$MouseEventInterface, {
    dataTransfer: 0
}), $7f3768da1ed50fcb$var$SyntheticDragEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$DragEventInterface), $7f3768da1ed50fcb$var$FocusEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$UIEventInterface, {
    relatedTarget: 0
}), $7f3768da1ed50fcb$var$SyntheticFocusEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$FocusEventInterface), $7f3768da1ed50fcb$var$AnimationEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $7f3768da1ed50fcb$var$SyntheticAnimationEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$AnimationEventInterface), $7f3768da1ed50fcb$var$ClipboardEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $7f3768da1ed50fcb$var$SyntheticClipboardEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$ClipboardEventInterface), $7f3768da1ed50fcb$var$CompositionEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$EventInterface, {
    data: 0
}), $7f3768da1ed50fcb$var$SyntheticCompositionEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$CompositionEventInterface), $7f3768da1ed50fcb$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $7f3768da1ed50fcb$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $7f3768da1ed50fcb$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $7f3768da1ed50fcb$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $7f3768da1ed50fcb$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $7f3768da1ed50fcb$var$getEventModifierState() {
    return $7f3768da1ed50fcb$var$modifierStateGetter;
}
var $7f3768da1ed50fcb$var$KeyboardEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $7f3768da1ed50fcb$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $7f3768da1ed50fcb$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $7f3768da1ed50fcb$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $7f3768da1ed50fcb$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $7f3768da1ed50fcb$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $7f3768da1ed50fcb$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $7f3768da1ed50fcb$var$SyntheticKeyboardEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$KeyboardEventInterface), $7f3768da1ed50fcb$var$PointerEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $7f3768da1ed50fcb$var$SyntheticPointerEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$PointerEventInterface), $7f3768da1ed50fcb$var$TouchEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $7f3768da1ed50fcb$var$getEventModifierState
}), $7f3768da1ed50fcb$var$SyntheticTouchEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$TouchEventInterface), $7f3768da1ed50fcb$var$TransitionEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $7f3768da1ed50fcb$var$SyntheticTransitionEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$TransitionEventInterface), $7f3768da1ed50fcb$var$WheelEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $7f3768da1ed50fcb$var$SyntheticWheelEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$WheelEventInterface), $7f3768da1ed50fcb$var$ToggleEventInterface = $7f3768da1ed50fcb$var$assign({}, $7f3768da1ed50fcb$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $7f3768da1ed50fcb$var$SyntheticToggleEvent = $7f3768da1ed50fcb$var$createSyntheticEvent($7f3768da1ed50fcb$var$ToggleEventInterface), $7f3768da1ed50fcb$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $7f3768da1ed50fcb$var$canUseCompositionEvent = $7f3768da1ed50fcb$var$canUseDOM && "CompositionEvent" in window, $7f3768da1ed50fcb$var$documentMode = null;
$7f3768da1ed50fcb$var$canUseDOM && "documentMode" in document && ($7f3768da1ed50fcb$var$documentMode = document.documentMode);
var $7f3768da1ed50fcb$var$canUseTextInputEvent = $7f3768da1ed50fcb$var$canUseDOM && "TextEvent" in window && !$7f3768da1ed50fcb$var$documentMode, $7f3768da1ed50fcb$var$useFallbackCompositionData = $7f3768da1ed50fcb$var$canUseDOM && (!$7f3768da1ed50fcb$var$canUseCompositionEvent || $7f3768da1ed50fcb$var$documentMode && 8 < $7f3768da1ed50fcb$var$documentMode && 11 >= $7f3768da1ed50fcb$var$documentMode), $7f3768da1ed50fcb$var$SPACEBAR_CHAR = String.fromCharCode(32), $7f3768da1ed50fcb$var$hasSpaceKeypress = !1;
function $7f3768da1ed50fcb$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $7f3768da1ed50fcb$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $7f3768da1ed50fcb$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $7f3768da1ed50fcb$var$isComposing = !1;
function $7f3768da1ed50fcb$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $7f3768da1ed50fcb$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $7f3768da1ed50fcb$var$hasSpaceKeypress = !0;
            return $7f3768da1ed50fcb$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $7f3768da1ed50fcb$var$SPACEBAR_CHAR && $7f3768da1ed50fcb$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $7f3768da1ed50fcb$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($7f3768da1ed50fcb$var$isComposing) return "compositionend" === domEventName || !$7f3768da1ed50fcb$var$canUseCompositionEvent && $7f3768da1ed50fcb$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $7f3768da1ed50fcb$var$getData(), $7f3768da1ed50fcb$var$fallbackText = $7f3768da1ed50fcb$var$startText = $7f3768da1ed50fcb$var$root = null, $7f3768da1ed50fcb$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $7f3768da1ed50fcb$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $7f3768da1ed50fcb$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $7f3768da1ed50fcb$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$7f3768da1ed50fcb$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $7f3768da1ed50fcb$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $7f3768da1ed50fcb$var$restoreTarget ? $7f3768da1ed50fcb$var$restoreQueue ? $7f3768da1ed50fcb$var$restoreQueue.push(target) : $7f3768da1ed50fcb$var$restoreQueue = [
        target
    ] : $7f3768da1ed50fcb$var$restoreTarget = target;
    inst = $7f3768da1ed50fcb$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $7f3768da1ed50fcb$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $7f3768da1ed50fcb$var$activeElement$1 = null, $7f3768da1ed50fcb$var$activeElementInst$1 = null;
function $7f3768da1ed50fcb$var$runEventInBatch(dispatchQueue) {
    $7f3768da1ed50fcb$var$processDispatchQueue(dispatchQueue, 0);
}
function $7f3768da1ed50fcb$var$getInstIfValueChanged(targetInst) {
    var targetNode = $7f3768da1ed50fcb$var$getNodeFromInstance(targetInst);
    if ($7f3768da1ed50fcb$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $7f3768da1ed50fcb$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $7f3768da1ed50fcb$var$isInputEventSupported = !1;
if ($7f3768da1ed50fcb$var$canUseDOM) {
    var $7f3768da1ed50fcb$var$JSCompiler_inline_result$jscomp$282;
    if ($7f3768da1ed50fcb$var$canUseDOM) {
        var $7f3768da1ed50fcb$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$7f3768da1ed50fcb$var$isSupported$jscomp$inline_417) {
            var $7f3768da1ed50fcb$var$element$jscomp$inline_418 = document.createElement("div");
            $7f3768da1ed50fcb$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $7f3768da1ed50fcb$var$isSupported$jscomp$inline_417 = "function" === typeof $7f3768da1ed50fcb$var$element$jscomp$inline_418.oninput;
        }
        $7f3768da1ed50fcb$var$JSCompiler_inline_result$jscomp$282 = $7f3768da1ed50fcb$var$isSupported$jscomp$inline_417;
    } else $7f3768da1ed50fcb$var$JSCompiler_inline_result$jscomp$282 = !1;
    $7f3768da1ed50fcb$var$isInputEventSupported = $7f3768da1ed50fcb$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $7f3768da1ed50fcb$var$stopWatchingForValueChange() {
    $7f3768da1ed50fcb$var$activeElement$1 && ($7f3768da1ed50fcb$var$activeElement$1.detachEvent("onpropertychange", $7f3768da1ed50fcb$var$handlePropertyChange), $7f3768da1ed50fcb$var$activeElementInst$1 = $7f3768da1ed50fcb$var$activeElement$1 = null);
}
function $7f3768da1ed50fcb$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $7f3768da1ed50fcb$var$getInstIfValueChanged($7f3768da1ed50fcb$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $7f3768da1ed50fcb$var$createAndAccumulateChangeEvent(dispatchQueue, $7f3768da1ed50fcb$var$activeElementInst$1, nativeEvent, $7f3768da1ed50fcb$var$getEventTarget(nativeEvent));
        $7f3768da1ed50fcb$var$batchedUpdates$1($7f3768da1ed50fcb$var$runEventInBatch, dispatchQueue);
    }
}
function $7f3768da1ed50fcb$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($7f3768da1ed50fcb$var$stopWatchingForValueChange(), $7f3768da1ed50fcb$var$activeElement$1 = target, $7f3768da1ed50fcb$var$activeElementInst$1 = targetInst, $7f3768da1ed50fcb$var$activeElement$1.attachEvent("onpropertychange", $7f3768da1ed50fcb$var$handlePropertyChange)) : "focusout" === domEventName && $7f3768da1ed50fcb$var$stopWatchingForValueChange();
}
function $7f3768da1ed50fcb$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $7f3768da1ed50fcb$var$getInstIfValueChanged($7f3768da1ed50fcb$var$activeElementInst$1);
}
function $7f3768da1ed50fcb$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $7f3768da1ed50fcb$var$getInstIfValueChanged(targetInst);
}
function $7f3768da1ed50fcb$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $7f3768da1ed50fcb$var$getInstIfValueChanged(targetInst);
}
function $7f3768da1ed50fcb$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $7f3768da1ed50fcb$var$objectIs = "function" === typeof Object.is ? Object.is : $7f3768da1ed50fcb$var$is;
function $7f3768da1ed50fcb$var$shallowEqual(objA, objB) {
    if ($7f3768da1ed50fcb$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$7f3768da1ed50fcb$var$hasOwnProperty.call(objB, currentKey) || !$7f3768da1ed50fcb$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $7f3768da1ed50fcb$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $7f3768da1ed50fcb$var$getNodeForCharacterOffset(root, offset) {
    var node = $7f3768da1ed50fcb$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $7f3768da1ed50fcb$var$getLeafNode(node);
    }
}
function $7f3768da1ed50fcb$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $7f3768da1ed50fcb$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $7f3768da1ed50fcb$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $7f3768da1ed50fcb$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $7f3768da1ed50fcb$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $7f3768da1ed50fcb$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $7f3768da1ed50fcb$var$skipSelectionChangeEvent = $7f3768da1ed50fcb$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $7f3768da1ed50fcb$var$activeElement = null, $7f3768da1ed50fcb$var$activeElementInst = null, $7f3768da1ed50fcb$var$lastSelection = null, $7f3768da1ed50fcb$var$mouseDown = !1;
function $7f3768da1ed50fcb$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $7f3768da1ed50fcb$var$mouseDown || null == $7f3768da1ed50fcb$var$activeElement || $7f3768da1ed50fcb$var$activeElement !== $7f3768da1ed50fcb$var$getActiveElement(doc) || (doc = $7f3768da1ed50fcb$var$activeElement, "selectionStart" in doc && $7f3768da1ed50fcb$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $7f3768da1ed50fcb$var$lastSelection && $7f3768da1ed50fcb$var$shallowEqual($7f3768da1ed50fcb$var$lastSelection, doc) || ($7f3768da1ed50fcb$var$lastSelection = doc, doc = $7f3768da1ed50fcb$var$accumulateTwoPhaseListeners($7f3768da1ed50fcb$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $7f3768da1ed50fcb$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $7f3768da1ed50fcb$var$activeElement)));
}
function $7f3768da1ed50fcb$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $7f3768da1ed50fcb$var$vendorPrefixes = {
    animationend: $7f3768da1ed50fcb$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $7f3768da1ed50fcb$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $7f3768da1ed50fcb$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $7f3768da1ed50fcb$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $7f3768da1ed50fcb$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $7f3768da1ed50fcb$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $7f3768da1ed50fcb$var$makePrefixMap("Transition", "TransitionEnd")
}, $7f3768da1ed50fcb$var$prefixedEventNames = {}, $7f3768da1ed50fcb$var$style = {};
$7f3768da1ed50fcb$var$canUseDOM && ($7f3768da1ed50fcb$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $7f3768da1ed50fcb$var$vendorPrefixes.animationend.animation, delete $7f3768da1ed50fcb$var$vendorPrefixes.animationiteration.animation, delete $7f3768da1ed50fcb$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $7f3768da1ed50fcb$var$vendorPrefixes.transitionend.transition);
function $7f3768da1ed50fcb$var$getVendorPrefixedEventName(eventName) {
    if ($7f3768da1ed50fcb$var$prefixedEventNames[eventName]) return $7f3768da1ed50fcb$var$prefixedEventNames[eventName];
    if (!$7f3768da1ed50fcb$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $7f3768da1ed50fcb$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $7f3768da1ed50fcb$var$style) return $7f3768da1ed50fcb$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $7f3768da1ed50fcb$var$ANIMATION_END = $7f3768da1ed50fcb$var$getVendorPrefixedEventName("animationend"), $7f3768da1ed50fcb$var$ANIMATION_ITERATION = $7f3768da1ed50fcb$var$getVendorPrefixedEventName("animationiteration"), $7f3768da1ed50fcb$var$ANIMATION_START = $7f3768da1ed50fcb$var$getVendorPrefixedEventName("animationstart"), $7f3768da1ed50fcb$var$TRANSITION_RUN = $7f3768da1ed50fcb$var$getVendorPrefixedEventName("transitionrun"), $7f3768da1ed50fcb$var$TRANSITION_START = $7f3768da1ed50fcb$var$getVendorPrefixedEventName("transitionstart"), $7f3768da1ed50fcb$var$TRANSITION_CANCEL = $7f3768da1ed50fcb$var$getVendorPrefixedEventName("transitioncancel"), $7f3768da1ed50fcb$var$TRANSITION_END = $7f3768da1ed50fcb$var$getVendorPrefixedEventName("transitionend"), $7f3768da1ed50fcb$var$topLevelEventsToReactNames = new Map(), $7f3768da1ed50fcb$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$7f3768da1ed50fcb$var$simpleEventPluginEvents.push("scrollEnd");
function $7f3768da1ed50fcb$var$registerSimpleEvent(domEventName, reactName) {
    $7f3768da1ed50fcb$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $7f3768da1ed50fcb$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $7f3768da1ed50fcb$var$CapturedStacks = new WeakMap();
function $7f3768da1ed50fcb$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $7f3768da1ed50fcb$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $7f3768da1ed50fcb$var$getStackByFiberInDevAndProd(source)
        };
        $7f3768da1ed50fcb$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $7f3768da1ed50fcb$var$getStackByFiberInDevAndProd(source)
    };
}
var $7f3768da1ed50fcb$var$concurrentQueues = [], $7f3768da1ed50fcb$var$concurrentQueuesIndex = 0, $7f3768da1ed50fcb$var$concurrentlyUpdatedLanes = 0;
function $7f3768da1ed50fcb$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $7f3768da1ed50fcb$var$concurrentQueuesIndex, i = $7f3768da1ed50fcb$var$concurrentlyUpdatedLanes = $7f3768da1ed50fcb$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $7f3768da1ed50fcb$var$concurrentQueues[i];
        $7f3768da1ed50fcb$var$concurrentQueues[i++] = null;
        var queue = $7f3768da1ed50fcb$var$concurrentQueues[i];
        $7f3768da1ed50fcb$var$concurrentQueues[i++] = null;
        var update = $7f3768da1ed50fcb$var$concurrentQueues[i];
        $7f3768da1ed50fcb$var$concurrentQueues[i++] = null;
        var lane = $7f3768da1ed50fcb$var$concurrentQueues[i];
        $7f3768da1ed50fcb$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $7f3768da1ed50fcb$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $7f3768da1ed50fcb$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $7f3768da1ed50fcb$var$concurrentQueues[$7f3768da1ed50fcb$var$concurrentQueuesIndex++] = fiber;
    $7f3768da1ed50fcb$var$concurrentQueues[$7f3768da1ed50fcb$var$concurrentQueuesIndex++] = queue;
    $7f3768da1ed50fcb$var$concurrentQueues[$7f3768da1ed50fcb$var$concurrentQueuesIndex++] = update;
    $7f3768da1ed50fcb$var$concurrentQueues[$7f3768da1ed50fcb$var$concurrentQueuesIndex++] = lane;
    $7f3768da1ed50fcb$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $7f3768da1ed50fcb$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $7f3768da1ed50fcb$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $7f3768da1ed50fcb$var$getRootForUpdatedFiber(fiber);
}
function $7f3768da1ed50fcb$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $7f3768da1ed50fcb$var$enqueueUpdate$1(fiber, null, null, lane);
    return $7f3768da1ed50fcb$var$getRootForUpdatedFiber(fiber);
}
function $7f3768da1ed50fcb$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $7f3768da1ed50fcb$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $7f3768da1ed50fcb$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $7f3768da1ed50fcb$var$nestedUpdateCount) throw $7f3768da1ed50fcb$var$nestedUpdateCount = 0, $7f3768da1ed50fcb$var$rootWithNestedUpdates = null, Error($7f3768da1ed50fcb$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $7f3768da1ed50fcb$var$emptyContextObject = {};
function $7f3768da1ed50fcb$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $7f3768da1ed50fcb$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $7f3768da1ed50fcb$var$FiberNode(tag, pendingProps, key, mode);
}
function $7f3768da1ed50fcb$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $7f3768da1ed50fcb$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $7f3768da1ed50fcb$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $7f3768da1ed50fcb$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $7f3768da1ed50fcb$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $7f3768da1ed50fcb$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $7f3768da1ed50fcb$var$isHostHoistableType(type, pendingProps, $7f3768da1ed50fcb$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $7f3768da1ed50fcb$var$REACT_ACTIVITY_TYPE:
            return type = $7f3768da1ed50fcb$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $7f3768da1ed50fcb$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $7f3768da1ed50fcb$var$REACT_FRAGMENT_TYPE:
            return $7f3768da1ed50fcb$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $7f3768da1ed50fcb$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $7f3768da1ed50fcb$var$REACT_PROFILER_TYPE:
            return type = $7f3768da1ed50fcb$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $7f3768da1ed50fcb$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $7f3768da1ed50fcb$var$REACT_SUSPENSE_TYPE:
            return type = $7f3768da1ed50fcb$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $7f3768da1ed50fcb$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $7f3768da1ed50fcb$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $7f3768da1ed50fcb$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $7f3768da1ed50fcb$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $7f3768da1ed50fcb$var$REACT_PROVIDER_TYPE:
                case $7f3768da1ed50fcb$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $7f3768da1ed50fcb$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $7f3768da1ed50fcb$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $7f3768da1ed50fcb$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $7f3768da1ed50fcb$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($7f3768da1ed50fcb$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $7f3768da1ed50fcb$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $7f3768da1ed50fcb$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $7f3768da1ed50fcb$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $7f3768da1ed50fcb$var$createFiberFromText(content, mode, lanes) {
    content = $7f3768da1ed50fcb$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $7f3768da1ed50fcb$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $7f3768da1ed50fcb$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $7f3768da1ed50fcb$var$forkStack = [], $7f3768da1ed50fcb$var$forkStackIndex = 0, $7f3768da1ed50fcb$var$treeForkProvider = null, $7f3768da1ed50fcb$var$treeForkCount = 0, $7f3768da1ed50fcb$var$idStack = [], $7f3768da1ed50fcb$var$idStackIndex = 0, $7f3768da1ed50fcb$var$treeContextProvider = null, $7f3768da1ed50fcb$var$treeContextId = 1, $7f3768da1ed50fcb$var$treeContextOverflow = "";
function $7f3768da1ed50fcb$var$pushTreeFork(workInProgress, totalChildren) {
    $7f3768da1ed50fcb$var$forkStack[$7f3768da1ed50fcb$var$forkStackIndex++] = $7f3768da1ed50fcb$var$treeForkCount;
    $7f3768da1ed50fcb$var$forkStack[$7f3768da1ed50fcb$var$forkStackIndex++] = $7f3768da1ed50fcb$var$treeForkProvider;
    $7f3768da1ed50fcb$var$treeForkProvider = workInProgress;
    $7f3768da1ed50fcb$var$treeForkCount = totalChildren;
}
function $7f3768da1ed50fcb$var$pushTreeId(workInProgress, totalChildren, index) {
    $7f3768da1ed50fcb$var$idStack[$7f3768da1ed50fcb$var$idStackIndex++] = $7f3768da1ed50fcb$var$treeContextId;
    $7f3768da1ed50fcb$var$idStack[$7f3768da1ed50fcb$var$idStackIndex++] = $7f3768da1ed50fcb$var$treeContextOverflow;
    $7f3768da1ed50fcb$var$idStack[$7f3768da1ed50fcb$var$idStackIndex++] = $7f3768da1ed50fcb$var$treeContextProvider;
    $7f3768da1ed50fcb$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $7f3768da1ed50fcb$var$treeContextId;
    workInProgress = $7f3768da1ed50fcb$var$treeContextOverflow;
    var baseLength = 32 - $7f3768da1ed50fcb$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $7f3768da1ed50fcb$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $7f3768da1ed50fcb$var$treeContextId = 1 << 32 - $7f3768da1ed50fcb$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $7f3768da1ed50fcb$var$treeContextOverflow = length + workInProgress;
    } else $7f3768da1ed50fcb$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $7f3768da1ed50fcb$var$treeContextOverflow = workInProgress;
}
function $7f3768da1ed50fcb$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($7f3768da1ed50fcb$var$pushTreeFork(workInProgress, 1), $7f3768da1ed50fcb$var$pushTreeId(workInProgress, 1, 0));
}
function $7f3768da1ed50fcb$var$popTreeContext(workInProgress) {
    for(; workInProgress === $7f3768da1ed50fcb$var$treeForkProvider;)$7f3768da1ed50fcb$var$treeForkProvider = $7f3768da1ed50fcb$var$forkStack[--$7f3768da1ed50fcb$var$forkStackIndex], $7f3768da1ed50fcb$var$forkStack[$7f3768da1ed50fcb$var$forkStackIndex] = null, $7f3768da1ed50fcb$var$treeForkCount = $7f3768da1ed50fcb$var$forkStack[--$7f3768da1ed50fcb$var$forkStackIndex], $7f3768da1ed50fcb$var$forkStack[$7f3768da1ed50fcb$var$forkStackIndex] = null;
    for(; workInProgress === $7f3768da1ed50fcb$var$treeContextProvider;)$7f3768da1ed50fcb$var$treeContextProvider = $7f3768da1ed50fcb$var$idStack[--$7f3768da1ed50fcb$var$idStackIndex], $7f3768da1ed50fcb$var$idStack[$7f3768da1ed50fcb$var$idStackIndex] = null, $7f3768da1ed50fcb$var$treeContextOverflow = $7f3768da1ed50fcb$var$idStack[--$7f3768da1ed50fcb$var$idStackIndex], $7f3768da1ed50fcb$var$idStack[$7f3768da1ed50fcb$var$idStackIndex] = null, $7f3768da1ed50fcb$var$treeContextId = $7f3768da1ed50fcb$var$idStack[--$7f3768da1ed50fcb$var$idStackIndex], $7f3768da1ed50fcb$var$idStack[$7f3768da1ed50fcb$var$idStackIndex] = null;
}
var $7f3768da1ed50fcb$var$hydrationParentFiber = null, $7f3768da1ed50fcb$var$nextHydratableInstance = null, $7f3768da1ed50fcb$var$isHydrating = !1, $7f3768da1ed50fcb$var$hydrationErrors = null, $7f3768da1ed50fcb$var$rootOrSingletonContext = !1, $7f3768da1ed50fcb$var$HydrationMismatchException = Error($7f3768da1ed50fcb$var$formatProdErrorMessage(519));
function $7f3768da1ed50fcb$var$throwOnHydrationMismatch(fiber) {
    var error = Error($7f3768da1ed50fcb$var$formatProdErrorMessage(418, ""));
    $7f3768da1ed50fcb$var$queueHydrationError($7f3768da1ed50fcb$var$createCapturedValueAtFiber(error, fiber));
    throw $7f3768da1ed50fcb$var$HydrationMismatchException;
}
function $7f3768da1ed50fcb$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$7f3768da1ed50fcb$var$internalInstanceKey] = fiber;
    instance[$7f3768da1ed50fcb$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("cancel", instance);
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $7f3768da1ed50fcb$var$mediaEventTypes.length; type++)$7f3768da1ed50fcb$var$listenToNonDelegatedEvent($7f3768da1ed50fcb$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("error", instance);
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("invalid", instance);
            $7f3768da1ed50fcb$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $7f3768da1ed50fcb$var$track(instance);
            break;
        case "select":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("invalid", instance), $7f3768da1ed50fcb$var$initTextarea(instance, props.value, props.defaultValue, props.children), $7f3768da1ed50fcb$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $7f3768da1ed50fcb$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($7f3768da1ed50fcb$var$listenToNonDelegatedEvent("beforetoggle", instance), $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $7f3768da1ed50fcb$var$noop$1), instance = !0) : instance = !1;
    instance || $7f3768da1ed50fcb$var$throwOnHydrationMismatch(fiber);
}
function $7f3768da1ed50fcb$var$popToNextHostParent(fiber) {
    for($7f3768da1ed50fcb$var$hydrationParentFiber = fiber.return; $7f3768da1ed50fcb$var$hydrationParentFiber;)switch($7f3768da1ed50fcb$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $7f3768da1ed50fcb$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $7f3768da1ed50fcb$var$rootOrSingletonContext = !0;
            return;
        default:
            $7f3768da1ed50fcb$var$hydrationParentFiber = $7f3768da1ed50fcb$var$hydrationParentFiber.return;
    }
}
function $7f3768da1ed50fcb$var$popHydrationState(fiber) {
    if (fiber !== $7f3768da1ed50fcb$var$hydrationParentFiber) return !1;
    if (!$7f3768da1ed50fcb$var$isHydrating) return $7f3768da1ed50fcb$var$popToNextHostParent(fiber), $7f3768da1ed50fcb$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $7f3768da1ed50fcb$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $7f3768da1ed50fcb$var$nextHydratableInstance && $7f3768da1ed50fcb$var$throwOnHydrationMismatch(fiber);
    $7f3768da1ed50fcb$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $7f3768da1ed50fcb$var$nextHydratableInstance = $7f3768da1ed50fcb$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $7f3768da1ed50fcb$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $7f3768da1ed50fcb$var$nextHydratableInstance, $7f3768da1ed50fcb$var$isSingletonScope(fiber.type) ? (fiber = $7f3768da1ed50fcb$var$previousHydratableOnEnteringScopedSingleton, $7f3768da1ed50fcb$var$previousHydratableOnEnteringScopedSingleton = null, $7f3768da1ed50fcb$var$nextHydratableInstance = fiber) : $7f3768da1ed50fcb$var$nextHydratableInstance = tag) : $7f3768da1ed50fcb$var$nextHydratableInstance = $7f3768da1ed50fcb$var$hydrationParentFiber ? $7f3768da1ed50fcb$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $7f3768da1ed50fcb$var$resetHydrationState() {
    $7f3768da1ed50fcb$var$nextHydratableInstance = $7f3768da1ed50fcb$var$hydrationParentFiber = null;
    $7f3768da1ed50fcb$var$isHydrating = !1;
}
function $7f3768da1ed50fcb$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $7f3768da1ed50fcb$var$hydrationErrors;
    null !== queuedErrors && (null === $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors ? $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors = queuedErrors : $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors.push.apply($7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors, queuedErrors), $7f3768da1ed50fcb$var$hydrationErrors = null);
    return queuedErrors;
}
function $7f3768da1ed50fcb$var$queueHydrationError(error) {
    null === $7f3768da1ed50fcb$var$hydrationErrors ? $7f3768da1ed50fcb$var$hydrationErrors = [
        error
    ] : $7f3768da1ed50fcb$var$hydrationErrors.push(error);
}
var $7f3768da1ed50fcb$var$valueCursor = $7f3768da1ed50fcb$var$createCursor(null), $7f3768da1ed50fcb$var$currentlyRenderingFiber$1 = null, $7f3768da1ed50fcb$var$lastContextDependency = null;
function $7f3768da1ed50fcb$var$pushProvider(providerFiber, context, nextValue) {
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $7f3768da1ed50fcb$var$popProvider(context) {
    context._currentValue = $7f3768da1ed50fcb$var$valueCursor.current;
    $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$valueCursor);
}
function $7f3768da1ed50fcb$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $7f3768da1ed50fcb$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $7f3768da1ed50fcb$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $7f3768da1ed50fcb$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $7f3768da1ed50fcb$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $7f3768da1ed50fcb$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $7f3768da1ed50fcb$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($7f3768da1ed50fcb$var$HostTransitionContext) : current = [
                $7f3768da1ed50fcb$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $7f3768da1ed50fcb$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $7f3768da1ed50fcb$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$7f3768da1ed50fcb$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $7f3768da1ed50fcb$var$prepareToReadContext(workInProgress) {
    $7f3768da1ed50fcb$var$currentlyRenderingFiber$1 = workInProgress;
    $7f3768da1ed50fcb$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $7f3768da1ed50fcb$var$readContext(context) {
    return $7f3768da1ed50fcb$var$readContextForConsumer($7f3768da1ed50fcb$var$currentlyRenderingFiber$1, context);
}
function $7f3768da1ed50fcb$var$readContextDuringReconciliation(consumer, context) {
    null === $7f3768da1ed50fcb$var$currentlyRenderingFiber$1 && $7f3768da1ed50fcb$var$prepareToReadContext(consumer);
    return $7f3768da1ed50fcb$var$readContextForConsumer(consumer, context);
}
function $7f3768da1ed50fcb$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $7f3768da1ed50fcb$var$lastContextDependency) {
        if (null === consumer) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(308));
        $7f3768da1ed50fcb$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $7f3768da1ed50fcb$var$lastContextDependency = $7f3768da1ed50fcb$var$lastContextDependency.next = context;
    return value;
}
var $7f3768da1ed50fcb$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $7f3768da1ed50fcb$var$scheduleCallback$2 = $2ixDp.unstable_scheduleCallback, $7f3768da1ed50fcb$var$NormalPriority = $2ixDp.unstable_NormalPriority, $7f3768da1ed50fcb$var$CacheContext = {
    $$typeof: $7f3768da1ed50fcb$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $7f3768da1ed50fcb$var$createCache() {
    return {
        controller: new $7f3768da1ed50fcb$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $7f3768da1ed50fcb$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $7f3768da1ed50fcb$var$scheduleCallback$2($7f3768da1ed50fcb$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $7f3768da1ed50fcb$var$currentEntangledListeners = null, $7f3768da1ed50fcb$var$currentEntangledPendingCount = 0, $7f3768da1ed50fcb$var$currentEntangledLane = 0, $7f3768da1ed50fcb$var$currentEntangledActionThenable = null;
function $7f3768da1ed50fcb$var$entangleAsyncAction(transition, thenable) {
    if (null === $7f3768da1ed50fcb$var$currentEntangledListeners) {
        var entangledListeners = $7f3768da1ed50fcb$var$currentEntangledListeners = [];
        $7f3768da1ed50fcb$var$currentEntangledPendingCount = 0;
        $7f3768da1ed50fcb$var$currentEntangledLane = $7f3768da1ed50fcb$var$requestTransitionLane();
        $7f3768da1ed50fcb$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $7f3768da1ed50fcb$var$currentEntangledPendingCount++;
    thenable.then($7f3768da1ed50fcb$var$pingEngtangledActionScope, $7f3768da1ed50fcb$var$pingEngtangledActionScope);
    return thenable;
}
function $7f3768da1ed50fcb$var$pingEngtangledActionScope() {
    if (0 === --$7f3768da1ed50fcb$var$currentEntangledPendingCount && null !== $7f3768da1ed50fcb$var$currentEntangledListeners) {
        null !== $7f3768da1ed50fcb$var$currentEntangledActionThenable && ($7f3768da1ed50fcb$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $7f3768da1ed50fcb$var$currentEntangledListeners;
        $7f3768da1ed50fcb$var$currentEntangledListeners = null;
        $7f3768da1ed50fcb$var$currentEntangledLane = 0;
        $7f3768da1ed50fcb$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $7f3768da1ed50fcb$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $7f3768da1ed50fcb$var$prevOnStartTransitionFinish = $7f3768da1ed50fcb$var$ReactSharedInternals.S;
$7f3768da1ed50fcb$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $7f3768da1ed50fcb$var$entangleAsyncAction(transition, returnValue);
    null !== $7f3768da1ed50fcb$var$prevOnStartTransitionFinish && $7f3768da1ed50fcb$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $7f3768da1ed50fcb$var$resumedCache = $7f3768da1ed50fcb$var$createCursor(null);
function $7f3768da1ed50fcb$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $7f3768da1ed50fcb$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $7f3768da1ed50fcb$var$workInProgressRoot.pooledCache;
}
function $7f3768da1ed50fcb$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$resumedCache, $7f3768da1ed50fcb$var$resumedCache.current) : $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$resumedCache, prevCachePool.pool);
}
function $7f3768da1ed50fcb$var$getSuspendedCache() {
    var cacheFromPool = $7f3768da1ed50fcb$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $7f3768da1ed50fcb$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $7f3768da1ed50fcb$var$SuspenseException = Error($7f3768da1ed50fcb$var$formatProdErrorMessage(460)), $7f3768da1ed50fcb$var$SuspenseyCommitException = Error($7f3768da1ed50fcb$var$formatProdErrorMessage(474)), $7f3768da1ed50fcb$var$SuspenseActionException = Error($7f3768da1ed50fcb$var$formatProdErrorMessage(542)), $7f3768da1ed50fcb$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $7f3768da1ed50fcb$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $7f3768da1ed50fcb$var$noop$3() {}
function $7f3768da1ed50fcb$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($7f3768da1ed50fcb$var$noop$3, $7f3768da1ed50fcb$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $7f3768da1ed50fcb$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($7f3768da1ed50fcb$var$noop$3, $7f3768da1ed50fcb$var$noop$3);
            else {
                thenableState = $7f3768da1ed50fcb$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $7f3768da1ed50fcb$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $7f3768da1ed50fcb$var$suspendedThenable = thenable;
            throw $7f3768da1ed50fcb$var$SuspenseException;
    }
}
var $7f3768da1ed50fcb$var$suspendedThenable = null;
function $7f3768da1ed50fcb$var$getSuspendedThenable() {
    if (null === $7f3768da1ed50fcb$var$suspendedThenable) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(459));
    var thenable = $7f3768da1ed50fcb$var$suspendedThenable;
    $7f3768da1ed50fcb$var$suspendedThenable = null;
    return thenable;
}
function $7f3768da1ed50fcb$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $7f3768da1ed50fcb$var$SuspenseException || rejectedReason === $7f3768da1ed50fcb$var$SuspenseActionException) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(483));
}
var $7f3768da1ed50fcb$var$hasForceUpdate = !1;
function $7f3768da1ed50fcb$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $7f3768da1ed50fcb$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $7f3768da1ed50fcb$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $7f3768da1ed50fcb$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($7f3768da1ed50fcb$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $7f3768da1ed50fcb$var$getRootForUpdatedFiber(fiber);
        $7f3768da1ed50fcb$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $7f3768da1ed50fcb$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $7f3768da1ed50fcb$var$getRootForUpdatedFiber(fiber);
}
function $7f3768da1ed50fcb$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $7f3768da1ed50fcb$var$markRootEntangled(root, lane);
    }
}
function $7f3768da1ed50fcb$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $7f3768da1ed50fcb$var$didReadFromEntangledAsyncAction = !1;
function $7f3768da1ed50fcb$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($7f3768da1ed50fcb$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $7f3768da1ed50fcb$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $7f3768da1ed50fcb$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $7f3768da1ed50fcb$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $7f3768da1ed50fcb$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($7f3768da1ed50fcb$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $7f3768da1ed50fcb$var$currentEntangledLane && ($7f3768da1ed50fcb$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $7f3768da1ed50fcb$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $7f3768da1ed50fcb$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $7f3768da1ed50fcb$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $7f3768da1ed50fcb$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $7f3768da1ed50fcb$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$7f3768da1ed50fcb$var$callCallback(callbacks[updateQueue], context);
}
var $7f3768da1ed50fcb$var$currentTreeHiddenStackCursor = $7f3768da1ed50fcb$var$createCursor(null), $7f3768da1ed50fcb$var$prevEntangledRenderLanesCursor = $7f3768da1ed50fcb$var$createCursor(0);
function $7f3768da1ed50fcb$var$pushHiddenContext(fiber, context) {
    fiber = $7f3768da1ed50fcb$var$entangledRenderLanes;
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$prevEntangledRenderLanesCursor, fiber);
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$currentTreeHiddenStackCursor, context);
    $7f3768da1ed50fcb$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $7f3768da1ed50fcb$var$reuseHiddenContextOnStack() {
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$prevEntangledRenderLanesCursor, $7f3768da1ed50fcb$var$entangledRenderLanes);
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$currentTreeHiddenStackCursor, $7f3768da1ed50fcb$var$currentTreeHiddenStackCursor.current);
}
function $7f3768da1ed50fcb$var$popHiddenContext() {
    $7f3768da1ed50fcb$var$entangledRenderLanes = $7f3768da1ed50fcb$var$prevEntangledRenderLanesCursor.current;
    $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$currentTreeHiddenStackCursor);
    $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$prevEntangledRenderLanesCursor);
}
var $7f3768da1ed50fcb$var$renderLanes = 0, $7f3768da1ed50fcb$var$currentlyRenderingFiber = null, $7f3768da1ed50fcb$var$currentHook = null, $7f3768da1ed50fcb$var$workInProgressHook = null, $7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdate = !1, $7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $7f3768da1ed50fcb$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $7f3768da1ed50fcb$var$localIdCounter = 0, $7f3768da1ed50fcb$var$thenableIndexCounter$1 = 0, $7f3768da1ed50fcb$var$thenableState$1 = null, $7f3768da1ed50fcb$var$globalClientIdCounter = 0;
function $7f3768da1ed50fcb$var$throwInvalidHookError() {
    throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(321));
}
function $7f3768da1ed50fcb$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$7f3768da1ed50fcb$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $7f3768da1ed50fcb$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $7f3768da1ed50fcb$var$renderLanes = nextRenderLanes;
    $7f3768da1ed50fcb$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $7f3768da1ed50fcb$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $7f3768da1ed50fcb$var$HooksDispatcherOnMount : $7f3768da1ed50fcb$var$HooksDispatcherOnUpdate;
    $7f3768da1ed50fcb$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $7f3768da1ed50fcb$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $7f3768da1ed50fcb$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $7f3768da1ed50fcb$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $7f3768da1ed50fcb$var$finishRenderingHooks(current) {
    $7f3768da1ed50fcb$var$ReactSharedInternals.H = $7f3768da1ed50fcb$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $7f3768da1ed50fcb$var$currentHook && null !== $7f3768da1ed50fcb$var$currentHook.next;
    $7f3768da1ed50fcb$var$renderLanes = 0;
    $7f3768da1ed50fcb$var$workInProgressHook = $7f3768da1ed50fcb$var$currentHook = $7f3768da1ed50fcb$var$currentlyRenderingFiber = null;
    $7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdate = !1;
    $7f3768da1ed50fcb$var$thenableIndexCounter$1 = 0;
    $7f3768da1ed50fcb$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(300));
    null === current || $7f3768da1ed50fcb$var$didReceiveUpdate || (current = current.dependencies, null !== current && $7f3768da1ed50fcb$var$checkIfContextChanged(current) && ($7f3768da1ed50fcb$var$didReceiveUpdate = !0));
}
function $7f3768da1ed50fcb$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $7f3768da1ed50fcb$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdateDuringThisPass && ($7f3768da1ed50fcb$var$thenableState$1 = null);
        $7f3768da1ed50fcb$var$thenableIndexCounter$1 = 0;
        $7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $7f3768da1ed50fcb$var$workInProgressHook = $7f3768da1ed50fcb$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $7f3768da1ed50fcb$var$ReactSharedInternals.H = $7f3768da1ed50fcb$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $7f3768da1ed50fcb$var$TransitionAwareHostComponent() {
    var dispatcher = $7f3768da1ed50fcb$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $7f3768da1ed50fcb$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $7f3768da1ed50fcb$var$currentHook ? $7f3768da1ed50fcb$var$currentHook.memoizedState : null) !== dispatcher && ($7f3768da1ed50fcb$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $7f3768da1ed50fcb$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $7f3768da1ed50fcb$var$localIdCounter;
    $7f3768da1ed50fcb$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $7f3768da1ed50fcb$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $7f3768da1ed50fcb$var$resetHooksOnUnwind(workInProgress) {
    if ($7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdate = !1;
    }
    $7f3768da1ed50fcb$var$renderLanes = 0;
    $7f3768da1ed50fcb$var$workInProgressHook = $7f3768da1ed50fcb$var$currentHook = $7f3768da1ed50fcb$var$currentlyRenderingFiber = null;
    $7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $7f3768da1ed50fcb$var$thenableIndexCounter$1 = $7f3768da1ed50fcb$var$localIdCounter = 0;
    $7f3768da1ed50fcb$var$thenableState$1 = null;
}
function $7f3768da1ed50fcb$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $7f3768da1ed50fcb$var$workInProgressHook ? $7f3768da1ed50fcb$var$currentlyRenderingFiber.memoizedState = $7f3768da1ed50fcb$var$workInProgressHook = hook : $7f3768da1ed50fcb$var$workInProgressHook = $7f3768da1ed50fcb$var$workInProgressHook.next = hook;
    return $7f3768da1ed50fcb$var$workInProgressHook;
}
function $7f3768da1ed50fcb$var$updateWorkInProgressHook() {
    if (null === $7f3768da1ed50fcb$var$currentHook) {
        var nextCurrentHook = $7f3768da1ed50fcb$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $7f3768da1ed50fcb$var$currentHook.next;
    var nextWorkInProgressHook = null === $7f3768da1ed50fcb$var$workInProgressHook ? $7f3768da1ed50fcb$var$currentlyRenderingFiber.memoizedState : $7f3768da1ed50fcb$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $7f3768da1ed50fcb$var$workInProgressHook = nextWorkInProgressHook, $7f3768da1ed50fcb$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $7f3768da1ed50fcb$var$currentlyRenderingFiber.alternate) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(467));
            throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(310));
        }
        $7f3768da1ed50fcb$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $7f3768da1ed50fcb$var$currentHook.memoizedState,
            baseState: $7f3768da1ed50fcb$var$currentHook.baseState,
            baseQueue: $7f3768da1ed50fcb$var$currentHook.baseQueue,
            queue: $7f3768da1ed50fcb$var$currentHook.queue,
            next: null
        };
        null === $7f3768da1ed50fcb$var$workInProgressHook ? $7f3768da1ed50fcb$var$currentlyRenderingFiber.memoizedState = $7f3768da1ed50fcb$var$workInProgressHook = nextCurrentHook : $7f3768da1ed50fcb$var$workInProgressHook = $7f3768da1ed50fcb$var$workInProgressHook.next = nextCurrentHook;
    }
    return $7f3768da1ed50fcb$var$workInProgressHook;
}
function $7f3768da1ed50fcb$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $7f3768da1ed50fcb$var$useThenable(thenable) {
    var index = $7f3768da1ed50fcb$var$thenableIndexCounter$1;
    $7f3768da1ed50fcb$var$thenableIndexCounter$1 += 1;
    null === $7f3768da1ed50fcb$var$thenableState$1 && ($7f3768da1ed50fcb$var$thenableState$1 = []);
    thenable = $7f3768da1ed50fcb$var$trackUsedThenable($7f3768da1ed50fcb$var$thenableState$1, thenable, index);
    index = $7f3768da1ed50fcb$var$currentlyRenderingFiber;
    null === (null === $7f3768da1ed50fcb$var$workInProgressHook ? index.memoizedState : $7f3768da1ed50fcb$var$workInProgressHook.next) && (index = index.alternate, $7f3768da1ed50fcb$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $7f3768da1ed50fcb$var$HooksDispatcherOnMount : $7f3768da1ed50fcb$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $7f3768da1ed50fcb$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $7f3768da1ed50fcb$var$useThenable(usable);
        if (usable.$$typeof === $7f3768da1ed50fcb$var$REACT_CONTEXT_TYPE) return $7f3768da1ed50fcb$var$readContext(usable);
    }
    throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(438, String(usable)));
}
function $7f3768da1ed50fcb$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $7f3768da1ed50fcb$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $7f3768da1ed50fcb$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $7f3768da1ed50fcb$var$createFunctionComponentUpdateQueue(), $7f3768da1ed50fcb$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $7f3768da1ed50fcb$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $7f3768da1ed50fcb$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $7f3768da1ed50fcb$var$updateReducer(reducer) {
    var hook = $7f3768da1ed50fcb$var$updateWorkInProgressHook();
    return $7f3768da1ed50fcb$var$updateReducerImpl(hook, $7f3768da1ed50fcb$var$currentHook, reducer);
}
function $7f3768da1ed50fcb$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($7f3768da1ed50fcb$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($7f3768da1ed50fcb$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $7f3768da1ed50fcb$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($7f3768da1ed50fcb$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $7f3768da1ed50fcb$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $7f3768da1ed50fcb$var$currentlyRenderingFiber.lanes |= revertLane, $7f3768da1ed50fcb$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $7f3768da1ed50fcb$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $7f3768da1ed50fcb$var$currentlyRenderingFiber.lanes |= updateLane, $7f3768da1ed50fcb$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$7f3768da1ed50fcb$var$objectIs(pendingQueue, hook.memoizedState) && ($7f3768da1ed50fcb$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $7f3768da1ed50fcb$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $7f3768da1ed50fcb$var$rerenderReducer(reducer) {
    var hook = $7f3768da1ed50fcb$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $7f3768da1ed50fcb$var$objectIs(newState, hook.memoizedState) || ($7f3768da1ed50fcb$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $7f3768da1ed50fcb$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $7f3768da1ed50fcb$var$currentlyRenderingFiber, hook = $7f3768da1ed50fcb$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $7f3768da1ed50fcb$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$7f3768da1ed50fcb$var$objectIs(($7f3768da1ed50fcb$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $7f3768da1ed50fcb$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $7f3768da1ed50fcb$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $7f3768da1ed50fcb$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $7f3768da1ed50fcb$var$workInProgressHook && $7f3768da1ed50fcb$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $7f3768da1ed50fcb$var$pushSimpleEffect(9, $7f3768da1ed50fcb$var$createEffectInstance(), $7f3768da1ed50fcb$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $7f3768da1ed50fcb$var$workInProgressRoot) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($7f3768da1ed50fcb$var$renderLanes & 124) || $7f3768da1ed50fcb$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $7f3768da1ed50fcb$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $7f3768da1ed50fcb$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $7f3768da1ed50fcb$var$createFunctionComponentUpdateQueue(), $7f3768da1ed50fcb$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $7f3768da1ed50fcb$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $7f3768da1ed50fcb$var$checkIfSnapshotChanged(inst) && $7f3768da1ed50fcb$var$forceStoreRerender(fiber);
}
function $7f3768da1ed50fcb$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $7f3768da1ed50fcb$var$checkIfSnapshotChanged(inst) && $7f3768da1ed50fcb$var$forceStoreRerender(fiber);
    });
}
function $7f3768da1ed50fcb$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$7f3768da1ed50fcb$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $7f3768da1ed50fcb$var$forceStoreRerender(fiber) {
    var root = $7f3768da1ed50fcb$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $7f3768da1ed50fcb$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $7f3768da1ed50fcb$var$mountStateImpl(initialState) {
    var hook = $7f3768da1ed50fcb$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($7f3768da1ed50fcb$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $7f3768da1ed50fcb$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $7f3768da1ed50fcb$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $7f3768da1ed50fcb$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $7f3768da1ed50fcb$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $7f3768da1ed50fcb$var$updateReducerImpl(hook, $7f3768da1ed50fcb$var$currentHook, "function" === typeof reducer ? reducer : $7f3768da1ed50fcb$var$basicStateReducer);
}
function $7f3768da1ed50fcb$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($7f3768da1ed50fcb$var$isRenderPhaseUpdate(fiber)) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $7f3768da1ed50fcb$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $7f3768da1ed50fcb$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $7f3768da1ed50fcb$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $7f3768da1ed50fcb$var$ReactSharedInternals.T, currentTransition = {};
        $7f3768da1ed50fcb$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $7f3768da1ed50fcb$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $7f3768da1ed50fcb$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $7f3768da1ed50fcb$var$onActionError(actionQueue, node, error);
        } finally{
            $7f3768da1ed50fcb$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $7f3768da1ed50fcb$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $7f3768da1ed50fcb$var$onActionError(actionQueue, node, error$38);
    }
}
function $7f3768da1ed50fcb$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $7f3768da1ed50fcb$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $7f3768da1ed50fcb$var$onActionError(actionQueue, node, error);
    }) : $7f3768da1ed50fcb$var$onActionSuccess(actionQueue, node, returnValue);
}
function $7f3768da1ed50fcb$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $7f3768da1ed50fcb$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $7f3768da1ed50fcb$var$runActionStateAction(actionQueue, nextState)));
}
function $7f3768da1ed50fcb$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $7f3768da1ed50fcb$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $7f3768da1ed50fcb$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $7f3768da1ed50fcb$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $7f3768da1ed50fcb$var$mountActionState(action, initialStateProp) {
    if ($7f3768da1ed50fcb$var$isHydrating) {
        var ssrFormState = $7f3768da1ed50fcb$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $7f3768da1ed50fcb$var$currentlyRenderingFiber;
                if ($7f3768da1ed50fcb$var$isHydrating) {
                    if ($7f3768da1ed50fcb$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $7f3768da1ed50fcb$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $7f3768da1ed50fcb$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $7f3768da1ed50fcb$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $7f3768da1ed50fcb$var$nextHydratableInstance = $7f3768da1ed50fcb$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $7f3768da1ed50fcb$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $7f3768da1ed50fcb$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $7f3768da1ed50fcb$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $7f3768da1ed50fcb$var$dispatchSetState.bind(null, $7f3768da1ed50fcb$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $7f3768da1ed50fcb$var$mountStateImpl(!1);
    inRootOrSingleton = $7f3768da1ed50fcb$var$dispatchOptimisticSetState.bind(null, $7f3768da1ed50fcb$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $7f3768da1ed50fcb$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $7f3768da1ed50fcb$var$dispatchActionState.bind(null, $7f3768da1ed50fcb$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $7f3768da1ed50fcb$var$updateActionState(action) {
    var stateHook = $7f3768da1ed50fcb$var$updateWorkInProgressHook();
    return $7f3768da1ed50fcb$var$updateActionStateImpl(stateHook, $7f3768da1ed50fcb$var$currentHook, action);
}
function $7f3768da1ed50fcb$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $7f3768da1ed50fcb$var$updateReducerImpl(stateHook, currentStateHook, $7f3768da1ed50fcb$var$actionStateReducer)[0];
    stateHook = $7f3768da1ed50fcb$var$updateReducer($7f3768da1ed50fcb$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $7f3768da1ed50fcb$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $7f3768da1ed50fcb$var$SuspenseException) throw $7f3768da1ed50fcb$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $7f3768da1ed50fcb$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($7f3768da1ed50fcb$var$currentlyRenderingFiber.flags |= 2048, $7f3768da1ed50fcb$var$pushSimpleEffect(9, $7f3768da1ed50fcb$var$createEffectInstance(), $7f3768da1ed50fcb$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $7f3768da1ed50fcb$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $7f3768da1ed50fcb$var$rerenderActionState(action) {
    var stateHook = $7f3768da1ed50fcb$var$updateWorkInProgressHook(), currentStateHook = $7f3768da1ed50fcb$var$currentHook;
    if (null !== currentStateHook) return $7f3768da1ed50fcb$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $7f3768da1ed50fcb$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $7f3768da1ed50fcb$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $7f3768da1ed50fcb$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $7f3768da1ed50fcb$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $7f3768da1ed50fcb$var$createFunctionComponentUpdateQueue(), $7f3768da1ed50fcb$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $7f3768da1ed50fcb$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $7f3768da1ed50fcb$var$updateRef() {
    return $7f3768da1ed50fcb$var$updateWorkInProgressHook().memoizedState;
}
function $7f3768da1ed50fcb$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $7f3768da1ed50fcb$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $7f3768da1ed50fcb$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $7f3768da1ed50fcb$var$pushSimpleEffect(1 | hookFlags, $7f3768da1ed50fcb$var$createEffectInstance(), create, createDeps);
}
function $7f3768da1ed50fcb$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $7f3768da1ed50fcb$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $7f3768da1ed50fcb$var$currentHook && null !== deps && $7f3768da1ed50fcb$var$areHookInputsEqual(deps, $7f3768da1ed50fcb$var$currentHook.memoizedState.deps) ? hook.memoizedState = $7f3768da1ed50fcb$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($7f3768da1ed50fcb$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $7f3768da1ed50fcb$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $7f3768da1ed50fcb$var$mountEffect(create, createDeps) {
    $7f3768da1ed50fcb$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $7f3768da1ed50fcb$var$updateEffect(create, createDeps) {
    $7f3768da1ed50fcb$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $7f3768da1ed50fcb$var$updateInsertionEffect(create, deps) {
    return $7f3768da1ed50fcb$var$updateEffectImpl(4, 2, create, deps);
}
function $7f3768da1ed50fcb$var$updateLayoutEffect(create, deps) {
    return $7f3768da1ed50fcb$var$updateEffectImpl(4, 4, create, deps);
}
function $7f3768da1ed50fcb$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $7f3768da1ed50fcb$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $7f3768da1ed50fcb$var$updateEffectImpl(4, 4, $7f3768da1ed50fcb$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $7f3768da1ed50fcb$var$mountDebugValue() {}
function $7f3768da1ed50fcb$var$updateCallback(callback, deps) {
    var hook = $7f3768da1ed50fcb$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $7f3768da1ed50fcb$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $7f3768da1ed50fcb$var$updateMemo(nextCreate, deps) {
    var hook = $7f3768da1ed50fcb$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $7f3768da1ed50fcb$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($7f3768da1ed50fcb$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $7f3768da1ed50fcb$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $7f3768da1ed50fcb$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $7f3768da1ed50fcb$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($7f3768da1ed50fcb$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $7f3768da1ed50fcb$var$requestDeferredLane();
    $7f3768da1ed50fcb$var$currentlyRenderingFiber.lanes |= hook;
    $7f3768da1ed50fcb$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $7f3768da1ed50fcb$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($7f3768da1ed50fcb$var$objectIs(value, prevValue)) return value;
    if (null !== $7f3768da1ed50fcb$var$currentTreeHiddenStackCursor.current) return hook = $7f3768da1ed50fcb$var$mountDeferredValueImpl(hook, value, initialValue), $7f3768da1ed50fcb$var$objectIs(hook, prevValue) || ($7f3768da1ed50fcb$var$didReceiveUpdate = !0), hook;
    if (0 === ($7f3768da1ed50fcb$var$renderLanes & 42)) return $7f3768da1ed50fcb$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $7f3768da1ed50fcb$var$requestDeferredLane();
    $7f3768da1ed50fcb$var$currentlyRenderingFiber.lanes |= hook;
    $7f3768da1ed50fcb$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $7f3768da1ed50fcb$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p;
    $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $7f3768da1ed50fcb$var$ReactSharedInternals.T, currentTransition = {};
    $7f3768da1ed50fcb$var$ReactSharedInternals.T = currentTransition;
    $7f3768da1ed50fcb$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $7f3768da1ed50fcb$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $7f3768da1ed50fcb$var$chainThenableValue(returnValue, finishedState);
            $7f3768da1ed50fcb$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $7f3768da1ed50fcb$var$requestUpdateLane(fiber));
        } else $7f3768da1ed50fcb$var$dispatchSetStateInternal(fiber, queue, finishedState, $7f3768da1ed50fcb$var$requestUpdateLane(fiber));
    } catch (error) {
        $7f3768da1ed50fcb$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $7f3768da1ed50fcb$var$requestUpdateLane());
    } finally{
        $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = previousPriority, $7f3768da1ed50fcb$var$ReactSharedInternals.T = prevTransition;
    }
}
function $7f3768da1ed50fcb$var$noop$2() {}
function $7f3768da1ed50fcb$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(476));
    var queue = $7f3768da1ed50fcb$var$ensureFormComponentIsStateful(formFiber).queue;
    $7f3768da1ed50fcb$var$startTransition(formFiber, queue, pendingState, $7f3768da1ed50fcb$var$sharedNotPendingObject, null === action ? $7f3768da1ed50fcb$var$noop$2 : function() {
        $7f3768da1ed50fcb$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $7f3768da1ed50fcb$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $7f3768da1ed50fcb$var$sharedNotPendingObject,
        baseState: $7f3768da1ed50fcb$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $7f3768da1ed50fcb$var$basicStateReducer,
            lastRenderedState: $7f3768da1ed50fcb$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $7f3768da1ed50fcb$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $7f3768da1ed50fcb$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $7f3768da1ed50fcb$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $7f3768da1ed50fcb$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $7f3768da1ed50fcb$var$requestUpdateLane());
}
function $7f3768da1ed50fcb$var$useHostTransitionStatus() {
    return $7f3768da1ed50fcb$var$readContext($7f3768da1ed50fcb$var$HostTransitionContext);
}
function $7f3768da1ed50fcb$var$updateId() {
    return $7f3768da1ed50fcb$var$updateWorkInProgressHook().memoizedState;
}
function $7f3768da1ed50fcb$var$updateRefresh() {
    return $7f3768da1ed50fcb$var$updateWorkInProgressHook().memoizedState;
}
function $7f3768da1ed50fcb$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $7f3768da1ed50fcb$var$requestUpdateLane();
                fiber = $7f3768da1ed50fcb$var$createUpdate(lane);
                var root$41 = $7f3768da1ed50fcb$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($7f3768da1ed50fcb$var$scheduleUpdateOnFiber(root$41, provider, lane), $7f3768da1ed50fcb$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $7f3768da1ed50fcb$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $7f3768da1ed50fcb$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $7f3768da1ed50fcb$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $7f3768da1ed50fcb$var$isRenderPhaseUpdate(fiber) ? $7f3768da1ed50fcb$var$enqueueRenderPhaseUpdate(queue, action) : (action = $7f3768da1ed50fcb$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($7f3768da1ed50fcb$var$scheduleUpdateOnFiber(action, fiber, lane), $7f3768da1ed50fcb$var$entangleTransitionUpdate(action, queue, lane)));
}
function $7f3768da1ed50fcb$var$dispatchSetState(fiber, queue, action) {
    var lane = $7f3768da1ed50fcb$var$requestUpdateLane();
    $7f3768da1ed50fcb$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $7f3768da1ed50fcb$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($7f3768da1ed50fcb$var$isRenderPhaseUpdate(fiber)) $7f3768da1ed50fcb$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($7f3768da1ed50fcb$var$objectIs(eagerState, currentState)) return $7f3768da1ed50fcb$var$enqueueUpdate$1(fiber, queue, update, 0), null === $7f3768da1ed50fcb$var$workInProgressRoot && $7f3768da1ed50fcb$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $7f3768da1ed50fcb$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $7f3768da1ed50fcb$var$scheduleUpdateOnFiber(action, fiber, lane), $7f3768da1ed50fcb$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $7f3768da1ed50fcb$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $7f3768da1ed50fcb$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($7f3768da1ed50fcb$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $7f3768da1ed50fcb$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $7f3768da1ed50fcb$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $7f3768da1ed50fcb$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $7f3768da1ed50fcb$var$currentlyRenderingFiber || null !== alternate && alternate === $7f3768da1ed50fcb$var$currentlyRenderingFiber;
}
function $7f3768da1ed50fcb$var$enqueueRenderPhaseUpdate(queue, update) {
    $7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdateDuringThisPass = $7f3768da1ed50fcb$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $7f3768da1ed50fcb$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $7f3768da1ed50fcb$var$markRootEntangled(root, lane);
    }
}
var $7f3768da1ed50fcb$var$ContextOnlyDispatcher = {
    readContext: $7f3768da1ed50fcb$var$readContext,
    use: $7f3768da1ed50fcb$var$use,
    useCallback: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useContext: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useEffect: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useImperativeHandle: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useLayoutEffect: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useInsertionEffect: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useMemo: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useReducer: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useRef: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useState: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useDebugValue: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useDeferredValue: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useTransition: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useSyncExternalStore: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useId: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useHostTransitionStatus: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useFormState: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useActionState: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useOptimistic: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useMemoCache: $7f3768da1ed50fcb$var$throwInvalidHookError,
    useCacheRefresh: $7f3768da1ed50fcb$var$throwInvalidHookError
}, $7f3768da1ed50fcb$var$HooksDispatcherOnMount = {
    readContext: $7f3768da1ed50fcb$var$readContext,
    use: $7f3768da1ed50fcb$var$use,
    useCallback: function(callback, deps) {
        $7f3768da1ed50fcb$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $7f3768da1ed50fcb$var$readContext,
    useEffect: $7f3768da1ed50fcb$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $7f3768da1ed50fcb$var$mountEffectImpl(4194308, 4, $7f3768da1ed50fcb$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $7f3768da1ed50fcb$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $7f3768da1ed50fcb$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $7f3768da1ed50fcb$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($7f3768da1ed50fcb$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $7f3768da1ed50fcb$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $7f3768da1ed50fcb$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $7f3768da1ed50fcb$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($7f3768da1ed50fcb$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $7f3768da1ed50fcb$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $7f3768da1ed50fcb$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $7f3768da1ed50fcb$var$dispatchReducerAction.bind(null, $7f3768da1ed50fcb$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $7f3768da1ed50fcb$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $7f3768da1ed50fcb$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $7f3768da1ed50fcb$var$dispatchSetState.bind(null, $7f3768da1ed50fcb$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $7f3768da1ed50fcb$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $7f3768da1ed50fcb$var$mountWorkInProgressHook();
        return $7f3768da1ed50fcb$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $7f3768da1ed50fcb$var$mountStateImpl(!1);
        stateHook = $7f3768da1ed50fcb$var$startTransition.bind(null, $7f3768da1ed50fcb$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $7f3768da1ed50fcb$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $7f3768da1ed50fcb$var$currentlyRenderingFiber, hook = $7f3768da1ed50fcb$var$mountWorkInProgressHook();
        if ($7f3768da1ed50fcb$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $7f3768da1ed50fcb$var$workInProgressRoot) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(349));
            0 !== ($7f3768da1ed50fcb$var$workInProgressRootRenderLanes & 124) || $7f3768da1ed50fcb$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $7f3768da1ed50fcb$var$mountEffect($7f3768da1ed50fcb$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $7f3768da1ed50fcb$var$pushSimpleEffect(9, $7f3768da1ed50fcb$var$createEffectInstance(), $7f3768da1ed50fcb$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $7f3768da1ed50fcb$var$mountWorkInProgressHook(), identifierPrefix = $7f3768da1ed50fcb$var$workInProgressRoot.identifierPrefix;
        if ($7f3768da1ed50fcb$var$isHydrating) {
            var JSCompiler_inline_result = $7f3768da1ed50fcb$var$treeContextOverflow;
            var idWithLeadingBit = $7f3768da1ed50fcb$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $7f3768da1ed50fcb$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $7f3768da1ed50fcb$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $7f3768da1ed50fcb$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $7f3768da1ed50fcb$var$useHostTransitionStatus,
    useFormState: $7f3768da1ed50fcb$var$mountActionState,
    useActionState: $7f3768da1ed50fcb$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $7f3768da1ed50fcb$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $7f3768da1ed50fcb$var$dispatchOptimisticSetState.bind(null, $7f3768da1ed50fcb$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $7f3768da1ed50fcb$var$useMemoCache,
    useCacheRefresh: function() {
        return $7f3768da1ed50fcb$var$mountWorkInProgressHook().memoizedState = $7f3768da1ed50fcb$var$refreshCache.bind(null, $7f3768da1ed50fcb$var$currentlyRenderingFiber);
    }
}, $7f3768da1ed50fcb$var$HooksDispatcherOnUpdate = {
    readContext: $7f3768da1ed50fcb$var$readContext,
    use: $7f3768da1ed50fcb$var$use,
    useCallback: $7f3768da1ed50fcb$var$updateCallback,
    useContext: $7f3768da1ed50fcb$var$readContext,
    useEffect: $7f3768da1ed50fcb$var$updateEffect,
    useImperativeHandle: $7f3768da1ed50fcb$var$updateImperativeHandle,
    useInsertionEffect: $7f3768da1ed50fcb$var$updateInsertionEffect,
    useLayoutEffect: $7f3768da1ed50fcb$var$updateLayoutEffect,
    useMemo: $7f3768da1ed50fcb$var$updateMemo,
    useReducer: $7f3768da1ed50fcb$var$updateReducer,
    useRef: $7f3768da1ed50fcb$var$updateRef,
    useState: function() {
        return $7f3768da1ed50fcb$var$updateReducer($7f3768da1ed50fcb$var$basicStateReducer);
    },
    useDebugValue: $7f3768da1ed50fcb$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $7f3768da1ed50fcb$var$updateWorkInProgressHook();
        return $7f3768da1ed50fcb$var$updateDeferredValueImpl(hook, $7f3768da1ed50fcb$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $7f3768da1ed50fcb$var$updateReducer($7f3768da1ed50fcb$var$basicStateReducer)[0], start = $7f3768da1ed50fcb$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $7f3768da1ed50fcb$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $7f3768da1ed50fcb$var$updateSyncExternalStore,
    useId: $7f3768da1ed50fcb$var$updateId,
    useHostTransitionStatus: $7f3768da1ed50fcb$var$useHostTransitionStatus,
    useFormState: $7f3768da1ed50fcb$var$updateActionState,
    useActionState: $7f3768da1ed50fcb$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $7f3768da1ed50fcb$var$updateWorkInProgressHook();
        return $7f3768da1ed50fcb$var$updateOptimisticImpl(hook, $7f3768da1ed50fcb$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $7f3768da1ed50fcb$var$useMemoCache,
    useCacheRefresh: $7f3768da1ed50fcb$var$updateRefresh
}, $7f3768da1ed50fcb$var$HooksDispatcherOnRerender = {
    readContext: $7f3768da1ed50fcb$var$readContext,
    use: $7f3768da1ed50fcb$var$use,
    useCallback: $7f3768da1ed50fcb$var$updateCallback,
    useContext: $7f3768da1ed50fcb$var$readContext,
    useEffect: $7f3768da1ed50fcb$var$updateEffect,
    useImperativeHandle: $7f3768da1ed50fcb$var$updateImperativeHandle,
    useInsertionEffect: $7f3768da1ed50fcb$var$updateInsertionEffect,
    useLayoutEffect: $7f3768da1ed50fcb$var$updateLayoutEffect,
    useMemo: $7f3768da1ed50fcb$var$updateMemo,
    useReducer: $7f3768da1ed50fcb$var$rerenderReducer,
    useRef: $7f3768da1ed50fcb$var$updateRef,
    useState: function() {
        return $7f3768da1ed50fcb$var$rerenderReducer($7f3768da1ed50fcb$var$basicStateReducer);
    },
    useDebugValue: $7f3768da1ed50fcb$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $7f3768da1ed50fcb$var$updateWorkInProgressHook();
        return null === $7f3768da1ed50fcb$var$currentHook ? $7f3768da1ed50fcb$var$mountDeferredValueImpl(hook, value, initialValue) : $7f3768da1ed50fcb$var$updateDeferredValueImpl(hook, $7f3768da1ed50fcb$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $7f3768da1ed50fcb$var$rerenderReducer($7f3768da1ed50fcb$var$basicStateReducer)[0], start = $7f3768da1ed50fcb$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $7f3768da1ed50fcb$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $7f3768da1ed50fcb$var$updateSyncExternalStore,
    useId: $7f3768da1ed50fcb$var$updateId,
    useHostTransitionStatus: $7f3768da1ed50fcb$var$useHostTransitionStatus,
    useFormState: $7f3768da1ed50fcb$var$rerenderActionState,
    useActionState: $7f3768da1ed50fcb$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $7f3768da1ed50fcb$var$updateWorkInProgressHook();
        if (null !== $7f3768da1ed50fcb$var$currentHook) return $7f3768da1ed50fcb$var$updateOptimisticImpl(hook, $7f3768da1ed50fcb$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $7f3768da1ed50fcb$var$useMemoCache,
    useCacheRefresh: $7f3768da1ed50fcb$var$updateRefresh
}, $7f3768da1ed50fcb$var$thenableState = null, $7f3768da1ed50fcb$var$thenableIndexCounter = 0;
function $7f3768da1ed50fcb$var$unwrapThenable(thenable) {
    var index = $7f3768da1ed50fcb$var$thenableIndexCounter;
    $7f3768da1ed50fcb$var$thenableIndexCounter += 1;
    null === $7f3768da1ed50fcb$var$thenableState && ($7f3768da1ed50fcb$var$thenableState = []);
    return $7f3768da1ed50fcb$var$trackUsedThenable($7f3768da1ed50fcb$var$thenableState, thenable, index);
}
function $7f3768da1ed50fcb$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $7f3768da1ed50fcb$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $7f3768da1ed50fcb$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $7f3768da1ed50fcb$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $7f3768da1ed50fcb$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $7f3768da1ed50fcb$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $7f3768da1ed50fcb$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $7f3768da1ed50fcb$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $7f3768da1ed50fcb$var$REACT_LAZY_TYPE && $7f3768da1ed50fcb$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $7f3768da1ed50fcb$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $7f3768da1ed50fcb$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $7f3768da1ed50fcb$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $7f3768da1ed50fcb$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $7f3768da1ed50fcb$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $7f3768da1ed50fcb$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $7f3768da1ed50fcb$var$REACT_ELEMENT_TYPE:
                    return lanes = $7f3768da1ed50fcb$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $7f3768da1ed50fcb$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $7f3768da1ed50fcb$var$REACT_PORTAL_TYPE:
                    return newChild = $7f3768da1ed50fcb$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $7f3768da1ed50fcb$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($7f3768da1ed50fcb$var$isArrayImpl(newChild) || $7f3768da1ed50fcb$var$getIteratorFn(newChild)) return newChild = $7f3768da1ed50fcb$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $7f3768da1ed50fcb$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $7f3768da1ed50fcb$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $7f3768da1ed50fcb$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $7f3768da1ed50fcb$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $7f3768da1ed50fcb$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $7f3768da1ed50fcb$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $7f3768da1ed50fcb$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($7f3768da1ed50fcb$var$isArrayImpl(newChild) || $7f3768da1ed50fcb$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $7f3768da1ed50fcb$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $7f3768da1ed50fcb$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $7f3768da1ed50fcb$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $7f3768da1ed50fcb$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $7f3768da1ed50fcb$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $7f3768da1ed50fcb$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $7f3768da1ed50fcb$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($7f3768da1ed50fcb$var$isArrayImpl(newChild) || $7f3768da1ed50fcb$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $7f3768da1ed50fcb$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $7f3768da1ed50fcb$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $7f3768da1ed50fcb$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $7f3768da1ed50fcb$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $7f3768da1ed50fcb$var$isHydrating && $7f3768da1ed50fcb$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $7f3768da1ed50fcb$var$isHydrating && $7f3768da1ed50fcb$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $7f3768da1ed50fcb$var$isHydrating && $7f3768da1ed50fcb$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $7f3768da1ed50fcb$var$isHydrating && $7f3768da1ed50fcb$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $7f3768da1ed50fcb$var$isHydrating && $7f3768da1ed50fcb$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $7f3768da1ed50fcb$var$isHydrating && $7f3768da1ed50fcb$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $7f3768da1ed50fcb$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $7f3768da1ed50fcb$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $7f3768da1ed50fcb$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $7f3768da1ed50fcb$var$REACT_LAZY_TYPE && $7f3768da1ed50fcb$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $7f3768da1ed50fcb$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $7f3768da1ed50fcb$var$REACT_FRAGMENT_TYPE ? (lanes = $7f3768da1ed50fcb$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $7f3768da1ed50fcb$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $7f3768da1ed50fcb$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $7f3768da1ed50fcb$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $7f3768da1ed50fcb$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $7f3768da1ed50fcb$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($7f3768da1ed50fcb$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($7f3768da1ed50fcb$var$getIteratorFn(newChild)) {
                key = $7f3768da1ed50fcb$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $7f3768da1ed50fcb$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $7f3768da1ed50fcb$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $7f3768da1ed50fcb$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $7f3768da1ed50fcb$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $7f3768da1ed50fcb$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $7f3768da1ed50fcb$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $7f3768da1ed50fcb$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $7f3768da1ed50fcb$var$SuspenseException || x === $7f3768da1ed50fcb$var$SuspenseActionException) throw x;
            var fiber = $7f3768da1ed50fcb$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $7f3768da1ed50fcb$var$reconcileChildFibers = $7f3768da1ed50fcb$var$createChildReconciler(!0), $7f3768da1ed50fcb$var$mountChildFibers = $7f3768da1ed50fcb$var$createChildReconciler(!1), $7f3768da1ed50fcb$var$suspenseHandlerStackCursor = $7f3768da1ed50fcb$var$createCursor(null), $7f3768da1ed50fcb$var$shellBoundary = null;
function $7f3768da1ed50fcb$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$suspenseStackCursor, $7f3768da1ed50fcb$var$suspenseStackCursor.current & 1);
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$suspenseHandlerStackCursor, handler);
    null === $7f3768da1ed50fcb$var$shellBoundary && (null === current || null !== $7f3768da1ed50fcb$var$currentTreeHiddenStackCursor.current ? $7f3768da1ed50fcb$var$shellBoundary = handler : null !== current.memoizedState && ($7f3768da1ed50fcb$var$shellBoundary = handler));
}
function $7f3768da1ed50fcb$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$suspenseStackCursor, $7f3768da1ed50fcb$var$suspenseStackCursor.current), $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$suspenseHandlerStackCursor, fiber), null === $7f3768da1ed50fcb$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($7f3768da1ed50fcb$var$shellBoundary = fiber);
        }
    } else $7f3768da1ed50fcb$var$reuseSuspenseHandlerOnStack(fiber);
}
function $7f3768da1ed50fcb$var$reuseSuspenseHandlerOnStack() {
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$suspenseStackCursor, $7f3768da1ed50fcb$var$suspenseStackCursor.current);
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$suspenseHandlerStackCursor, $7f3768da1ed50fcb$var$suspenseHandlerStackCursor.current);
}
function $7f3768da1ed50fcb$var$popSuspenseHandler(fiber) {
    $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$suspenseHandlerStackCursor);
    $7f3768da1ed50fcb$var$shellBoundary === fiber && ($7f3768da1ed50fcb$var$shellBoundary = null);
    $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$suspenseStackCursor);
}
var $7f3768da1ed50fcb$var$suspenseStackCursor = $7f3768da1ed50fcb$var$createCursor(0);
function $7f3768da1ed50fcb$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $7f3768da1ed50fcb$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $7f3768da1ed50fcb$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $7f3768da1ed50fcb$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $7f3768da1ed50fcb$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $7f3768da1ed50fcb$var$requestUpdateLane(), update = $7f3768da1ed50fcb$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $7f3768da1ed50fcb$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($7f3768da1ed50fcb$var$scheduleUpdateOnFiber(payload, inst, lane), $7f3768da1ed50fcb$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $7f3768da1ed50fcb$var$requestUpdateLane(), update = $7f3768da1ed50fcb$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $7f3768da1ed50fcb$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($7f3768da1ed50fcb$var$scheduleUpdateOnFiber(payload, inst, lane), $7f3768da1ed50fcb$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $7f3768da1ed50fcb$var$requestUpdateLane(), update = $7f3768da1ed50fcb$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $7f3768da1ed50fcb$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($7f3768da1ed50fcb$var$scheduleUpdateOnFiber(callback, inst, lane), $7f3768da1ed50fcb$var$entangleTransitions(callback, inst, lane));
    }
};
function $7f3768da1ed50fcb$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$7f3768da1ed50fcb$var$shallowEqual(oldProps, newProps) || !$7f3768da1ed50fcb$var$shallowEqual(oldState, newState) : !0;
}
function $7f3768da1ed50fcb$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $7f3768da1ed50fcb$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $7f3768da1ed50fcb$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $7f3768da1ed50fcb$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $7f3768da1ed50fcb$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $7f3768da1ed50fcb$var$defaultOnUncaughtError(error) {
    $7f3768da1ed50fcb$var$reportGlobalError(error);
}
function $7f3768da1ed50fcb$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $7f3768da1ed50fcb$var$defaultOnRecoverableError(error) {
    $7f3768da1ed50fcb$var$reportGlobalError(error);
}
function $7f3768da1ed50fcb$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $7f3768da1ed50fcb$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $7f3768da1ed50fcb$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $7f3768da1ed50fcb$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $7f3768da1ed50fcb$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $7f3768da1ed50fcb$var$createClassErrorUpdate(lane) {
    lane = $7f3768da1ed50fcb$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $7f3768da1ed50fcb$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $7f3768da1ed50fcb$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $7f3768da1ed50fcb$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $7f3768da1ed50fcb$var$legacyErrorBoundariesThatAlreadyFailed ? $7f3768da1ed50fcb$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $7f3768da1ed50fcb$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $7f3768da1ed50fcb$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $7f3768da1ed50fcb$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $7f3768da1ed50fcb$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $7f3768da1ed50fcb$var$shellBoundary ? $7f3768da1ed50fcb$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $7f3768da1ed50fcb$var$workInProgressRootExitStatus && ($7f3768da1ed50fcb$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $7f3768da1ed50fcb$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $7f3768da1ed50fcb$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $7f3768da1ed50fcb$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $7f3768da1ed50fcb$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $7f3768da1ed50fcb$var$attachPingListener(root, value, rootRenderLanes);
        $7f3768da1ed50fcb$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($7f3768da1ed50fcb$var$isHydrating) return returnFiber = $7f3768da1ed50fcb$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $7f3768da1ed50fcb$var$HydrationMismatchException && (root = Error($7f3768da1ed50fcb$var$formatProdErrorMessage(422), {
        cause: value
    }), $7f3768da1ed50fcb$var$queueHydrationError($7f3768da1ed50fcb$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $7f3768da1ed50fcb$var$HydrationMismatchException && (returnFiber = Error($7f3768da1ed50fcb$var$formatProdErrorMessage(423), {
        cause: value
    }), $7f3768da1ed50fcb$var$queueHydrationError($7f3768da1ed50fcb$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $7f3768da1ed50fcb$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $7f3768da1ed50fcb$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $7f3768da1ed50fcb$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $7f3768da1ed50fcb$var$workInProgressRootExitStatus && ($7f3768da1ed50fcb$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($7f3768da1ed50fcb$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $7f3768da1ed50fcb$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $7f3768da1ed50fcb$var$workInProgressRootConcurrentErrors ? $7f3768da1ed50fcb$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $7f3768da1ed50fcb$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $7f3768da1ed50fcb$var$workInProgressRootExitStatus && ($7f3768da1ed50fcb$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $7f3768da1ed50fcb$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $7f3768da1ed50fcb$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $7f3768da1ed50fcb$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $7f3768da1ed50fcb$var$legacyErrorBoundariesThatAlreadyFailed || !$7f3768da1ed50fcb$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $7f3768da1ed50fcb$var$createClassErrorUpdate(rootRenderLanes), $7f3768da1ed50fcb$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $7f3768da1ed50fcb$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $7f3768da1ed50fcb$var$SelectiveHydrationException = Error($7f3768da1ed50fcb$var$formatProdErrorMessage(461)), $7f3768da1ed50fcb$var$didReceiveUpdate = !1;
function $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $7f3768da1ed50fcb$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $7f3768da1ed50fcb$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $7f3768da1ed50fcb$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $7f3768da1ed50fcb$var$prepareToReadContext(workInProgress);
    nextProps = $7f3768da1ed50fcb$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $7f3768da1ed50fcb$var$checkDidRenderIdHook();
    if (null !== current && !$7f3768da1ed50fcb$var$didReceiveUpdate) return $7f3768da1ed50fcb$var$bailoutHooks(current, workInProgress, renderLanes), $7f3768da1ed50fcb$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $7f3768da1ed50fcb$var$isHydrating && key && $7f3768da1ed50fcb$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $7f3768da1ed50fcb$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$7f3768da1ed50fcb$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $7f3768da1ed50fcb$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $7f3768da1ed50fcb$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$7f3768da1ed50fcb$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $7f3768da1ed50fcb$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $7f3768da1ed50fcb$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $7f3768da1ed50fcb$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $7f3768da1ed50fcb$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($7f3768da1ed50fcb$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($7f3768da1ed50fcb$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $7f3768da1ed50fcb$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($7f3768da1ed50fcb$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $7f3768da1ed50fcb$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $7f3768da1ed50fcb$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $7f3768da1ed50fcb$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $7f3768da1ed50fcb$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $7f3768da1ed50fcb$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $7f3768da1ed50fcb$var$pushHiddenContext(workInProgress, prevState) : $7f3768da1ed50fcb$var$reuseHiddenContextOnStack(), $7f3768da1ed50fcb$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $7f3768da1ed50fcb$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($7f3768da1ed50fcb$var$pushTransition(workInProgress, prevState.cachePool), $7f3768da1ed50fcb$var$pushHiddenContext(workInProgress, prevState), $7f3768da1ed50fcb$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $7f3768da1ed50fcb$var$pushTransition(workInProgress, null), $7f3768da1ed50fcb$var$reuseHiddenContextOnStack(), $7f3768da1ed50fcb$var$reuseSuspenseHandlerOnStack(workInProgress));
    $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $7f3768da1ed50fcb$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $7f3768da1ed50fcb$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $7f3768da1ed50fcb$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $7f3768da1ed50fcb$var$pushTransition(workInProgress, null);
    $7f3768da1ed50fcb$var$reuseHiddenContextOnStack();
    $7f3768da1ed50fcb$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $7f3768da1ed50fcb$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $7f3768da1ed50fcb$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $7f3768da1ed50fcb$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $7f3768da1ed50fcb$var$prepareToReadContext(workInProgress);
    Component = $7f3768da1ed50fcb$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $7f3768da1ed50fcb$var$checkDidRenderIdHook();
    if (null !== current && !$7f3768da1ed50fcb$var$didReceiveUpdate) return $7f3768da1ed50fcb$var$bailoutHooks(current, workInProgress, renderLanes), $7f3768da1ed50fcb$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $7f3768da1ed50fcb$var$isHydrating && nextProps && $7f3768da1ed50fcb$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $7f3768da1ed50fcb$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $7f3768da1ed50fcb$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $7f3768da1ed50fcb$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $7f3768da1ed50fcb$var$finishRenderingHooks(current);
    Component = $7f3768da1ed50fcb$var$checkDidRenderIdHook();
    if (null !== current && !$7f3768da1ed50fcb$var$didReceiveUpdate) return $7f3768da1ed50fcb$var$bailoutHooks(current, workInProgress, renderLanes), $7f3768da1ed50fcb$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $7f3768da1ed50fcb$var$isHydrating && Component && $7f3768da1ed50fcb$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $7f3768da1ed50fcb$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $7f3768da1ed50fcb$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $7f3768da1ed50fcb$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $7f3768da1ed50fcb$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $7f3768da1ed50fcb$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $7f3768da1ed50fcb$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $7f3768da1ed50fcb$var$readContext(contextType) : $7f3768da1ed50fcb$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($7f3768da1ed50fcb$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $7f3768da1ed50fcb$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $7f3768da1ed50fcb$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $7f3768da1ed50fcb$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $7f3768da1ed50fcb$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $7f3768da1ed50fcb$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $7f3768da1ed50fcb$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $7f3768da1ed50fcb$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $7f3768da1ed50fcb$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $7f3768da1ed50fcb$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $7f3768da1ed50fcb$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $7f3768da1ed50fcb$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($7f3768da1ed50fcb$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $7f3768da1ed50fcb$var$hasForceUpdate || $7f3768da1ed50fcb$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $7f3768da1ed50fcb$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $7f3768da1ed50fcb$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $7f3768da1ed50fcb$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $7f3768da1ed50fcb$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $7f3768da1ed50fcb$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $7f3768da1ed50fcb$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $7f3768da1ed50fcb$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $7f3768da1ed50fcb$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $7f3768da1ed50fcb$var$hasForceUpdate || null !== current && null !== current.dependencies && $7f3768da1ed50fcb$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($7f3768da1ed50fcb$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $7f3768da1ed50fcb$var$hasForceUpdate || $7f3768da1ed50fcb$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $7f3768da1ed50fcb$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $7f3768da1ed50fcb$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $7f3768da1ed50fcb$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $7f3768da1ed50fcb$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $7f3768da1ed50fcb$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $7f3768da1ed50fcb$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $7f3768da1ed50fcb$var$resetHydrationState();
    workInProgress.flags |= 256;
    $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $7f3768da1ed50fcb$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $7f3768da1ed50fcb$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $7f3768da1ed50fcb$var$getSuspendedCache()
    };
}
function $7f3768da1ed50fcb$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $7f3768da1ed50fcb$var$workInProgressDeferredLane);
    return current;
}
function $7f3768da1ed50fcb$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($7f3768da1ed50fcb$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($7f3768da1ed50fcb$var$isHydrating) {
            showFallback ? $7f3768da1ed50fcb$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $7f3768da1ed50fcb$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($7f3768da1ed50fcb$var$isHydrating) {
                var nextInstance = $7f3768da1ed50fcb$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $7f3768da1ed50fcb$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $7f3768da1ed50fcb$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $7f3768da1ed50fcb$var$treeContextProvider ? {
                            id: $7f3768da1ed50fcb$var$treeContextId,
                            overflow: $7f3768da1ed50fcb$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $7f3768da1ed50fcb$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $7f3768da1ed50fcb$var$hydrationParentFiber = workInProgress, $7f3768da1ed50fcb$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $7f3768da1ed50fcb$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $7f3768da1ed50fcb$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $7f3768da1ed50fcb$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $7f3768da1ed50fcb$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $7f3768da1ed50fcb$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $7f3768da1ed50fcb$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $7f3768da1ed50fcb$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $7f3768da1ed50fcb$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $7f3768da1ed50fcb$var$SUSPENDED_MARKER, nextProps;
        $7f3768da1ed50fcb$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $7f3768da1ed50fcb$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($7f3768da1ed50fcb$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $7f3768da1ed50fcb$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($7f3768da1ed50fcb$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($7f3768da1ed50fcb$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $7f3768da1ed50fcb$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $7f3768da1ed50fcb$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $7f3768da1ed50fcb$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $7f3768da1ed50fcb$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $7f3768da1ed50fcb$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $7f3768da1ed50fcb$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($7f3768da1ed50fcb$var$pushPrimaryTreeSuspenseHandler(workInProgress), $7f3768da1ed50fcb$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($7f3768da1ed50fcb$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $7f3768da1ed50fcb$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $7f3768da1ed50fcb$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($7f3768da1ed50fcb$var$didReceiveUpdate || $7f3768da1ed50fcb$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $7f3768da1ed50fcb$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $7f3768da1ed50fcb$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $7f3768da1ed50fcb$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $7f3768da1ed50fcb$var$enqueueConcurrentRenderForLane(current, nextProps), $7f3768da1ed50fcb$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $7f3768da1ed50fcb$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $7f3768da1ed50fcb$var$renderDidSuspendDelayIfPossible();
            workInProgress = $7f3768da1ed50fcb$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $7f3768da1ed50fcb$var$nextHydratableInstance = $7f3768da1ed50fcb$var$getNextHydratable(nextInstance.nextSibling), $7f3768da1ed50fcb$var$hydrationParentFiber = workInProgress, $7f3768da1ed50fcb$var$isHydrating = !0, $7f3768da1ed50fcb$var$hydrationErrors = null, $7f3768da1ed50fcb$var$rootOrSingletonContext = !1, null !== current && ($7f3768da1ed50fcb$var$idStack[$7f3768da1ed50fcb$var$idStackIndex++] = $7f3768da1ed50fcb$var$treeContextId, $7f3768da1ed50fcb$var$idStack[$7f3768da1ed50fcb$var$idStackIndex++] = $7f3768da1ed50fcb$var$treeContextOverflow, $7f3768da1ed50fcb$var$idStack[$7f3768da1ed50fcb$var$idStackIndex++] = $7f3768da1ed50fcb$var$treeContextProvider, $7f3768da1ed50fcb$var$treeContextId = current.id, $7f3768da1ed50fcb$var$treeContextOverflow = current.overflow, $7f3768da1ed50fcb$var$treeContextProvider = workInProgress), workInProgress = $7f3768da1ed50fcb$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $7f3768da1ed50fcb$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $7f3768da1ed50fcb$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $7f3768da1ed50fcb$var$createWorkInProgress(digest, showFallback) : (showFallback = $7f3768da1ed50fcb$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $7f3768da1ed50fcb$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $7f3768da1ed50fcb$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $7f3768da1ed50fcb$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $7f3768da1ed50fcb$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $7f3768da1ed50fcb$var$SUSPENDED_MARKER, nextProps;
    $7f3768da1ed50fcb$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $7f3768da1ed50fcb$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $7f3768da1ed50fcb$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $7f3768da1ed50fcb$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $7f3768da1ed50fcb$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $7f3768da1ed50fcb$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $7f3768da1ed50fcb$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $7f3768da1ed50fcb$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $7f3768da1ed50fcb$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $7f3768da1ed50fcb$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $7f3768da1ed50fcb$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $7f3768da1ed50fcb$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $7f3768da1ed50fcb$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $7f3768da1ed50fcb$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $7f3768da1ed50fcb$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $7f3768da1ed50fcb$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $7f3768da1ed50fcb$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $7f3768da1ed50fcb$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $7f3768da1ed50fcb$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $7f3768da1ed50fcb$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $7f3768da1ed50fcb$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $7f3768da1ed50fcb$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $7f3768da1ed50fcb$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($7f3768da1ed50fcb$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $7f3768da1ed50fcb$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $7f3768da1ed50fcb$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $7f3768da1ed50fcb$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $7f3768da1ed50fcb$var$checkIfContextChanged(current) ? !0 : !1;
}
function $7f3768da1ed50fcb$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $7f3768da1ed50fcb$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $7f3768da1ed50fcb$var$pushProvider(workInProgress, $7f3768da1ed50fcb$var$CacheContext, current.memoizedState.cache);
            $7f3768da1ed50fcb$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $7f3768da1ed50fcb$var$pushHostContext(workInProgress);
            break;
        case 4:
            $7f3768da1ed50fcb$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $7f3768da1ed50fcb$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $7f3768da1ed50fcb$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $7f3768da1ed50fcb$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $7f3768da1ed50fcb$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $7f3768da1ed50fcb$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $7f3768da1ed50fcb$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($7f3768da1ed50fcb$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $7f3768da1ed50fcb$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$suspenseStackCursor, $7f3768da1ed50fcb$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $7f3768da1ed50fcb$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $7f3768da1ed50fcb$var$pushProvider(workInProgress, $7f3768da1ed50fcb$var$CacheContext, current.memoizedState.cache);
    }
    return $7f3768da1ed50fcb$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $7f3768da1ed50fcb$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $7f3768da1ed50fcb$var$didReceiveUpdate = !0;
        else {
            if (!$7f3768da1ed50fcb$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $7f3768da1ed50fcb$var$didReceiveUpdate = !1, $7f3768da1ed50fcb$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $7f3768da1ed50fcb$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $7f3768da1ed50fcb$var$didReceiveUpdate = !1, $7f3768da1ed50fcb$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $7f3768da1ed50fcb$var$pushTreeId(workInProgress, $7f3768da1ed50fcb$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $7f3768da1ed50fcb$var$shouldConstruct(lazyComponent) ? (current = $7f3768da1ed50fcb$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $7f3768da1ed50fcb$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $7f3768da1ed50fcb$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $7f3768da1ed50fcb$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $7f3768da1ed50fcb$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $7f3768da1ed50fcb$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $7f3768da1ed50fcb$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $7f3768da1ed50fcb$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $7f3768da1ed50fcb$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $7f3768da1ed50fcb$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $7f3768da1ed50fcb$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $7f3768da1ed50fcb$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $7f3768da1ed50fcb$var$cloneUpdateQueue(current, workInProgress);
                $7f3768da1ed50fcb$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $7f3768da1ed50fcb$var$pushProvider(workInProgress, $7f3768da1ed50fcb$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $7f3768da1ed50fcb$var$propagateContextChanges(workInProgress, [
                    $7f3768da1ed50fcb$var$CacheContext
                ], renderLanes, !0);
                $7f3768da1ed50fcb$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $7f3768da1ed50fcb$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $7f3768da1ed50fcb$var$createCapturedValueAtFiber(Error($7f3768da1ed50fcb$var$formatProdErrorMessage(424)), workInProgress);
                        $7f3768da1ed50fcb$var$queueHydrationError(init);
                        workInProgress = $7f3768da1ed50fcb$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $7f3768da1ed50fcb$var$nextHydratableInstance = $7f3768da1ed50fcb$var$getNextHydratable(current.firstChild);
                        $7f3768da1ed50fcb$var$hydrationParentFiber = workInProgress;
                        $7f3768da1ed50fcb$var$isHydrating = !0;
                        $7f3768da1ed50fcb$var$hydrationErrors = null;
                        $7f3768da1ed50fcb$var$rootOrSingletonContext = !0;
                        renderLanes = $7f3768da1ed50fcb$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $7f3768da1ed50fcb$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $7f3768da1ed50fcb$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $7f3768da1ed50fcb$var$markRef(current, workInProgress), null === current ? (renderLanes = $7f3768da1ed50fcb$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $7f3768da1ed50fcb$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $7f3768da1ed50fcb$var$getOwnerDocumentFromRootContainer($7f3768da1ed50fcb$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$7f3768da1ed50fcb$var$internalInstanceKey] = workInProgress, lazyComponent[$7f3768da1ed50fcb$var$internalPropsKey] = current, $7f3768da1ed50fcb$var$setInitialProperties(lazyComponent, renderLanes, current), $7f3768da1ed50fcb$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $7f3768da1ed50fcb$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $7f3768da1ed50fcb$var$pushHostContext(workInProgress), null === current && $7f3768da1ed50fcb$var$isHydrating && (lazyComponent = workInProgress.stateNode = $7f3768da1ed50fcb$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $7f3768da1ed50fcb$var$rootInstanceStackCursor.current), $7f3768da1ed50fcb$var$hydrationParentFiber = workInProgress, $7f3768da1ed50fcb$var$rootOrSingletonContext = !0, init = $7f3768da1ed50fcb$var$nextHydratableInstance, $7f3768da1ed50fcb$var$isSingletonScope(workInProgress.type) ? ($7f3768da1ed50fcb$var$previousHydratableOnEnteringScopedSingleton = init, $7f3768da1ed50fcb$var$nextHydratableInstance = $7f3768da1ed50fcb$var$getNextHydratable(lazyComponent.firstChild)) : $7f3768da1ed50fcb$var$nextHydratableInstance = init), $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $7f3768da1ed50fcb$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $7f3768da1ed50fcb$var$isHydrating) {
                if (init = lazyComponent = $7f3768da1ed50fcb$var$nextHydratableInstance) lazyComponent = $7f3768da1ed50fcb$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $7f3768da1ed50fcb$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $7f3768da1ed50fcb$var$hydrationParentFiber = workInProgress, $7f3768da1ed50fcb$var$nextHydratableInstance = $7f3768da1ed50fcb$var$getNextHydratable(lazyComponent.firstChild), $7f3768da1ed50fcb$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $7f3768da1ed50fcb$var$throwOnHydrationMismatch(workInProgress);
            }
            $7f3768da1ed50fcb$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $7f3768da1ed50fcb$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $7f3768da1ed50fcb$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $7f3768da1ed50fcb$var$renderWithHooks(current, workInProgress, $7f3768da1ed50fcb$var$TransitionAwareHostComponent, null, null, renderLanes), $7f3768da1ed50fcb$var$HostTransitionContext._currentValue = init);
            $7f3768da1ed50fcb$var$markRef(current, workInProgress);
            $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $7f3768da1ed50fcb$var$isHydrating) {
                if (current = renderLanes = $7f3768da1ed50fcb$var$nextHydratableInstance) renderLanes = $7f3768da1ed50fcb$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $7f3768da1ed50fcb$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $7f3768da1ed50fcb$var$hydrationParentFiber = workInProgress, $7f3768da1ed50fcb$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $7f3768da1ed50fcb$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $7f3768da1ed50fcb$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $7f3768da1ed50fcb$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $7f3768da1ed50fcb$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $7f3768da1ed50fcb$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $7f3768da1ed50fcb$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $7f3768da1ed50fcb$var$prepareToReadContext(workInProgress), init = $7f3768da1ed50fcb$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $7f3768da1ed50fcb$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $7f3768da1ed50fcb$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $7f3768da1ed50fcb$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $7f3768da1ed50fcb$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $7f3768da1ed50fcb$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $7f3768da1ed50fcb$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $7f3768da1ed50fcb$var$prepareToReadContext(workInProgress), lazyComponent = $7f3768da1ed50fcb$var$readContext($7f3768da1ed50fcb$var$CacheContext), null === current ? (init = $7f3768da1ed50fcb$var$peekCacheFromPool(), null === init && (init = $7f3768da1ed50fcb$var$workInProgressRoot, prevState = $7f3768da1ed50fcb$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $7f3768da1ed50fcb$var$initializeUpdateQueue(workInProgress), $7f3768da1ed50fcb$var$pushProvider(workInProgress, $7f3768da1ed50fcb$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($7f3768da1ed50fcb$var$cloneUpdateQueue(current, workInProgress), $7f3768da1ed50fcb$var$processUpdateQueue(workInProgress, null, null, renderLanes), $7f3768da1ed50fcb$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $7f3768da1ed50fcb$var$pushProvider(workInProgress, $7f3768da1ed50fcb$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $7f3768da1ed50fcb$var$pushProvider(workInProgress, $7f3768da1ed50fcb$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $7f3768da1ed50fcb$var$propagateContextChanges(workInProgress, [
                $7f3768da1ed50fcb$var$CacheContext
            ], renderLanes, !0))), $7f3768da1ed50fcb$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $7f3768da1ed50fcb$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $7f3768da1ed50fcb$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$7f3768da1ed50fcb$var$preloadResource(resource)) {
        resource = $7f3768da1ed50fcb$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($7f3768da1ed50fcb$var$workInProgressRootRenderLanes & 4194048) === $7f3768da1ed50fcb$var$workInProgressRootRenderLanes ? null !== $7f3768da1ed50fcb$var$shellBoundary : ($7f3768da1ed50fcb$var$workInProgressRootRenderLanes & 62914560) !== $7f3768da1ed50fcb$var$workInProgressRootRenderLanes && 0 === ($7f3768da1ed50fcb$var$workInProgressRootRenderLanes & 536870912) || resource !== $7f3768da1ed50fcb$var$shellBoundary)) throw $7f3768da1ed50fcb$var$suspendedThenable = $7f3768da1ed50fcb$var$noopSuspenseyCommitThenable, $7f3768da1ed50fcb$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $7f3768da1ed50fcb$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $7f3768da1ed50fcb$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $7f3768da1ed50fcb$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $7f3768da1ed50fcb$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$7f3768da1ed50fcb$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $7f3768da1ed50fcb$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $7f3768da1ed50fcb$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $7f3768da1ed50fcb$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $7f3768da1ed50fcb$var$bubbleProperties(workInProgress), null;
        case 1:
            return $7f3768da1ed50fcb$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $7f3768da1ed50fcb$var$popProvider($7f3768da1ed50fcb$var$CacheContext);
            $7f3768da1ed50fcb$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $7f3768da1ed50fcb$var$popHydrationState(workInProgress) ? $7f3768da1ed50fcb$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $7f3768da1ed50fcb$var$upgradeHydrationErrorsToRecoverable());
            $7f3768da1ed50fcb$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($7f3768da1ed50fcb$var$markUpdate(workInProgress), null !== renderLanes ? ($7f3768da1ed50fcb$var$bubbleProperties(workInProgress), $7f3768da1ed50fcb$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($7f3768da1ed50fcb$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($7f3768da1ed50fcb$var$markUpdate(workInProgress), $7f3768da1ed50fcb$var$bubbleProperties(workInProgress), $7f3768da1ed50fcb$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($7f3768da1ed50fcb$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $7f3768da1ed50fcb$var$markUpdate(workInProgress), $7f3768da1ed50fcb$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $7f3768da1ed50fcb$var$popHostContext(workInProgress);
            renderLanes = $7f3768da1ed50fcb$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $7f3768da1ed50fcb$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(166));
                    $7f3768da1ed50fcb$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $7f3768da1ed50fcb$var$contextStackCursor.current;
                $7f3768da1ed50fcb$var$popHydrationState(workInProgress) ? $7f3768da1ed50fcb$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $7f3768da1ed50fcb$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $7f3768da1ed50fcb$var$markUpdate(workInProgress));
            }
            $7f3768da1ed50fcb$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $7f3768da1ed50fcb$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $7f3768da1ed50fcb$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(166));
                    $7f3768da1ed50fcb$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $7f3768da1ed50fcb$var$contextStackCursor.current;
                if ($7f3768da1ed50fcb$var$popHydrationState(workInProgress)) $7f3768da1ed50fcb$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $7f3768da1ed50fcb$var$getOwnerDocumentFromRootContainer($7f3768da1ed50fcb$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$7f3768da1ed50fcb$var$internalInstanceKey] = workInProgress;
                    current[$7f3768da1ed50fcb$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($7f3768da1ed50fcb$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $7f3768da1ed50fcb$var$markUpdate(workInProgress);
                }
            }
            $7f3768da1ed50fcb$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $7f3768da1ed50fcb$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(166));
                current = $7f3768da1ed50fcb$var$rootInstanceStackCursor.current;
                if ($7f3768da1ed50fcb$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $7f3768da1ed50fcb$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$7f3768da1ed50fcb$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $7f3768da1ed50fcb$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $7f3768da1ed50fcb$var$throwOnHydrationMismatch(workInProgress);
                } else current = $7f3768da1ed50fcb$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$7f3768da1ed50fcb$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $7f3768da1ed50fcb$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $7f3768da1ed50fcb$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(317));
                        type[$7f3768da1ed50fcb$var$internalInstanceKey] = workInProgress;
                    } else $7f3768da1ed50fcb$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $7f3768da1ed50fcb$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $7f3768da1ed50fcb$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $7f3768da1ed50fcb$var$popSuspenseHandler(workInProgress), workInProgress;
                    $7f3768da1ed50fcb$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $7f3768da1ed50fcb$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $7f3768da1ed50fcb$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $7f3768da1ed50fcb$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $7f3768da1ed50fcb$var$popHostContainer(), null === current && $7f3768da1ed50fcb$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $7f3768da1ed50fcb$var$bubbleProperties(workInProgress), null;
        case 10:
            return $7f3768da1ed50fcb$var$popProvider(workInProgress.type), $7f3768da1ed50fcb$var$bubbleProperties(workInProgress), null;
        case 19:
            $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $7f3768da1ed50fcb$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $7f3768da1ed50fcb$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $7f3768da1ed50fcb$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $7f3768da1ed50fcb$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $7f3768da1ed50fcb$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $7f3768da1ed50fcb$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$7f3768da1ed50fcb$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$suspenseStackCursor, $7f3768da1ed50fcb$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $7f3768da1ed50fcb$var$now() > $7f3768da1ed50fcb$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $7f3768da1ed50fcb$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $7f3768da1ed50fcb$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $7f3768da1ed50fcb$var$scheduleRetryEffect(workInProgress, current), $7f3768da1ed50fcb$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$7f3768da1ed50fcb$var$isHydrating) return $7f3768da1ed50fcb$var$bubbleProperties(workInProgress), null;
                    } else 2 * $7f3768da1ed50fcb$var$now() - type.renderingStartTime > $7f3768da1ed50fcb$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $7f3768da1ed50fcb$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $7f3768da1ed50fcb$var$now(), workInProgress.sibling = null, current = $7f3768da1ed50fcb$var$suspenseStackCursor.current, $7f3768da1ed50fcb$var$push($7f3768da1ed50fcb$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $7f3768da1ed50fcb$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $7f3768da1ed50fcb$var$popSuspenseHandler(workInProgress), $7f3768da1ed50fcb$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($7f3768da1ed50fcb$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $7f3768da1ed50fcb$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $7f3768da1ed50fcb$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $7f3768da1ed50fcb$var$popProvider($7f3768da1ed50fcb$var$CacheContext), $7f3768da1ed50fcb$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $7f3768da1ed50fcb$var$unwindWork(current, workInProgress) {
    $7f3768da1ed50fcb$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $7f3768da1ed50fcb$var$popProvider($7f3768da1ed50fcb$var$CacheContext), $7f3768da1ed50fcb$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $7f3768da1ed50fcb$var$popHostContext(workInProgress), null;
        case 13:
            $7f3768da1ed50fcb$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(340));
                $7f3768da1ed50fcb$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$suspenseStackCursor), null;
        case 4:
            return $7f3768da1ed50fcb$var$popHostContainer(), null;
        case 10:
            return $7f3768da1ed50fcb$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $7f3768da1ed50fcb$var$popSuspenseHandler(workInProgress), $7f3768da1ed50fcb$var$popHiddenContext(), null !== current && $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $7f3768da1ed50fcb$var$popProvider($7f3768da1ed50fcb$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $7f3768da1ed50fcb$var$unwindInterruptedWork(current, interruptedWork) {
    $7f3768da1ed50fcb$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $7f3768da1ed50fcb$var$popProvider($7f3768da1ed50fcb$var$CacheContext);
            $7f3768da1ed50fcb$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $7f3768da1ed50fcb$var$popHostContext(interruptedWork);
            break;
        case 4:
            $7f3768da1ed50fcb$var$popHostContainer();
            break;
        case 13:
            $7f3768da1ed50fcb$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$suspenseStackCursor);
            break;
        case 10:
            $7f3768da1ed50fcb$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $7f3768da1ed50fcb$var$popSuspenseHandler(interruptedWork);
            $7f3768da1ed50fcb$var$popHiddenContext();
            null !== current && $7f3768da1ed50fcb$var$pop($7f3768da1ed50fcb$var$resumedCache);
            break;
        case 24:
            $7f3768da1ed50fcb$var$popProvider($7f3768da1ed50fcb$var$CacheContext);
    }
}
function $7f3768da1ed50fcb$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $7f3768da1ed50fcb$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $7f3768da1ed50fcb$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $7f3768da1ed50fcb$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $7f3768da1ed50fcb$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $7f3768da1ed50fcb$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $7f3768da1ed50fcb$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $7f3768da1ed50fcb$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $7f3768da1ed50fcb$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $7f3768da1ed50fcb$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $7f3768da1ed50fcb$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $7f3768da1ed50fcb$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $7f3768da1ed50fcb$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $7f3768da1ed50fcb$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $7f3768da1ed50fcb$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $7f3768da1ed50fcb$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$7f3768da1ed50fcb$var$internalPropsKey] = newProps;
    } catch (error) {
        $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $7f3768da1ed50fcb$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $7f3768da1ed50fcb$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $7f3768da1ed50fcb$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $7f3768da1ed50fcb$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $7f3768da1ed50fcb$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $7f3768da1ed50fcb$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $7f3768da1ed50fcb$var$noop$1));
    else if (4 !== tag && (27 === tag && $7f3768da1ed50fcb$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($7f3768da1ed50fcb$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$7f3768da1ed50fcb$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $7f3768da1ed50fcb$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $7f3768da1ed50fcb$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($7f3768da1ed50fcb$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$7f3768da1ed50fcb$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $7f3768da1ed50fcb$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $7f3768da1ed50fcb$var$setInitialProperties(singleton, type, props);
        singleton[$7f3768da1ed50fcb$var$internalInstanceKey] = finishedWork;
        singleton[$7f3768da1ed50fcb$var$internalPropsKey] = props;
    } catch (error) {
        $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $7f3768da1ed50fcb$var$offscreenSubtreeIsHidden = !1, $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden = !1, $7f3768da1ed50fcb$var$needsFormReset = !1, $7f3768da1ed50fcb$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $7f3768da1ed50fcb$var$nextEffect = null;
function $7f3768da1ed50fcb$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $7f3768da1ed50fcb$var$eventsEnabled = $7f3768da1ed50fcb$var$_enabled;
    root = $7f3768da1ed50fcb$var$getActiveElementDeep(root);
    if ($7f3768da1ed50fcb$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $7f3768da1ed50fcb$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $7f3768da1ed50fcb$var$_enabled = !1;
    for($7f3768da1ed50fcb$var$nextEffect = firstChild; null !== $7f3768da1ed50fcb$var$nextEffect;)if (firstChild = $7f3768da1ed50fcb$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $7f3768da1ed50fcb$var$nextEffect = root;
    else for(; null !== $7f3768da1ed50fcb$var$nextEffect;){
        firstChild = $7f3768da1ed50fcb$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $7f3768da1ed50fcb$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $7f3768da1ed50fcb$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $7f3768da1ed50fcb$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $7f3768da1ed50fcb$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $7f3768da1ed50fcb$var$nextEffect = root;
            break;
        }
        $7f3768da1ed50fcb$var$nextEffect = firstChild.return;
    }
}
function $7f3768da1ed50fcb$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $7f3768da1ed50fcb$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $7f3768da1ed50fcb$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $7f3768da1ed50fcb$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $7f3768da1ed50fcb$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $7f3768da1ed50fcb$var$commitClassCallbacks(finishedWork);
            flags & 512 && $7f3768da1ed50fcb$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $7f3768da1ed50fcb$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $7f3768da1ed50fcb$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $7f3768da1ed50fcb$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $7f3768da1ed50fcb$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $7f3768da1ed50fcb$var$commitHostMount(finishedWork);
            flags & 512 && $7f3768da1ed50fcb$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $7f3768da1ed50fcb$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $7f3768da1ed50fcb$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $7f3768da1ed50fcb$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $7f3768da1ed50fcb$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $7f3768da1ed50fcb$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $7f3768da1ed50fcb$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden;
                prevProps = $7f3768da1ed50fcb$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden;
                $7f3768da1ed50fcb$var$offscreenSubtreeIsHidden = flags;
                ($7f3768da1ed50fcb$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $7f3768da1ed50fcb$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $7f3768da1ed50fcb$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $7f3768da1ed50fcb$var$offscreenSubtreeIsHidden = prevProps;
                $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $7f3768da1ed50fcb$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $7f3768da1ed50fcb$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $7f3768da1ed50fcb$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $7f3768da1ed50fcb$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $7f3768da1ed50fcb$var$hostParent = null, $7f3768da1ed50fcb$var$hostParentIsContainer = !1;
function $7f3768da1ed50fcb$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$7f3768da1ed50fcb$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $7f3768da1ed50fcb$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($7f3768da1ed50fcb$var$injectedHook && "function" === typeof $7f3768da1ed50fcb$var$injectedHook.onCommitFiberUnmount) try {
        $7f3768da1ed50fcb$var$injectedHook.onCommitFiberUnmount($7f3768da1ed50fcb$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden || $7f3768da1ed50fcb$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $7f3768da1ed50fcb$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden || $7f3768da1ed50fcb$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $7f3768da1ed50fcb$var$hostParent, prevHostParentIsContainer = $7f3768da1ed50fcb$var$hostParentIsContainer;
            $7f3768da1ed50fcb$var$isSingletonScope(deletedFiber.type) && ($7f3768da1ed50fcb$var$hostParent = deletedFiber.stateNode, $7f3768da1ed50fcb$var$hostParentIsContainer = !1);
            $7f3768da1ed50fcb$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $7f3768da1ed50fcb$var$releaseSingletonInstance(deletedFiber.stateNode);
            $7f3768da1ed50fcb$var$hostParent = prevHostParent;
            $7f3768da1ed50fcb$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden || $7f3768da1ed50fcb$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $7f3768da1ed50fcb$var$hostParent;
            prevHostParentIsContainer = $7f3768da1ed50fcb$var$hostParentIsContainer;
            $7f3768da1ed50fcb$var$hostParent = null;
            $7f3768da1ed50fcb$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $7f3768da1ed50fcb$var$hostParent = prevHostParent;
            $7f3768da1ed50fcb$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $7f3768da1ed50fcb$var$hostParent) {
                if ($7f3768da1ed50fcb$var$hostParentIsContainer) try {
                    (9 === $7f3768da1ed50fcb$var$hostParent.nodeType ? $7f3768da1ed50fcb$var$hostParent.body : "HTML" === $7f3768da1ed50fcb$var$hostParent.nodeName ? $7f3768da1ed50fcb$var$hostParent.ownerDocument.body : $7f3768da1ed50fcb$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $7f3768da1ed50fcb$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $7f3768da1ed50fcb$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $7f3768da1ed50fcb$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $7f3768da1ed50fcb$var$hostParent && ($7f3768da1ed50fcb$var$hostParentIsContainer ? (finishedRoot = $7f3768da1ed50fcb$var$hostParent, $7f3768da1ed50fcb$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $7f3768da1ed50fcb$var$retryIfBlockedOn(finishedRoot)) : $7f3768da1ed50fcb$var$clearSuspenseBoundary($7f3768da1ed50fcb$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $7f3768da1ed50fcb$var$hostParent;
            prevHostParentIsContainer = $7f3768da1ed50fcb$var$hostParentIsContainer;
            $7f3768da1ed50fcb$var$hostParent = deletedFiber.stateNode.containerInfo;
            $7f3768da1ed50fcb$var$hostParentIsContainer = !0;
            $7f3768da1ed50fcb$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $7f3768da1ed50fcb$var$hostParent = prevHostParent;
            $7f3768da1ed50fcb$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden || $7f3768da1ed50fcb$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden || $7f3768da1ed50fcb$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $7f3768da1ed50fcb$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden || ($7f3768da1ed50fcb$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $7f3768da1ed50fcb$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $7f3768da1ed50fcb$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $7f3768da1ed50fcb$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden = (prevHostParent = $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $7f3768da1ed50fcb$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $7f3768da1ed50fcb$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $7f3768da1ed50fcb$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $7f3768da1ed50fcb$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $7f3768da1ed50fcb$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $7f3768da1ed50fcb$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $7f3768da1ed50fcb$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $7f3768da1ed50fcb$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $7f3768da1ed50fcb$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $7f3768da1ed50fcb$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($7f3768da1ed50fcb$var$isSingletonScope(parent.type)) {
                        $7f3768da1ed50fcb$var$hostParent = parent.stateNode;
                        $7f3768da1ed50fcb$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $7f3768da1ed50fcb$var$hostParent = parent.stateNode;
                    $7f3768da1ed50fcb$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $7f3768da1ed50fcb$var$hostParent = parent.stateNode.containerInfo;
                    $7f3768da1ed50fcb$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $7f3768da1ed50fcb$var$hostParent) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(160));
        $7f3768da1ed50fcb$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $7f3768da1ed50fcb$var$hostParent = null;
        $7f3768da1ed50fcb$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$7f3768da1ed50fcb$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $7f3768da1ed50fcb$var$currentHoistableRoot = null;
function $7f3768da1ed50fcb$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($7f3768da1ed50fcb$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $7f3768da1ed50fcb$var$commitHookEffectListMount(3, finishedWork), $7f3768da1ed50fcb$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($7f3768da1ed50fcb$var$offscreenSubtreeWasHidden || null === current || $7f3768da1ed50fcb$var$safelyDetachRef(current, current.return));
            flags & 64 && $7f3768da1ed50fcb$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $7f3768da1ed50fcb$var$currentHoistableRoot;
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($7f3768da1ed50fcb$var$offscreenSubtreeWasHidden || null === current || $7f3768da1ed50fcb$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$7f3768da1ed50fcb$var$internalHoistableMarker] || currentResource[$7f3768da1ed50fcb$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $7f3768da1ed50fcb$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$7f3768da1ed50fcb$var$internalInstanceKey] = finishedWork;
                                        $7f3768da1ed50fcb$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $7f3768da1ed50fcb$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $7f3768da1ed50fcb$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $7f3768da1ed50fcb$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $7f3768da1ed50fcb$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$7f3768da1ed50fcb$var$internalInstanceKey] = finishedWork;
                                $7f3768da1ed50fcb$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $7f3768da1ed50fcb$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $7f3768da1ed50fcb$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $7f3768da1ed50fcb$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $7f3768da1ed50fcb$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $7f3768da1ed50fcb$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($7f3768da1ed50fcb$var$offscreenSubtreeWasHidden || null === current || $7f3768da1ed50fcb$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $7f3768da1ed50fcb$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($7f3768da1ed50fcb$var$offscreenSubtreeWasHidden || null === current || $7f3768da1ed50fcb$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $7f3768da1ed50fcb$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $7f3768da1ed50fcb$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($7f3768da1ed50fcb$var$needsFormReset = !0);
            break;
        case 6:
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $7f3768da1ed50fcb$var$tagCaches = null;
            hoistableRoot = $7f3768da1ed50fcb$var$currentHoistableRoot;
            $7f3768da1ed50fcb$var$currentHoistableRoot = $7f3768da1ed50fcb$var$getHoistableRoot(root.containerInfo);
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$currentHoistableRoot = hoistableRoot;
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $7f3768da1ed50fcb$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $7f3768da1ed50fcb$var$needsFormReset && ($7f3768da1ed50fcb$var$needsFormReset = !1, $7f3768da1ed50fcb$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $7f3768da1ed50fcb$var$currentHoistableRoot;
            $7f3768da1ed50fcb$var$currentHoistableRoot = $7f3768da1ed50fcb$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            $7f3768da1ed50fcb$var$currentHoistableRoot = flags;
            break;
        case 12:
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($7f3768da1ed50fcb$var$globalMostRecentFallbackTime = $7f3768da1ed50fcb$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $7f3768da1ed50fcb$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $7f3768da1ed50fcb$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden;
            $7f3768da1ed50fcb$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $7f3768da1ed50fcb$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $7f3768da1ed50fcb$var$offscreenSubtreeIsHidden || $7f3768da1ed50fcb$var$offscreenSubtreeWasHidden || $7f3768da1ed50fcb$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $7f3768da1ed50fcb$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $7f3768da1ed50fcb$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $7f3768da1ed50fcb$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $7f3768da1ed50fcb$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $7f3768da1ed50fcb$var$recursivelyTraverseMutationEffects(root, finishedWork), $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork);
    }
}
function $7f3768da1ed50fcb$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($7f3768da1ed50fcb$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $7f3768da1ed50fcb$var$getHostSibling(finishedWork);
                    $7f3768da1ed50fcb$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($7f3768da1ed50fcb$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $7f3768da1ed50fcb$var$getHostSibling(finishedWork);
                    $7f3768da1ed50fcb$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $7f3768da1ed50fcb$var$getHostSibling(finishedWork);
                    $7f3768da1ed50fcb$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $7f3768da1ed50fcb$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $7f3768da1ed50fcb$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $7f3768da1ed50fcb$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$7f3768da1ed50fcb$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $7f3768da1ed50fcb$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $7f3768da1ed50fcb$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $7f3768da1ed50fcb$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $7f3768da1ed50fcb$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $7f3768da1ed50fcb$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $7f3768da1ed50fcb$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $7f3768da1ed50fcb$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $7f3768da1ed50fcb$var$safelyDetachRef(finishedWork, finishedWork.return);
                $7f3768da1ed50fcb$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $7f3768da1ed50fcb$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $7f3768da1ed50fcb$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $7f3768da1ed50fcb$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $7f3768da1ed50fcb$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $7f3768da1ed50fcb$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $7f3768da1ed50fcb$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $7f3768da1ed50fcb$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $7f3768da1ed50fcb$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$7f3768da1ed50fcb$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $7f3768da1ed50fcb$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $7f3768da1ed50fcb$var$commitClassCallbacks(finishedWork);
                $7f3768da1ed50fcb$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $7f3768da1ed50fcb$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $7f3768da1ed50fcb$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $7f3768da1ed50fcb$var$commitHostMount(finishedWork);
                $7f3768da1ed50fcb$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $7f3768da1ed50fcb$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $7f3768da1ed50fcb$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $7f3768da1ed50fcb$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $7f3768da1ed50fcb$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $7f3768da1ed50fcb$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $7f3768da1ed50fcb$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $7f3768da1ed50fcb$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $7f3768da1ed50fcb$var$releaseCache(previousCache));
}
function $7f3768da1ed50fcb$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $7f3768da1ed50fcb$var$releaseCache(current));
}
function $7f3768da1ed50fcb$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$7f3768da1ed50fcb$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $7f3768da1ed50fcb$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $7f3768da1ed50fcb$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $7f3768da1ed50fcb$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $7f3768da1ed50fcb$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $7f3768da1ed50fcb$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $7f3768da1ed50fcb$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $7f3768da1ed50fcb$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $7f3768da1ed50fcb$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $7f3768da1ed50fcb$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $7f3768da1ed50fcb$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $7f3768da1ed50fcb$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $7f3768da1ed50fcb$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $7f3768da1ed50fcb$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $7f3768da1ed50fcb$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $7f3768da1ed50fcb$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $7f3768da1ed50fcb$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $7f3768da1ed50fcb$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $7f3768da1ed50fcb$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $7f3768da1ed50fcb$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $7f3768da1ed50fcb$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $7f3768da1ed50fcb$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $7f3768da1ed50fcb$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $7f3768da1ed50fcb$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $7f3768da1ed50fcb$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $7f3768da1ed50fcb$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $7f3768da1ed50fcb$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $7f3768da1ed50fcb$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $7f3768da1ed50fcb$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $7f3768da1ed50fcb$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $7f3768da1ed50fcb$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $7f3768da1ed50fcb$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $7f3768da1ed50fcb$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $7f3768da1ed50fcb$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $7f3768da1ed50fcb$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $7f3768da1ed50fcb$var$suspenseyCommitFlag = 8192;
function $7f3768da1ed50fcb$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $7f3768da1ed50fcb$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$7f3768da1ed50fcb$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $7f3768da1ed50fcb$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $7f3768da1ed50fcb$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $7f3768da1ed50fcb$var$suspenseyCommitFlag && null !== fiber.memoizedState && $7f3768da1ed50fcb$var$suspendResource($7f3768da1ed50fcb$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $7f3768da1ed50fcb$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $7f3768da1ed50fcb$var$currentHoistableRoot;
            $7f3768da1ed50fcb$var$currentHoistableRoot = $7f3768da1ed50fcb$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $7f3768da1ed50fcb$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $7f3768da1ed50fcb$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $7f3768da1ed50fcb$var$suspenseyCommitFlag, $7f3768da1ed50fcb$var$suspenseyCommitFlag = 16777216, $7f3768da1ed50fcb$var$recursivelyAccumulateSuspenseyCommit(fiber), $7f3768da1ed50fcb$var$suspenseyCommitFlag = previousHoistableRoot) : $7f3768da1ed50fcb$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $7f3768da1ed50fcb$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $7f3768da1ed50fcb$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $7f3768da1ed50fcb$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $7f3768da1ed50fcb$var$nextEffect = childToDelete;
            $7f3768da1ed50fcb$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $7f3768da1ed50fcb$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$7f3768da1ed50fcb$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $7f3768da1ed50fcb$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $7f3768da1ed50fcb$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $7f3768da1ed50fcb$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $7f3768da1ed50fcb$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $7f3768da1ed50fcb$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $7f3768da1ed50fcb$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $7f3768da1ed50fcb$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $7f3768da1ed50fcb$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $7f3768da1ed50fcb$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $7f3768da1ed50fcb$var$nextEffect = childToDelete;
            $7f3768da1ed50fcb$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $7f3768da1ed50fcb$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $7f3768da1ed50fcb$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $7f3768da1ed50fcb$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $7f3768da1ed50fcb$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $7f3768da1ed50fcb$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $7f3768da1ed50fcb$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $7f3768da1ed50fcb$var$nextEffect;){
        var fiber = $7f3768da1ed50fcb$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $7f3768da1ed50fcb$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $7f3768da1ed50fcb$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $7f3768da1ed50fcb$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $7f3768da1ed50fcb$var$nextEffect;){
            cache = $7f3768da1ed50fcb$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $7f3768da1ed50fcb$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $7f3768da1ed50fcb$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $7f3768da1ed50fcb$var$nextEffect = sibling;
                break a;
            }
            $7f3768da1ed50fcb$var$nextEffect = returnFiber;
        }
    }
}
var $7f3768da1ed50fcb$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $7f3768da1ed50fcb$var$readContext($7f3768da1ed50fcb$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $7f3768da1ed50fcb$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $7f3768da1ed50fcb$var$executionContext = 0, $7f3768da1ed50fcb$var$workInProgressRoot = null, $7f3768da1ed50fcb$var$workInProgress = null, $7f3768da1ed50fcb$var$workInProgressRootRenderLanes = 0, $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 0, $7f3768da1ed50fcb$var$workInProgressThrownValue = null, $7f3768da1ed50fcb$var$workInProgressRootDidSkipSuspendedSiblings = !1, $7f3768da1ed50fcb$var$workInProgressRootIsPrerendering = !1, $7f3768da1ed50fcb$var$workInProgressRootDidAttachPingListener = !1, $7f3768da1ed50fcb$var$entangledRenderLanes = 0, $7f3768da1ed50fcb$var$workInProgressRootExitStatus = 0, $7f3768da1ed50fcb$var$workInProgressRootSkippedLanes = 0, $7f3768da1ed50fcb$var$workInProgressRootInterleavedUpdatedLanes = 0, $7f3768da1ed50fcb$var$workInProgressRootPingedLanes = 0, $7f3768da1ed50fcb$var$workInProgressDeferredLane = 0, $7f3768da1ed50fcb$var$workInProgressSuspendedRetryLanes = 0, $7f3768da1ed50fcb$var$workInProgressRootConcurrentErrors = null, $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors = null, $7f3768da1ed50fcb$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $7f3768da1ed50fcb$var$globalMostRecentFallbackTime = 0, $7f3768da1ed50fcb$var$workInProgressRootRenderTargetTime = Infinity, $7f3768da1ed50fcb$var$workInProgressTransitions = null, $7f3768da1ed50fcb$var$legacyErrorBoundariesThatAlreadyFailed = null, $7f3768da1ed50fcb$var$pendingEffectsStatus = 0, $7f3768da1ed50fcb$var$pendingEffectsRoot = null, $7f3768da1ed50fcb$var$pendingFinishedWork = null, $7f3768da1ed50fcb$var$pendingEffectsLanes = 0, $7f3768da1ed50fcb$var$pendingEffectsRemainingLanes = 0, $7f3768da1ed50fcb$var$pendingPassiveTransitions = null, $7f3768da1ed50fcb$var$pendingRecoverableErrors = null, $7f3768da1ed50fcb$var$nestedUpdateCount = 0, $7f3768da1ed50fcb$var$rootWithNestedUpdates = null;
function $7f3768da1ed50fcb$var$requestUpdateLane() {
    if (0 !== ($7f3768da1ed50fcb$var$executionContext & 2) && 0 !== $7f3768da1ed50fcb$var$workInProgressRootRenderLanes) return $7f3768da1ed50fcb$var$workInProgressRootRenderLanes & -$7f3768da1ed50fcb$var$workInProgressRootRenderLanes;
    if (null !== $7f3768da1ed50fcb$var$ReactSharedInternals.T) {
        var actionScopeLane = $7f3768da1ed50fcb$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $7f3768da1ed50fcb$var$requestTransitionLane();
    }
    return $7f3768da1ed50fcb$var$resolveUpdatePriority();
}
function $7f3768da1ed50fcb$var$requestDeferredLane() {
    0 === $7f3768da1ed50fcb$var$workInProgressDeferredLane && ($7f3768da1ed50fcb$var$workInProgressDeferredLane = 0 === ($7f3768da1ed50fcb$var$workInProgressRootRenderLanes & 536870912) || $7f3768da1ed50fcb$var$isHydrating ? $7f3768da1ed50fcb$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $7f3768da1ed50fcb$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $7f3768da1ed50fcb$var$workInProgressDeferredLane;
}
function $7f3768da1ed50fcb$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $7f3768da1ed50fcb$var$workInProgressRoot && (2 === $7f3768da1ed50fcb$var$workInProgressSuspendedReason || 9 === $7f3768da1ed50fcb$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $7f3768da1ed50fcb$var$prepareFreshStack(root, 0), $7f3768da1ed50fcb$var$markRootSuspended(root, $7f3768da1ed50fcb$var$workInProgressRootRenderLanes, $7f3768da1ed50fcb$var$workInProgressDeferredLane, !1);
    $7f3768da1ed50fcb$var$markRootUpdated$1(root, lane);
    if (0 === ($7f3768da1ed50fcb$var$executionContext & 2) || root !== $7f3768da1ed50fcb$var$workInProgressRoot) root === $7f3768da1ed50fcb$var$workInProgressRoot && (0 === ($7f3768da1ed50fcb$var$executionContext & 2) && ($7f3768da1ed50fcb$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $7f3768da1ed50fcb$var$workInProgressRootExitStatus && $7f3768da1ed50fcb$var$markRootSuspended(root, $7f3768da1ed50fcb$var$workInProgressRootRenderLanes, $7f3768da1ed50fcb$var$workInProgressDeferredLane, !1)), $7f3768da1ed50fcb$var$ensureRootIsScheduled(root);
}
function $7f3768da1ed50fcb$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($7f3768da1ed50fcb$var$executionContext & 6)) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $7f3768da1ed50fcb$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $7f3768da1ed50fcb$var$renderRootConcurrent(root$jscomp$0, lanes) : $7f3768da1ed50fcb$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $7f3768da1ed50fcb$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $7f3768da1ed50fcb$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$7f3768da1ed50fcb$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $7f3768da1ed50fcb$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $7f3768da1ed50fcb$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($7f3768da1ed50fcb$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $7f3768da1ed50fcb$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($7f3768da1ed50fcb$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $7f3768da1ed50fcb$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors;
                            $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors ? $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors.push.apply($7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $7f3768da1ed50fcb$var$prepareFreshStack(root$jscomp$0, 0);
                $7f3768da1ed50fcb$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $7f3768da1ed50fcb$var$markRootSuspended(shouldTimeSlice, lanes, $7f3768da1ed50fcb$var$workInProgressDeferredLane, !$7f3768da1ed50fcb$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $7f3768da1ed50fcb$var$globalMostRecentFallbackTime + 300 - $7f3768da1ed50fcb$var$now(), 10 < exitStatus)) {
                    $7f3768da1ed50fcb$var$markRootSuspended(shouldTimeSlice, lanes, $7f3768da1ed50fcb$var$workInProgressDeferredLane, !$7f3768da1ed50fcb$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $7f3768da1ed50fcb$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $7f3768da1ed50fcb$var$scheduleTimeout($7f3768da1ed50fcb$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors, $7f3768da1ed50fcb$var$workInProgressTransitions, $7f3768da1ed50fcb$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $7f3768da1ed50fcb$var$workInProgressDeferredLane, $7f3768da1ed50fcb$var$workInProgressRootInterleavedUpdatedLanes, $7f3768da1ed50fcb$var$workInProgressSuspendedRetryLanes, $7f3768da1ed50fcb$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $7f3768da1ed50fcb$var$commitRootWhenReady(shouldTimeSlice, forceSync, $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors, $7f3768da1ed50fcb$var$workInProgressTransitions, $7f3768da1ed50fcb$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $7f3768da1ed50fcb$var$workInProgressDeferredLane, $7f3768da1ed50fcb$var$workInProgressRootInterleavedUpdatedLanes, $7f3768da1ed50fcb$var$workInProgressSuspendedRetryLanes, $7f3768da1ed50fcb$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $7f3768da1ed50fcb$var$ensureRootIsScheduled(root$jscomp$0);
}
function $7f3768da1ed50fcb$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($7f3768da1ed50fcb$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $7f3768da1ed50fcb$var$noop
        }, $7f3768da1ed50fcb$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $7f3768da1ed50fcb$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($7f3768da1ed50fcb$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $7f3768da1ed50fcb$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $7f3768da1ed50fcb$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $7f3768da1ed50fcb$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$7f3768da1ed50fcb$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $7f3768da1ed50fcb$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$7f3768da1ed50fcb$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$7f3768da1ed50fcb$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $7f3768da1ed50fcb$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $7f3768da1ed50fcb$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $7f3768da1ed50fcb$var$flushSyncWork$1() {
    return 0 === ($7f3768da1ed50fcb$var$executionContext & 6) ? ($7f3768da1ed50fcb$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $7f3768da1ed50fcb$var$resetWorkInProgressStack() {
    if (null !== $7f3768da1ed50fcb$var$workInProgress) {
        if (0 === $7f3768da1ed50fcb$var$workInProgressSuspendedReason) var interruptedWork = $7f3768da1ed50fcb$var$workInProgress.return;
        else interruptedWork = $7f3768da1ed50fcb$var$workInProgress, $7f3768da1ed50fcb$var$lastContextDependency = $7f3768da1ed50fcb$var$currentlyRenderingFiber$1 = null, $7f3768da1ed50fcb$var$resetHooksOnUnwind(interruptedWork), $7f3768da1ed50fcb$var$thenableState = null, $7f3768da1ed50fcb$var$thenableIndexCounter = 0, interruptedWork = $7f3768da1ed50fcb$var$workInProgress;
        for(; null !== interruptedWork;)$7f3768da1ed50fcb$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $7f3768da1ed50fcb$var$workInProgress = null;
    }
}
function $7f3768da1ed50fcb$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $7f3768da1ed50fcb$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $7f3768da1ed50fcb$var$resetWorkInProgressStack();
    $7f3768da1ed50fcb$var$workInProgressRoot = root;
    $7f3768da1ed50fcb$var$workInProgress = timeoutHandle = $7f3768da1ed50fcb$var$createWorkInProgress(root.current, null);
    $7f3768da1ed50fcb$var$workInProgressRootRenderLanes = lanes;
    $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 0;
    $7f3768da1ed50fcb$var$workInProgressThrownValue = null;
    $7f3768da1ed50fcb$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $7f3768da1ed50fcb$var$workInProgressRootIsPrerendering = $7f3768da1ed50fcb$var$checkIfRootIsPrerendering(root, lanes);
    $7f3768da1ed50fcb$var$workInProgressRootDidAttachPingListener = !1;
    $7f3768da1ed50fcb$var$workInProgressSuspendedRetryLanes = $7f3768da1ed50fcb$var$workInProgressDeferredLane = $7f3768da1ed50fcb$var$workInProgressRootPingedLanes = $7f3768da1ed50fcb$var$workInProgressRootInterleavedUpdatedLanes = $7f3768da1ed50fcb$var$workInProgressRootSkippedLanes = $7f3768da1ed50fcb$var$workInProgressRootExitStatus = 0;
    $7f3768da1ed50fcb$var$workInProgressRootRecoverableErrors = $7f3768da1ed50fcb$var$workInProgressRootConcurrentErrors = null;
    $7f3768da1ed50fcb$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $7f3768da1ed50fcb$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $7f3768da1ed50fcb$var$entangledRenderLanes = lanes;
    $7f3768da1ed50fcb$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $7f3768da1ed50fcb$var$handleThrow(root, thrownValue) {
    $7f3768da1ed50fcb$var$currentlyRenderingFiber = null;
    $7f3768da1ed50fcb$var$ReactSharedInternals.H = $7f3768da1ed50fcb$var$ContextOnlyDispatcher;
    thrownValue === $7f3768da1ed50fcb$var$SuspenseException || thrownValue === $7f3768da1ed50fcb$var$SuspenseActionException ? (thrownValue = $7f3768da1ed50fcb$var$getSuspendedThenable(), $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 3) : thrownValue === $7f3768da1ed50fcb$var$SuspenseyCommitException ? (thrownValue = $7f3768da1ed50fcb$var$getSuspendedThenable(), $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 4) : $7f3768da1ed50fcb$var$workInProgressSuspendedReason = thrownValue === $7f3768da1ed50fcb$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $7f3768da1ed50fcb$var$workInProgressThrownValue = thrownValue;
    null === $7f3768da1ed50fcb$var$workInProgress && ($7f3768da1ed50fcb$var$workInProgressRootExitStatus = 1, $7f3768da1ed50fcb$var$logUncaughtError(root, $7f3768da1ed50fcb$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $7f3768da1ed50fcb$var$pushDispatcher() {
    var prevDispatcher = $7f3768da1ed50fcb$var$ReactSharedInternals.H;
    $7f3768da1ed50fcb$var$ReactSharedInternals.H = $7f3768da1ed50fcb$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $7f3768da1ed50fcb$var$ContextOnlyDispatcher : prevDispatcher;
}
function $7f3768da1ed50fcb$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $7f3768da1ed50fcb$var$ReactSharedInternals.A;
    $7f3768da1ed50fcb$var$ReactSharedInternals.A = $7f3768da1ed50fcb$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $7f3768da1ed50fcb$var$renderDidSuspendDelayIfPossible() {
    $7f3768da1ed50fcb$var$workInProgressRootExitStatus = 4;
    $7f3768da1ed50fcb$var$workInProgressRootDidSkipSuspendedSiblings || ($7f3768da1ed50fcb$var$workInProgressRootRenderLanes & 4194048) !== $7f3768da1ed50fcb$var$workInProgressRootRenderLanes && null !== $7f3768da1ed50fcb$var$suspenseHandlerStackCursor.current || ($7f3768da1ed50fcb$var$workInProgressRootIsPrerendering = !0);
    0 === ($7f3768da1ed50fcb$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($7f3768da1ed50fcb$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $7f3768da1ed50fcb$var$workInProgressRoot || $7f3768da1ed50fcb$var$markRootSuspended($7f3768da1ed50fcb$var$workInProgressRoot, $7f3768da1ed50fcb$var$workInProgressRootRenderLanes, $7f3768da1ed50fcb$var$workInProgressDeferredLane, !1);
}
function $7f3768da1ed50fcb$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $7f3768da1ed50fcb$var$executionContext;
    $7f3768da1ed50fcb$var$executionContext |= 2;
    var prevDispatcher = $7f3768da1ed50fcb$var$pushDispatcher(), prevAsyncDispatcher = $7f3768da1ed50fcb$var$pushAsyncDispatcher();
    if ($7f3768da1ed50fcb$var$workInProgressRoot !== root || $7f3768da1ed50fcb$var$workInProgressRootRenderLanes !== lanes) $7f3768da1ed50fcb$var$workInProgressTransitions = null, $7f3768da1ed50fcb$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $7f3768da1ed50fcb$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $7f3768da1ed50fcb$var$workInProgressSuspendedReason && null !== $7f3768da1ed50fcb$var$workInProgress) {
            var unitOfWork = $7f3768da1ed50fcb$var$workInProgress, thrownValue = $7f3768da1ed50fcb$var$workInProgressThrownValue;
            switch($7f3768da1ed50fcb$var$workInProgressSuspendedReason){
                case 8:
                    $7f3768da1ed50fcb$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $7f3768da1ed50fcb$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $7f3768da1ed50fcb$var$workInProgressSuspendedReason;
                    $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 0;
                    $7f3768da1ed50fcb$var$workInProgressThrownValue = null;
                    $7f3768da1ed50fcb$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $7f3768da1ed50fcb$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $7f3768da1ed50fcb$var$workInProgressSuspendedReason, $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 0, $7f3768da1ed50fcb$var$workInProgressThrownValue = null, $7f3768da1ed50fcb$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $7f3768da1ed50fcb$var$workLoopSync();
        exitStatus = $7f3768da1ed50fcb$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $7f3768da1ed50fcb$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $7f3768da1ed50fcb$var$lastContextDependency = $7f3768da1ed50fcb$var$currentlyRenderingFiber$1 = null;
    $7f3768da1ed50fcb$var$executionContext = prevExecutionContext;
    $7f3768da1ed50fcb$var$ReactSharedInternals.H = prevDispatcher;
    $7f3768da1ed50fcb$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $7f3768da1ed50fcb$var$workInProgress && ($7f3768da1ed50fcb$var$workInProgressRoot = null, $7f3768da1ed50fcb$var$workInProgressRootRenderLanes = 0, $7f3768da1ed50fcb$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $7f3768da1ed50fcb$var$workLoopSync() {
    for(; null !== $7f3768da1ed50fcb$var$workInProgress;)$7f3768da1ed50fcb$var$performUnitOfWork($7f3768da1ed50fcb$var$workInProgress);
}
function $7f3768da1ed50fcb$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $7f3768da1ed50fcb$var$executionContext;
    $7f3768da1ed50fcb$var$executionContext |= 2;
    var prevDispatcher = $7f3768da1ed50fcb$var$pushDispatcher(), prevAsyncDispatcher = $7f3768da1ed50fcb$var$pushAsyncDispatcher();
    $7f3768da1ed50fcb$var$workInProgressRoot !== root || $7f3768da1ed50fcb$var$workInProgressRootRenderLanes !== lanes ? ($7f3768da1ed50fcb$var$workInProgressTransitions = null, $7f3768da1ed50fcb$var$workInProgressRootRenderTargetTime = $7f3768da1ed50fcb$var$now() + 500, $7f3768da1ed50fcb$var$prepareFreshStack(root, lanes)) : $7f3768da1ed50fcb$var$workInProgressRootIsPrerendering = $7f3768da1ed50fcb$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $7f3768da1ed50fcb$var$workInProgressSuspendedReason && null !== $7f3768da1ed50fcb$var$workInProgress) {
            lanes = $7f3768da1ed50fcb$var$workInProgress;
            var thrownValue = $7f3768da1ed50fcb$var$workInProgressThrownValue;
            b: switch($7f3768da1ed50fcb$var$workInProgressSuspendedReason){
                case 1:
                    $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 0;
                    $7f3768da1ed50fcb$var$workInProgressThrownValue = null;
                    $7f3768da1ed50fcb$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($7f3768da1ed50fcb$var$isThenableResolved(thrownValue)) {
                        $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 0;
                        $7f3768da1ed50fcb$var$workInProgressThrownValue = null;
                        $7f3768da1ed50fcb$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $7f3768da1ed50fcb$var$workInProgressSuspendedReason && 9 !== $7f3768da1ed50fcb$var$workInProgressSuspendedReason || $7f3768da1ed50fcb$var$workInProgressRoot !== root || ($7f3768da1ed50fcb$var$workInProgressSuspendedReason = 7);
                        $7f3768da1ed50fcb$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $7f3768da1ed50fcb$var$isThenableResolved(thrownValue) ? ($7f3768da1ed50fcb$var$workInProgressSuspendedReason = 0, $7f3768da1ed50fcb$var$workInProgressThrownValue = null, $7f3768da1ed50fcb$var$replaySuspendedUnitOfWork(lanes)) : ($7f3768da1ed50fcb$var$workInProgressSuspendedReason = 0, $7f3768da1ed50fcb$var$workInProgressThrownValue = null, $7f3768da1ed50fcb$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($7f3768da1ed50fcb$var$workInProgress.tag){
                        case 26:
                            resource = $7f3768da1ed50fcb$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $7f3768da1ed50fcb$var$workInProgress;
                            if (resource ? $7f3768da1ed50fcb$var$preloadResource(resource) : 1) {
                                $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 0;
                                $7f3768da1ed50fcb$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $7f3768da1ed50fcb$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($7f3768da1ed50fcb$var$workInProgress = returnFiber, $7f3768da1ed50fcb$var$completeUnitOfWork(returnFiber)) : $7f3768da1ed50fcb$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 0;
                    $7f3768da1ed50fcb$var$workInProgressThrownValue = null;
                    $7f3768da1ed50fcb$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $7f3768da1ed50fcb$var$workInProgressSuspendedReason = 0;
                    $7f3768da1ed50fcb$var$workInProgressThrownValue = null;
                    $7f3768da1ed50fcb$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $7f3768da1ed50fcb$var$resetWorkInProgressStack();
                    $7f3768da1ed50fcb$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(462));
            }
        }
        $7f3768da1ed50fcb$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $7f3768da1ed50fcb$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $7f3768da1ed50fcb$var$lastContextDependency = $7f3768da1ed50fcb$var$currentlyRenderingFiber$1 = null;
    $7f3768da1ed50fcb$var$ReactSharedInternals.H = prevDispatcher;
    $7f3768da1ed50fcb$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $7f3768da1ed50fcb$var$executionContext = prevExecutionContext;
    if (null !== $7f3768da1ed50fcb$var$workInProgress) return 0;
    $7f3768da1ed50fcb$var$workInProgressRoot = null;
    $7f3768da1ed50fcb$var$workInProgressRootRenderLanes = 0;
    $7f3768da1ed50fcb$var$finishQueueingConcurrentUpdates();
    return $7f3768da1ed50fcb$var$workInProgressRootExitStatus;
}
function $7f3768da1ed50fcb$var$workLoopConcurrentByScheduler() {
    for(; null !== $7f3768da1ed50fcb$var$workInProgress && !$7f3768da1ed50fcb$var$shouldYield();)$7f3768da1ed50fcb$var$performUnitOfWork($7f3768da1ed50fcb$var$workInProgress);
}
function $7f3768da1ed50fcb$var$performUnitOfWork(unitOfWork) {
    var next = $7f3768da1ed50fcb$var$beginWork(unitOfWork.alternate, unitOfWork, $7f3768da1ed50fcb$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $7f3768da1ed50fcb$var$completeUnitOfWork(unitOfWork) : $7f3768da1ed50fcb$var$workInProgress = next;
}
function $7f3768da1ed50fcb$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $7f3768da1ed50fcb$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $7f3768da1ed50fcb$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $7f3768da1ed50fcb$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $7f3768da1ed50fcb$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $7f3768da1ed50fcb$var$resetHooksOnUnwind(next);
        default:
            $7f3768da1ed50fcb$var$unwindInterruptedWork(current, next), next = $7f3768da1ed50fcb$var$workInProgress = $7f3768da1ed50fcb$var$resetWorkInProgress(next, $7f3768da1ed50fcb$var$entangledRenderLanes), next = $7f3768da1ed50fcb$var$beginWork(current, next, $7f3768da1ed50fcb$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $7f3768da1ed50fcb$var$completeUnitOfWork(unitOfWork) : $7f3768da1ed50fcb$var$workInProgress = next;
}
function $7f3768da1ed50fcb$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $7f3768da1ed50fcb$var$lastContextDependency = $7f3768da1ed50fcb$var$currentlyRenderingFiber$1 = null;
    $7f3768da1ed50fcb$var$resetHooksOnUnwind(unitOfWork);
    $7f3768da1ed50fcb$var$thenableState = null;
    $7f3768da1ed50fcb$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($7f3768da1ed50fcb$var$throwException(root, returnFiber, unitOfWork, thrownValue, $7f3768da1ed50fcb$var$workInProgressRootRenderLanes)) {
            $7f3768da1ed50fcb$var$workInProgressRootExitStatus = 1;
            $7f3768da1ed50fcb$var$logUncaughtError(root, $7f3768da1ed50fcb$var$createCapturedValueAtFiber(thrownValue, root.current));
            $7f3768da1ed50fcb$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $7f3768da1ed50fcb$var$workInProgress = returnFiber, error;
        $7f3768da1ed50fcb$var$workInProgressRootExitStatus = 1;
        $7f3768da1ed50fcb$var$logUncaughtError(root, $7f3768da1ed50fcb$var$createCapturedValueAtFiber(thrownValue, root.current));
        $7f3768da1ed50fcb$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($7f3768da1ed50fcb$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($7f3768da1ed50fcb$var$workInProgressRootIsPrerendering || 0 !== ($7f3768da1ed50fcb$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($7f3768da1ed50fcb$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $7f3768da1ed50fcb$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $7f3768da1ed50fcb$var$unwindUnitOfWork(unitOfWork, root);
    } else $7f3768da1ed50fcb$var$completeUnitOfWork(unitOfWork);
}
function $7f3768da1ed50fcb$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $7f3768da1ed50fcb$var$unwindUnitOfWork(completedWork, $7f3768da1ed50fcb$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $7f3768da1ed50fcb$var$completeWork(completedWork.alternate, completedWork, $7f3768da1ed50fcb$var$entangledRenderLanes);
        if (null !== next) {
            $7f3768da1ed50fcb$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $7f3768da1ed50fcb$var$workInProgress = completedWork;
            return;
        }
        $7f3768da1ed50fcb$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $7f3768da1ed50fcb$var$workInProgressRootExitStatus && ($7f3768da1ed50fcb$var$workInProgressRootExitStatus = 5);
}
function $7f3768da1ed50fcb$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $7f3768da1ed50fcb$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $7f3768da1ed50fcb$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $7f3768da1ed50fcb$var$workInProgress = unitOfWork;
            return;
        }
        $7f3768da1ed50fcb$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $7f3768da1ed50fcb$var$workInProgressRootExitStatus = 6;
    $7f3768da1ed50fcb$var$workInProgress = null;
}
function $7f3768da1ed50fcb$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $7f3768da1ed50fcb$var$flushPendingEffects();
    while (0 !== $7f3768da1ed50fcb$var$pendingEffectsStatus);
    if (0 !== ($7f3768da1ed50fcb$var$executionContext & 6)) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $7f3768da1ed50fcb$var$concurrentlyUpdatedLanes;
        $7f3768da1ed50fcb$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $7f3768da1ed50fcb$var$workInProgressRoot && ($7f3768da1ed50fcb$var$workInProgress = $7f3768da1ed50fcb$var$workInProgressRoot = null, $7f3768da1ed50fcb$var$workInProgressRootRenderLanes = 0);
        $7f3768da1ed50fcb$var$pendingFinishedWork = finishedWork;
        $7f3768da1ed50fcb$var$pendingEffectsRoot = root;
        $7f3768da1ed50fcb$var$pendingEffectsLanes = lanes;
        $7f3768da1ed50fcb$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $7f3768da1ed50fcb$var$pendingPassiveTransitions = transitions;
        $7f3768da1ed50fcb$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $7f3768da1ed50fcb$var$scheduleCallback$1($7f3768da1ed50fcb$var$NormalPriority$1, function() {
            $7f3768da1ed50fcb$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $7f3768da1ed50fcb$var$ReactSharedInternals.T;
            $7f3768da1ed50fcb$var$ReactSharedInternals.T = null;
            transitions = $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p;
            $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $7f3768da1ed50fcb$var$executionContext;
            $7f3768da1ed50fcb$var$executionContext |= 4;
            try {
                $7f3768da1ed50fcb$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $7f3768da1ed50fcb$var$executionContext = spawnedLane, $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = transitions, $7f3768da1ed50fcb$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $7f3768da1ed50fcb$var$pendingEffectsStatus = 1;
        $7f3768da1ed50fcb$var$flushMutationEffects();
        $7f3768da1ed50fcb$var$flushLayoutEffects();
        $7f3768da1ed50fcb$var$flushSpawnedWork();
    }
}
function $7f3768da1ed50fcb$var$flushMutationEffects() {
    if (1 === $7f3768da1ed50fcb$var$pendingEffectsStatus) {
        $7f3768da1ed50fcb$var$pendingEffectsStatus = 0;
        var root = $7f3768da1ed50fcb$var$pendingEffectsRoot, finishedWork = $7f3768da1ed50fcb$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $7f3768da1ed50fcb$var$ReactSharedInternals.T;
            $7f3768da1ed50fcb$var$ReactSharedInternals.T = null;
            var previousPriority = $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p;
            $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $7f3768da1ed50fcb$var$executionContext;
            $7f3768da1ed50fcb$var$executionContext |= 4;
            try {
                $7f3768da1ed50fcb$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $7f3768da1ed50fcb$var$selectionInformation, curFocusedElem = $7f3768da1ed50fcb$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $7f3768da1ed50fcb$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $7f3768da1ed50fcb$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $7f3768da1ed50fcb$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $7f3768da1ed50fcb$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $7f3768da1ed50fcb$var$_enabled = !!$7f3768da1ed50fcb$var$eventsEnabled;
                $7f3768da1ed50fcb$var$selectionInformation = $7f3768da1ed50fcb$var$eventsEnabled = null;
            } finally{
                $7f3768da1ed50fcb$var$executionContext = prevExecutionContext, $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = previousPriority, $7f3768da1ed50fcb$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $7f3768da1ed50fcb$var$pendingEffectsStatus = 2;
    }
}
function $7f3768da1ed50fcb$var$flushLayoutEffects() {
    if (2 === $7f3768da1ed50fcb$var$pendingEffectsStatus) {
        $7f3768da1ed50fcb$var$pendingEffectsStatus = 0;
        var root = $7f3768da1ed50fcb$var$pendingEffectsRoot, finishedWork = $7f3768da1ed50fcb$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $7f3768da1ed50fcb$var$ReactSharedInternals.T;
            $7f3768da1ed50fcb$var$ReactSharedInternals.T = null;
            var previousPriority = $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p;
            $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $7f3768da1ed50fcb$var$executionContext;
            $7f3768da1ed50fcb$var$executionContext |= 4;
            try {
                $7f3768da1ed50fcb$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $7f3768da1ed50fcb$var$executionContext = prevExecutionContext, $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = previousPriority, $7f3768da1ed50fcb$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $7f3768da1ed50fcb$var$pendingEffectsStatus = 3;
    }
}
function $7f3768da1ed50fcb$var$flushSpawnedWork() {
    if (4 === $7f3768da1ed50fcb$var$pendingEffectsStatus || 3 === $7f3768da1ed50fcb$var$pendingEffectsStatus) {
        $7f3768da1ed50fcb$var$pendingEffectsStatus = 0;
        $7f3768da1ed50fcb$var$requestPaint();
        var root = $7f3768da1ed50fcb$var$pendingEffectsRoot, finishedWork = $7f3768da1ed50fcb$var$pendingFinishedWork, lanes = $7f3768da1ed50fcb$var$pendingEffectsLanes, recoverableErrors = $7f3768da1ed50fcb$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $7f3768da1ed50fcb$var$pendingEffectsStatus = 5 : ($7f3768da1ed50fcb$var$pendingEffectsStatus = 0, $7f3768da1ed50fcb$var$pendingFinishedWork = $7f3768da1ed50fcb$var$pendingEffectsRoot = null, $7f3768da1ed50fcb$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($7f3768da1ed50fcb$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $7f3768da1ed50fcb$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($7f3768da1ed50fcb$var$injectedHook && "function" === typeof $7f3768da1ed50fcb$var$injectedHook.onCommitFiberRoot) try {
            $7f3768da1ed50fcb$var$injectedHook.onCommitFiberRoot($7f3768da1ed50fcb$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $7f3768da1ed50fcb$var$ReactSharedInternals.T;
            remainingLanes = $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p;
            $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = 2;
            $7f3768da1ed50fcb$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $7f3768da1ed50fcb$var$ReactSharedInternals.T = finishedWork, $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($7f3768da1ed50fcb$var$pendingEffectsLanes & 3) && $7f3768da1ed50fcb$var$flushPendingEffects();
        $7f3768da1ed50fcb$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $7f3768da1ed50fcb$var$rootWithNestedUpdates ? $7f3768da1ed50fcb$var$nestedUpdateCount++ : ($7f3768da1ed50fcb$var$nestedUpdateCount = 0, $7f3768da1ed50fcb$var$rootWithNestedUpdates = root) : $7f3768da1ed50fcb$var$nestedUpdateCount = 0;
        $7f3768da1ed50fcb$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $7f3768da1ed50fcb$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $7f3768da1ed50fcb$var$releaseCache(remainingLanes)));
}
function $7f3768da1ed50fcb$var$flushPendingEffects(wasDelayedCommit) {
    $7f3768da1ed50fcb$var$flushMutationEffects();
    $7f3768da1ed50fcb$var$flushLayoutEffects();
    $7f3768da1ed50fcb$var$flushSpawnedWork();
    return $7f3768da1ed50fcb$var$flushPassiveEffects(wasDelayedCommit);
}
function $7f3768da1ed50fcb$var$flushPassiveEffects() {
    if (5 !== $7f3768da1ed50fcb$var$pendingEffectsStatus) return !1;
    var root = $7f3768da1ed50fcb$var$pendingEffectsRoot, remainingLanes = $7f3768da1ed50fcb$var$pendingEffectsRemainingLanes;
    $7f3768da1ed50fcb$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $7f3768da1ed50fcb$var$lanesToEventPriority($7f3768da1ed50fcb$var$pendingEffectsLanes), prevTransition = $7f3768da1ed50fcb$var$ReactSharedInternals.T, previousPriority = $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p;
    try {
        $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $7f3768da1ed50fcb$var$ReactSharedInternals.T = null;
        renderPriority = $7f3768da1ed50fcb$var$pendingPassiveTransitions;
        $7f3768da1ed50fcb$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $7f3768da1ed50fcb$var$pendingEffectsRoot, lanes = $7f3768da1ed50fcb$var$pendingEffectsLanes;
        $7f3768da1ed50fcb$var$pendingEffectsStatus = 0;
        $7f3768da1ed50fcb$var$pendingFinishedWork = $7f3768da1ed50fcb$var$pendingEffectsRoot = null;
        $7f3768da1ed50fcb$var$pendingEffectsLanes = 0;
        if (0 !== ($7f3768da1ed50fcb$var$executionContext & 6)) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(331));
        var prevExecutionContext = $7f3768da1ed50fcb$var$executionContext;
        $7f3768da1ed50fcb$var$executionContext |= 4;
        $7f3768da1ed50fcb$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $7f3768da1ed50fcb$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $7f3768da1ed50fcb$var$executionContext = prevExecutionContext;
        $7f3768da1ed50fcb$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($7f3768da1ed50fcb$var$injectedHook && "function" === typeof $7f3768da1ed50fcb$var$injectedHook.onPostCommitFiberRoot) try {
            $7f3768da1ed50fcb$var$injectedHook.onPostCommitFiberRoot($7f3768da1ed50fcb$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = previousPriority, $7f3768da1ed50fcb$var$ReactSharedInternals.T = prevTransition, $7f3768da1ed50fcb$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $7f3768da1ed50fcb$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $7f3768da1ed50fcb$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $7f3768da1ed50fcb$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $7f3768da1ed50fcb$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($7f3768da1ed50fcb$var$markRootUpdated$1(rootFiber, 2), $7f3768da1ed50fcb$var$ensureRootIsScheduled(rootFiber));
}
function $7f3768da1ed50fcb$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $7f3768da1ed50fcb$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $7f3768da1ed50fcb$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $7f3768da1ed50fcb$var$legacyErrorBoundariesThatAlreadyFailed || !$7f3768da1ed50fcb$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $7f3768da1ed50fcb$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $7f3768da1ed50fcb$var$createClassErrorUpdate(2);
                instance = $7f3768da1ed50fcb$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($7f3768da1ed50fcb$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $7f3768da1ed50fcb$var$markRootUpdated$1(instance, 2), $7f3768da1ed50fcb$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $7f3768da1ed50fcb$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $7f3768da1ed50fcb$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($7f3768da1ed50fcb$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $7f3768da1ed50fcb$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $7f3768da1ed50fcb$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $7f3768da1ed50fcb$var$workInProgressRoot === root && ($7f3768da1ed50fcb$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $7f3768da1ed50fcb$var$workInProgressRootExitStatus || 3 === $7f3768da1ed50fcb$var$workInProgressRootExitStatus && ($7f3768da1ed50fcb$var$workInProgressRootRenderLanes & 62914560) === $7f3768da1ed50fcb$var$workInProgressRootRenderLanes && 300 > $7f3768da1ed50fcb$var$now() - $7f3768da1ed50fcb$var$globalMostRecentFallbackTime ? 0 === ($7f3768da1ed50fcb$var$executionContext & 2) && $7f3768da1ed50fcb$var$prepareFreshStack(root, 0) : $7f3768da1ed50fcb$var$workInProgressRootPingedLanes |= pingedLanes, $7f3768da1ed50fcb$var$workInProgressSuspendedRetryLanes === $7f3768da1ed50fcb$var$workInProgressRootRenderLanes && ($7f3768da1ed50fcb$var$workInProgressSuspendedRetryLanes = 0));
    $7f3768da1ed50fcb$var$ensureRootIsScheduled(root);
}
function $7f3768da1ed50fcb$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $7f3768da1ed50fcb$var$claimNextRetryLane());
    boundaryFiber = $7f3768da1ed50fcb$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($7f3768da1ed50fcb$var$markRootUpdated$1(boundaryFiber, retryLane), $7f3768da1ed50fcb$var$ensureRootIsScheduled(boundaryFiber));
}
function $7f3768da1ed50fcb$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $7f3768da1ed50fcb$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $7f3768da1ed50fcb$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $7f3768da1ed50fcb$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $7f3768da1ed50fcb$var$scheduleCallback$1(priorityLevel, callback) {
    return $7f3768da1ed50fcb$var$scheduleCallback$3(priorityLevel, callback);
}
var $7f3768da1ed50fcb$var$firstScheduledRoot = null, $7f3768da1ed50fcb$var$lastScheduledRoot = null, $7f3768da1ed50fcb$var$didScheduleMicrotask = !1, $7f3768da1ed50fcb$var$mightHavePendingSyncWork = !1, $7f3768da1ed50fcb$var$isFlushingWork = !1, $7f3768da1ed50fcb$var$currentEventTransitionLane = 0;
function $7f3768da1ed50fcb$var$ensureRootIsScheduled(root) {
    root !== $7f3768da1ed50fcb$var$lastScheduledRoot && null === root.next && (null === $7f3768da1ed50fcb$var$lastScheduledRoot ? $7f3768da1ed50fcb$var$firstScheduledRoot = $7f3768da1ed50fcb$var$lastScheduledRoot = root : $7f3768da1ed50fcb$var$lastScheduledRoot = $7f3768da1ed50fcb$var$lastScheduledRoot.next = root);
    $7f3768da1ed50fcb$var$mightHavePendingSyncWork = !0;
    $7f3768da1ed50fcb$var$didScheduleMicrotask || ($7f3768da1ed50fcb$var$didScheduleMicrotask = !0, $7f3768da1ed50fcb$var$scheduleImmediateRootScheduleTask());
}
function $7f3768da1ed50fcb$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$7f3768da1ed50fcb$var$isFlushingWork && $7f3768da1ed50fcb$var$mightHavePendingSyncWork) {
        $7f3768da1ed50fcb$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $7f3768da1ed50fcb$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $7f3768da1ed50fcb$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $7f3768da1ed50fcb$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $7f3768da1ed50fcb$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $7f3768da1ed50fcb$var$getNextLanes(root$174, root$174 === $7f3768da1ed50fcb$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $7f3768da1ed50fcb$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $7f3768da1ed50fcb$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $7f3768da1ed50fcb$var$isFlushingWork = !1;
    }
}
function $7f3768da1ed50fcb$var$processRootScheduleInImmediateTask() {
    $7f3768da1ed50fcb$var$processRootScheduleInMicrotask();
}
function $7f3768da1ed50fcb$var$processRootScheduleInMicrotask() {
    $7f3768da1ed50fcb$var$mightHavePendingSyncWork = $7f3768da1ed50fcb$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $7f3768da1ed50fcb$var$currentEventTransitionLane && ($7f3768da1ed50fcb$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $7f3768da1ed50fcb$var$currentEventTransitionLane), $7f3768da1ed50fcb$var$currentEventTransitionLane = 0);
    for(var currentTime = $7f3768da1ed50fcb$var$now(), prev = null, root = $7f3768da1ed50fcb$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $7f3768da1ed50fcb$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $7f3768da1ed50fcb$var$firstScheduledRoot = next : prev.next = next, null === next && ($7f3768da1ed50fcb$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $7f3768da1ed50fcb$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $7f3768da1ed50fcb$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $7f3768da1ed50fcb$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $7f3768da1ed50fcb$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $7f3768da1ed50fcb$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $7f3768da1ed50fcb$var$workInProgressRoot;
    suspendedLanes = $7f3768da1ed50fcb$var$workInProgressRootRenderLanes;
    suspendedLanes = $7f3768da1ed50fcb$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $7f3768da1ed50fcb$var$workInProgressSuspendedReason || 9 === $7f3768da1ed50fcb$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $7f3768da1ed50fcb$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $7f3768da1ed50fcb$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $7f3768da1ed50fcb$var$cancelCallback$1(pingedLanes);
        switch($7f3768da1ed50fcb$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $7f3768da1ed50fcb$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $7f3768da1ed50fcb$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $7f3768da1ed50fcb$var$IdlePriority;
                break;
            default:
                suspendedLanes = $7f3768da1ed50fcb$var$NormalPriority$1;
        }
        pingedLanes = $7f3768da1ed50fcb$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $7f3768da1ed50fcb$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $7f3768da1ed50fcb$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $7f3768da1ed50fcb$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $7f3768da1ed50fcb$var$pendingEffectsStatus && 5 !== $7f3768da1ed50fcb$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($7f3768da1ed50fcb$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $7f3768da1ed50fcb$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $7f3768da1ed50fcb$var$getNextLanes(root, root === $7f3768da1ed50fcb$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $7f3768da1ed50fcb$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $7f3768da1ed50fcb$var$scheduleTaskForRootDuringMicrotask(root, $7f3768da1ed50fcb$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $7f3768da1ed50fcb$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $7f3768da1ed50fcb$var$performSyncWorkOnRoot(root, lanes) {
    if ($7f3768da1ed50fcb$var$flushPendingEffects()) return null;
    $7f3768da1ed50fcb$var$performWorkOnRoot(root, lanes, !0);
}
function $7f3768da1ed50fcb$var$scheduleImmediateRootScheduleTask() {
    $7f3768da1ed50fcb$var$scheduleMicrotask(function() {
        0 !== ($7f3768da1ed50fcb$var$executionContext & 6) ? $7f3768da1ed50fcb$var$scheduleCallback$3($7f3768da1ed50fcb$var$ImmediatePriority, $7f3768da1ed50fcb$var$processRootScheduleInImmediateTask) : $7f3768da1ed50fcb$var$processRootScheduleInMicrotask();
    });
}
function $7f3768da1ed50fcb$var$requestTransitionLane() {
    0 === $7f3768da1ed50fcb$var$currentEventTransitionLane && ($7f3768da1ed50fcb$var$currentEventTransitionLane = $7f3768da1ed50fcb$var$claimNextTransitionLane());
    return $7f3768da1ed50fcb$var$currentEventTransitionLane;
}
function $7f3768da1ed50fcb$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $7f3768da1ed50fcb$var$sanitizeURL("" + actionProp);
}
function $7f3768da1ed50fcb$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $7f3768da1ed50fcb$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $7f3768da1ed50fcb$var$coerceFormActionProp((nativeEventTarget[$7f3768da1ed50fcb$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$7f3768da1ed50fcb$var$internalPropsKey] || null) ? $7f3768da1ed50fcb$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $7f3768da1ed50fcb$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $7f3768da1ed50fcb$var$currentEventTransitionLane) {
                                var formData = submitter ? $7f3768da1ed50fcb$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $7f3768da1ed50fcb$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $7f3768da1ed50fcb$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $7f3768da1ed50fcb$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $7f3768da1ed50fcb$var$i$jscomp$inline_1528 = 0; $7f3768da1ed50fcb$var$i$jscomp$inline_1528 < $7f3768da1ed50fcb$var$simpleEventPluginEvents.length; $7f3768da1ed50fcb$var$i$jscomp$inline_1528++){
    var $7f3768da1ed50fcb$var$eventName$jscomp$inline_1529 = $7f3768da1ed50fcb$var$simpleEventPluginEvents[$7f3768da1ed50fcb$var$i$jscomp$inline_1528], $7f3768da1ed50fcb$var$domEventName$jscomp$inline_1530 = $7f3768da1ed50fcb$var$eventName$jscomp$inline_1529.toLowerCase(), $7f3768da1ed50fcb$var$capitalizedEvent$jscomp$inline_1531 = $7f3768da1ed50fcb$var$eventName$jscomp$inline_1529[0].toUpperCase() + $7f3768da1ed50fcb$var$eventName$jscomp$inline_1529.slice(1);
    $7f3768da1ed50fcb$var$registerSimpleEvent($7f3768da1ed50fcb$var$domEventName$jscomp$inline_1530, "on" + $7f3768da1ed50fcb$var$capitalizedEvent$jscomp$inline_1531);
}
$7f3768da1ed50fcb$var$registerSimpleEvent($7f3768da1ed50fcb$var$ANIMATION_END, "onAnimationEnd");
$7f3768da1ed50fcb$var$registerSimpleEvent($7f3768da1ed50fcb$var$ANIMATION_ITERATION, "onAnimationIteration");
$7f3768da1ed50fcb$var$registerSimpleEvent($7f3768da1ed50fcb$var$ANIMATION_START, "onAnimationStart");
$7f3768da1ed50fcb$var$registerSimpleEvent("dblclick", "onDoubleClick");
$7f3768da1ed50fcb$var$registerSimpleEvent("focusin", "onFocus");
$7f3768da1ed50fcb$var$registerSimpleEvent("focusout", "onBlur");
$7f3768da1ed50fcb$var$registerSimpleEvent($7f3768da1ed50fcb$var$TRANSITION_RUN, "onTransitionRun");
$7f3768da1ed50fcb$var$registerSimpleEvent($7f3768da1ed50fcb$var$TRANSITION_START, "onTransitionStart");
$7f3768da1ed50fcb$var$registerSimpleEvent($7f3768da1ed50fcb$var$TRANSITION_CANCEL, "onTransitionCancel");
$7f3768da1ed50fcb$var$registerSimpleEvent($7f3768da1ed50fcb$var$TRANSITION_END, "onTransitionEnd");
$7f3768da1ed50fcb$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$7f3768da1ed50fcb$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$7f3768da1ed50fcb$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$7f3768da1ed50fcb$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$7f3768da1ed50fcb$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$7f3768da1ed50fcb$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$7f3768da1ed50fcb$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$7f3768da1ed50fcb$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$7f3768da1ed50fcb$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$7f3768da1ed50fcb$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $7f3768da1ed50fcb$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $7f3768da1ed50fcb$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($7f3768da1ed50fcb$var$mediaEventTypes));
function $7f3768da1ed50fcb$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $7f3768da1ed50fcb$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $7f3768da1ed50fcb$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $7f3768da1ed50fcb$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$7f3768da1ed50fcb$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$7f3768da1ed50fcb$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($7f3768da1ed50fcb$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $7f3768da1ed50fcb$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $7f3768da1ed50fcb$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $7f3768da1ed50fcb$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $7f3768da1ed50fcb$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$7f3768da1ed50fcb$var$listeningMarker]) {
        rootContainerElement[$7f3768da1ed50fcb$var$listeningMarker] = !0;
        $7f3768da1ed50fcb$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($7f3768da1ed50fcb$var$nonDelegatedEvents.has(domEventName) || $7f3768da1ed50fcb$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $7f3768da1ed50fcb$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$7f3768da1ed50fcb$var$listeningMarker] || (ownerDocument[$7f3768da1ed50fcb$var$listeningMarker] = !0, $7f3768da1ed50fcb$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $7f3768da1ed50fcb$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($7f3768da1ed50fcb$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $7f3768da1ed50fcb$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $7f3768da1ed50fcb$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $7f3768da1ed50fcb$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$7f3768da1ed50fcb$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $7f3768da1ed50fcb$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $7f3768da1ed50fcb$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $7f3768da1ed50fcb$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $7f3768da1ed50fcb$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $7f3768da1ed50fcb$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $7f3768da1ed50fcb$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticTouchEvent;
                        break;
                    case $7f3768da1ed50fcb$var$ANIMATION_END:
                    case $7f3768da1ed50fcb$var$ANIMATION_ITERATION:
                    case $7f3768da1ed50fcb$var$ANIMATION_START:
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticAnimationEvent;
                        break;
                    case $7f3768da1ed50fcb$var$TRANSITION_END:
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $7f3768da1ed50fcb$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $7f3768da1ed50fcb$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($7f3768da1ed50fcb$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $7f3768da1ed50fcb$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($7f3768da1ed50fcb$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$7f3768da1ed50fcb$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $7f3768da1ed50fcb$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $7f3768da1ed50fcb$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $7f3768da1ed50fcb$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $7f3768da1ed50fcb$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $7f3768da1ed50fcb$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $7f3768da1ed50fcb$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $7f3768da1ed50fcb$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $7f3768da1ed50fcb$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $7f3768da1ed50fcb$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $7f3768da1ed50fcb$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $7f3768da1ed50fcb$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $7f3768da1ed50fcb$var$getParent(inCapturePhase);
                                reactEventName = $7f3768da1ed50fcb$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $7f3768da1ed50fcb$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $7f3768da1ed50fcb$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $7f3768da1ed50fcb$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $7f3768da1ed50fcb$var$getTargetInstForChangeEvent;
                else if ($7f3768da1ed50fcb$var$isTextInputElement(reactName)) {
                    if ($7f3768da1ed50fcb$var$isInputEventSupported) getTargetInstFunc = $7f3768da1ed50fcb$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $7f3768da1ed50fcb$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $7f3768da1ed50fcb$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $7f3768da1ed50fcb$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $7f3768da1ed50fcb$var$getTargetInstForChangeEvent) : getTargetInstFunc = $7f3768da1ed50fcb$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $7f3768da1ed50fcb$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $7f3768da1ed50fcb$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $7f3768da1ed50fcb$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($7f3768da1ed50fcb$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $7f3768da1ed50fcb$var$activeElement = handleEventFunc, $7f3768da1ed50fcb$var$activeElementInst = targetInst, $7f3768da1ed50fcb$var$lastSelection = null;
                    break;
                case "focusout":
                    $7f3768da1ed50fcb$var$lastSelection = $7f3768da1ed50fcb$var$activeElementInst = $7f3768da1ed50fcb$var$activeElement = null;
                    break;
                case "mousedown":
                    $7f3768da1ed50fcb$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $7f3768da1ed50fcb$var$mouseDown = !1;
                    $7f3768da1ed50fcb$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($7f3768da1ed50fcb$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $7f3768da1ed50fcb$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($7f3768da1ed50fcb$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $7f3768da1ed50fcb$var$isComposing ? $7f3768da1ed50fcb$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($7f3768da1ed50fcb$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($7f3768da1ed50fcb$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $7f3768da1ed50fcb$var$isComposing && (fallbackData = $7f3768da1ed50fcb$var$getData()) : ($7f3768da1ed50fcb$var$root = nativeEventTarget, $7f3768da1ed50fcb$var$startText = "value" in $7f3768da1ed50fcb$var$root ? $7f3768da1ed50fcb$var$root.value : $7f3768da1ed50fcb$var$root.textContent, $7f3768da1ed50fcb$var$isComposing = !0)), handleEventFunc = $7f3768da1ed50fcb$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $7f3768da1ed50fcb$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $7f3768da1ed50fcb$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $7f3768da1ed50fcb$var$canUseTextInputEvent ? $7f3768da1ed50fcb$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $7f3768da1ed50fcb$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $7f3768da1ed50fcb$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $7f3768da1ed50fcb$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $7f3768da1ed50fcb$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $7f3768da1ed50fcb$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $7f3768da1ed50fcb$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $7f3768da1ed50fcb$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $7f3768da1ed50fcb$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($7f3768da1ed50fcb$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $7f3768da1ed50fcb$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($7f3768da1ed50fcb$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $7f3768da1ed50fcb$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $7f3768da1ed50fcb$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $7f3768da1ed50fcb$var$getListener(target, registrationName), null != stateNode && listeners.unshift($7f3768da1ed50fcb$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $7f3768da1ed50fcb$var$getListener(target, registrationName), null != stateNode && listeners.push($7f3768da1ed50fcb$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $7f3768da1ed50fcb$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $7f3768da1ed50fcb$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $7f3768da1ed50fcb$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($7f3768da1ed50fcb$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($7f3768da1ed50fcb$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $7f3768da1ed50fcb$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $7f3768da1ed50fcb$var$normalizeMarkupForTextOrAttribute(clientText);
    return $7f3768da1ed50fcb$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $7f3768da1ed50fcb$var$noop$1() {}
function $7f3768da1ed50fcb$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $7f3768da1ed50fcb$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $7f3768da1ed50fcb$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $7f3768da1ed50fcb$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $7f3768da1ed50fcb$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $7f3768da1ed50fcb$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $7f3768da1ed50fcb$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $7f3768da1ed50fcb$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $7f3768da1ed50fcb$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $7f3768da1ed50fcb$var$setProp(domElement, tag, "name", props.name, props, null), $7f3768da1ed50fcb$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $7f3768da1ed50fcb$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $7f3768da1ed50fcb$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($7f3768da1ed50fcb$var$setProp(domElement, tag, "encType", props.encType, props, null), $7f3768da1ed50fcb$var$setProp(domElement, tag, "method", props.method, props, null), $7f3768da1ed50fcb$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $7f3768da1ed50fcb$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $7f3768da1ed50fcb$var$noop$1);
            break;
        case "onScroll":
            null != value && $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $7f3768da1ed50fcb$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("toggle", domElement);
            $7f3768da1ed50fcb$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $7f3768da1ed50fcb$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $7f3768da1ed50fcb$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $7f3768da1ed50fcb$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $7f3768da1ed50fcb$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $7f3768da1ed50fcb$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $7f3768da1ed50fcb$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $7f3768da1ed50fcb$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $7f3768da1ed50fcb$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $7f3768da1ed50fcb$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $7f3768da1ed50fcb$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $7f3768da1ed50fcb$var$aliases.get(key) || key, $7f3768da1ed50fcb$var$setValueForAttribute(domElement, key, value);
    }
}
function $7f3768da1ed50fcb$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $7f3768da1ed50fcb$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $7f3768da1ed50fcb$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $7f3768da1ed50fcb$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $7f3768da1ed50fcb$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$7f3768da1ed50fcb$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$7f3768da1ed50fcb$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $7f3768da1ed50fcb$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $7f3768da1ed50fcb$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("error", domElement);
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(137, tag));
                    default:
                        $7f3768da1ed50fcb$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $7f3768da1ed50fcb$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $7f3768da1ed50fcb$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $7f3768da1ed50fcb$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $7f3768da1ed50fcb$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $7f3768da1ed50fcb$var$track(domElement);
            return;
        case "select":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $7f3768da1ed50fcb$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $7f3768da1ed50fcb$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $7f3768da1ed50fcb$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(91));
                    break;
                default:
                    $7f3768da1ed50fcb$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $7f3768da1ed50fcb$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $7f3768da1ed50fcb$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $7f3768da1ed50fcb$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("toggle", domElement);
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("cancel", domElement);
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $7f3768da1ed50fcb$var$mediaEventTypes.length; hasSrc++)$7f3768da1ed50fcb$var$listenToNonDelegatedEvent($7f3768da1ed50fcb$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("error", domElement);
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("error", domElement), $7f3768da1ed50fcb$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(137, tag));
                default:
                    $7f3768da1ed50fcb$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($7f3768da1ed50fcb$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $7f3768da1ed50fcb$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $7f3768da1ed50fcb$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $7f3768da1ed50fcb$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $7f3768da1ed50fcb$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $7f3768da1ed50fcb$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $7f3768da1ed50fcb$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $7f3768da1ed50fcb$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $7f3768da1ed50fcb$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $7f3768da1ed50fcb$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $7f3768da1ed50fcb$var$updateOptions(domElement, !!lastProps, tag, !0) : $7f3768da1ed50fcb$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $7f3768da1ed50fcb$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $7f3768da1ed50fcb$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $7f3768da1ed50fcb$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $7f3768da1ed50fcb$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $7f3768da1ed50fcb$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $7f3768da1ed50fcb$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $7f3768da1ed50fcb$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($7f3768da1ed50fcb$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $7f3768da1ed50fcb$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $7f3768da1ed50fcb$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $7f3768da1ed50fcb$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $7f3768da1ed50fcb$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $7f3768da1ed50fcb$var$eventsEnabled = null, $7f3768da1ed50fcb$var$selectionInformation = null;
function $7f3768da1ed50fcb$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $7f3768da1ed50fcb$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $7f3768da1ed50fcb$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $7f3768da1ed50fcb$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $7f3768da1ed50fcb$var$currentPopstateTransitionEvent = null;
function $7f3768da1ed50fcb$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $7f3768da1ed50fcb$var$currentPopstateTransitionEvent) return !1;
        $7f3768da1ed50fcb$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $7f3768da1ed50fcb$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $7f3768da1ed50fcb$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $7f3768da1ed50fcb$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $7f3768da1ed50fcb$var$localPromise = "function" === typeof Promise ? Promise : void 0, $7f3768da1ed50fcb$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $7f3768da1ed50fcb$var$localPromise ? function(callback) {
    return $7f3768da1ed50fcb$var$localPromise.resolve(null).then(callback).catch($7f3768da1ed50fcb$var$handleErrorInNextTick);
} : $7f3768da1ed50fcb$var$scheduleTimeout;
function $7f3768da1ed50fcb$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $7f3768da1ed50fcb$var$isSingletonScope(type) {
    return "head" === type;
}
function $7f3768da1ed50fcb$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $7f3768da1ed50fcb$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $7f3768da1ed50fcb$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $7f3768da1ed50fcb$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$7f3768da1ed50fcb$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $7f3768da1ed50fcb$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $7f3768da1ed50fcb$var$retryIfBlockedOn(suspenseInstance);
}
function $7f3768da1ed50fcb$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $7f3768da1ed50fcb$var$clearContainerSparingly(node);
                $7f3768da1ed50fcb$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $7f3768da1ed50fcb$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$7f3768da1ed50fcb$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $7f3768da1ed50fcb$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $7f3768da1ed50fcb$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $7f3768da1ed50fcb$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $7f3768da1ed50fcb$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $7f3768da1ed50fcb$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $7f3768da1ed50fcb$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $7f3768da1ed50fcb$var$previousHydratableOnEnteringScopedSingleton = null;
function $7f3768da1ed50fcb$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $7f3768da1ed50fcb$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $7f3768da1ed50fcb$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(451));
    }
}
function $7f3768da1ed50fcb$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $7f3768da1ed50fcb$var$detachDeletedInstance(instance);
}
var $7f3768da1ed50fcb$var$preloadPropsMap = new Map(), $7f3768da1ed50fcb$var$preconnectsSet = new Set();
function $7f3768da1ed50fcb$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $7f3768da1ed50fcb$var$previousDispatcher = $7f3768da1ed50fcb$var$ReactDOMSharedInternals.d;
$7f3768da1ed50fcb$var$ReactDOMSharedInternals.d = {
    f: $7f3768da1ed50fcb$var$flushSyncWork,
    r: $7f3768da1ed50fcb$var$requestFormReset,
    D: $7f3768da1ed50fcb$var$prefetchDNS,
    C: $7f3768da1ed50fcb$var$preconnect,
    L: $7f3768da1ed50fcb$var$preload,
    m: $7f3768da1ed50fcb$var$preloadModule,
    X: $7f3768da1ed50fcb$var$preinitScript,
    S: $7f3768da1ed50fcb$var$preinitStyle,
    M: $7f3768da1ed50fcb$var$preinitModuleScript
};
function $7f3768da1ed50fcb$var$flushSyncWork() {
    var previousWasRendering = $7f3768da1ed50fcb$var$previousDispatcher.f(), wasRendering = $7f3768da1ed50fcb$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $7f3768da1ed50fcb$var$requestFormReset(form) {
    var formInst = $7f3768da1ed50fcb$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $7f3768da1ed50fcb$var$requestFormReset$1(formInst) : $7f3768da1ed50fcb$var$previousDispatcher.r(form);
}
var $7f3768da1ed50fcb$var$globalDocument = "undefined" === typeof document ? null : document;
function $7f3768da1ed50fcb$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $7f3768da1ed50fcb$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $7f3768da1ed50fcb$var$preconnectsSet.has(limitedEscapedHref) || ($7f3768da1ed50fcb$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $7f3768da1ed50fcb$var$setInitialProperties(href, "link", rel), $7f3768da1ed50fcb$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $7f3768da1ed50fcb$var$prefetchDNS(href) {
    $7f3768da1ed50fcb$var$previousDispatcher.D(href);
    $7f3768da1ed50fcb$var$preconnectAs("dns-prefetch", href, null);
}
function $7f3768da1ed50fcb$var$preconnect(href, crossOrigin) {
    $7f3768da1ed50fcb$var$previousDispatcher.C(href, crossOrigin);
    $7f3768da1ed50fcb$var$preconnectAs("preconnect", href, crossOrigin);
}
function $7f3768da1ed50fcb$var$preload(href, as, options) {
    $7f3768da1ed50fcb$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $7f3768da1ed50fcb$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $7f3768da1ed50fcb$var$getStyleKey(href);
                break;
            case "script":
                key = $7f3768da1ed50fcb$var$getScriptKey(href);
        }
        $7f3768da1ed50fcb$var$preloadPropsMap.has(key) || (href = $7f3768da1ed50fcb$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $7f3768da1ed50fcb$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($7f3768da1ed50fcb$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($7f3768da1ed50fcb$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $7f3768da1ed50fcb$var$setInitialProperties(as, "link", href), $7f3768da1ed50fcb$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $7f3768da1ed50fcb$var$preloadModule(href, options) {
    $7f3768da1ed50fcb$var$previousDispatcher.m(href, options);
    var ownerDocument = $7f3768da1ed50fcb$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $7f3768da1ed50fcb$var$getScriptKey(href);
        }
        if (!$7f3768da1ed50fcb$var$preloadPropsMap.has(key) && (href = $7f3768da1ed50fcb$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $7f3768da1ed50fcb$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($7f3768da1ed50fcb$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $7f3768da1ed50fcb$var$setInitialProperties(as, "link", href);
            $7f3768da1ed50fcb$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $7f3768da1ed50fcb$var$preinitStyle(href, precedence, options) {
    $7f3768da1ed50fcb$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $7f3768da1ed50fcb$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $7f3768da1ed50fcb$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $7f3768da1ed50fcb$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($7f3768da1ed50fcb$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $7f3768da1ed50fcb$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $7f3768da1ed50fcb$var$preloadPropsMap.get(key)) && $7f3768da1ed50fcb$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $7f3768da1ed50fcb$var$markNodeAsHoistable(link);
                $7f3768da1ed50fcb$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $7f3768da1ed50fcb$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $7f3768da1ed50fcb$var$preinitScript(src, options) {
    $7f3768da1ed50fcb$var$previousDispatcher.X(src, options);
    var ownerDocument = $7f3768da1ed50fcb$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $7f3768da1ed50fcb$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $7f3768da1ed50fcb$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($7f3768da1ed50fcb$var$getScriptSelectorFromKey(key)), resource || (src = $7f3768da1ed50fcb$var$assign({
            src: src,
            async: !0
        }, options), (options = $7f3768da1ed50fcb$var$preloadPropsMap.get(key)) && $7f3768da1ed50fcb$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $7f3768da1ed50fcb$var$markNodeAsHoistable(resource), $7f3768da1ed50fcb$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $7f3768da1ed50fcb$var$preinitModuleScript(src, options) {
    $7f3768da1ed50fcb$var$previousDispatcher.M(src, options);
    var ownerDocument = $7f3768da1ed50fcb$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $7f3768da1ed50fcb$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $7f3768da1ed50fcb$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($7f3768da1ed50fcb$var$getScriptSelectorFromKey(key)), resource || (src = $7f3768da1ed50fcb$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $7f3768da1ed50fcb$var$preloadPropsMap.get(key)) && $7f3768da1ed50fcb$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $7f3768da1ed50fcb$var$markNodeAsHoistable(resource), $7f3768da1ed50fcb$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $7f3768da1ed50fcb$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $7f3768da1ed50fcb$var$rootInstanceStackCursor.current) ? $7f3768da1ed50fcb$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $7f3768da1ed50fcb$var$getStyleKey(pendingProps.href), pendingProps = $7f3768da1ed50fcb$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $7f3768da1ed50fcb$var$getStyleKey(pendingProps.href);
                var styles$244 = $7f3768da1ed50fcb$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($7f3768da1ed50fcb$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $7f3768da1ed50fcb$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $7f3768da1ed50fcb$var$preloadPropsMap.set(type, pendingProps), styles$244 || $7f3768da1ed50fcb$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $7f3768da1ed50fcb$var$getScriptKey(pendingProps), pendingProps = $7f3768da1ed50fcb$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(444, type));
    }
}
function $7f3768da1ed50fcb$var$getStyleKey(href) {
    return 'href="' + $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $7f3768da1ed50fcb$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $7f3768da1ed50fcb$var$stylesheetPropsFromRawProps(rawProps) {
    return $7f3768da1ed50fcb$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $7f3768da1ed50fcb$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $7f3768da1ed50fcb$var$setInitialProperties(key, "link", preloadProps), $7f3768da1ed50fcb$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $7f3768da1ed50fcb$var$getScriptKey(src) {
    return '[src="' + $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $7f3768da1ed50fcb$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $7f3768da1ed50fcb$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $7f3768da1ed50fcb$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $7f3768da1ed50fcb$var$markNodeAsHoistable(instance), instance;
            var styleProps = $7f3768da1ed50fcb$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $7f3768da1ed50fcb$var$markNodeAsHoistable(instance);
            $7f3768da1ed50fcb$var$setInitialProperties(instance, "style", styleProps);
            $7f3768da1ed50fcb$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $7f3768da1ed50fcb$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($7f3768da1ed50fcb$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $7f3768da1ed50fcb$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $7f3768da1ed50fcb$var$stylesheetPropsFromRawProps(props);
            (styleProps = $7f3768da1ed50fcb$var$preloadPropsMap.get(styleProps)) && $7f3768da1ed50fcb$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $7f3768da1ed50fcb$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $7f3768da1ed50fcb$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $7f3768da1ed50fcb$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $7f3768da1ed50fcb$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($7f3768da1ed50fcb$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $7f3768da1ed50fcb$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $7f3768da1ed50fcb$var$preloadPropsMap.get(instance$250)) instance = $7f3768da1ed50fcb$var$assign({}, props), $7f3768da1ed50fcb$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $7f3768da1ed50fcb$var$markNodeAsHoistable(styleProps);
            $7f3768da1ed50fcb$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $7f3768da1ed50fcb$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $7f3768da1ed50fcb$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $7f3768da1ed50fcb$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $7f3768da1ed50fcb$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $7f3768da1ed50fcb$var$tagCaches = null;
function $7f3768da1ed50fcb$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $7f3768da1ed50fcb$var$tagCaches) {
        var cache = new Map();
        var caches = $7f3768da1ed50fcb$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $7f3768da1ed50fcb$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$7f3768da1ed50fcb$var$internalHoistableMarker] || node[$7f3768da1ed50fcb$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $7f3768da1ed50fcb$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $7f3768da1ed50fcb$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $7f3768da1ed50fcb$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $7f3768da1ed50fcb$var$suspendedState = null;
function $7f3768da1ed50fcb$var$noop() {}
function $7f3768da1ed50fcb$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $7f3768da1ed50fcb$var$suspendedState) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(475));
    var state = $7f3768da1ed50fcb$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $7f3768da1ed50fcb$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($7f3768da1ed50fcb$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $7f3768da1ed50fcb$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $7f3768da1ed50fcb$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $7f3768da1ed50fcb$var$stylesheetPropsFromRawProps(props);
            (key = $7f3768da1ed50fcb$var$preloadPropsMap.get(key)) && $7f3768da1ed50fcb$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $7f3768da1ed50fcb$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $7f3768da1ed50fcb$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $7f3768da1ed50fcb$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $7f3768da1ed50fcb$var$waitForCommitToBeReady() {
    if (null === $7f3768da1ed50fcb$var$suspendedState) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(475));
    var state = $7f3768da1ed50fcb$var$suspendedState;
    state.stylesheets && 0 === state.count && $7f3768da1ed50fcb$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $7f3768da1ed50fcb$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $7f3768da1ed50fcb$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $7f3768da1ed50fcb$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $7f3768da1ed50fcb$var$precedencesByRoot = null;
function $7f3768da1ed50fcb$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $7f3768da1ed50fcb$var$precedencesByRoot = new Map(), resources.forEach($7f3768da1ed50fcb$var$insertStylesheetIntoRoot, state), $7f3768da1ed50fcb$var$precedencesByRoot = null, $7f3768da1ed50fcb$var$onUnsuspend.call(state));
}
function $7f3768da1ed50fcb$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $7f3768da1ed50fcb$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $7f3768da1ed50fcb$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $7f3768da1ed50fcb$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $7f3768da1ed50fcb$var$HostTransitionContext = {
    $$typeof: $7f3768da1ed50fcb$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $7f3768da1ed50fcb$var$sharedNotPendingObject,
    _currentValue2: $7f3768da1ed50fcb$var$sharedNotPendingObject,
    _threadCount: 0
};
function $7f3768da1ed50fcb$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $7f3768da1ed50fcb$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $7f3768da1ed50fcb$var$createLaneMap(0);
    this.hiddenUpdates = $7f3768da1ed50fcb$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $7f3768da1ed50fcb$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $7f3768da1ed50fcb$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $7f3768da1ed50fcb$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $7f3768da1ed50fcb$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $7f3768da1ed50fcb$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $7f3768da1ed50fcb$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $7f3768da1ed50fcb$var$emptyContextObject;
    parentComponent = $7f3768da1ed50fcb$var$emptyContextObject;
    return parentComponent;
}
function $7f3768da1ed50fcb$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $7f3768da1ed50fcb$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $7f3768da1ed50fcb$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $7f3768da1ed50fcb$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($7f3768da1ed50fcb$var$scheduleUpdateOnFiber(element, rootFiber, lane), $7f3768da1ed50fcb$var$entangleTransitions(element, rootFiber, lane));
}
function $7f3768da1ed50fcb$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $7f3768da1ed50fcb$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $7f3768da1ed50fcb$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $7f3768da1ed50fcb$var$markRetryLaneImpl(fiber, retryLane);
}
function $7f3768da1ed50fcb$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $7f3768da1ed50fcb$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $7f3768da1ed50fcb$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $7f3768da1ed50fcb$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $7f3768da1ed50fcb$var$_enabled = !0;
function $7f3768da1ed50fcb$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $7f3768da1ed50fcb$var$ReactSharedInternals.T;
    $7f3768da1ed50fcb$var$ReactSharedInternals.T = null;
    var previousPriority = $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p;
    try {
        $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = 2, $7f3768da1ed50fcb$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = previousPriority, $7f3768da1ed50fcb$var$ReactSharedInternals.T = prevTransition;
    }
}
function $7f3768da1ed50fcb$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $7f3768da1ed50fcb$var$ReactSharedInternals.T;
    $7f3768da1ed50fcb$var$ReactSharedInternals.T = null;
    var previousPriority = $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p;
    try {
        $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = 8, $7f3768da1ed50fcb$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $7f3768da1ed50fcb$var$ReactDOMSharedInternals.p = previousPriority, $7f3768da1ed50fcb$var$ReactSharedInternals.T = prevTransition;
    }
}
function $7f3768da1ed50fcb$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($7f3768da1ed50fcb$var$_enabled) {
        var blockedOn = $7f3768da1ed50fcb$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $7f3768da1ed50fcb$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $7f3768da1ed50fcb$var$return_targetInst, targetContainer), $7f3768da1ed50fcb$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($7f3768da1ed50fcb$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($7f3768da1ed50fcb$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $7f3768da1ed50fcb$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $7f3768da1ed50fcb$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $7f3768da1ed50fcb$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $7f3768da1ed50fcb$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $7f3768da1ed50fcb$var$ensureRootIsScheduled(fiber);
                                0 === ($7f3768da1ed50fcb$var$executionContext & 6) && ($7f3768da1ed50fcb$var$workInProgressRootRenderTargetTime = $7f3768da1ed50fcb$var$now() + 500, $7f3768da1ed50fcb$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $7f3768da1ed50fcb$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $7f3768da1ed50fcb$var$scheduleUpdateOnFiber(root, fiber, 2), $7f3768da1ed50fcb$var$flushSyncWork$1(), $7f3768da1ed50fcb$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $7f3768da1ed50fcb$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $7f3768da1ed50fcb$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $7f3768da1ed50fcb$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $7f3768da1ed50fcb$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $7f3768da1ed50fcb$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $7f3768da1ed50fcb$var$getEventTarget(nativeEvent);
    return $7f3768da1ed50fcb$var$findInstanceBlockingTarget(nativeEvent);
}
var $7f3768da1ed50fcb$var$return_targetInst = null;
function $7f3768da1ed50fcb$var$findInstanceBlockingTarget(targetNode) {
    $7f3768da1ed50fcb$var$return_targetInst = null;
    targetNode = $7f3768da1ed50fcb$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $7f3768da1ed50fcb$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $7f3768da1ed50fcb$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $7f3768da1ed50fcb$var$return_targetInst = targetNode;
    return null;
}
function $7f3768da1ed50fcb$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($7f3768da1ed50fcb$var$getCurrentPriorityLevel()){
                case $7f3768da1ed50fcb$var$ImmediatePriority:
                    return 2;
                case $7f3768da1ed50fcb$var$UserBlockingPriority:
                    return 8;
                case $7f3768da1ed50fcb$var$NormalPriority$1:
                case $7f3768da1ed50fcb$var$LowPriority:
                    return 32;
                case $7f3768da1ed50fcb$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $7f3768da1ed50fcb$var$hasScheduledReplayAttempt = !1, $7f3768da1ed50fcb$var$queuedFocus = null, $7f3768da1ed50fcb$var$queuedDrag = null, $7f3768da1ed50fcb$var$queuedMouse = null, $7f3768da1ed50fcb$var$queuedPointers = new Map(), $7f3768da1ed50fcb$var$queuedPointerCaptures = new Map(), $7f3768da1ed50fcb$var$queuedExplicitHydrationTargets = [], $7f3768da1ed50fcb$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $7f3768da1ed50fcb$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $7f3768da1ed50fcb$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $7f3768da1ed50fcb$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $7f3768da1ed50fcb$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $7f3768da1ed50fcb$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $7f3768da1ed50fcb$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $7f3768da1ed50fcb$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $7f3768da1ed50fcb$var$getInstanceFromNode(blockedOn), null !== blockedOn && $7f3768da1ed50fcb$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $7f3768da1ed50fcb$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $7f3768da1ed50fcb$var$queuedFocus = $7f3768da1ed50fcb$var$accumulateOrCreateContinuousQueuedReplayableEvent($7f3768da1ed50fcb$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $7f3768da1ed50fcb$var$queuedDrag = $7f3768da1ed50fcb$var$accumulateOrCreateContinuousQueuedReplayableEvent($7f3768da1ed50fcb$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $7f3768da1ed50fcb$var$queuedMouse = $7f3768da1ed50fcb$var$accumulateOrCreateContinuousQueuedReplayableEvent($7f3768da1ed50fcb$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $7f3768da1ed50fcb$var$queuedPointers.set(pointerId, $7f3768da1ed50fcb$var$accumulateOrCreateContinuousQueuedReplayableEvent($7f3768da1ed50fcb$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $7f3768da1ed50fcb$var$queuedPointerCaptures.set(pointerId, $7f3768da1ed50fcb$var$accumulateOrCreateContinuousQueuedReplayableEvent($7f3768da1ed50fcb$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $7f3768da1ed50fcb$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $7f3768da1ed50fcb$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $7f3768da1ed50fcb$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $7f3768da1ed50fcb$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $7f3768da1ed50fcb$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $7f3768da1ed50fcb$var$requestUpdateLane();
                            lane = $7f3768da1ed50fcb$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $7f3768da1ed50fcb$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $7f3768da1ed50fcb$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $7f3768da1ed50fcb$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $7f3768da1ed50fcb$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $7f3768da1ed50fcb$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $7f3768da1ed50fcb$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $7f3768da1ed50fcb$var$currentReplayingEvent = null;
        } else return targetContainers = $7f3768da1ed50fcb$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $7f3768da1ed50fcb$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $7f3768da1ed50fcb$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $7f3768da1ed50fcb$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $7f3768da1ed50fcb$var$replayUnblockedEvents() {
    $7f3768da1ed50fcb$var$hasScheduledReplayAttempt = !1;
    null !== $7f3768da1ed50fcb$var$queuedFocus && $7f3768da1ed50fcb$var$attemptReplayContinuousQueuedEvent($7f3768da1ed50fcb$var$queuedFocus) && ($7f3768da1ed50fcb$var$queuedFocus = null);
    null !== $7f3768da1ed50fcb$var$queuedDrag && $7f3768da1ed50fcb$var$attemptReplayContinuousQueuedEvent($7f3768da1ed50fcb$var$queuedDrag) && ($7f3768da1ed50fcb$var$queuedDrag = null);
    null !== $7f3768da1ed50fcb$var$queuedMouse && $7f3768da1ed50fcb$var$attemptReplayContinuousQueuedEvent($7f3768da1ed50fcb$var$queuedMouse) && ($7f3768da1ed50fcb$var$queuedMouse = null);
    $7f3768da1ed50fcb$var$queuedPointers.forEach($7f3768da1ed50fcb$var$attemptReplayContinuousQueuedEventInMap);
    $7f3768da1ed50fcb$var$queuedPointerCaptures.forEach($7f3768da1ed50fcb$var$attemptReplayContinuousQueuedEventInMap);
}
function $7f3768da1ed50fcb$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $7f3768da1ed50fcb$var$hasScheduledReplayAttempt || ($7f3768da1ed50fcb$var$hasScheduledReplayAttempt = !0, $2ixDp.unstable_scheduleCallback($2ixDp.unstable_NormalPriority, $7f3768da1ed50fcb$var$replayUnblockedEvents)));
}
var $7f3768da1ed50fcb$var$lastScheduledReplayQueue = null;
function $7f3768da1ed50fcb$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $7f3768da1ed50fcb$var$lastScheduledReplayQueue !== formReplayingQueue && ($7f3768da1ed50fcb$var$lastScheduledReplayQueue = formReplayingQueue, $2ixDp.unstable_scheduleCallback($2ixDp.unstable_NormalPriority, function() {
        $7f3768da1ed50fcb$var$lastScheduledReplayQueue === formReplayingQueue && ($7f3768da1ed50fcb$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $7f3768da1ed50fcb$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $7f3768da1ed50fcb$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $7f3768da1ed50fcb$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $7f3768da1ed50fcb$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $7f3768da1ed50fcb$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $7f3768da1ed50fcb$var$queuedFocus && $7f3768da1ed50fcb$var$scheduleCallbackIfUnblocked($7f3768da1ed50fcb$var$queuedFocus, unblocked);
    null !== $7f3768da1ed50fcb$var$queuedDrag && $7f3768da1ed50fcb$var$scheduleCallbackIfUnblocked($7f3768da1ed50fcb$var$queuedDrag, unblocked);
    null !== $7f3768da1ed50fcb$var$queuedMouse && $7f3768da1ed50fcb$var$scheduleCallbackIfUnblocked($7f3768da1ed50fcb$var$queuedMouse, unblocked);
    $7f3768da1ed50fcb$var$queuedPointers.forEach(unblock);
    $7f3768da1ed50fcb$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $7f3768da1ed50fcb$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $7f3768da1ed50fcb$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $7f3768da1ed50fcb$var$queuedExplicitHydrationTargets.length && (i = $7f3768da1ed50fcb$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$7f3768da1ed50fcb$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $7f3768da1ed50fcb$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$7f3768da1ed50fcb$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $7f3768da1ed50fcb$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$7f3768da1ed50fcb$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $7f3768da1ed50fcb$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $7f3768da1ed50fcb$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $7f3768da1ed50fcb$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$7f3768da1ed50fcb$var$ReactDOMHydrationRoot.prototype.render = $7f3768da1ed50fcb$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(409));
    var current = root.current, lane = $7f3768da1ed50fcb$var$requestUpdateLane();
    $7f3768da1ed50fcb$var$updateContainerImpl(current, lane, children, root, null, null);
};
$7f3768da1ed50fcb$var$ReactDOMHydrationRoot.prototype.unmount = $7f3768da1ed50fcb$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $7f3768da1ed50fcb$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $7f3768da1ed50fcb$var$flushSyncWork$1();
        container[$7f3768da1ed50fcb$var$internalContainerInstanceKey] = null;
    }
};
function $7f3768da1ed50fcb$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$7f3768da1ed50fcb$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $7f3768da1ed50fcb$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $7f3768da1ed50fcb$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $7f3768da1ed50fcb$var$queuedExplicitHydrationTargets[i].priority; i++);
        $7f3768da1ed50fcb$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $7f3768da1ed50fcb$var$attemptExplicitHydrationTarget(target);
    }
};
var $7f3768da1ed50fcb$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $h96tf.version;
if ("19.1.1" !== $7f3768da1ed50fcb$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(527, $7f3768da1ed50fcb$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.1"));
$7f3768da1ed50fcb$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $7f3768da1ed50fcb$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $7f3768da1ed50fcb$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $7f3768da1ed50fcb$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $7f3768da1ed50fcb$var$ReactSharedInternals,
    reconcilerVersion: "19.1.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $7f3768da1ed50fcb$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$7f3768da1ed50fcb$var$hook$jscomp$inline_2257.isDisabled && $7f3768da1ed50fcb$var$hook$jscomp$inline_2257.supportsFiber) try {
        $7f3768da1ed50fcb$var$rendererID = $7f3768da1ed50fcb$var$hook$jscomp$inline_2257.inject($7f3768da1ed50fcb$var$internals$jscomp$inline_2256), $7f3768da1ed50fcb$var$injectedHook = $7f3768da1ed50fcb$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$7f3768da1ed50fcb$export$882461b6382ed46c = function(container, options) {
    if (!$7f3768da1ed50fcb$var$isValidContainer(container)) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $7f3768da1ed50fcb$var$defaultOnUncaughtError, onCaughtError = $7f3768da1ed50fcb$var$defaultOnCaughtError, onRecoverableError = $7f3768da1ed50fcb$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $7f3768da1ed50fcb$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$7f3768da1ed50fcb$var$internalContainerInstanceKey] = options.current;
    $7f3768da1ed50fcb$var$listenToAllSupportedEvents(container);
    return new $7f3768da1ed50fcb$var$ReactDOMRoot(options);
};
$7f3768da1ed50fcb$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$7f3768da1ed50fcb$var$isValidContainer(container)) throw Error($7f3768da1ed50fcb$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $7f3768da1ed50fcb$var$defaultOnUncaughtError, onCaughtError = $7f3768da1ed50fcb$var$defaultOnCaughtError, onRecoverableError = $7f3768da1ed50fcb$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $7f3768da1ed50fcb$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $7f3768da1ed50fcb$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $7f3768da1ed50fcb$var$requestUpdateLane();
    isStrictMode = $7f3768da1ed50fcb$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $7f3768da1ed50fcb$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $7f3768da1ed50fcb$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $7f3768da1ed50fcb$var$markRootUpdated$1(initialChildren, options);
    $7f3768da1ed50fcb$var$ensureRootIsScheduled(initialChildren);
    container[$7f3768da1ed50fcb$var$internalContainerInstanceKey] = initialChildren.current;
    $7f3768da1ed50fcb$var$listenToAllSupportedEvents(container);
    return new $7f3768da1ed50fcb$var$ReactDOMHydrationRoot(initialChildren);
};
$7f3768da1ed50fcb$export$83d89fbfd8236492 = "19.1.1";

});
parcelRegister("2ixDp", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9XcR1"));

});
parcelRegister("9XcR1", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $73f3984cb3ac8864$export$c4744153514ff05d; }, function (v) { return $73f3984cb3ac8864$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $73f3984cb3ac8864$export$3e506c1ccc9cc1a7; }, function (v) { return $73f3984cb3ac8864$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $73f3984cb3ac8864$export$e26fe2ed2fa76875; }, function (v) { return $73f3984cb3ac8864$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $73f3984cb3ac8864$export$502329bbf4b505b1; }, function (v) { return $73f3984cb3ac8864$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $73f3984cb3ac8864$export$6e3807111c4874c4; }, function (v) { return $73f3984cb3ac8864$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $73f3984cb3ac8864$export$c27134553091fb3a; }, function (v) { return $73f3984cb3ac8864$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $73f3984cb3ac8864$export$33ee1acdc04fd2a2; }, function (v) { return $73f3984cb3ac8864$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $73f3984cb3ac8864$export$b00a404bbd5edef2; }, function (v) { return $73f3984cb3ac8864$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $73f3984cb3ac8864$export$d66a1c1c77bd778b; }, function (v) { return $73f3984cb3ac8864$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $73f3984cb3ac8864$export$d3dfb8e4810cb555; }, function (v) { return $73f3984cb3ac8864$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $73f3984cb3ac8864$export$72fdf0e06517287b; }, function (v) { return $73f3984cb3ac8864$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $73f3984cb3ac8864$export$816d2913ae6b83b1; }, function (v) { return $73f3984cb3ac8864$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $73f3984cb3ac8864$export$61bcfe829111a1d0; }, function (v) { return $73f3984cb3ac8864$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $73f3984cb3ac8864$export$7ee8c9beb337bc3f; }, function (v) { return $73f3984cb3ac8864$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $73f3984cb3ac8864$export$b5836b71941fa3ed; }, function (v) { return $73f3984cb3ac8864$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $73f3984cb3ac8864$export$cf845f2c119da08a; }, function (v) { return $73f3984cb3ac8864$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $73f3984cb3ac8864$export$c4744153514ff05d;
var $73f3984cb3ac8864$export$3e506c1ccc9cc1a7;
var $73f3984cb3ac8864$export$e26fe2ed2fa76875;
var $73f3984cb3ac8864$export$502329bbf4b505b1;
var $73f3984cb3ac8864$export$6e3807111c4874c4;
var $73f3984cb3ac8864$export$c27134553091fb3a;
var $73f3984cb3ac8864$export$33ee1acdc04fd2a2;
var $73f3984cb3ac8864$export$b00a404bbd5edef2;
var $73f3984cb3ac8864$export$d66a1c1c77bd778b;
var $73f3984cb3ac8864$export$d3dfb8e4810cb555;
var $73f3984cb3ac8864$export$72fdf0e06517287b;
var $73f3984cb3ac8864$export$816d2913ae6b83b1;
var $73f3984cb3ac8864$export$61bcfe829111a1d0;
var $73f3984cb3ac8864$export$7ee8c9beb337bc3f;
var $73f3984cb3ac8864$export$b5836b71941fa3ed;
var $73f3984cb3ac8864$export$cf845f2c119da08a;
"use strict";
function $73f3984cb3ac8864$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $73f3984cb3ac8864$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $73f3984cb3ac8864$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $73f3984cb3ac8864$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $73f3984cb3ac8864$var$compare(left, last)) rightIndex < length && 0 > $73f3984cb3ac8864$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $73f3984cb3ac8864$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $73f3984cb3ac8864$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$73f3984cb3ac8864$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $73f3984cb3ac8864$var$localPerformance = performance;
    $73f3984cb3ac8864$export$c4744153514ff05d = function() {
        return $73f3984cb3ac8864$var$localPerformance.now();
    };
} else {
    var $73f3984cb3ac8864$var$localDate = Date, $73f3984cb3ac8864$var$initialTime = $73f3984cb3ac8864$var$localDate.now();
    $73f3984cb3ac8864$export$c4744153514ff05d = function() {
        return $73f3984cb3ac8864$var$localDate.now() - $73f3984cb3ac8864$var$initialTime;
    };
}
var $73f3984cb3ac8864$var$taskQueue = [], $73f3984cb3ac8864$var$timerQueue = [], $73f3984cb3ac8864$var$taskIdCounter = 1, $73f3984cb3ac8864$var$currentTask = null, $73f3984cb3ac8864$var$currentPriorityLevel = 3, $73f3984cb3ac8864$var$isPerformingWork = !1, $73f3984cb3ac8864$var$isHostCallbackScheduled = !1, $73f3984cb3ac8864$var$isHostTimeoutScheduled = !1, $73f3984cb3ac8864$var$needsPaint = !1, $73f3984cb3ac8864$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $73f3984cb3ac8864$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $73f3984cb3ac8864$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $73f3984cb3ac8864$var$advanceTimers(currentTime) {
    for(var timer = $73f3984cb3ac8864$var$peek($73f3984cb3ac8864$var$timerQueue); null !== timer;){
        if (null === timer.callback) $73f3984cb3ac8864$var$pop($73f3984cb3ac8864$var$timerQueue);
        else if (timer.startTime <= currentTime) $73f3984cb3ac8864$var$pop($73f3984cb3ac8864$var$timerQueue), timer.sortIndex = timer.expirationTime, $73f3984cb3ac8864$var$push($73f3984cb3ac8864$var$taskQueue, timer);
        else break;
        timer = $73f3984cb3ac8864$var$peek($73f3984cb3ac8864$var$timerQueue);
    }
}
function $73f3984cb3ac8864$var$handleTimeout(currentTime) {
    $73f3984cb3ac8864$var$isHostTimeoutScheduled = !1;
    $73f3984cb3ac8864$var$advanceTimers(currentTime);
    if (!$73f3984cb3ac8864$var$isHostCallbackScheduled) {
        if (null !== $73f3984cb3ac8864$var$peek($73f3984cb3ac8864$var$taskQueue)) $73f3984cb3ac8864$var$isHostCallbackScheduled = !0, $73f3984cb3ac8864$var$isMessageLoopRunning || ($73f3984cb3ac8864$var$isMessageLoopRunning = !0, $73f3984cb3ac8864$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $73f3984cb3ac8864$var$peek($73f3984cb3ac8864$var$timerQueue);
            null !== firstTimer && $73f3984cb3ac8864$var$requestHostTimeout($73f3984cb3ac8864$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $73f3984cb3ac8864$var$isMessageLoopRunning = !1, $73f3984cb3ac8864$var$taskTimeoutID = -1, $73f3984cb3ac8864$var$frameInterval = 5, $73f3984cb3ac8864$var$startTime = -1;
function $73f3984cb3ac8864$var$shouldYieldToHost() {
    return $73f3984cb3ac8864$var$needsPaint ? !0 : $73f3984cb3ac8864$export$c4744153514ff05d() - $73f3984cb3ac8864$var$startTime < $73f3984cb3ac8864$var$frameInterval ? !1 : !0;
}
function $73f3984cb3ac8864$var$performWorkUntilDeadline() {
    $73f3984cb3ac8864$var$needsPaint = !1;
    if ($73f3984cb3ac8864$var$isMessageLoopRunning) {
        var currentTime = $73f3984cb3ac8864$export$c4744153514ff05d();
        $73f3984cb3ac8864$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $73f3984cb3ac8864$var$isHostCallbackScheduled = !1;
                $73f3984cb3ac8864$var$isHostTimeoutScheduled && ($73f3984cb3ac8864$var$isHostTimeoutScheduled = !1, $73f3984cb3ac8864$var$localClearTimeout($73f3984cb3ac8864$var$taskTimeoutID), $73f3984cb3ac8864$var$taskTimeoutID = -1);
                $73f3984cb3ac8864$var$isPerformingWork = !0;
                var previousPriorityLevel = $73f3984cb3ac8864$var$currentPriorityLevel;
                try {
                    b: {
                        $73f3984cb3ac8864$var$advanceTimers(currentTime);
                        for($73f3984cb3ac8864$var$currentTask = $73f3984cb3ac8864$var$peek($73f3984cb3ac8864$var$taskQueue); null !== $73f3984cb3ac8864$var$currentTask && !($73f3984cb3ac8864$var$currentTask.expirationTime > currentTime && $73f3984cb3ac8864$var$shouldYieldToHost());){
                            var callback = $73f3984cb3ac8864$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $73f3984cb3ac8864$var$currentTask.callback = null;
                                $73f3984cb3ac8864$var$currentPriorityLevel = $73f3984cb3ac8864$var$currentTask.priorityLevel;
                                var continuationCallback = callback($73f3984cb3ac8864$var$currentTask.expirationTime <= currentTime);
                                currentTime = $73f3984cb3ac8864$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $73f3984cb3ac8864$var$currentTask.callback = continuationCallback;
                                    $73f3984cb3ac8864$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $73f3984cb3ac8864$var$currentTask === $73f3984cb3ac8864$var$peek($73f3984cb3ac8864$var$taskQueue) && $73f3984cb3ac8864$var$pop($73f3984cb3ac8864$var$taskQueue);
                                $73f3984cb3ac8864$var$advanceTimers(currentTime);
                            } else $73f3984cb3ac8864$var$pop($73f3984cb3ac8864$var$taskQueue);
                            $73f3984cb3ac8864$var$currentTask = $73f3984cb3ac8864$var$peek($73f3984cb3ac8864$var$taskQueue);
                        }
                        if (null !== $73f3984cb3ac8864$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $73f3984cb3ac8864$var$peek($73f3984cb3ac8864$var$timerQueue);
                            null !== firstTimer && $73f3984cb3ac8864$var$requestHostTimeout($73f3984cb3ac8864$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $73f3984cb3ac8864$var$currentTask = null, $73f3984cb3ac8864$var$currentPriorityLevel = previousPriorityLevel, $73f3984cb3ac8864$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $73f3984cb3ac8864$var$schedulePerformWorkUntilDeadline() : $73f3984cb3ac8864$var$isMessageLoopRunning = !1;
        }
    }
}
var $73f3984cb3ac8864$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $73f3984cb3ac8864$var$localSetImmediate) $73f3984cb3ac8864$var$schedulePerformWorkUntilDeadline = function() {
    $73f3984cb3ac8864$var$localSetImmediate($73f3984cb3ac8864$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $73f3984cb3ac8864$var$channel = new MessageChannel(), $73f3984cb3ac8864$var$port = $73f3984cb3ac8864$var$channel.port2;
    $73f3984cb3ac8864$var$channel.port1.onmessage = $73f3984cb3ac8864$var$performWorkUntilDeadline;
    $73f3984cb3ac8864$var$schedulePerformWorkUntilDeadline = function() {
        $73f3984cb3ac8864$var$port.postMessage(null);
    };
} else $73f3984cb3ac8864$var$schedulePerformWorkUntilDeadline = function() {
    $73f3984cb3ac8864$var$localSetTimeout($73f3984cb3ac8864$var$performWorkUntilDeadline, 0);
};
function $73f3984cb3ac8864$var$requestHostTimeout(callback, ms) {
    $73f3984cb3ac8864$var$taskTimeoutID = $73f3984cb3ac8864$var$localSetTimeout(function() {
        callback($73f3984cb3ac8864$export$c4744153514ff05d());
    }, ms);
}
$73f3984cb3ac8864$export$3e506c1ccc9cc1a7 = 5;
$73f3984cb3ac8864$export$e26fe2ed2fa76875 = 1;
$73f3984cb3ac8864$export$502329bbf4b505b1 = 4;
$73f3984cb3ac8864$export$6e3807111c4874c4 = 3;
$73f3984cb3ac8864$export$c27134553091fb3a = null;
$73f3984cb3ac8864$export$33ee1acdc04fd2a2 = 2;
$73f3984cb3ac8864$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$73f3984cb3ac8864$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $73f3984cb3ac8864$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$73f3984cb3ac8864$export$d3dfb8e4810cb555 = function() {
    return $73f3984cb3ac8864$var$currentPriorityLevel;
};
$73f3984cb3ac8864$export$72fdf0e06517287b = function(eventHandler) {
    switch($73f3984cb3ac8864$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $73f3984cb3ac8864$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $73f3984cb3ac8864$var$currentPriorityLevel;
    $73f3984cb3ac8864$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $73f3984cb3ac8864$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$73f3984cb3ac8864$export$816d2913ae6b83b1 = function() {
    $73f3984cb3ac8864$var$needsPaint = !0;
};
$73f3984cb3ac8864$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $73f3984cb3ac8864$var$currentPriorityLevel;
    $73f3984cb3ac8864$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $73f3984cb3ac8864$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$73f3984cb3ac8864$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $73f3984cb3ac8864$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $73f3984cb3ac8864$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $73f3984cb3ac8864$var$push($73f3984cb3ac8864$var$timerQueue, priorityLevel), null === $73f3984cb3ac8864$var$peek($73f3984cb3ac8864$var$taskQueue) && priorityLevel === $73f3984cb3ac8864$var$peek($73f3984cb3ac8864$var$timerQueue) && ($73f3984cb3ac8864$var$isHostTimeoutScheduled ? ($73f3984cb3ac8864$var$localClearTimeout($73f3984cb3ac8864$var$taskTimeoutID), $73f3984cb3ac8864$var$taskTimeoutID = -1) : $73f3984cb3ac8864$var$isHostTimeoutScheduled = !0, $73f3984cb3ac8864$var$requestHostTimeout($73f3984cb3ac8864$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $73f3984cb3ac8864$var$push($73f3984cb3ac8864$var$taskQueue, priorityLevel), $73f3984cb3ac8864$var$isHostCallbackScheduled || $73f3984cb3ac8864$var$isPerformingWork || ($73f3984cb3ac8864$var$isHostCallbackScheduled = !0, $73f3984cb3ac8864$var$isMessageLoopRunning || ($73f3984cb3ac8864$var$isMessageLoopRunning = !0, $73f3984cb3ac8864$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$73f3984cb3ac8864$export$b5836b71941fa3ed = $73f3984cb3ac8864$var$shouldYieldToHost;
$73f3984cb3ac8864$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $73f3984cb3ac8864$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $73f3984cb3ac8864$var$currentPriorityLevel;
        $73f3984cb3ac8864$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $73f3984cb3ac8864$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("h96tf", function(module, exports) {
'use strict';

module.exports = (parcelRequire("DDZit"));

});

parcelRegister("70Ozn", function(module, exports) {
'use strict';
function $51afc28df60f0937$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($51afc28df60f0937$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$51afc28df60f0937$var$checkDCE();

module.exports = (parcelRequire("7kvDC"));

});
parcelRegister("7kvDC", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $5562f14dc1eac64a$export$69ce8ef3fe5cead0; }, function (v) { return $5562f14dc1eac64a$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $5562f14dc1eac64a$export$d39a5bbd09211389; }, function (v) { return $5562f14dc1eac64a$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $5562f14dc1eac64a$export$cd75ccfd720a3cd4; }, function (v) { return $5562f14dc1eac64a$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $5562f14dc1eac64a$export$a0816fa17a9e79be; }, function (v) { return $5562f14dc1eac64a$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $5562f14dc1eac64a$export$7292efcadded39f3; }, function (v) { return $5562f14dc1eac64a$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $5562f14dc1eac64a$export$da407abadb9b8f86; }, function (v) { return $5562f14dc1eac64a$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $5562f14dc1eac64a$export$314cfea32580671c; }, function (v) { return $5562f14dc1eac64a$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $5562f14dc1eac64a$export$513ccb98c53b8039; }, function (v) { return $5562f14dc1eac64a$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $5562f14dc1eac64a$export$dbca993bc2d264a; }, function (v) { return $5562f14dc1eac64a$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $5562f14dc1eac64a$export$4797a8006f0655d0; }, function (v) { return $5562f14dc1eac64a$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $5562f14dc1eac64a$export$c78a37762a8d58e1; }, function (v) { return $5562f14dc1eac64a$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $5562f14dc1eac64a$export$606f11b2eb45ecc6; }, function (v) { return $5562f14dc1eac64a$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $5562f14dc1eac64a$export$f7e8a0bf92324b1e; }, function (v) { return $5562f14dc1eac64a$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $5562f14dc1eac64a$export$83d89fbfd8236492; }, function (v) { return $5562f14dc1eac64a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5562f14dc1eac64a$export$69ce8ef3fe5cead0;
var $5562f14dc1eac64a$export$d39a5bbd09211389;
var $5562f14dc1eac64a$export$cd75ccfd720a3cd4;
var $5562f14dc1eac64a$export$a0816fa17a9e79be;
var $5562f14dc1eac64a$export$7292efcadded39f3;
var $5562f14dc1eac64a$export$da407abadb9b8f86;
var $5562f14dc1eac64a$export$314cfea32580671c;
var $5562f14dc1eac64a$export$513ccb98c53b8039;
var $5562f14dc1eac64a$export$dbca993bc2d264a;
var $5562f14dc1eac64a$export$4797a8006f0655d0;
var $5562f14dc1eac64a$export$c78a37762a8d58e1;
var $5562f14dc1eac64a$export$606f11b2eb45ecc6;
var $5562f14dc1eac64a$export$f7e8a0bf92324b1e;
var $5562f14dc1eac64a$export$83d89fbfd8236492;
"use strict";

var $h96tf = parcelRequire("h96tf");
function $5562f14dc1eac64a$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $5562f14dc1eac64a$var$noop() {}
var $5562f14dc1eac64a$var$Internals = {
    d: {
        f: $5562f14dc1eac64a$var$noop,
        r: function() {
            throw Error($5562f14dc1eac64a$var$formatProdErrorMessage(522));
        },
        D: $5562f14dc1eac64a$var$noop,
        C: $5562f14dc1eac64a$var$noop,
        L: $5562f14dc1eac64a$var$noop,
        m: $5562f14dc1eac64a$var$noop,
        X: $5562f14dc1eac64a$var$noop,
        S: $5562f14dc1eac64a$var$noop,
        M: $5562f14dc1eac64a$var$noop
    },
    p: 0,
    findDOMNode: null
}, $5562f14dc1eac64a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $5562f14dc1eac64a$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5562f14dc1eac64a$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $5562f14dc1eac64a$var$ReactSharedInternals = $h96tf.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $5562f14dc1eac64a$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$5562f14dc1eac64a$export$69ce8ef3fe5cead0 = $5562f14dc1eac64a$var$Internals;
$5562f14dc1eac64a$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($5562f14dc1eac64a$var$formatProdErrorMessage(299));
    return $5562f14dc1eac64a$var$createPortal$1(children, container, null, key);
};
$5562f14dc1eac64a$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $5562f14dc1eac64a$var$ReactSharedInternals.T, previousUpdatePriority = $5562f14dc1eac64a$var$Internals.p;
    try {
        if ($5562f14dc1eac64a$var$ReactSharedInternals.T = null, $5562f14dc1eac64a$var$Internals.p = 2, fn) return fn();
    } finally{
        $5562f14dc1eac64a$var$ReactSharedInternals.T = previousTransition, $5562f14dc1eac64a$var$Internals.p = previousUpdatePriority, $5562f14dc1eac64a$var$Internals.d.f();
    }
};
$5562f14dc1eac64a$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $5562f14dc1eac64a$var$Internals.d.C(href, options));
};
$5562f14dc1eac64a$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $5562f14dc1eac64a$var$Internals.d.D(href);
};
$5562f14dc1eac64a$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $5562f14dc1eac64a$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $5562f14dc1eac64a$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $5562f14dc1eac64a$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$5562f14dc1eac64a$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $5562f14dc1eac64a$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $5562f14dc1eac64a$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $5562f14dc1eac64a$var$Internals.d.M(href);
    }
};
$5562f14dc1eac64a$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $5562f14dc1eac64a$var$getCrossOriginStringAs(as, options.crossOrigin);
        $5562f14dc1eac64a$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$5562f14dc1eac64a$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $5562f14dc1eac64a$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $5562f14dc1eac64a$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $5562f14dc1eac64a$var$Internals.d.m(href);
    }
};
$5562f14dc1eac64a$export$4797a8006f0655d0 = function(form) {
    $5562f14dc1eac64a$var$Internals.d.r(form);
};
$5562f14dc1eac64a$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$5562f14dc1eac64a$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $5562f14dc1eac64a$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$5562f14dc1eac64a$export$f7e8a0bf92324b1e = function() {
    return $5562f14dc1eac64a$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$5562f14dc1eac64a$export$83d89fbfd8236492 = "19.1.1";

});



var $039a8d5005718833$exports = {};
'use strict';

$039a8d5005718833$exports = (parcelRequire("hIGkg"));



var $h96tf = parcelRequire("h96tf");
var $cfd79d02f9a77f3e$exports = {};
'use strict';
function $cfd79d02f9a77f3e$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($cfd79d02f9a77f3e$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$cfd79d02f9a77f3e$var$checkDCE();

$cfd79d02f9a77f3e$exports = (parcelRequire("aVay2"));


/*!
  * Bootstrap v5.3.7 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $4d5be6a614affd41$exports = {};

$parcel$export($4d5be6a614affd41$exports, "popperGenerator", function () { return $a808533111537e33$export$ed5e13716264f202; });
$parcel$export($4d5be6a614affd41$exports, "detectOverflow", function () { return $cc0a6a50e5cde91f$export$2e2bcd8739ae039; });
$parcel$export($4d5be6a614affd41$exports, "createPopperBase", function () { return $a808533111537e33$export$8f7491d57c8f97a9; });
$parcel$export($4d5be6a614affd41$exports, "createPopper", function () { return $aa6d72b066192613$export$8f7491d57c8f97a9; });
$parcel$export($4d5be6a614affd41$exports, "createPopperLite", function () { return $c034b64664ee6bd4$export$8f7491d57c8f97a9; });
var $e93c158083b8a720$exports = {};

$parcel$export($e93c158083b8a720$exports, "top", function () { return $e93c158083b8a720$export$1e95b668f3b82d; });
$parcel$export($e93c158083b8a720$exports, "bottom", function () { return $e93c158083b8a720$export$40e543e69a8b3fbb; });
$parcel$export($e93c158083b8a720$exports, "right", function () { return $e93c158083b8a720$export$79ffe56a765070d2; });
$parcel$export($e93c158083b8a720$exports, "left", function () { return $e93c158083b8a720$export$eabcd2c8791e7bf4; });
$parcel$export($e93c158083b8a720$exports, "auto", function () { return $e93c158083b8a720$export$dfb5619354ba860; });
$parcel$export($e93c158083b8a720$exports, "basePlacements", function () { return $e93c158083b8a720$export$aec2ce47c367b8c3; });
$parcel$export($e93c158083b8a720$exports, "start", function () { return $e93c158083b8a720$export$b3571188c770cc5a; });
$parcel$export($e93c158083b8a720$exports, "end", function () { return $e93c158083b8a720$export$bd5df0f255a350f8; });
$parcel$export($e93c158083b8a720$exports, "clippingParents", function () { return $e93c158083b8a720$export$390fd549c5303b4d; });
$parcel$export($e93c158083b8a720$exports, "viewport", function () { return $e93c158083b8a720$export$d7b7311ec04a3e8f; });
$parcel$export($e93c158083b8a720$exports, "popper", function () { return $e93c158083b8a720$export$ae5ab1c730825774; });
$parcel$export($e93c158083b8a720$exports, "reference", function () { return $e93c158083b8a720$export$ca50aac9f3ba507f; });
$parcel$export($e93c158083b8a720$exports, "variationPlacements", function () { return $e93c158083b8a720$export$368f9a87e87fa4e1; });
$parcel$export($e93c158083b8a720$exports, "placements", function () { return $e93c158083b8a720$export$803cd8101b6c182b; });
$parcel$export($e93c158083b8a720$exports, "beforeRead", function () { return $e93c158083b8a720$export$421679a7c3d56e; });
$parcel$export($e93c158083b8a720$exports, "read", function () { return $e93c158083b8a720$export$aafa59e2e03f2942; });
$parcel$export($e93c158083b8a720$exports, "afterRead", function () { return $e93c158083b8a720$export$6964f6c886723980; });
$parcel$export($e93c158083b8a720$exports, "beforeMain", function () { return $e93c158083b8a720$export$c65e99957a05207c; });
$parcel$export($e93c158083b8a720$exports, "main", function () { return $e93c158083b8a720$export$f22da7240b7add18; });
$parcel$export($e93c158083b8a720$exports, "afterMain", function () { return $e93c158083b8a720$export$bab79516f2d662fe; });
$parcel$export($e93c158083b8a720$exports, "beforeWrite", function () { return $e93c158083b8a720$export$8d4d2d70e7d46032; });
$parcel$export($e93c158083b8a720$exports, "write", function () { return $e93c158083b8a720$export$68d8715fc104d294; });
$parcel$export($e93c158083b8a720$exports, "afterWrite", function () { return $e93c158083b8a720$export$70a6e5159acce2e6; });
$parcel$export($e93c158083b8a720$exports, "modifierPhases", function () { return $e93c158083b8a720$export$d087d3878fdf71d5; });
var $e93c158083b8a720$export$1e95b668f3b82d = 'top';
var $e93c158083b8a720$export$40e543e69a8b3fbb = 'bottom';
var $e93c158083b8a720$export$79ffe56a765070d2 = 'right';
var $e93c158083b8a720$export$eabcd2c8791e7bf4 = 'left';
var $e93c158083b8a720$export$dfb5619354ba860 = 'auto';
var $e93c158083b8a720$export$aec2ce47c367b8c3 = [
    $e93c158083b8a720$export$1e95b668f3b82d,
    $e93c158083b8a720$export$40e543e69a8b3fbb,
    $e93c158083b8a720$export$79ffe56a765070d2,
    $e93c158083b8a720$export$eabcd2c8791e7bf4
];
var $e93c158083b8a720$export$b3571188c770cc5a = 'start';
var $e93c158083b8a720$export$bd5df0f255a350f8 = 'end';
var $e93c158083b8a720$export$390fd549c5303b4d = 'clippingParents';
var $e93c158083b8a720$export$d7b7311ec04a3e8f = 'viewport';
var $e93c158083b8a720$export$ae5ab1c730825774 = 'popper';
var $e93c158083b8a720$export$ca50aac9f3ba507f = 'reference';
var $e93c158083b8a720$export$368f9a87e87fa4e1 = /*#__PURE__*/ $e93c158083b8a720$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $e93c158083b8a720$export$b3571188c770cc5a,
        placement + "-" + $e93c158083b8a720$export$bd5df0f255a350f8
    ]);
}, []);
var $e93c158083b8a720$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($e93c158083b8a720$export$aec2ce47c367b8c3, [
    $e93c158083b8a720$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $e93c158083b8a720$export$b3571188c770cc5a,
        placement + "-" + $e93c158083b8a720$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $e93c158083b8a720$export$421679a7c3d56e = 'beforeRead';
var $e93c158083b8a720$export$aafa59e2e03f2942 = 'read';
var $e93c158083b8a720$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $e93c158083b8a720$export$c65e99957a05207c = 'beforeMain';
var $e93c158083b8a720$export$f22da7240b7add18 = 'main';
var $e93c158083b8a720$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $e93c158083b8a720$export$8d4d2d70e7d46032 = 'beforeWrite';
var $e93c158083b8a720$export$68d8715fc104d294 = 'write';
var $e93c158083b8a720$export$70a6e5159acce2e6 = 'afterWrite';
var $e93c158083b8a720$export$d087d3878fdf71d5 = [
    $e93c158083b8a720$export$421679a7c3d56e,
    $e93c158083b8a720$export$aafa59e2e03f2942,
    $e93c158083b8a720$export$6964f6c886723980,
    $e93c158083b8a720$export$c65e99957a05207c,
    $e93c158083b8a720$export$f22da7240b7add18,
    $e93c158083b8a720$export$bab79516f2d662fe,
    $e93c158083b8a720$export$8d4d2d70e7d46032,
    $e93c158083b8a720$export$68d8715fc104d294,
    $e93c158083b8a720$export$70a6e5159acce2e6
];


var $678a560bc0da2128$exports = {};

$parcel$export($678a560bc0da2128$exports, "applyStyles", function () { return $55d0ea01aaeddcc3$export$2e2bcd8739ae039; });
$parcel$export($678a560bc0da2128$exports, "arrow", function () { return $1134ffb51d1d44b0$export$2e2bcd8739ae039; });
$parcel$export($678a560bc0da2128$exports, "computeStyles", function () { return $8c46fe5cfb412964$export$2e2bcd8739ae039; });
$parcel$export($678a560bc0da2128$exports, "eventListeners", function () { return $ff2099ac94aa32d6$export$2e2bcd8739ae039; });
$parcel$export($678a560bc0da2128$exports, "flip", function () { return $94736cb2c245f35f$export$2e2bcd8739ae039; });
$parcel$export($678a560bc0da2128$exports, "hide", function () { return $d6729403daf339ff$export$2e2bcd8739ae039; });
$parcel$export($678a560bc0da2128$exports, "offset", function () { return $1c6c897baf7ab5d1$export$2e2bcd8739ae039; });
$parcel$export($678a560bc0da2128$exports, "popperOffsets", function () { return $641ac6891aa1e1c0$export$2e2bcd8739ae039; });
$parcel$export($678a560bc0da2128$exports, "preventOverflow", function () { return $99d46f783ebc0ae8$export$2e2bcd8739ae039; });
function $37fd052579cb1bb3$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $bbdd3bbeb8780031$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $0f13250bc169227f$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0f13250bc169227f$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0f13250bc169227f$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $55d0ea01aaeddcc3$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $0f13250bc169227f$export$1b3bfaa9684536aa)(element) || !(0, $37fd052579cb1bb3$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $55d0ea01aaeddcc3$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $0f13250bc169227f$export$1b3bfaa9684536aa)(element) || !(0, $37fd052579cb1bb3$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $55d0ea01aaeddcc3$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $55d0ea01aaeddcc3$var$applyStyles,
    effect: $55d0ea01aaeddcc3$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $4ab1490debb5ed21$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $1ce3ff52adb4d265$export$8960430cfd85939f = Math.max;
var $1ce3ff52adb4d265$export$96ec731ed4dcb222 = Math.min;
var $1ce3ff52adb4d265$export$2077e0241d6afd3c = Math.round;



function $41be600fd6522d2d$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b423faa2869aa210$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $41be600fd6522d2d$export$2e2bcd8739ae039)());
}


function $e523b545e2c7fb34$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $0f13250bc169227f$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $1ce3ff52adb4d265$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $1ce3ff52adb4d265$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $0f13250bc169227f$export$45a5e7f76e0caa8d)(element) ? (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b423faa2869aa210$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $efc13ab136a2cd7b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $e523b545e2c7fb34$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $334970cc4a30c165$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $0f13250bc169227f$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $53e71bd08264aaeb$export$2e2bcd8739ae039(element) {
    return (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $8e2e4886eb1f4561$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $37fd052579cb1bb3$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0f53e9314ae9bee3$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $0f13250bc169227f$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $2c4f5cd45234b469$export$2e2bcd8739ae039(element) {
    if ((0, $37fd052579cb1bb3$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $0f13250bc169227f$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0f53e9314ae9bee3$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $7255ecbbad9fd937$var$getTrueOffsetParent(element) {
    if (!(0, $0f13250bc169227f$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $53e71bd08264aaeb$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $7255ecbbad9fd937$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $41be600fd6522d2d$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $41be600fd6522d2d$export$2e2bcd8739ae039)());
    if (isIE && (0, $0f13250bc169227f$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $53e71bd08264aaeb$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $2c4f5cd45234b469$export$2e2bcd8739ae039)(element);
    if ((0, $0f13250bc169227f$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $0f13250bc169227f$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $37fd052579cb1bb3$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $53e71bd08264aaeb$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $7255ecbbad9fd937$export$2e2bcd8739ae039(element) {
    var window = (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(element);
    var offsetParent = $7255ecbbad9fd937$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $8e2e4886eb1f4561$export$2e2bcd8739ae039)(offsetParent) && (0, $53e71bd08264aaeb$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $7255ecbbad9fd937$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $37fd052579cb1bb3$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $37fd052579cb1bb3$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $53e71bd08264aaeb$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $7255ecbbad9fd937$var$getContainingBlock(element) || window;
}


function $be163e7ce5e31d5d$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $3b1ad643a618174b$export$f28d906d67a997f3(min, value, max) {
    return (0, $1ce3ff52adb4d265$export$8960430cfd85939f)(min, (0, $1ce3ff52adb4d265$export$96ec731ed4dcb222)(value, max));
}
function $3b1ad643a618174b$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $3b1ad643a618174b$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $91852900b8338243$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $bdc4f2a77991297f$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $91852900b8338243$export$2e2bcd8739ae039)(), paddingObject);
}


function $2307b20aa2563386$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $1134ffb51d1d44b0$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $bdc4f2a77991297f$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $2307b20aa2563386$export$2e2bcd8739ae039)(padding, (0, $e93c158083b8a720$export$aec2ce47c367b8c3)));
};
function $1134ffb51d1d44b0$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $4ab1490debb5ed21$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $be163e7ce5e31d5d$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $e93c158083b8a720$export$eabcd2c8791e7bf4),
        (0, $e93c158083b8a720$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1134ffb51d1d44b0$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $efc13ab136a2cd7b$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $e93c158083b8a720$export$1e95b668f3b82d) : (0, $e93c158083b8a720$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $e93c158083b8a720$export$40e543e69a8b3fbb) : (0, $e93c158083b8a720$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $7255ecbbad9fd937$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $3b1ad643a618174b$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1134ffb51d1d44b0$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $334970cc4a30c165$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1134ffb51d1d44b0$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $1134ffb51d1d44b0$var$arrow,
    effect: $1134ffb51d1d44b0$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $bea736c019bd1409$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $8c46fe5cfb412964$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $8c46fe5cfb412964$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $1ce3ff52adb4d265$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $1ce3ff52adb4d265$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $8c46fe5cfb412964$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $e93c158083b8a720$export$eabcd2c8791e7bf4);
    var sideY = (0, $e93c158083b8a720$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $7255ecbbad9fd937$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0f53e9314ae9bee3$export$2e2bcd8739ae039)(popper);
            if ((0, $53e71bd08264aaeb$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $e93c158083b8a720$export$1e95b668f3b82d) || (placement === (0, $e93c158083b8a720$export$eabcd2c8791e7bf4) || placement === (0, $e93c158083b8a720$export$79ffe56a765070d2)) && variation === (0, $e93c158083b8a720$export$bd5df0f255a350f8)) {
            sideY = (0, $e93c158083b8a720$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $e93c158083b8a720$export$eabcd2c8791e7bf4) || (placement === (0, $e93c158083b8a720$export$1e95b668f3b82d) || placement === (0, $e93c158083b8a720$export$40e543e69a8b3fbb)) && variation === (0, $e93c158083b8a720$export$bd5df0f255a350f8)) {
            sideX = (0, $e93c158083b8a720$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $8c46fe5cfb412964$var$unsetSides);
    var _ref4 = roundOffsets === true ? $8c46fe5cfb412964$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $8c46fe5cfb412964$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $4ab1490debb5ed21$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $bea736c019bd1409$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $8c46fe5cfb412964$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $8c46fe5cfb412964$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8c46fe5cfb412964$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $8c46fe5cfb412964$var$computeStyles,
    data: {}
};



var $ff2099ac94aa32d6$var$passive = {
    passive: true
};
function $ff2099ac94aa32d6$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $ff2099ac94aa32d6$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $ff2099ac94aa32d6$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $ff2099ac94aa32d6$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $ff2099ac94aa32d6$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff2099ac94aa32d6$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $ff2099ac94aa32d6$var$effect,
    data: {}
};


var $8b61f158b0db0e69$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $8b61f158b0db0e69$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $8b61f158b0db0e69$var$hash[matched];
    });
}



var $b61cc6c9401c3420$var$hash = {
    start: 'end',
    end: 'start'
};
function $b61cc6c9401c3420$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b61cc6c9401c3420$var$hash[matched];
    });
}








function $828adfc7e532f78d$export$2e2bcd8739ae039(node) {
    var win = (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $a656937c8468260c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $e523b545e2c7fb34$export$2e2bcd8739ae039)((0, $0f53e9314ae9bee3$export$2e2bcd8739ae039)(element)).left + (0, $828adfc7e532f78d$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $3a31a034dcd5f4f2$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(element);
    var html = (0, $0f53e9314ae9bee3$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b423faa2869aa210$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $a656937c8468260c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $58f00a5eb9d52bea$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0f53e9314ae9bee3$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $828adfc7e532f78d$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $1ce3ff52adb4d265$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $1ce3ff52adb4d265$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $a656937c8468260c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $53e71bd08264aaeb$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $1ce3ff52adb4d265$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $656081c977c658a0$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $53e71bd08264aaeb$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $fb767edeee5d77ab$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $37fd052579cb1bb3$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $0f13250bc169227f$export$1b3bfaa9684536aa)(node) && (0, $656081c977c658a0$export$2e2bcd8739ae039)(node)) return node;
    return $fb767edeee5d77ab$export$2e2bcd8739ae039((0, $2c4f5cd45234b469$export$2e2bcd8739ae039)(node));
}





function $1150ed723ae2f927$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $fb767edeee5d77ab$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $656081c977c658a0$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1150ed723ae2f927$export$2e2bcd8739ae039((0, $2c4f5cd45234b469$export$2e2bcd8739ae039)(target)));
}










function $83fe2ec4760d6254$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $5e2a63cfd18d5138$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $e523b545e2c7fb34$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $5e2a63cfd18d5138$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $e93c158083b8a720$export$d7b7311ec04a3e8f) ? (0, $83fe2ec4760d6254$export$2e2bcd8739ae039)((0, $3a31a034dcd5f4f2$export$2e2bcd8739ae039)(element, strategy)) : (0, $0f13250bc169227f$export$45a5e7f76e0caa8d)(clippingParent) ? $5e2a63cfd18d5138$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $83fe2ec4760d6254$export$2e2bcd8739ae039)((0, $58f00a5eb9d52bea$export$2e2bcd8739ae039)((0, $0f53e9314ae9bee3$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $5e2a63cfd18d5138$var$getClippingParents(element) {
    var clippingParents = (0, $1150ed723ae2f927$export$2e2bcd8739ae039)((0, $2c4f5cd45234b469$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $53e71bd08264aaeb$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $0f13250bc169227f$export$1b3bfaa9684536aa)(element) ? (0, $7255ecbbad9fd937$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $0f13250bc169227f$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $0f13250bc169227f$export$45a5e7f76e0caa8d)(clippingParent) && (0, $334970cc4a30c165$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $37fd052579cb1bb3$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $5e2a63cfd18d5138$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $5e2a63cfd18d5138$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $5e2a63cfd18d5138$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $1ce3ff52adb4d265$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $1ce3ff52adb4d265$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $1ce3ff52adb4d265$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1ce3ff52adb4d265$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $5e2a63cfd18d5138$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $b2b6ea03070a9aed$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $4ab1490debb5ed21$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $bea736c019bd1409$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $e93c158083b8a720$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $e93c158083b8a720$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $e93c158083b8a720$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $e93c158083b8a720$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $be163e7ce5e31d5d$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $e93c158083b8a720$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $e93c158083b8a720$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $cc0a6a50e5cde91f$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $e93c158083b8a720$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $e93c158083b8a720$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $e93c158083b8a720$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $bdc4f2a77991297f$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $2307b20aa2563386$export$2e2bcd8739ae039)(padding, (0, $e93c158083b8a720$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $e93c158083b8a720$export$ae5ab1c730825774) ? (0, $e93c158083b8a720$export$ca50aac9f3ba507f) : (0, $e93c158083b8a720$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5e2a63cfd18d5138$export$2e2bcd8739ae039)((0, $0f13250bc169227f$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0f53e9314ae9bee3$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $e523b545e2c7fb34$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $b2b6ea03070a9aed$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $83fe2ec4760d6254$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $e93c158083b8a720$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $e93c158083b8a720$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $e93c158083b8a720$export$79ffe56a765070d2),
                (0, $e93c158083b8a720$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $e93c158083b8a720$export$1e95b668f3b82d),
                (0, $e93c158083b8a720$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $d90c9839c0ce2bdd$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $e93c158083b8a720$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $bea736c019bd1409$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $e93c158083b8a720$export$368f9a87e87fa4e1) : (0, $e93c158083b8a720$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $bea736c019bd1409$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $e93c158083b8a720$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $cc0a6a50e5cde91f$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $4ab1490debb5ed21$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $94736cb2c245f35f$var$getExpandedFallbackPlacements(placement) {
    if ((0, $4ab1490debb5ed21$export$2e2bcd8739ae039)(placement) === (0, $e93c158083b8a720$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $8b61f158b0db0e69$export$2e2bcd8739ae039)(placement);
    return [
        (0, $b61cc6c9401c3420$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $b61cc6c9401c3420$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $94736cb2c245f35f$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $4ab1490debb5ed21$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $8b61f158b0db0e69$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $94736cb2c245f35f$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $4ab1490debb5ed21$export$2e2bcd8739ae039)(placement) === (0, $e93c158083b8a720$export$dfb5619354ba860) ? (0, $d90c9839c0ce2bdd$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $4ab1490debb5ed21$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $bea736c019bd1409$export$2e2bcd8739ae039)(placement) === (0, $e93c158083b8a720$export$b3571188c770cc5a);
        var isVertical = [
            (0, $e93c158083b8a720$export$1e95b668f3b82d),
            (0, $e93c158083b8a720$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $cc0a6a50e5cde91f$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $e93c158083b8a720$export$79ffe56a765070d2) : (0, $e93c158083b8a720$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $e93c158083b8a720$export$40e543e69a8b3fbb) : (0, $e93c158083b8a720$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $8b61f158b0db0e69$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $8b61f158b0db0e69$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $94736cb2c245f35f$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $94736cb2c245f35f$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $d6729403daf339ff$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d6729403daf339ff$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $e93c158083b8a720$export$1e95b668f3b82d),
        (0, $e93c158083b8a720$export$79ffe56a765070d2),
        (0, $e93c158083b8a720$export$40e543e69a8b3fbb),
        (0, $e93c158083b8a720$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d6729403daf339ff$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $cc0a6a50e5cde91f$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $cc0a6a50e5cde91f$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d6729403daf339ff$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d6729403daf339ff$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d6729403daf339ff$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d6729403daf339ff$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d6729403daf339ff$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d6729403daf339ff$var$hide
};




function $1c6c897baf7ab5d1$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $4ab1490debb5ed21$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $e93c158083b8a720$export$eabcd2c8791e7bf4),
        (0, $e93c158083b8a720$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $e93c158083b8a720$export$eabcd2c8791e7bf4),
        (0, $e93c158083b8a720$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $1c6c897baf7ab5d1$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $e93c158083b8a720$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $1c6c897baf7ab5d1$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $1c6c897baf7ab5d1$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $1c6c897baf7ab5d1$var$offset
};



function $641ac6891aa1e1c0$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $b2b6ea03070a9aed$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $641ac6891aa1e1c0$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $641ac6891aa1e1c0$var$popperOffsets,
    data: {}
};





function $2f7c703d7d3d8418$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $99d46f783ebc0ae8$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $cc0a6a50e5cde91f$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $4ab1490debb5ed21$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $bea736c019bd1409$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $be163e7ce5e31d5d$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $2f7c703d7d3d8418$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $e93c158083b8a720$export$1e95b668f3b82d) : (0, $e93c158083b8a720$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $e93c158083b8a720$export$40e543e69a8b3fbb) : (0, $e93c158083b8a720$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $e93c158083b8a720$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $e93c158083b8a720$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $efc13ab136a2cd7b$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $91852900b8338243$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $3b1ad643a618174b$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $7255ecbbad9fd937$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $3b1ad643a618174b$export$f28d906d67a997f3)(tether ? (0, $1ce3ff52adb4d265$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $1ce3ff52adb4d265$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $e93c158083b8a720$export$1e95b668f3b82d) : (0, $e93c158083b8a720$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $e93c158083b8a720$export$40e543e69a8b3fbb) : (0, $e93c158083b8a720$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $e93c158083b8a720$export$1e95b668f3b82d),
            (0, $e93c158083b8a720$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $3b1ad643a618174b$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $3b1ad643a618174b$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $99d46f783ebc0ae8$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $99d46f783ebc0ae8$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $402c81f82b235e7b$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b6ffdecd4efd7725$export$2e2bcd8739ae039(node) {
    if (node === (0, $bbdd3bbeb8780031$export$2e2bcd8739ae039)(node) || !(0, $0f13250bc169227f$export$1b3bfaa9684536aa)(node)) return (0, $828adfc7e532f78d$export$2e2bcd8739ae039)(node);
    else return (0, $402c81f82b235e7b$export$2e2bcd8739ae039)(node);
}








function $eff0cd48ca5c2bc2$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $1ce3ff52adb4d265$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $1ce3ff52adb4d265$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $eff0cd48ca5c2bc2$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $0f13250bc169227f$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $0f13250bc169227f$export$1b3bfaa9684536aa)(offsetParent) && $eff0cd48ca5c2bc2$var$isElementScaled(offsetParent);
    var documentElement = (0, $0f53e9314ae9bee3$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $e523b545e2c7fb34$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $37fd052579cb1bb3$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $656081c977c658a0$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b6ffdecd4efd7725$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $0f13250bc169227f$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $e523b545e2c7fb34$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $a656937c8468260c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $926060018a1d8e6f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $926060018a1d8e6f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $926060018a1d8e6f$var$order(modifiers); // order based on phase
    return (0, $e93c158083b8a720$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $252384c862214784$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $d6b11dcb9366fb77$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $a808533111537e33$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $a808533111537e33$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $a808533111537e33$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $a808533111537e33$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $a808533111537e33$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $0f13250bc169227f$export$45a5e7f76e0caa8d)(reference) ? (0, $1150ed723ae2f927$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $1150ed723ae2f927$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $1150ed723ae2f927$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $926060018a1d8e6f$export$2e2bcd8739ae039)((0, $d6b11dcb9366fb77$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$a808533111537e33$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $eff0cd48ca5c2bc2$export$2e2bcd8739ae039)(reference, (0, $7255ecbbad9fd937$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $efc13ab136a2cd7b$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $252384c862214784$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$a808533111537e33$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $a808533111537e33$export$8f7491d57c8f97a9 = /*#__PURE__*/ $a808533111537e33$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $aa6d72b066192613$export$d34966752335dd47 = [
    (0, $ff2099ac94aa32d6$export$2e2bcd8739ae039),
    (0, $641ac6891aa1e1c0$export$2e2bcd8739ae039),
    (0, $8c46fe5cfb412964$export$2e2bcd8739ae039),
    (0, $55d0ea01aaeddcc3$export$2e2bcd8739ae039),
    (0, $1c6c897baf7ab5d1$export$2e2bcd8739ae039),
    (0, $94736cb2c245f35f$export$2e2bcd8739ae039),
    (0, $99d46f783ebc0ae8$export$2e2bcd8739ae039),
    (0, $1134ffb51d1d44b0$export$2e2bcd8739ae039),
    (0, $d6729403daf339ff$export$2e2bcd8739ae039)
];
var $aa6d72b066192613$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $a808533111537e33$export$ed5e13716264f202)({
    defaultModifiers: $aa6d72b066192613$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $c034b64664ee6bd4$export$d34966752335dd47 = [
    (0, $ff2099ac94aa32d6$export$2e2bcd8739ae039),
    (0, $641ac6891aa1e1c0$export$2e2bcd8739ae039),
    (0, $8c46fe5cfb412964$export$2e2bcd8739ae039),
    (0, $55d0ea01aaeddcc3$export$2e2bcd8739ae039)
];
var $c034b64664ee6bd4$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $a808533111537e33$export$ed5e13716264f202)({
    defaultModifiers: $c034b64664ee6bd4$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($4d5be6a614affd41$exports, $e93c158083b8a720$exports);
$parcel$exportWildcard($4d5be6a614affd41$exports, $678a560bc0da2128$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$elementMap = new Map();
const $8c9d2162215f88e6$var$Data = {
    set (element, key, instance) {
        if (!$8c9d2162215f88e6$var$elementMap.has(element)) $8c9d2162215f88e6$var$elementMap.set(element, new Map());
        const instanceMap = $8c9d2162215f88e6$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($8c9d2162215f88e6$var$elementMap.has(element)) return $8c9d2162215f88e6$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$8c9d2162215f88e6$var$elementMap.has(element)) return;
        const instanceMap = $8c9d2162215f88e6$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $8c9d2162215f88e6$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $8c9d2162215f88e6$var$MAX_UID = 1000000;
const $8c9d2162215f88e6$var$MILLISECONDS_MULTIPLIER = 1000;
const $8c9d2162215f88e6$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $8c9d2162215f88e6$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $8c9d2162215f88e6$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $8c9d2162215f88e6$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $8c9d2162215f88e6$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $8c9d2162215f88e6$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $8c9d2162215f88e6$var$MILLISECONDS_MULTIPLIER;
};
const $8c9d2162215f88e6$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($8c9d2162215f88e6$var$TRANSITION_END));
};
const $8c9d2162215f88e6$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $8c9d2162215f88e6$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($8c9d2162215f88e6$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($8c9d2162215f88e6$var$parseSelector(object));
    return null;
};
const $8c9d2162215f88e6$var$isVisible = (element)=>{
    if (!$8c9d2162215f88e6$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $8c9d2162215f88e6$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $8c9d2162215f88e6$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $8c9d2162215f88e6$var$findShadowRoot(element.parentNode);
};
const $8c9d2162215f88e6$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $8c9d2162215f88e6$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $8c9d2162215f88e6$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $8c9d2162215f88e6$var$DOMContentLoadedCallbacks = [];
const $8c9d2162215f88e6$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$8c9d2162215f88e6$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $8c9d2162215f88e6$var$DOMContentLoadedCallbacks)callback();
        });
        $8c9d2162215f88e6$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $8c9d2162215f88e6$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $8c9d2162215f88e6$var$defineJQueryPlugin = (plugin)=>{
    $8c9d2162215f88e6$var$onDOMContentLoaded(()=>{
        const $ = $8c9d2162215f88e6$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $8c9d2162215f88e6$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $8c9d2162215f88e6$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $8c9d2162215f88e6$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $8c9d2162215f88e6$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($8c9d2162215f88e6$var$TRANSITION_END, handler);
        $8c9d2162215f88e6$var$execute(callback);
    };
    transitionElement.addEventListener($8c9d2162215f88e6$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $8c9d2162215f88e6$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $8c9d2162215f88e6$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $8c9d2162215f88e6$var$stripNameRegex = /\..*/;
const $8c9d2162215f88e6$var$stripUidRegex = /::\d+$/;
const $8c9d2162215f88e6$var$eventRegistry = {}; // Events storage
let $8c9d2162215f88e6$var$uidEvent = 1;
const $8c9d2162215f88e6$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $8c9d2162215f88e6$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $8c9d2162215f88e6$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$8c9d2162215f88e6$var$uidEvent++}` || element.uidEvent || $8c9d2162215f88e6$var$uidEvent++;
}
function $8c9d2162215f88e6$var$getElementEvents(element) {
    const uid = $8c9d2162215f88e6$var$makeEventUid(element);
    element.uidEvent = uid;
    $8c9d2162215f88e6$var$eventRegistry[uid] = $8c9d2162215f88e6$var$eventRegistry[uid] || {};
    return $8c9d2162215f88e6$var$eventRegistry[uid];
}
function $8c9d2162215f88e6$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $8c9d2162215f88e6$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $8c9d2162215f88e6$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $8c9d2162215f88e6$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $8c9d2162215f88e6$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $8c9d2162215f88e6$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $8c9d2162215f88e6$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $8c9d2162215f88e6$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $8c9d2162215f88e6$var$getTypeEvent(originalTypeEvent);
    if (!$8c9d2162215f88e6$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $8c9d2162215f88e6$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $8c9d2162215f88e6$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $8c9d2162215f88e6$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $8c9d2162215f88e6$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $8c9d2162215f88e6$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $8c9d2162215f88e6$var$makeEventUid(callable, originalTypeEvent.replace($8c9d2162215f88e6$var$namespaceRegex, ''));
    const fn = isDelegated ? $8c9d2162215f88e6$var$bootstrapDelegationHandler(element, handler, callable) : $8c9d2162215f88e6$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $8c9d2162215f88e6$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $8c9d2162215f88e6$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $8c9d2162215f88e6$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $8c9d2162215f88e6$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $8c9d2162215f88e6$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($8c9d2162215f88e6$var$stripNameRegex, '');
    return $8c9d2162215f88e6$var$customEvents[event] || event;
}
const $8c9d2162215f88e6$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $8c9d2162215f88e6$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $8c9d2162215f88e6$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $8c9d2162215f88e6$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $8c9d2162215f88e6$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $8c9d2162215f88e6$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$8c9d2162215f88e6$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($8c9d2162215f88e6$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $8c9d2162215f88e6$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $8c9d2162215f88e6$var$getjQuery();
        const typeEvent = $8c9d2162215f88e6$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $8c9d2162215f88e6$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $8c9d2162215f88e6$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $8c9d2162215f88e6$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $8c9d2162215f88e6$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $8c9d2162215f88e6$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$8c9d2162215f88e6$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$8c9d2162215f88e6$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $8c9d2162215f88e6$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $8c9d2162215f88e6$var$normalizeData(element.getAttribute(`data-bs-${$8c9d2162215f88e6$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $8c9d2162215f88e6$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $8c9d2162215f88e6$var$isElement(element) ? $8c9d2162215f88e6$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$8c9d2162215f88e6$var$isElement(element) ? $8c9d2162215f88e6$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $8c9d2162215f88e6$var$isElement(value) ? 'element' : $8c9d2162215f88e6$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$VERSION = '5.3.7';
/**
 * Class definition
 */ class $8c9d2162215f88e6$var$BaseComponent extends $8c9d2162215f88e6$var$Config {
    // Public
    dispose() {
        $8c9d2162215f88e6$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $8c9d2162215f88e6$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $8c9d2162215f88e6$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $8c9d2162215f88e6$var$Data.get($8c9d2162215f88e6$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $8c9d2162215f88e6$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
    constructor(element, config){
        super();
        element = $8c9d2162215f88e6$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $8c9d2162215f88e6$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $8c9d2162215f88e6$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$8c9d2162215f88e6$var$parseSelector(sel)).join(',') : null;
};
const $8c9d2162215f88e6$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$8c9d2162215f88e6$var$isDisabled(el) && $8c9d2162215f88e6$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $8c9d2162215f88e6$var$getSelector(element);
        if (selector) return $8c9d2162215f88e6$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $8c9d2162215f88e6$var$getSelector(element);
        return selector ? $8c9d2162215f88e6$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $8c9d2162215f88e6$var$getSelector(element);
        return selector ? $8c9d2162215f88e6$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $8c9d2162215f88e6$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $8c9d2162215f88e6$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($8c9d2162215f88e6$var$isDisabled(this)) return;
        const target = $8c9d2162215f88e6$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$f = 'alert';
const $8c9d2162215f88e6$var$DATA_KEY$a = 'bs.alert';
const $8c9d2162215f88e6$var$EVENT_KEY$b = `.${$8c9d2162215f88e6$var$DATA_KEY$a}`;
const $8c9d2162215f88e6$var$EVENT_CLOSE = `close${$8c9d2162215f88e6$var$EVENT_KEY$b}`;
const $8c9d2162215f88e6$var$EVENT_CLOSED = `closed${$8c9d2162215f88e6$var$EVENT_KEY$b}`;
const $8c9d2162215f88e6$var$CLASS_NAME_FADE$5 = 'fade';
const $8c9d2162215f88e6$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$caec2af78bcc877f extends $8c9d2162215f88e6$var$BaseComponent {
    // Getters
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $8c9d2162215f88e6$var$enableDismissTrigger($8c9d2162215f88e6$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$e = 'button';
const $8c9d2162215f88e6$var$DATA_KEY$9 = 'bs.button';
const $8c9d2162215f88e6$var$EVENT_KEY$a = `.${$8c9d2162215f88e6$var$DATA_KEY$9}`;
const $8c9d2162215f88e6$var$DATA_API_KEY$6 = '.data-api';
const $8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$3 = 'active';
const $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$6 = `click${$8c9d2162215f88e6$var$EVENT_KEY$a}${$8c9d2162215f88e6$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$353f5b6fc5456de1 extends $8c9d2162215f88e6$var$BaseComponent {
    // Getters
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$6, $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$5);
    const data = $8c9d2162215f88e6$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$d = 'swipe';
const $8c9d2162215f88e6$var$EVENT_KEY$9 = '.bs.swipe';
const $8c9d2162215f88e6$var$EVENT_TOUCHSTART = `touchstart${$8c9d2162215f88e6$var$EVENT_KEY$9}`;
const $8c9d2162215f88e6$var$EVENT_TOUCHMOVE = `touchmove${$8c9d2162215f88e6$var$EVENT_KEY$9}`;
const $8c9d2162215f88e6$var$EVENT_TOUCHEND = `touchend${$8c9d2162215f88e6$var$EVENT_KEY$9}`;
const $8c9d2162215f88e6$var$EVENT_POINTERDOWN = `pointerdown${$8c9d2162215f88e6$var$EVENT_KEY$9}`;
const $8c9d2162215f88e6$var$EVENT_POINTERUP = `pointerup${$8c9d2162215f88e6$var$EVENT_KEY$9}`;
const $8c9d2162215f88e6$var$POINTER_TYPE_TOUCH = 'touch';
const $8c9d2162215f88e6$var$POINTER_TYPE_PEN = 'pen';
const $8c9d2162215f88e6$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $8c9d2162215f88e6$var$SWIPE_THRESHOLD = 40;
const $8c9d2162215f88e6$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $8c9d2162215f88e6$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$var$Swipe extends $8c9d2162215f88e6$var$Config {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$c;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$c;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$d;
    }
    // Public
    dispose() {
        $8c9d2162215f88e6$var$EventHandler.off(this._element, $8c9d2162215f88e6$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $8c9d2162215f88e6$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $8c9d2162215f88e6$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $8c9d2162215f88e6$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $8c9d2162215f88e6$var$POINTER_TYPE_PEN || event.pointerType === $8c9d2162215f88e6$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$8c9d2162215f88e6$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$c = 'carousel';
const $8c9d2162215f88e6$var$DATA_KEY$8 = 'bs.carousel';
const $8c9d2162215f88e6$var$EVENT_KEY$8 = `.${$8c9d2162215f88e6$var$DATA_KEY$8}`;
const $8c9d2162215f88e6$var$DATA_API_KEY$5 = '.data-api';
const $8c9d2162215f88e6$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $8c9d2162215f88e6$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $8c9d2162215f88e6$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $8c9d2162215f88e6$var$ORDER_NEXT = 'next';
const $8c9d2162215f88e6$var$ORDER_PREV = 'prev';
const $8c9d2162215f88e6$var$DIRECTION_LEFT = 'left';
const $8c9d2162215f88e6$var$DIRECTION_RIGHT = 'right';
const $8c9d2162215f88e6$var$EVENT_SLIDE = `slide${$8c9d2162215f88e6$var$EVENT_KEY$8}`;
const $8c9d2162215f88e6$var$EVENT_SLID = `slid${$8c9d2162215f88e6$var$EVENT_KEY$8}`;
const $8c9d2162215f88e6$var$EVENT_KEYDOWN$1 = `keydown${$8c9d2162215f88e6$var$EVENT_KEY$8}`;
const $8c9d2162215f88e6$var$EVENT_MOUSEENTER$1 = `mouseenter${$8c9d2162215f88e6$var$EVENT_KEY$8}`;
const $8c9d2162215f88e6$var$EVENT_MOUSELEAVE$1 = `mouseleave${$8c9d2162215f88e6$var$EVENT_KEY$8}`;
const $8c9d2162215f88e6$var$EVENT_DRAG_START = `dragstart${$8c9d2162215f88e6$var$EVENT_KEY$8}`;
const $8c9d2162215f88e6$var$EVENT_LOAD_DATA_API$3 = `load${$8c9d2162215f88e6$var$EVENT_KEY$8}${$8c9d2162215f88e6$var$DATA_API_KEY$5}`;
const $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$5 = `click${$8c9d2162215f88e6$var$EVENT_KEY$8}${$8c9d2162215f88e6$var$DATA_API_KEY$5}`;
const $8c9d2162215f88e6$var$CLASS_NAME_CAROUSEL = 'carousel';
const $8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$2 = 'active';
const $8c9d2162215f88e6$var$CLASS_NAME_SLIDE = 'slide';
const $8c9d2162215f88e6$var$CLASS_NAME_END = 'carousel-item-end';
const $8c9d2162215f88e6$var$CLASS_NAME_START = 'carousel-item-start';
const $8c9d2162215f88e6$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $8c9d2162215f88e6$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $8c9d2162215f88e6$var$SELECTOR_ACTIVE = '.active';
const $8c9d2162215f88e6$var$SELECTOR_ITEM = '.carousel-item';
const $8c9d2162215f88e6$var$SELECTOR_ACTIVE_ITEM = $8c9d2162215f88e6$var$SELECTOR_ACTIVE + $8c9d2162215f88e6$var$SELECTOR_ITEM;
const $8c9d2162215f88e6$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $8c9d2162215f88e6$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $8c9d2162215f88e6$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $8c9d2162215f88e6$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $8c9d2162215f88e6$var$KEY_TO_DIRECTION = {
    [$8c9d2162215f88e6$var$ARROW_LEFT_KEY$1]: $8c9d2162215f88e6$var$DIRECTION_RIGHT,
    [$8c9d2162215f88e6$var$ARROW_RIGHT_KEY$1]: $8c9d2162215f88e6$var$DIRECTION_LEFT
};
const $8c9d2162215f88e6$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $8c9d2162215f88e6$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$144901db2ea8e967 extends $8c9d2162215f88e6$var$BaseComponent {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$b;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$b;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$c;
    }
    // Public
    next() {
        this._slide($8c9d2162215f88e6$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $8c9d2162215f88e6$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($8c9d2162215f88e6$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $8c9d2162215f88e6$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $8c9d2162215f88e6$var$EventHandler.one(this._element, $8c9d2162215f88e6$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $8c9d2162215f88e6$var$EventHandler.one(this._element, $8c9d2162215f88e6$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $8c9d2162215f88e6$var$ORDER_NEXT : $8c9d2162215f88e6$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $8c9d2162215f88e6$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$SELECTOR_ITEM_IMG, this._element))$8c9d2162215f88e6$var$EventHandler.on(img, $8c9d2162215f88e6$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $8c9d2162215f88e6$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($8c9d2162215f88e6$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($8c9d2162215f88e6$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $8c9d2162215f88e6$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $8c9d2162215f88e6$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $8c9d2162215f88e6$var$SelectorEngine.findOne($8c9d2162215f88e6$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $8c9d2162215f88e6$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $8c9d2162215f88e6$var$ORDER_NEXT;
        const nextElement = element || $8c9d2162215f88e6$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $8c9d2162215f88e6$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($8c9d2162215f88e6$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $8c9d2162215f88e6$var$CLASS_NAME_START : $8c9d2162215f88e6$var$CLASS_NAME_END;
        const orderClassName = isNext ? $8c9d2162215f88e6$var$CLASS_NAME_NEXT : $8c9d2162215f88e6$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $8c9d2162215f88e6$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($8c9d2162215f88e6$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $8c9d2162215f88e6$var$SelectorEngine.findOne($8c9d2162215f88e6$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($8c9d2162215f88e6$var$isRTL()) return direction === $8c9d2162215f88e6$var$DIRECTION_LEFT ? $8c9d2162215f88e6$var$ORDER_PREV : $8c9d2162215f88e6$var$ORDER_NEXT;
        return direction === $8c9d2162215f88e6$var$DIRECTION_LEFT ? $8c9d2162215f88e6$var$ORDER_NEXT : $8c9d2162215f88e6$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($8c9d2162215f88e6$var$isRTL()) return order === $8c9d2162215f88e6$var$ORDER_PREV ? $8c9d2162215f88e6$var$DIRECTION_LEFT : $8c9d2162215f88e6$var$DIRECTION_RIGHT;
        return order === $8c9d2162215f88e6$var$ORDER_PREV ? $8c9d2162215f88e6$var$DIRECTION_RIGHT : $8c9d2162215f88e6$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $8c9d2162215f88e6$var$SelectorEngine.findOne($8c9d2162215f88e6$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $8c9d2162215f88e6$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
}
/**
 * Data API implementation
 */ $8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$5, $8c9d2162215f88e6$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $8c9d2162215f88e6$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $8c9d2162215f88e6$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($8c9d2162215f88e6$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$8c9d2162215f88e6$var$EventHandler.on(window, $8c9d2162215f88e6$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$8c9d2162215f88e6$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$b = 'collapse';
const $8c9d2162215f88e6$var$DATA_KEY$7 = 'bs.collapse';
const $8c9d2162215f88e6$var$EVENT_KEY$7 = `.${$8c9d2162215f88e6$var$DATA_KEY$7}`;
const $8c9d2162215f88e6$var$DATA_API_KEY$4 = '.data-api';
const $8c9d2162215f88e6$var$EVENT_SHOW$6 = `show${$8c9d2162215f88e6$var$EVENT_KEY$7}`;
const $8c9d2162215f88e6$var$EVENT_SHOWN$6 = `shown${$8c9d2162215f88e6$var$EVENT_KEY$7}`;
const $8c9d2162215f88e6$var$EVENT_HIDE$6 = `hide${$8c9d2162215f88e6$var$EVENT_KEY$7}`;
const $8c9d2162215f88e6$var$EVENT_HIDDEN$6 = `hidden${$8c9d2162215f88e6$var$EVENT_KEY$7}`;
const $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$4 = `click${$8c9d2162215f88e6$var$EVENT_KEY$7}${$8c9d2162215f88e6$var$DATA_API_KEY$4}`;
const $8c9d2162215f88e6$var$CLASS_NAME_SHOW$7 = 'show';
const $8c9d2162215f88e6$var$CLASS_NAME_COLLAPSE = 'collapse';
const $8c9d2162215f88e6$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $8c9d2162215f88e6$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $8c9d2162215f88e6$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$8c9d2162215f88e6$var$CLASS_NAME_COLLAPSE} .${$8c9d2162215f88e6$var$CLASS_NAME_COLLAPSE}`;
const $8c9d2162215f88e6$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $8c9d2162215f88e6$var$WIDTH = 'width';
const $8c9d2162215f88e6$var$HEIGHT = 'height';
const $8c9d2162215f88e6$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $8c9d2162215f88e6$var$Default$a = {
    parent: null,
    toggle: true
};
const $8c9d2162215f88e6$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$78768a9af065a7b extends $8c9d2162215f88e6$var$BaseComponent {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$a;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$a;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($8c9d2162215f88e6$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$8c9d2162215f88e6$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_COLLAPSE, $8c9d2162215f88e6$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $8c9d2162215f88e6$var$reflow(this._element);
        this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_COLLAPSE, $8c9d2162215f88e6$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $8c9d2162215f88e6$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_COLLAPSE);
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $8c9d2162215f88e6$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_HORIZONTAL) ? $8c9d2162215f88e6$var$WIDTH : $8c9d2162215f88e6$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $8c9d2162215f88e6$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $8c9d2162215f88e6$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($8c9d2162215f88e6$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $8c9d2162215f88e6$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $8c9d2162215f88e6$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
}
/**
 * Data API implementation
 */ $8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$4, $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $8c9d2162215f88e6$var$SelectorEngine.getMultipleElementsFromSelector(this))$8c9d2162215f88e6$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$a = 'dropdown';
const $8c9d2162215f88e6$var$DATA_KEY$6 = 'bs.dropdown';
const $8c9d2162215f88e6$var$EVENT_KEY$6 = `.${$8c9d2162215f88e6$var$DATA_KEY$6}`;
const $8c9d2162215f88e6$var$DATA_API_KEY$3 = '.data-api';
const $8c9d2162215f88e6$var$ESCAPE_KEY$2 = 'Escape';
const $8c9d2162215f88e6$var$TAB_KEY$1 = 'Tab';
const $8c9d2162215f88e6$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $8c9d2162215f88e6$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $8c9d2162215f88e6$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $8c9d2162215f88e6$var$EVENT_HIDE$5 = `hide${$8c9d2162215f88e6$var$EVENT_KEY$6}`;
const $8c9d2162215f88e6$var$EVENT_HIDDEN$5 = `hidden${$8c9d2162215f88e6$var$EVENT_KEY$6}`;
const $8c9d2162215f88e6$var$EVENT_SHOW$5 = `show${$8c9d2162215f88e6$var$EVENT_KEY$6}`;
const $8c9d2162215f88e6$var$EVENT_SHOWN$5 = `shown${$8c9d2162215f88e6$var$EVENT_KEY$6}`;
const $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$3 = `click${$8c9d2162215f88e6$var$EVENT_KEY$6}${$8c9d2162215f88e6$var$DATA_API_KEY$3}`;
const $8c9d2162215f88e6$var$EVENT_KEYDOWN_DATA_API = `keydown${$8c9d2162215f88e6$var$EVENT_KEY$6}${$8c9d2162215f88e6$var$DATA_API_KEY$3}`;
const $8c9d2162215f88e6$var$EVENT_KEYUP_DATA_API = `keyup${$8c9d2162215f88e6$var$EVENT_KEY$6}${$8c9d2162215f88e6$var$DATA_API_KEY$3}`;
const $8c9d2162215f88e6$var$CLASS_NAME_SHOW$6 = 'show';
const $8c9d2162215f88e6$var$CLASS_NAME_DROPUP = 'dropup';
const $8c9d2162215f88e6$var$CLASS_NAME_DROPEND = 'dropend';
const $8c9d2162215f88e6$var$CLASS_NAME_DROPSTART = 'dropstart';
const $8c9d2162215f88e6$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $8c9d2162215f88e6$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$3}.${$8c9d2162215f88e6$var$CLASS_NAME_SHOW$6}`;
const $8c9d2162215f88e6$var$SELECTOR_MENU = '.dropdown-menu';
const $8c9d2162215f88e6$var$SELECTOR_NAVBAR = '.navbar';
const $8c9d2162215f88e6$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $8c9d2162215f88e6$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $8c9d2162215f88e6$var$PLACEMENT_TOP = $8c9d2162215f88e6$var$isRTL() ? 'top-end' : 'top-start';
const $8c9d2162215f88e6$var$PLACEMENT_TOPEND = $8c9d2162215f88e6$var$isRTL() ? 'top-start' : 'top-end';
const $8c9d2162215f88e6$var$PLACEMENT_BOTTOM = $8c9d2162215f88e6$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $8c9d2162215f88e6$var$PLACEMENT_BOTTOMEND = $8c9d2162215f88e6$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $8c9d2162215f88e6$var$PLACEMENT_RIGHT = $8c9d2162215f88e6$var$isRTL() ? 'left-start' : 'right-start';
const $8c9d2162215f88e6$var$PLACEMENT_LEFT = $8c9d2162215f88e6$var$isRTL() ? 'right-start' : 'left-start';
const $8c9d2162215f88e6$var$PLACEMENT_TOPCENTER = 'top';
const $8c9d2162215f88e6$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $8c9d2162215f88e6$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $8c9d2162215f88e6$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$931cbfb6bfb85fc extends $8c9d2162215f88e6$var$BaseComponent {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$9;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$9;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($8c9d2162215f88e6$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($8c9d2162215f88e6$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$8c9d2162215f88e6$var$EventHandler.on(element, 'mouseover', $8c9d2162215f88e6$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($8c9d2162215f88e6$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_SHOW$6);
        $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($8c9d2162215f88e6$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$8c9d2162215f88e6$var$EventHandler.off(element, 'mouseover', $8c9d2162215f88e6$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $8c9d2162215f88e6$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDDEN$5, relatedTarget);
        // Explicitly return focus to the trigger element
        this._element.focus();
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$8c9d2162215f88e6$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$8c9d2162215f88e6$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $4d5be6a614affd41$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($8c9d2162215f88e6$var$isElement(this._config.reference)) referenceElement = $8c9d2162215f88e6$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $4d5be6a614affd41$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_DROPEND)) return $8c9d2162215f88e6$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_DROPSTART)) return $8c9d2162215f88e6$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_DROPUP_CENTER)) return $8c9d2162215f88e6$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_DROPDOWN_CENTER)) return $8c9d2162215f88e6$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_DROPUP)) return isEnd ? $8c9d2162215f88e6$var$PLACEMENT_TOPEND : $8c9d2162215f88e6$var$PLACEMENT_TOP;
        return isEnd ? $8c9d2162215f88e6$var$PLACEMENT_BOTTOMEND : $8c9d2162215f88e6$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($8c9d2162215f88e6$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $8c9d2162215f88e6$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$8c9d2162215f88e6$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$8c9d2162215f88e6$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $8c9d2162215f88e6$var$getNextActiveElement(items, target, key === $8c9d2162215f88e6$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $8c9d2162215f88e6$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $8c9d2162215f88e6$var$TAB_KEY$1) return;
        const openToggles = $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $8c9d2162215f88e6$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $8c9d2162215f88e6$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $8c9d2162215f88e6$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $8c9d2162215f88e6$var$ARROW_UP_KEY$1,
            $8c9d2162215f88e6$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$3) ? this : $8c9d2162215f88e6$var$SelectorEngine.prev(this, $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$3)[0] || $8c9d2162215f88e6$var$SelectorEngine.next(this, $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$3)[0] || $8c9d2162215f88e6$var$SelectorEngine.findOne($8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $8c9d2162215f88e6$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $8c9d2162215f88e6$var$SelectorEngine.next(this._element, $8c9d2162215f88e6$var$SELECTOR_MENU)[0] || $8c9d2162215f88e6$var$SelectorEngine.prev(this._element, $8c9d2162215f88e6$var$SELECTOR_MENU)[0] || $8c9d2162215f88e6$var$SelectorEngine.findOne($8c9d2162215f88e6$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
}
/**
 * Data API implementation
 */ $8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_KEYDOWN_DATA_API, $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$3, $8c9d2162215f88e6$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_KEYDOWN_DATA_API, $8c9d2162215f88e6$var$SELECTOR_MENU, $8c9d2162215f88e6$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$3, $8c9d2162215f88e6$export$931cbfb6bfb85fc.clearMenus);
$8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_KEYUP_DATA_API, $8c9d2162215f88e6$export$931cbfb6bfb85fc.clearMenus);
$8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$3, $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $8c9d2162215f88e6$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$9 = 'backdrop';
const $8c9d2162215f88e6$var$CLASS_NAME_FADE$4 = 'fade';
const $8c9d2162215f88e6$var$CLASS_NAME_SHOW$5 = 'show';
const $8c9d2162215f88e6$var$EVENT_MOUSEDOWN = `mousedown.bs.${$8c9d2162215f88e6$var$NAME$9}`;
const $8c9d2162215f88e6$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $8c9d2162215f88e6$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$var$Backdrop extends $8c9d2162215f88e6$var$Config {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$8;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$8;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $8c9d2162215f88e6$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $8c9d2162215f88e6$var$reflow(element);
        element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $8c9d2162215f88e6$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $8c9d2162215f88e6$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $8c9d2162215f88e6$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $8c9d2162215f88e6$var$EventHandler.off(this._element, $8c9d2162215f88e6$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($8c9d2162215f88e6$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $8c9d2162215f88e6$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $8c9d2162215f88e6$var$EventHandler.on(element, $8c9d2162215f88e6$var$EVENT_MOUSEDOWN, ()=>{
            $8c9d2162215f88e6$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $8c9d2162215f88e6$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$8 = 'focustrap';
const $8c9d2162215f88e6$var$DATA_KEY$5 = 'bs.focustrap';
const $8c9d2162215f88e6$var$EVENT_KEY$5 = `.${$8c9d2162215f88e6$var$DATA_KEY$5}`;
const $8c9d2162215f88e6$var$EVENT_FOCUSIN$2 = `focusin${$8c9d2162215f88e6$var$EVENT_KEY$5}`;
const $8c9d2162215f88e6$var$EVENT_KEYDOWN_TAB = `keydown.tab${$8c9d2162215f88e6$var$EVENT_KEY$5}`;
const $8c9d2162215f88e6$var$TAB_KEY = 'Tab';
const $8c9d2162215f88e6$var$TAB_NAV_FORWARD = 'forward';
const $8c9d2162215f88e6$var$TAB_NAV_BACKWARD = 'backward';
const $8c9d2162215f88e6$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $8c9d2162215f88e6$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$var$FocusTrap extends $8c9d2162215f88e6$var$Config {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$7;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$7;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $8c9d2162215f88e6$var$EventHandler.off(document, $8c9d2162215f88e6$var$EVENT_KEY$5); // guard against infinite focus loop
        $8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $8c9d2162215f88e6$var$EventHandler.off(document, $8c9d2162215f88e6$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $8c9d2162215f88e6$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $8c9d2162215f88e6$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $8c9d2162215f88e6$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $8c9d2162215f88e6$var$TAB_NAV_BACKWARD : $8c9d2162215f88e6$var$TAB_NAV_FORWARD;
    }
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $8c9d2162215f88e6$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $8c9d2162215f88e6$var$PROPERTY_PADDING = 'padding-right';
const $8c9d2162215f88e6$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $8c9d2162215f88e6$var$ScrollBarHelper {
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $8c9d2162215f88e6$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($8c9d2162215f88e6$var$SELECTOR_FIXED_CONTENT, $8c9d2162215f88e6$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($8c9d2162215f88e6$var$SELECTOR_STICKY_CONTENT, $8c9d2162215f88e6$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $8c9d2162215f88e6$var$PROPERTY_PADDING);
        this._resetElementAttributes($8c9d2162215f88e6$var$SELECTOR_FIXED_CONTENT, $8c9d2162215f88e6$var$PROPERTY_PADDING);
        this._resetElementAttributes($8c9d2162215f88e6$var$SELECTOR_STICKY_CONTENT, $8c9d2162215f88e6$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $8c9d2162215f88e6$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $8c9d2162215f88e6$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $8c9d2162215f88e6$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($8c9d2162215f88e6$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $8c9d2162215f88e6$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
    constructor(){
        this._element = document.body;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$7 = 'modal';
const $8c9d2162215f88e6$var$DATA_KEY$4 = 'bs.modal';
const $8c9d2162215f88e6$var$EVENT_KEY$4 = `.${$8c9d2162215f88e6$var$DATA_KEY$4}`;
const $8c9d2162215f88e6$var$DATA_API_KEY$2 = '.data-api';
const $8c9d2162215f88e6$var$ESCAPE_KEY$1 = 'Escape';
const $8c9d2162215f88e6$var$EVENT_HIDE$4 = `hide${$8c9d2162215f88e6$var$EVENT_KEY$4}`;
const $8c9d2162215f88e6$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$8c9d2162215f88e6$var$EVENT_KEY$4}`;
const $8c9d2162215f88e6$var$EVENT_HIDDEN$4 = `hidden${$8c9d2162215f88e6$var$EVENT_KEY$4}`;
const $8c9d2162215f88e6$var$EVENT_SHOW$4 = `show${$8c9d2162215f88e6$var$EVENT_KEY$4}`;
const $8c9d2162215f88e6$var$EVENT_SHOWN$4 = `shown${$8c9d2162215f88e6$var$EVENT_KEY$4}`;
const $8c9d2162215f88e6$var$EVENT_RESIZE$1 = `resize${$8c9d2162215f88e6$var$EVENT_KEY$4}`;
const $8c9d2162215f88e6$var$EVENT_CLICK_DISMISS = `click.dismiss${$8c9d2162215f88e6$var$EVENT_KEY$4}`;
const $8c9d2162215f88e6$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$8c9d2162215f88e6$var$EVENT_KEY$4}`;
const $8c9d2162215f88e6$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$8c9d2162215f88e6$var$EVENT_KEY$4}`;
const $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$2 = `click${$8c9d2162215f88e6$var$EVENT_KEY$4}${$8c9d2162215f88e6$var$DATA_API_KEY$2}`;
const $8c9d2162215f88e6$var$CLASS_NAME_OPEN = 'modal-open';
const $8c9d2162215f88e6$var$CLASS_NAME_FADE$3 = 'fade';
const $8c9d2162215f88e6$var$CLASS_NAME_SHOW$4 = 'show';
const $8c9d2162215f88e6$var$CLASS_NAME_STATIC = 'modal-static';
const $8c9d2162215f88e6$var$OPEN_SELECTOR$1 = '.modal.show';
const $8c9d2162215f88e6$var$SELECTOR_DIALOG = '.modal-dialog';
const $8c9d2162215f88e6$var$SELECTOR_MODAL_BODY = '.modal-body';
const $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $8c9d2162215f88e6$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $8c9d2162215f88e6$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$2b77a92f1a5ad772 extends $8c9d2162215f88e6$var$BaseComponent {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$6;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$6;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($8c9d2162215f88e6$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $8c9d2162215f88e6$var$EventHandler.off(window, $8c9d2162215f88e6$var$EVENT_KEY$4);
        $8c9d2162215f88e6$var$EventHandler.off(this._dialog, $8c9d2162215f88e6$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $8c9d2162215f88e6$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $8c9d2162215f88e6$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $8c9d2162215f88e6$var$SelectorEngine.findOne($8c9d2162215f88e6$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $8c9d2162215f88e6$var$reflow(this._element);
        this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $8c9d2162215f88e6$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $8c9d2162215f88e6$var$EventHandler.on(window, $8c9d2162215f88e6$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $8c9d2162215f88e6$var$EventHandler.one(this._element, $8c9d2162215f88e6$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $8c9d2162215f88e6$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $8c9d2162215f88e6$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
    constructor(element, config){
        super(element, config);
        this._dialog = $8c9d2162215f88e6$var$SelectorEngine.findOne($8c9d2162215f88e6$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $8c9d2162215f88e6$var$ScrollBarHelper();
        this._addEventListeners();
    }
}
/**
 * Data API implementation
 */ $8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$2, $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $8c9d2162215f88e6$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $8c9d2162215f88e6$var$EventHandler.one(target, $8c9d2162215f88e6$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $8c9d2162215f88e6$var$EventHandler.one(target, $8c9d2162215f88e6$var$EVENT_HIDDEN$4, ()=>{
            if ($8c9d2162215f88e6$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $8c9d2162215f88e6$var$SelectorEngine.findOne($8c9d2162215f88e6$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $8c9d2162215f88e6$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $8c9d2162215f88e6$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$8c9d2162215f88e6$var$enableDismissTrigger($8c9d2162215f88e6$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$6 = 'offcanvas';
const $8c9d2162215f88e6$var$DATA_KEY$3 = 'bs.offcanvas';
const $8c9d2162215f88e6$var$EVENT_KEY$3 = `.${$8c9d2162215f88e6$var$DATA_KEY$3}`;
const $8c9d2162215f88e6$var$DATA_API_KEY$1 = '.data-api';
const $8c9d2162215f88e6$var$EVENT_LOAD_DATA_API$2 = `load${$8c9d2162215f88e6$var$EVENT_KEY$3}${$8c9d2162215f88e6$var$DATA_API_KEY$1}`;
const $8c9d2162215f88e6$var$ESCAPE_KEY = 'Escape';
const $8c9d2162215f88e6$var$CLASS_NAME_SHOW$3 = 'show';
const $8c9d2162215f88e6$var$CLASS_NAME_SHOWING$1 = 'showing';
const $8c9d2162215f88e6$var$CLASS_NAME_HIDING = 'hiding';
const $8c9d2162215f88e6$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $8c9d2162215f88e6$var$OPEN_SELECTOR = '.offcanvas.show';
const $8c9d2162215f88e6$var$EVENT_SHOW$3 = `show${$8c9d2162215f88e6$var$EVENT_KEY$3}`;
const $8c9d2162215f88e6$var$EVENT_SHOWN$3 = `shown${$8c9d2162215f88e6$var$EVENT_KEY$3}`;
const $8c9d2162215f88e6$var$EVENT_HIDE$3 = `hide${$8c9d2162215f88e6$var$EVENT_KEY$3}`;
const $8c9d2162215f88e6$var$EVENT_HIDE_PREVENTED = `hidePrevented${$8c9d2162215f88e6$var$EVENT_KEY$3}`;
const $8c9d2162215f88e6$var$EVENT_HIDDEN$3 = `hidden${$8c9d2162215f88e6$var$EVENT_KEY$3}`;
const $8c9d2162215f88e6$var$EVENT_RESIZE = `resize${$8c9d2162215f88e6$var$EVENT_KEY$3}`;
const $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$1 = `click${$8c9d2162215f88e6$var$EVENT_KEY$3}${$8c9d2162215f88e6$var$DATA_API_KEY$1}`;
const $8c9d2162215f88e6$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$8c9d2162215f88e6$var$EVENT_KEY$3}`;
const $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $8c9d2162215f88e6$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $8c9d2162215f88e6$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$591ca0244c9dfcd4 extends $8c9d2162215f88e6$var$BaseComponent {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$5;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$5;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $8c9d2162215f88e6$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOWING$1);
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOW$3, $8c9d2162215f88e6$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $8c9d2162215f88e6$var$ScrollBarHelper().reset();
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $8c9d2162215f88e6$var$Backdrop({
            className: $8c9d2162215f88e6$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $8c9d2162215f88e6$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $8c9d2162215f88e6$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
}
/**
 * Data API implementation
 */ $8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API$1, $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $8c9d2162215f88e6$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($8c9d2162215f88e6$var$isDisabled(this)) return;
    $8c9d2162215f88e6$var$EventHandler.one(target, $8c9d2162215f88e6$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($8c9d2162215f88e6$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $8c9d2162215f88e6$var$SelectorEngine.findOne($8c9d2162215f88e6$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $8c9d2162215f88e6$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $8c9d2162215f88e6$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$8c9d2162215f88e6$var$EventHandler.on(window, $8c9d2162215f88e6$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$OPEN_SELECTOR))$8c9d2162215f88e6$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$8c9d2162215f88e6$var$EventHandler.on(window, $8c9d2162215f88e6$var$EVENT_RESIZE, ()=>{
    for (const element of $8c9d2162215f88e6$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $8c9d2162215f88e6$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$8c9d2162215f88e6$var$enableDismissTrigger($8c9d2162215f88e6$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $8c9d2162215f88e6$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $8c9d2162215f88e6$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $8c9d2162215f88e6$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $8c9d2162215f88e6$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $8c9d2162215f88e6$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $8c9d2162215f88e6$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($8c9d2162215f88e6$var$uriAttributes.has(attributeName)) return Boolean($8c9d2162215f88e6$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $8c9d2162215f88e6$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$8c9d2162215f88e6$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$5 = 'TemplateFactory';
const $8c9d2162215f88e6$var$Default$4 = {
    allowList: $8c9d2162215f88e6$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $8c9d2162215f88e6$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $8c9d2162215f88e6$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$var$TemplateFactory extends $8c9d2162215f88e6$var$Config {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$4;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$4;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $8c9d2162215f88e6$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $8c9d2162215f88e6$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($8c9d2162215f88e6$var$isElement(content)) {
            this._putElementInTemplate($8c9d2162215f88e6$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $8c9d2162215f88e6$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $8c9d2162215f88e6$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$4 = 'tooltip';
const $8c9d2162215f88e6$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $8c9d2162215f88e6$var$CLASS_NAME_FADE$2 = 'fade';
const $8c9d2162215f88e6$var$CLASS_NAME_MODAL = 'modal';
const $8c9d2162215f88e6$var$CLASS_NAME_SHOW$2 = 'show';
const $8c9d2162215f88e6$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $8c9d2162215f88e6$var$SELECTOR_MODAL = `.${$8c9d2162215f88e6$var$CLASS_NAME_MODAL}`;
const $8c9d2162215f88e6$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $8c9d2162215f88e6$var$TRIGGER_HOVER = 'hover';
const $8c9d2162215f88e6$var$TRIGGER_FOCUS = 'focus';
const $8c9d2162215f88e6$var$TRIGGER_CLICK = 'click';
const $8c9d2162215f88e6$var$TRIGGER_MANUAL = 'manual';
const $8c9d2162215f88e6$var$EVENT_HIDE$2 = 'hide';
const $8c9d2162215f88e6$var$EVENT_HIDDEN$2 = 'hidden';
const $8c9d2162215f88e6$var$EVENT_SHOW$2 = 'show';
const $8c9d2162215f88e6$var$EVENT_SHOWN$2 = 'shown';
const $8c9d2162215f88e6$var$EVENT_INSERTED = 'inserted';
const $8c9d2162215f88e6$var$EVENT_CLICK$1 = 'click';
const $8c9d2162215f88e6$var$EVENT_FOCUSIN$1 = 'focusin';
const $8c9d2162215f88e6$var$EVENT_FOCUSOUT$1 = 'focusout';
const $8c9d2162215f88e6$var$EVENT_MOUSEENTER = 'mouseenter';
const $8c9d2162215f88e6$var$EVENT_MOUSELEAVE = 'mouseleave';
const $8c9d2162215f88e6$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $8c9d2162215f88e6$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $8c9d2162215f88e6$var$isRTL() ? 'right' : 'left'
};
const $8c9d2162215f88e6$var$Default$3 = {
    allowList: $8c9d2162215f88e6$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $8c9d2162215f88e6$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$28c660c63b792dea extends $8c9d2162215f88e6$var$BaseComponent {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$3;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$3;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $8c9d2162215f88e6$var$EventHandler.off(this._element.closest($8c9d2162215f88e6$var$SELECTOR_MODAL), $8c9d2162215f88e6$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, this.constructor.eventName($8c9d2162215f88e6$var$EVENT_SHOW$2));
        const shadowRoot = $8c9d2162215f88e6$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, this.constructor.eventName($8c9d2162215f88e6$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($8c9d2162215f88e6$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$8c9d2162215f88e6$var$EventHandler.on(element, 'mouseover', $8c9d2162215f88e6$var$noop);
        const complete = ()=>{
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, this.constructor.eventName($8c9d2162215f88e6$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, this.constructor.eventName($8c9d2162215f88e6$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$8c9d2162215f88e6$var$EventHandler.off(element, 'mouseover', $8c9d2162215f88e6$var$noop);
        this._activeTrigger[$8c9d2162215f88e6$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$8c9d2162215f88e6$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$8c9d2162215f88e6$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, this.constructor.eventName($8c9d2162215f88e6$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_FADE$2, $8c9d2162215f88e6$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $8c9d2162215f88e6$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($8c9d2162215f88e6$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $8c9d2162215f88e6$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$8c9d2162215f88e6$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $8c9d2162215f88e6$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $8c9d2162215f88e6$var$AttachmentMap[placement.toUpperCase()];
        return $4d5be6a614affd41$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $8c9d2162215f88e6$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$8c9d2162215f88e6$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $8c9d2162215f88e6$var$EventHandler.on(this._element, this.constructor.eventName($8c9d2162215f88e6$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$8c9d2162215f88e6$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$8c9d2162215f88e6$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $8c9d2162215f88e6$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $8c9d2162215f88e6$var$TRIGGER_HOVER ? this.constructor.eventName($8c9d2162215f88e6$var$EVENT_MOUSEENTER) : this.constructor.eventName($8c9d2162215f88e6$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $8c9d2162215f88e6$var$TRIGGER_HOVER ? this.constructor.eventName($8c9d2162215f88e6$var$EVENT_MOUSELEAVE) : this.constructor.eventName($8c9d2162215f88e6$var$EVENT_FOCUSOUT$1);
                $8c9d2162215f88e6$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $8c9d2162215f88e6$var$TRIGGER_FOCUS : $8c9d2162215f88e6$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $8c9d2162215f88e6$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $8c9d2162215f88e6$var$TRIGGER_FOCUS : $8c9d2162215f88e6$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $8c9d2162215f88e6$var$EventHandler.on(this._element.closest($8c9d2162215f88e6$var$SELECTOR_MODAL), $8c9d2162215f88e6$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $8c9d2162215f88e6$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($8c9d2162215f88e6$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $8c9d2162215f88e6$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    constructor(element, config){
        if (typeof $4d5be6a614affd41$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
}
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$3 = 'popover';
const $8c9d2162215f88e6$var$SELECTOR_TITLE = '.popover-header';
const $8c9d2162215f88e6$var$SELECTOR_CONTENT = '.popover-body';
const $8c9d2162215f88e6$var$Default$2 = {
    ...$8c9d2162215f88e6$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $8c9d2162215f88e6$var$DefaultType$2 = {
    ...$8c9d2162215f88e6$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$5b6b19405a83ff9d extends $8c9d2162215f88e6$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$2;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$2;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$8c9d2162215f88e6$var$SELECTOR_TITLE]: this._getTitle(),
            [$8c9d2162215f88e6$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$2 = 'scrollspy';
const $8c9d2162215f88e6$var$DATA_KEY$2 = 'bs.scrollspy';
const $8c9d2162215f88e6$var$EVENT_KEY$2 = `.${$8c9d2162215f88e6$var$DATA_KEY$2}`;
const $8c9d2162215f88e6$var$DATA_API_KEY = '.data-api';
const $8c9d2162215f88e6$var$EVENT_ACTIVATE = `activate${$8c9d2162215f88e6$var$EVENT_KEY$2}`;
const $8c9d2162215f88e6$var$EVENT_CLICK = `click${$8c9d2162215f88e6$var$EVENT_KEY$2}`;
const $8c9d2162215f88e6$var$EVENT_LOAD_DATA_API$1 = `load${$8c9d2162215f88e6$var$EVENT_KEY$2}${$8c9d2162215f88e6$var$DATA_API_KEY}`;
const $8c9d2162215f88e6$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$1 = 'active';
const $8c9d2162215f88e6$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $8c9d2162215f88e6$var$SELECTOR_TARGET_LINKS = '[href]';
const $8c9d2162215f88e6$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $8c9d2162215f88e6$var$SELECTOR_NAV_LINKS = '.nav-link';
const $8c9d2162215f88e6$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $8c9d2162215f88e6$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $8c9d2162215f88e6$var$SELECTOR_LINK_ITEMS = `${$8c9d2162215f88e6$var$SELECTOR_NAV_LINKS}, ${$8c9d2162215f88e6$var$SELECTOR_NAV_ITEMS} > ${$8c9d2162215f88e6$var$SELECTOR_NAV_LINKS}, ${$8c9d2162215f88e6$var$SELECTOR_LIST_ITEMS}`;
const $8c9d2162215f88e6$var$SELECTOR_DROPDOWN = '.dropdown';
const $8c9d2162215f88e6$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $8c9d2162215f88e6$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $8c9d2162215f88e6$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$a6472a5298a374be extends $8c9d2162215f88e6$var$BaseComponent {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default$1;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType$1;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $8c9d2162215f88e6$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $8c9d2162215f88e6$var$EventHandler.off(this._config.target, $8c9d2162215f88e6$var$EVENT_CLICK);
        $8c9d2162215f88e6$var$EventHandler.on(this._config.target, $8c9d2162215f88e6$var$EVENT_CLICK, $8c9d2162215f88e6$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $8c9d2162215f88e6$var$isDisabled(anchor)) continue;
            const observableSection = $8c9d2162215f88e6$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($8c9d2162215f88e6$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $8c9d2162215f88e6$var$SelectorEngine.findOne($8c9d2162215f88e6$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($8c9d2162215f88e6$var$SELECTOR_DROPDOWN)).classList.add($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $8c9d2162215f88e6$var$SelectorEngine.parents(target, $8c9d2162215f88e6$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $8c9d2162215f88e6$var$SelectorEngine.prev(listGroup, $8c9d2162215f88e6$var$SELECTOR_LINK_ITEMS))item.classList.add($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $8c9d2162215f88e6$var$SelectorEngine.find(`${$8c9d2162215f88e6$var$SELECTOR_TARGET_LINKS}.${$8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
}
/**
 * Data API implementation
 */ $8c9d2162215f88e6$var$EventHandler.on(window, $8c9d2162215f88e6$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$SELECTOR_DATA_SPY))$8c9d2162215f88e6$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME$1 = 'tab';
const $8c9d2162215f88e6$var$DATA_KEY$1 = 'bs.tab';
const $8c9d2162215f88e6$var$EVENT_KEY$1 = `.${$8c9d2162215f88e6$var$DATA_KEY$1}`;
const $8c9d2162215f88e6$var$EVENT_HIDE$1 = `hide${$8c9d2162215f88e6$var$EVENT_KEY$1}`;
const $8c9d2162215f88e6$var$EVENT_HIDDEN$1 = `hidden${$8c9d2162215f88e6$var$EVENT_KEY$1}`;
const $8c9d2162215f88e6$var$EVENT_SHOW$1 = `show${$8c9d2162215f88e6$var$EVENT_KEY$1}`;
const $8c9d2162215f88e6$var$EVENT_SHOWN$1 = `shown${$8c9d2162215f88e6$var$EVENT_KEY$1}`;
const $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API = `click${$8c9d2162215f88e6$var$EVENT_KEY$1}`;
const $8c9d2162215f88e6$var$EVENT_KEYDOWN = `keydown${$8c9d2162215f88e6$var$EVENT_KEY$1}`;
const $8c9d2162215f88e6$var$EVENT_LOAD_DATA_API = `load${$8c9d2162215f88e6$var$EVENT_KEY$1}`;
const $8c9d2162215f88e6$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $8c9d2162215f88e6$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $8c9d2162215f88e6$var$ARROW_UP_KEY = 'ArrowUp';
const $8c9d2162215f88e6$var$ARROW_DOWN_KEY = 'ArrowDown';
const $8c9d2162215f88e6$var$HOME_KEY = 'Home';
const $8c9d2162215f88e6$var$END_KEY = 'End';
const $8c9d2162215f88e6$var$CLASS_NAME_ACTIVE = 'active';
const $8c9d2162215f88e6$var$CLASS_NAME_FADE$1 = 'fade';
const $8c9d2162215f88e6$var$CLASS_NAME_SHOW$1 = 'show';
const $8c9d2162215f88e6$var$CLASS_DROPDOWN = 'dropdown';
const $8c9d2162215f88e6$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $8c9d2162215f88e6$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $8c9d2162215f88e6$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$8c9d2162215f88e6$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $8c9d2162215f88e6$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $8c9d2162215f88e6$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $8c9d2162215f88e6$var$SELECTOR_INNER = `.nav-link${$8c9d2162215f88e6$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$8c9d2162215f88e6$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$8c9d2162215f88e6$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $8c9d2162215f88e6$var$SELECTOR_INNER_ELEM = `${$8c9d2162215f88e6$var$SELECTOR_INNER}, ${$8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE}`;
const $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$8c9d2162215f88e6$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$8c9d2162215f88e6$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$8c9d2162215f88e6$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$3e41faf802a29e71 extends $8c9d2162215f88e6$var$BaseComponent {
    // Getters
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $8c9d2162215f88e6$var$EventHandler.trigger(active, $8c9d2162215f88e6$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $8c9d2162215f88e6$var$EventHandler.trigger(innerElem, $8c9d2162215f88e6$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE);
        this._activate($8c9d2162215f88e6$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $8c9d2162215f88e6$var$EventHandler.trigger(element, $8c9d2162215f88e6$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($8c9d2162215f88e6$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $8c9d2162215f88e6$var$EventHandler.trigger(element, $8c9d2162215f88e6$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $8c9d2162215f88e6$var$ARROW_LEFT_KEY,
            $8c9d2162215f88e6$var$ARROW_RIGHT_KEY,
            $8c9d2162215f88e6$var$ARROW_UP_KEY,
            $8c9d2162215f88e6$var$ARROW_DOWN_KEY,
            $8c9d2162215f88e6$var$HOME_KEY,
            $8c9d2162215f88e6$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$8c9d2162215f88e6$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $8c9d2162215f88e6$var$HOME_KEY,
            $8c9d2162215f88e6$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $8c9d2162215f88e6$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $8c9d2162215f88e6$var$ARROW_RIGHT_KEY,
                $8c9d2162215f88e6$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $8c9d2162215f88e6$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $8c9d2162215f88e6$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $8c9d2162215f88e6$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($8c9d2162215f88e6$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $8c9d2162215f88e6$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($8c9d2162215f88e6$var$SELECTOR_DROPDOWN_TOGGLE, $8c9d2162215f88e6$var$CLASS_NAME_ACTIVE);
        toggle($8c9d2162215f88e6$var$SELECTOR_DROPDOWN_MENU, $8c9d2162215f88e6$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($8c9d2162215f88e6$var$SELECTOR_INNER_ELEM) ? elem : $8c9d2162215f88e6$var$SelectorEngine.findOne($8c9d2162215f88e6$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($8c9d2162215f88e6$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    constructor(element){
        super(element);
        this._parent = this._element.closest($8c9d2162215f88e6$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
}
/**
 * Data API implementation
 */ $8c9d2162215f88e6$var$EventHandler.on(document, $8c9d2162215f88e6$var$EVENT_CLICK_DATA_API, $8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($8c9d2162215f88e6$var$isDisabled(this)) return;
    $8c9d2162215f88e6$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $8c9d2162215f88e6$var$EventHandler.on(window, $8c9d2162215f88e6$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $8c9d2162215f88e6$var$SelectorEngine.find($8c9d2162215f88e6$var$SELECTOR_DATA_TOGGLE_ACTIVE))$8c9d2162215f88e6$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8c9d2162215f88e6$var$NAME = 'toast';
const $8c9d2162215f88e6$var$DATA_KEY = 'bs.toast';
const $8c9d2162215f88e6$var$EVENT_KEY = `.${$8c9d2162215f88e6$var$DATA_KEY}`;
const $8c9d2162215f88e6$var$EVENT_MOUSEOVER = `mouseover${$8c9d2162215f88e6$var$EVENT_KEY}`;
const $8c9d2162215f88e6$var$EVENT_MOUSEOUT = `mouseout${$8c9d2162215f88e6$var$EVENT_KEY}`;
const $8c9d2162215f88e6$var$EVENT_FOCUSIN = `focusin${$8c9d2162215f88e6$var$EVENT_KEY}`;
const $8c9d2162215f88e6$var$EVENT_FOCUSOUT = `focusout${$8c9d2162215f88e6$var$EVENT_KEY}`;
const $8c9d2162215f88e6$var$EVENT_HIDE = `hide${$8c9d2162215f88e6$var$EVENT_KEY}`;
const $8c9d2162215f88e6$var$EVENT_HIDDEN = `hidden${$8c9d2162215f88e6$var$EVENT_KEY}`;
const $8c9d2162215f88e6$var$EVENT_SHOW = `show${$8c9d2162215f88e6$var$EVENT_KEY}`;
const $8c9d2162215f88e6$var$EVENT_SHOWN = `shown${$8c9d2162215f88e6$var$EVENT_KEY}`;
const $8c9d2162215f88e6$var$CLASS_NAME_FADE = 'fade';
const $8c9d2162215f88e6$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $8c9d2162215f88e6$var$CLASS_NAME_SHOW = 'show';
const $8c9d2162215f88e6$var$CLASS_NAME_SHOWING = 'showing';
const $8c9d2162215f88e6$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $8c9d2162215f88e6$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $8c9d2162215f88e6$export$8d8dc7d5f743331b extends $8c9d2162215f88e6$var$BaseComponent {
    // Getters
    static get Default() {
        return $8c9d2162215f88e6$var$Default;
    }
    static get DefaultType() {
        return $8c9d2162215f88e6$var$DefaultType;
    }
    static get NAME() {
        return $8c9d2162215f88e6$var$NAME;
    }
    // Public
    show() {
        const showEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOWING);
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_HIDE); // @deprecated
        $8c9d2162215f88e6$var$reflow(this._element);
        this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_SHOW, $8c9d2162215f88e6$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOWING, $8c9d2162215f88e6$var$CLASS_NAME_SHOW);
            $8c9d2162215f88e6$var$EventHandler.trigger(this._element, $8c9d2162215f88e6$var$EVENT_HIDDEN);
        };
        this._element.classList.add($8c9d2162215f88e6$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($8c9d2162215f88e6$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($8c9d2162215f88e6$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $8c9d2162215f88e6$var$EventHandler.on(this._element, $8c9d2162215f88e6$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8c9d2162215f88e6$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
}
/**
 * Data API implementation
 */ $8c9d2162215f88e6$var$enableDismissTrigger($8c9d2162215f88e6$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $8c9d2162215f88e6$var$defineJQueryPlugin($8c9d2162215f88e6$export$8d8dc7d5f743331b);



var $h96tf = parcelRequire("h96tf");


var $h96tf = parcelRequire("h96tf");
function $d11c9e7ef030e3fc$export$be48fd776273e509(rawCount) {
    rawCount = Number(rawCount);
    const isInt = Number.isInteger(rawCount);
    const greaterThanZero = rawCount > 0;
    return isInt && greaterThanZero;
}
function $d11c9e7ef030e3fc$export$fc6693e6d6c19a86(rawCount) {
    if (!$d11c9e7ef030e3fc$export$be48fd776273e509(rawCount)) return 1;
    return Number(rawCount);
}
function $d11c9e7ef030e3fc$export$784d13d8ee351f07(o) {
    return Object.assign({}, o);
}
function $d11c9e7ef030e3fc$export$7e32b29e1cb162e1(object) {
    // Retrieve the property names defined on object
    const propNames = Reflect.ownKeys(object);
    // Freeze properties before freezing self
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $d11c9e7ef030e3fc$export$7e32b29e1cb162e1(value);
    }
    return Object.freeze(object);
}
function $d11c9e7ef030e3fc$export$f295056f0756f4d0(...args) {
    let max = args[0];
    for(let i = 1; i < args.length; i++)if (args[i] > max) max = args[i];
    return max;
}
function $d11c9e7ef030e3fc$export$8ebeb7689b812edc(one, two) {
    if (one.size !== two.size) return false;
    for (const item of one){
        if (!two.has(item)) return false;
    }
    return true;
}
function $d11c9e7ef030e3fc$export$7cac92885a58ea4a(set, char) {
    if (set.size === 0) return '';
    let result = '';
    for (const key of set){
        result += char;
        result += key;
    }
    return result.slice(1);
}


const $3c786cb677838e50$export$62680b65e63e14ec = {
    schemaVersion: 1,
    currentTake: 1,
    keyboardShortcuts: {
        incrementCount: "Alt+Shift+=",
        decrementCount: "Alt+Shift+-",
        resetCount: "Alt+Shift+0"
    },
    alwaysOnTop: true,
    showDetailsBox: true,
    counterMode: 'manual',
    /* manual, ptFileWatcher */ ptFileWatcherMode: {
        mode: 'clip',
        /* clip, playlist */ showModeIndicator: true,
        subMode: 'all',
        /* all, specific */ offset: 0,
        offsetShortcuts: false,
        showOffset: true,
        trackName: '',
        audioFilesPath: ''
    },
    takeDisplaySettings: {
        takeTextPrefix: 'Take',
        showTakePrefix: true,
        showTakeButtons: true
    }
};
function $3c786cb677838e50$export$6ed07d3b439a822b(settings, schema = $3c786cb677838e50$export$62680b65e63e14ec) {
    for (const [key, value] of Object.entries(settings)){
        // Recur into objects and arrays
        if (typeof value === 'object') {
            if (!$3c786cb677838e50$export$6ed07d3b439a822b(value, schema[key])) return false;
            continue;
        }
        // If the key isn't in the schema
        if (schema[key] === undefined) return false;
        // If the value is the wrong type
        if (typeof value !== typeof schema[key]) return false;
    }
    // If the settings are missing a key
    for (const key of Object.keys(schema)){
        if (settings[key] === undefined) return false;
    }
    return true;
}



const $a633e4899aaa0405$var$runningInElectron = window.settings !== undefined;
async function $a633e4899aaa0405$export$54453bb1ffd2fd71() {
    if ($a633e4899aaa0405$var$runningInElectron) return await window.settings.getSettings();
    // Some defaults are different on the web.
    (0, $3c786cb677838e50$export$62680b65e63e14ec).keyboardShortcuts.incrementCount = "Shift+Plus";
    (0, $3c786cb677838e50$export$62680b65e63e14ec).keyboardShortcuts.decrementCount = "Shift+_";
    (0, $3c786cb677838e50$export$62680b65e63e14ec).keyboardShortcuts.resetCount = "Shift+R";
    return 0, $3c786cb677838e50$export$62680b65e63e14ec;
}


const $187864d4e8fb2ec4$export$8fa45c82eddfe270 = /*#__PURE__*/ (0, $h96tf.createContext)(null);
const $187864d4e8fb2ec4$export$69fe5218ed1245e = /*#__PURE__*/ (0, $h96tf.createContext)(null);
function $187864d4e8fb2ec4$export$e134aa690da9cc14({ children: children }) {
    const [settings, dispatch] = (0, $h96tf.useReducer)($187864d4e8fb2ec4$var$settingsReducer, (0, $3c786cb677838e50$export$62680b65e63e14ec));
    (0, $h96tf.useEffect)(()=>{
        (0, $a633e4899aaa0405$export$54453bb1ffd2fd71)().then((settings)=>{
            dispatch({
                type: 'load',
                value: settings
            });
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement($187864d4e8fb2ec4$export$8fa45c82eddfe270, {
        value: settings
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement($187864d4e8fb2ec4$export$69fe5218ed1245e, {
        value: dispatch
    }, children));
}
function $187864d4e8fb2ec4$var$settingsReducer(settings, action) {
    switch(action.type){
        case 'load':
            return action.value;
        case 'change':
            return $187864d4e8fb2ec4$var$handleChangeAction(settings, action);
        case 'reset':
            if (window.settings !== undefined) window.settings.changeSettings((0, $3c786cb677838e50$export$62680b65e63e14ec));
            return (0, $d11c9e7ef030e3fc$export$784d13d8ee351f07)((0, $3c786cb677838e50$export$62680b65e63e14ec));
        default:
            throw Error('[Settings][Reducer] Unknown reducer action');
    }
}
function $187864d4e8fb2ec4$var$handleChangeAction(settings, action) {
    if (action.settingKeys === undefined) return action.value;
    if (action.settingKeys.length === 0) return action.value;
    const settingKeys = action.settingKeys;
    let setting = settings;
    for(let i = 0; i < settingKeys.length - 1; i++){
        const key = settingKeys[i];
        if (setting[key] === undefined) throw Error(`settings.${action.settingKeys.join('.')} does not exist`);
        setting = setting[key];
    }
    setting[settingKeys.at(-1)] = action.value;
    if (window.settings !== undefined) window.settings.changeSettings(settings);
    return (0, $d11c9e7ef030e3fc$export$784d13d8ee351f07)(settings);
}
function $187864d4e8fb2ec4$export$12b0e20ae7d96a25(...settingKeys) {
    const settings = (0, $h96tf.useContext)($187864d4e8fb2ec4$export$8fa45c82eddfe270);
    const dispatch = (0, $h96tf.useContext)($187864d4e8fb2ec4$export$69fe5218ed1245e);
    const setter = (0, $h96tf.useCallback)((value)=>{
        dispatch({
            type: 'change',
            settingKeys: settingKeys,
            value: value
        });
    }, [
        settingKeys,
        dispatch
    ]);
    let setting = settings;
    for (const key of settingKeys){
        if (setting[key] === undefined) throw Error(`useSetting: the key ${settingKeys.join('.')}is not a valid setting`);
        setting = setting[key];
    }
    return [
        setting,
        setter
    ];
}
function $187864d4e8fb2ec4$export$e1caeacb0a7b57b8() {
    const dispatch = (0, $h96tf.useContext)($187864d4e8fb2ec4$export$69fe5218ed1245e);
    return (0, $h96tf.useCallback)(()=>{
        dispatch({
            type: 'reset'
        });
    }, [
        dispatch
    ]);
}



var $h96tf = parcelRequire("h96tf");

var $h96tf = parcelRequire("h96tf");
function $33e0352a83cf13d2$export$e5cc6136f1e14be3() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "white",
        className: "bi bi-gear-wide-connected",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("path", {
        d: "M7.068.727c.243-.97 1.62-.97 1.864 0l.071.286a.96.96 0 0 0 1.622.434l.205-.211c.695-.719 1.888-.03 1.613.931l-.08.284a.96.96 0 0 0 1.187 1.187l.283-.081c.96-.275 1.65.918.931 1.613l-.211.205a.96.96 0 0 0 .434 1.622l.286.071c.97.243.97 1.62 0 1.864l-.286.071a.96.96 0 0 0-.434 1.622l.211.205c.719.695.03 1.888-.931 1.613l-.284-.08a.96.96 0 0 0-1.187 1.187l.081.283c.275.96-.918 1.65-1.613.931l-.205-.211a.96.96 0 0 0-1.622.434l-.071.286c-.243.97-1.62.97-1.864 0l-.071-.286a.96.96 0 0 0-1.622-.434l-.205.211c-.695.719-1.888.03-1.613-.931l.08-.284a.96.96 0 0 0-1.186-1.187l-.284.081c-.96.275-1.65-.918-.931-1.613l.211-.205a.96.96 0 0 0-.434-1.622l-.286-.071c-.97-.243-.97-1.62 0-1.864l.286-.071a.96.96 0 0 0 .434-1.622l-.211-.205c-.719-.695-.03-1.888.931-1.613l.284.08a.96.96 0 0 0 1.187-1.186l-.081-.284c-.275-.96.918-1.65 1.613-.931l.205.211a.96.96 0 0 0 1.622-.434zM12.973 8.5H8.25l-2.834 3.779A4.998 4.998 0 0 0 12.973 8.5m0-1a4.998 4.998 0 0 0-7.557-3.779l2.834 3.78zM5.048 3.967l-.087.065zm-.431.355A4.98 4.98 0 0 0 3.002 8c0 1.455.622 2.765 1.615 3.678L7.375 8zm.344 7.646.087.065z"
    }));
}



var $h96tf = parcelRequire("h96tf");


var $h96tf = parcelRequire("h96tf");

var $h96tf = parcelRequire("h96tf");
function $47bc5cb6c16c6855$export$6d08773d2e66f8f2({ name: name, description: description, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "row mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "col-6 align-self-center p-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("h6", {
        className: "my-0"
    }, name), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("p", {
        className: "my-0 text-body-tertiary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("small", null, description)) : undefined), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "col-6 align-self-center p-0"
    }, children));
}


function $de2337dda9fc8599$export$61a038936c60c848({ name: name, value: value, onChange: onChange, children: children }) {
    const handleChange = (0, $h96tf.useCallback)((event)=>{
        onChange(Boolean(event.target.checked));
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $47bc5cb6c16c6855$export$6d08773d2e66f8f2), {
        name: name,
        description: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "form-check form-switch form-check-reverse me-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("input", {
        className: "form-check-input",
        role: "switch",
        onChange: handleChange,
        checked: value,
        type: "checkbox",
        id: "flexSwitchCheckReverse",
        style: {
            transform: 'scale(1.5)'
        }
    })));
}



var $h96tf = parcelRequire("h96tf");

function $de590bd51b2243a3$export$6648d5fa18559e7f({ name: name, options: options, value: value, onChange: onChange, children: children }) {
    const handleChange = (0, $h96tf.useCallback)((event)=>{
        onChange(event.target.value);
    }, [
        onChange
    ]);
    const selectOptions = options.map((option)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("option", {
            value: option.value,
            key: option.value
        }, option.name);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $47bc5cb6c16c6855$export$6d08773d2e66f8f2), {
        name: name,
        description: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("select", {
        className: "form-select",
        "aria-label": name,
        onChange: handleChange,
        value: value
    }, selectOptions));
}



var $h96tf = parcelRequire("h96tf");

var $h96tf = parcelRequire("h96tf");

const $d14c2a87cc1b733c$var$web_code_to_electron_key_map = {
    Escape: "Esc",
    Digit1: "1",
    Digit2: "2",
    Digit3: "3",
    Digit4: "4",
    Digit5: "5",
    Digit6: "6",
    Digit7: "7",
    Digit8: "8",
    Digit9: "9",
    Digit0: "0",
    Minus: "-",
    Equal: "=",
    Backspace: "Backspace",
    Tab: "Tab",
    KeyQ: "Q",
    KeyW: "W",
    KeyE: "E",
    KeyR: "R",
    KeyT: "T",
    KeyY: "Y",
    KeyU: "U",
    KeyI: "I",
    KeyO: "O",
    KeyP: "P",
    BracketLeft: "[",
    BracketRight: "]",
    Enter: "Enter",
    ControlLeft: "Ctrl",
    KeyA: "A",
    KeyS: "S",
    KeyD: "D",
    KeyF: "F",
    KeyG: "G",
    KeyH: "H",
    KeyJ: "J",
    KeyK: "K",
    KeyL: "L",
    Semicolon: ";",
    Quote: "'",
    Backquote: "`",
    ShiftLeft: "Shift",
    Backslash: "\\",
    KeyZ: "Z",
    KeyX: "X",
    KeyC: "C",
    KeyV: "V",
    KeyB: "B",
    KeyN: "N",
    KeyM: "M",
    Comma: ",",
    Period: ".",
    Slash: "/",
    ShiftRight: "Shift",
    NumpadMultiply: "nummult",
    AltLeft: "Alt",
    Space: "Space",
    CapsLock: "Capslock",
    F1: "F1",
    F2: "F2",
    F3: "F3",
    F4: "F4",
    F5: "F5",
    F6: "F6",
    F7: "F7",
    F8: "F8",
    F9: "F9",
    F10: "F10",
    ScrollLock: "Scrollock",
    Numpad7: "num7",
    Numpad8: "num8",
    Numpad9: "num9",
    NumpadSubtract: "numsub",
    Numpad4: "num4",
    Numpad5: "num5",
    Numpad6: "num6",
    NumpadAdd: "numadd",
    Numpad1: "num1",
    Numpad2: "num2",
    Numpad3: "num3",
    Numpad0: "num0",
    NumpadDecimal: "numdec",
    PrintScreen: "PrintScreen",
    IntlBackslash: "",
    F11: "F11",
    F12: "F12",
    NumpadEqual: "=",
    F13: "F13",
    F14: "F14",
    F15: "F15",
    F16: "F16",
    F17: "F17",
    F18: "F18",
    F19: "F19",
    F20: "F20",
    F21: "F21",
    F22: "F22",
    F23: "F23",
    F24: "F24",
    KanaMode: "",
    Lang2: "",
    Lang1: "",
    IntlRo: "",
    Convert: "",
    NonConvert: "",
    IntlYen: "",
    NumpadComma: ",",
    Undo: "",
    Paste: "",
    MediaTrackPrevious: "MediaPreviousTrack",
    Cut: "",
    Copy: "",
    MediaTrackNext: "MediaNextTrack",
    NumpadEnter: "Enter",
    ControlRight: "Ctrl",
    AudioVolumeMute: "VolumeMute",
    LaunchApp2: "",
    MediaPlayPause: "MediaPlayPause",
    MediaStop: "MediaStop",
    Eject: "",
    AudioVolumeDown: "VolumeDown",
    AudioVolumeUp: "VolumeUp",
    BrowserHome: "",
    NumpadDivide: "numdiv",
    AltRight: "Alt",
    Help: "",
    NumLock: "Numlock",
    Pause: "MediaPlayPause",
    Home: "Home",
    ArrowUp: "Up",
    PageUp: "PageUp",
    ArrowLeft: "Left",
    ArrowRight: "Right",
    End: "End",
    ArrowDown: "Down",
    PageDown: "PageDown",
    Insert: "Insert",
    Delete: "Delete",
    MetaLeft: "Cmd",
    MetaRight: "Cmd",
    ContextMenu: "",
    Power: "",
    Sleep: "",
    WakeUp: "",
    BrowserSearch: "",
    BrowserFavorites: "",
    BrowserRefresh: "",
    BrowserStop: "",
    BrowserForward: "",
    BrowserBack: "",
    LaunchApp1: "",
    LaunchMail: "",
    MediaSelect: ""
};
let $d14c2a87cc1b733c$var$electron_to_web_code_map = {};
for (const [key, value] of Object.entries($d14c2a87cc1b733c$var$web_code_to_electron_key_map))if ($d14c2a87cc1b733c$var$electron_to_web_code_map[value] === undefined) $d14c2a87cc1b733c$var$electron_to_web_code_map[value] = key;
/* DEPRECATED - But don't get rid of it because it was a pain to make
const  electron_to_web_key_map = {
  CommandOrControl: isMacOS  ? "Meta" : "Control",
  CmdOrCtrl: isMacOS  ? "Meta" : "Control",
  Command: "Meta", 
  Cmd: "Meta", 
  Super: "Meta", 
  Option: "Alt", 
  Esc: "Escape", 
  Plus: "+", 
  Space: " ", 
  Return: "Enter", 
  Up: "ArrowUp", 
  Down: "ArrowDown", 
  Left: "ArrowLeft", 
  Right: "ArrowRight", 
  "numdec": "Decimal",
  "numadd": "Add",
  "numsub": "Subtract",
  "nummult": "Multiply",
  "numdiv": "Divide",
  num0: "0",
  num1: "1",
  num2: "2",
  num3: "3",
  num4: "4",
  num5: "5",
  num6: "6",
  num7: "7",
  num8: "8",
  num9: "9",
}
let web_key_to_electron_map = {};
for (const [key, value] of Object.entries(electron_to_web_key_map)) {
  web_key_to_electron_map[value] = key;
}
*/ function $d14c2a87cc1b733c$var$parseShortcut(shortcutString) {
    const keyStrs = shortcutString.split("+");
    let keys = new Set();
    for (const keyStr of keyStrs){
        if (keyStr === "") continue;
        if ($d14c2a87cc1b733c$var$electron_to_web_code_map[keyStr] !== undefined) {
            keys.add($d14c2a87cc1b733c$var$electron_to_web_code_map[keyStr]);
            continue;
        }
        keys.add(keyStr);
    }
    return keys;
}
function $d14c2a87cc1b733c$export$20225055d685d131(keySet) {
    for (const key of keySet)switch($d14c2a87cc1b733c$var$web_code_to_electron_key_map[key]){
        case "Cmd":
        case "Ctrl":
        case "Alt":
        case "Shift":
            continue;
        default:
            return false;
    }
    return true;
}
function $d14c2a87cc1b733c$export$e1d1c7d53548b7ac(keySet) {
    let result = '';
    for (const key of keySet){
        if ($d14c2a87cc1b733c$var$web_code_to_electron_key_map[key] === undefined) continue;
        if ($d14c2a87cc1b733c$var$web_code_to_electron_key_map[key] === '') continue;
        if (result !== '') result += '+';
        result += $d14c2a87cc1b733c$var$web_code_to_electron_key_map[key];
    }
    return result;
}
function $d14c2a87cc1b733c$export$b0ebbe7904d8d94a(callback, shortcut, electronTarget) {
    $d14c2a87cc1b733c$export$9dce3fb7d3c554d7(callback, shortcut);
    $d14c2a87cc1b733c$export$b5095bb90175fd88(callback, electronTarget);
}
const $d14c2a87cc1b733c$export$c6e99618882a99c4 = new Set();
window.addEventListener('keydown', (event)=>{
    if (event.key.length === 1) $d14c2a87cc1b733c$export$c6e99618882a99c4.add(event.key.toUpperCase());
    else $d14c2a87cc1b733c$export$c6e99618882a99c4.add(event.key);
});
window.addEventListener('keyup', (event)=>{
    // HACK: Prevent accumulation of alt code characters.
    if (event.key === "Alt" || event.key === 'Meta' || event.key === 'Super') $d14c2a87cc1b733c$export$c6e99618882a99c4.clear();
    if (event.key.length === 1) $d14c2a87cc1b733c$export$c6e99618882a99c4.delete(event.key.toUpperCase());
    else $d14c2a87cc1b733c$export$c6e99618882a99c4.delete(event.key);
});
function $d14c2a87cc1b733c$export$9dce3fb7d3c554d7(callback, shortcut) {
    const handler = (0, $h96tf.useCallback)(()=>{
        const shortcutKeys = $d14c2a87cc1b733c$var$parseShortcut(shortcut);
        if ((0, $d11c9e7ef030e3fc$export$8ebeb7689b812edc)(shortcutKeys, $d14c2a87cc1b733c$export$c6e99618882a99c4)) callback();
    }, [
        callback,
        shortcut
    ]);
    (0, $h96tf.useEffect)(()=>{
        window.addEventListener('keydown', handler);
        return ()=>{
            window.removeEventListener('keydown', handler);
        };
    }, [
        handler,
        shortcut
    ]);
}
function $d14c2a87cc1b733c$export$b5095bb90175fd88(callback, target) {
    const targetProps = target.split(".");
    (0, $h96tf.useEffect)(()=>{
        // Check that the target exists first
        let target = window;
        for (const prop of targetProps){
            if (target[prop] === undefined) return;
            target = target[prop];
        }
        target(callback);
    }, [
        callback,
        targetProps
    ]);
}



var $h96tf = parcelRequire("h96tf");

var $h96tf = parcelRequire("h96tf");
function $283b71f4d1372a4c$var$ExpandingInput(props, ref) {
    const { style: style, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        ref: ref,
        contentEditable: "true",
        style: Object.assign({
            outline: "none",
            minWidth: "40%"
        }, style),
        ...restProps
    });
}
var $283b71f4d1372a4c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $h96tf.forwardRef)($283b71f4d1372a4c$var$ExpandingInput);


function $565ef684d07fe24b$export$2e2bcd8739ae039(props) {
    const { display: display, onInput: onInput, validateInput: validateInput, ...restProps } = props;
    const inputDisplay = (0, $h96tf.useRef)(null);
    const [caretOffset, setCaretOffset] = (0, $h96tf.useState)(1);
    (0, $h96tf.useEffect)(()=>{
        if (inputDisplay.current !== null) inputDisplay.current.innerText = display;
        if (document.activeElement !== inputDisplay.current) return;
        const selection = window.getSelection();
        if (selection.rangeCount === 0) return;
        for(let i = 0; i < caretOffset; i++)selection.modify("move", "right", "character");
    }, [
        inputDisplay,
        display,
        caretOffset
    ]);
    const handleValidation = (0, $h96tf.useCallback)((event)=>{
        if (validateInput === undefined) return;
        const currentText = event.target.innerText;
        const startIndex = event.currentTarget.selectionStart || 0;
        const endIndex = event.currentTarget.selectionEnd || startIndex;
        const nextInput = `${currentText.slice(0, startIndex)}${event.data}${currentText.slice(endIndex)}`;
        if (!validateInput(nextInput, event)) event.preventDefault();
    }, [
        validateInput
    ]);
    const handleInput = (0, $h96tf.useCallback)((event)=>{
        if (event.nativeEvent.inputType === "insertFromPaste") return;
        const selection = window.getSelection();
        const caretOffset = selection.anchorOffset;
        setCaretOffset(caretOffset);
        onInput(event.target.innerText, event);
    }, [
        onInput,
        setCaretOffset
    ]);
    const handlePaste = (0, $h96tf.useCallback)((event)=>{
        const text = event.clipboardData.getData('text');
        if (validateInput !== undefined) {
            if (validateInput(text)) onInput(text, event);
        } else onInput(text, event);
        event.preventDefault();
    }, [
        validateInput,
        onInput
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $283b71f4d1372a4c$export$2e2bcd8739ae039), {
        ref: inputDisplay,
        onBeforeInput: handleValidation,
        onPaste: handlePaste,
        onInput: handleInput,
        ...restProps
    });
}



const $1abcd65e3432d481$var$newShortcut = new Set();
function $1abcd65e3432d481$var$keyIsInvalid(key) {
    switch(key){
        case 'Escape':
        case 'Enter':
        case ' ':
        case 'Backspace':
            return true;
        default:
            return false;
    }
}
function $1abcd65e3432d481$export$234cd5ee72972140({ name: name, value: value, onChange: onChange, showReset: showReset = false, resetValue: resetValue = false, children: children }) {
    const [reading, setReading] = (0, $h96tf.useState)(false);
    const [display, setDisplay] = (0, $h96tf.useState)(value);
    (0, $h96tf.useEffect)(()=>{
        const handler = (event)=>{
            if ($1abcd65e3432d481$var$keyIsInvalid(event.code)) {
                event.target.blur();
                return;
            }
            if ($1abcd65e3432d481$var$newShortcut.size >= 5) {
                event.target.blur();
                return;
            }
            $1abcd65e3432d481$var$newShortcut.add(event.code);
            setDisplay((0, $d14c2a87cc1b733c$export$e1d1c7d53548b7ac)($1abcd65e3432d481$var$newShortcut));
        };
        if (reading) {
            window.addEventListener('keydown', handler);
            return ()=>window.removeEventListener('keydown', handler);
        }
    }, [
        reading,
        setDisplay
    ]);
    const handleFocus = (0, $h96tf.useCallback)(()=>{
        setDisplay(value);
        setReading(true);
    }, [
        setReading,
        setDisplay,
        value
    ]);
    const handleBlur = (0, $h96tf.useCallback)(()=>{
        setReading(false);
        if ($1abcd65e3432d481$var$newShortcut.size !== 0 && !(0, $d14c2a87cc1b733c$export$20225055d685d131)($1abcd65e3432d481$var$newShortcut)) onChange((0, $d14c2a87cc1b733c$export$e1d1c7d53548b7ac)($1abcd65e3432d481$var$newShortcut));
        $1abcd65e3432d481$var$newShortcut.clear();
        setDisplay(value);
    }, [
        setReading,
        onChange,
        setDisplay,
        value
    ]);
    const handleReset = (0, $h96tf.useCallback)(()=>{
        if (!resetValue || !showReset) return;
        onChange(resetValue);
    }, [
        onChange,
        showReset,
        resetValue
    ]);
    let inputDisplayClassName = 'p-1 ';
    inputDisplayClassName += showReset ? 'form-control' : 'border rounded';
    let itemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $565ef684d07fe24b$export$2e2bcd8739ae039), {
        className: inputDisplayClassName,
        display: reading ? display : value,
        onInput: ()=>{},
        onFocus: handleFocus,
        onBlur: handleBlur,
        style: {
            minWidth: "20%"
        }
    });
    if (showReset) itemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "input-group"
    }, itemContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "btn btn-outline-secondary",
        onClick: handleReset
    }, "Reset"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $47bc5cb6c16c6855$export$6d08773d2e66f8f2), {
        name: name,
        description: children
    }, itemContent);
}



var $h96tf = parcelRequire("h96tf");


var $h96tf = parcelRequire("h96tf");
var $c2e965fc45443612$export$3063d4ba30906ea1;
var $c2e965fc45443612$export$9037a62497fa7cac;
var $c2e965fc45443612$export$9564d582d8211330;
$c2e965fc45443612$export$3063d4ba30906ea1 = `nshueq_clear-button`;
$c2e965fc45443612$export$9037a62497fa7cac = `nshueq_clear-button-container`;
$c2e965fc45443612$export$9564d582d8211330 = `nshueq_clear-button-parent`;


const $f7a34619d79831d8$export$5328738e6beedda0 = $c2e965fc45443612$export$9564d582d8211330;
function $f7a34619d79831d8$export$13ec83e50bf04290({ onClick: onClick }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: $c2e965fc45443612$export$9037a62497fa7cac
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("button", {
        className: $c2e965fc45443612$export$3063d4ba30906ea1,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "bi bi-x",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("path", {
        d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
    }))));
}


function $8ac601ce79d64d69$export$cca78f130c060156({ name: name, value: value, onChange: onChange, children: children }) {
    const handlePathSelect = (0, $h96tf.useCallback)((path)=>{
        if (path === undefined) return;
        onChange(path);
    }, [
        onChange
    ]);
    const handleClick = (0, $h96tf.useCallback)(()=>{
        window.settings.handleDialogResponse(handlePathSelect);
        window.settings.showDialog({
            properties: [
                'openDirectory'
            ]
        });
    }, []);
    const handleClear = (0, $h96tf.useCallback)(()=>{
        onChange('');
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $47bc5cb6c16c6855$export$6d08773d2e66f8f2), {
        name: name,
        description: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: (0, $f7a34619d79831d8$export$5328738e6beedda0) + ' input-group'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("input", {
        type: "text",
        readOnly: true,
        value: value,
        className: "form-control overflow-x-scroll"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $f7a34619d79831d8$export$13ec83e50bf04290), {
        onClick: handleClear
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "btn btn-outline-secondary",
        onClick: handleClick
    }, "Browse")));
}



var $h96tf = parcelRequire("h96tf");



function $4a61639b84da987d$var$validateInput(input, event) {
    const invalidCharacters = /(\n)[^\n]/;
    const isValid = input.search(invalidCharacters) === -1;
    if (!isValid) event.target.blur();
    return isValid;
}
function $4a61639b84da987d$export$400942b1e6133700({ name: name, value: value, onChange: onChange, showReset: showReset = false, resetValue: resetValue = "", showClear: showClear = true, children: children }) {
    const [reading, setReading] = (0, $h96tf.useState)(false);
    const [display, setDisplay] = (0, $h96tf.useState)(value);
    const handleFocus = (0, $h96tf.useCallback)(()=>{
        setDisplay(value);
        setReading(true);
    }, [
        value,
        setDisplay,
        setReading
    ]);
    const handleBlur = (0, $h96tf.useCallback)(()=>{
        onChange(display);
        setReading(false);
    }, [
        setReading,
        display,
        onChange
    ]);
    const handleInput = (0, $h96tf.useCallback)((input)=>{
        setDisplay(input);
    }, [
        setDisplay
    ]);
    const handleReset = (0, $h96tf.useCallback)(()=>{
        onChange(resetValue);
    }, [
        onChange
    ]);
    let inputDisplayClassName = 'p-1 ';
    inputDisplayClassName += showReset ? 'form-control' : 'border rounded';
    let itemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: (0, $f7a34619d79831d8$export$5328738e6beedda0),
        style: {
            display: 'flex',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $565ef684d07fe24b$export$2e2bcd8739ae039), {
        className: inputDisplayClassName,
        display: reading ? display : value,
        onInput: handleInput,
        onFocus: handleFocus,
        onBlur: handleBlur,
        validateInput: $4a61639b84da987d$var$validateInput,
        style: {
            width: '100%'
        }
    }), showClear && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $f7a34619d79831d8$export$13ec83e50bf04290), {
        onClick: handleReset
    }));
    if (showReset) itemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "input-group"
    }, itemContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "btn btn-outline-secondary",
        onClick: handleReset
    }, "Reset"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $47bc5cb6c16c6855$export$6d08773d2e66f8f2), {
        name: name,
        description: children
    }, itemContent);
}



var $h96tf = parcelRequire("h96tf");

function $fb764235887f2deb$export$547e5b284e7a189c({ name: name, value: value, onChange: onChange, children: children }) {
    const handleChange = (0, $h96tf.useCallback)((input)=>{
        if (typeof input === "string" && input.trim() === '') return;
        let number;
        try {
            number = Number(input);
        } catch  {
            return;
        }
        if (!Number.isInteger(number)) return;
        onChange(number);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $4a61639b84da987d$export$400942b1e6133700), {
        name: name,
        value: value,
        onChange: handleChange,
        showClear: false
    }, children);
}




function $13d455722ff69500$export$5fedf1aa9280d73d() {
    const [counterMode] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('counterMode');
    const [fileWatcherMode, setFileWatcherMode] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'mode');
    const [showModeIndicator, setShowModeIndicator] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'showModeIndicator');
    const [fileWatcherSubMode, setFileWatcherSubMode] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'subMode');
    const [trackName, setTrackName] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'trackName');
    const [audioFilesPath, setAudioFilesPath] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'audioFilesPath');
    const [offset, setOffset] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'offset');
    const [offsetShortcuts, setOffsetShortcuts] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'offsetShortcuts');
    const [showOffset, setShowOffset] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'showOffset');
    const handleSetSubMode = (0, $h96tf.useCallback)((mode)=>{
        if (mode === 'all') setTrackName('');
        setFileWatcherSubMode(mode);
    }, [
        fileWatcherSubMode,
        setFileWatcherSubMode,
        setTrackName
    ]);
    if (window.settings === undefined) return undefined;
    if (counterMode !== 'ptFileWatcher') return undefined;
    const clipModeSettings = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $de590bd51b2243a3$export$6648d5fa18559e7f), {
        name: "Tracks to watch",
        value: fileWatcherSubMode,
        onChange: handleSetSubMode,
        options: [
            {
                name: 'Any Track',
                value: 'all'
            },
            {
                name: 'Specific Track',
                value: 'specific'
            }
        ]
    }), fileWatcherSubMode === 'specific' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $4a61639b84da987d$export$400942b1e6133700), {
        name: "Track name",
        value: trackName,
        onChange: setTrackName
    }) : undefined);
    const playlistModeSettings = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $de590bd51b2243a3$export$6648d5fa18559e7f), {
        name: "Playlists to watch",
        value: fileWatcherSubMode,
        onChange: handleSetSubMode,
        options: [
            {
                name: 'Any Track Playlists',
                value: 'all'
            },
            {
                name: 'Specific Track Playlists',
                value: 'specific'
            }
        ]
    }), fileWatcherSubMode === 'specific' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $4a61639b84da987d$export$400942b1e6133700), {
        name: "Track name",
        value: trackName,
        onChange: setTrackName
    }) : undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("h4", {
        className: "row border-bottom mt-3"
    }, "Pro Tools File Watcher"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $8ac601ce79d64d69$export$cca78f130c060156), {
        name: "Audio Files folder path",
        value: audioFilesPath,
        onChange: setAudioFilesPath
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $de590bd51b2243a3$export$6648d5fa18559e7f), {
        name: "Take Count follows",
        value: fileWatcherMode,
        onChange: setFileWatcherMode,
        options: [
            {
                name: 'Clip Number',
                value: 'clip'
            },
            {
                name: 'Playlist Number',
                value: 'playlist'
            }
        ]
    }), fileWatcherMode === 'playlist' ? playlistModeSettings : clipModeSettings, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $fb764235887f2deb$export$547e5b284e7a189c), {
        name: "Take Count offset",
        value: offset,
        onChange: setOffset,
        description: "Offset adjusts the automatic take value up or down."
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $de2337dda9fc8599$export$61a038936c60c848), {
        name: "Offset Shortcuts",
        value: offsetShortcuts,
        onChange: setOffsetShortcuts
    }, "Counter shortcuts change offset instead of take number."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $de2337dda9fc8599$export$61a038936c60c848), {
        name: "Show offset",
        value: showOffset,
        onChange: setShowOffset
    }, "Shows the current offset on the main screen."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $de2337dda9fc8599$export$61a038936c60c848), {
        name: "Show Mode Indicator",
        value: showModeIndicator,
        onChange: setShowModeIndicator
    }, "Shows the current Pro Tools File Watcher mode on the main screen."));
}



var $h96tf = parcelRequire("h96tf");



function $ecc2b29d9004ca1f$export$dbc06cd8bcd66e5d() {
    const [incrementCountShortcut, setIncrementCountShortcut] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('keyboardShortcuts', 'incrementCount');
    const [decrementCountShortcut, setDecrementCountShortcut] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('keyboardShortcuts', 'decrementCount');
    const [resetCountShortcut, setResetCountShortcut] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('keyboardShortcuts', 'resetCount');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("h4", {
        className: "row border-bottom mt-3"
    }, "Keyboard Shortcuts"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("p", null, "To change keyboard shortcuts: click the shortcut box, enter the shortcut you want, then click away from the box."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $1abcd65e3432d481$export$234cd5ee72972140), {
        name: "Increment count",
        value: incrementCountShortcut,
        onChange: setIncrementCountShortcut,
        showReset: true,
        resetValue: (0, $3c786cb677838e50$export$62680b65e63e14ec).keyboardShortcuts.incrementCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $1abcd65e3432d481$export$234cd5ee72972140), {
        name: "Decrement count",
        value: decrementCountShortcut,
        onChange: setDecrementCountShortcut,
        showReset: true,
        resetValue: (0, $3c786cb677838e50$export$62680b65e63e14ec).keyboardShortcuts.decrementCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $1abcd65e3432d481$export$234cd5ee72972140), {
        name: "Reset count",
        value: resetCountShortcut,
        onChange: setResetCountShortcut,
        showReset: true,
        resetValue: (0, $3c786cb677838e50$export$62680b65e63e14ec).keyboardShortcuts.resetCount
    }));
}



var $h96tf = parcelRequire("h96tf");


function $73179dd99861abed$export$d1ec5db8c03397fc() {
    const [alwaysOnTop, setAlwaysOnTop] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('alwaysOnTop');
    const [showDetailsBox, setShowDetailsBox] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('showDetailsBox');
    if (window.settings === undefined) return undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("h4", {
        className: "row border-bottom mt-3"
    }, "Window"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $de2337dda9fc8599$export$61a038936c60c848), {
        name: "Always on top",
        value: alwaysOnTop,
        onChange: setAlwaysOnTop
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $de2337dda9fc8599$export$61a038936c60c848), {
        name: "Show details box",
        value: showDetailsBox,
        onChange: setShowDetailsBox
    }));
}



var $h96tf = parcelRequire("h96tf");


function $587e175e58cf5bae$export$218c29f66b0c4e92() {
    const [mode, setMode] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('counterMode');
    const options = [
        {
            name: 'Manual',
            value: 'manual'
        }
    ];
    if (window.settings !== undefined) options.push({
        name: 'Pro Tools File Watcher',
        value: 'ptFileWatcher'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("h4", {
        className: "row border-bottom"
    }, "Take Counting"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $de590bd51b2243a3$export$6648d5fa18559e7f), {
        name: "Mode",
        value: mode,
        onChange: setMode,
        options: options
    }));
}



var $h96tf = parcelRequire("h96tf");


function $16707294d1b36434$export$1645b4b1ea9d52ad() {
    const [takeTextPrefix, setTakePrefix] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('takeDisplaySettings', 'takeTextPrefix');
    const [showTakePrefix, setShowTakePrefix] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('takeDisplaySettings', 'showTakePrefix');
    const [showTakeButtons, setShowTakeButtons] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('takeDisplaySettings', 'showTakeButtons');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("h4", {
        className: "row border-bottom mt-3"
    }, "Take Display"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $4a61639b84da987d$export$400942b1e6133700), {
        name: "Take Display Prefix",
        value: takeTextPrefix,
        onChange: setTakePrefix
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $de2337dda9fc8599$export$61a038936c60c848), {
        name: "Show Take Prefix",
        value: showTakePrefix,
        onChange: setShowTakePrefix
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $de2337dda9fc8599$export$61a038936c60c848), {
        name: "Show Take Buttons",
        value: showTakeButtons,
        onChange: setShowTakeButtons
    }));
}



var $h96tf = parcelRequire("h96tf");



var $h96tf = parcelRequire("h96tf");
var $4364ccfa925478a4$exports = {};
/*!
  * Bootstrap v5.3.7 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $4364ccfa925478a4$exports = factory();
})($4364ccfa925478a4$exports, function() {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const elementMap = new Map();
    const Data = {
        set (element, key, instance) {
            if (!elementMap.has(element)) elementMap.set(element, new Map());
            const instanceMap = elementMap.get(element);
            // make it clear we only want one instance per element
            // can be removed later when multiple key/instances are fine to be used
            if (!instanceMap.has(key) && instanceMap.size !== 0) {
                // eslint-disable-next-line no-console
                console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
                return;
            }
            instanceMap.set(key, instance);
        },
        get (element, key) {
            if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
            return null;
        },
        remove (element, key) {
            if (!elementMap.has(element)) return;
            const instanceMap = elementMap.get(element);
            instanceMap.delete(key);
            // free up element references if there are no instances left for an element
            if (instanceMap.size === 0) elementMap.delete(element);
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const MAX_UID = 1000000;
    const MILLISECONDS_MULTIPLIER = 1000;
    const TRANSITION_END = 'transitionend';
    /**
   * Properly escape IDs selectors to handle weird IDs
   * @param {string} selector
   * @returns {string}
   */ const parseSelector = (selector)=>{
        if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
        selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
        return selector;
    };
    // Shout-out Angus Croll (https://goo.gl/pxwQGp)
    const toType = (object)=>{
        if (object === null || object === undefined) return `${object}`;
        return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    /**
   * Public Util API
   */ const getUID = (prefix)=>{
        do prefix += Math.floor(Math.random() * MAX_UID);
        while (document.getElementById(prefix));
        return prefix;
    };
    const getTransitionDurationFromElement = (element)=>{
        if (!element) return 0;
        // Get transition-duration of the element
        let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
        const floatTransitionDuration = Number.parseFloat(transitionDuration);
        const floatTransitionDelay = Number.parseFloat(transitionDelay);
        // Return 0 if element or transition duration is not found
        if (!floatTransitionDuration && !floatTransitionDelay) return 0;
        // If multiple durations are defined, take the first
        transitionDuration = transitionDuration.split(',')[0];
        transitionDelay = transitionDelay.split(',')[0];
        return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    const triggerTransitionEnd = (element)=>{
        element.dispatchEvent(new Event(TRANSITION_END));
    };
    const isElement$1 = (object)=>{
        if (!object || typeof object !== 'object') return false;
        if (typeof object.jquery !== 'undefined') object = object[0];
        return typeof object.nodeType !== 'undefined';
    };
    const getElement = (object)=>{
        // it's a jQuery object or a node element
        if (isElement$1(object)) return object.jquery ? object[0] : object;
        if (typeof object === 'string' && object.length > 0) return document.querySelector(parseSelector(object));
        return null;
    };
    const isVisible = (element)=>{
        if (!isElement$1(element) || element.getClientRects().length === 0) return false;
        const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
        // Handle `details` element as its content may falsie appear visible when it is closed
        const closedDetails = element.closest('details:not([open])');
        if (!closedDetails) return elementIsVisible;
        if (closedDetails !== element) {
            const summary = element.closest('summary');
            if (summary && summary.parentNode !== closedDetails) return false;
            if (summary === null) return false;
        }
        return elementIsVisible;
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains('disabled')) return true;
        if (typeof element.disabled !== 'undefined') return element.disabled;
        return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
    };
    const findShadowRoot = (element)=>{
        if (!document.documentElement.attachShadow) return null;
        // Can find the shadow root otherwise it'll return the document
        if (typeof element.getRootNode === 'function') {
            const root = element.getRootNode();
            return root instanceof ShadowRoot ? root : null;
        }
        if (element instanceof ShadowRoot) return element;
        // when we don't find a shadow root
        if (!element.parentNode) return null;
        return findShadowRoot(element.parentNode);
    };
    const noop = ()=>{};
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ const reflow = (element)=>{
        element.offsetHeight; // eslint-disable-line no-unused-expressions
    };
    const getjQuery = ()=>{
        if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === 'loading') {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
                for (const callback of DOMContentLoadedCallbacks)callback();
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const isRTL = ()=>document.documentElement.dir === 'rtl';
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    const execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
        return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
    };
    const executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
        if (!waitForTransition) {
            execute(callback);
            return;
        }
        const durationPadding = 5;
        const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
        let called = false;
        const handler = ({ target: target })=>{
            if (target !== transitionElement) return;
            called = true;
            transitionElement.removeEventListener(TRANSITION_END, handler);
            execute(callback);
        };
        transitionElement.addEventListener(TRANSITION_END, handler);
        setTimeout(()=>{
            if (!called) triggerTransitionEnd(transitionElement);
        }, emulatedDuration);
    };
    /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */ const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
        const listLength = list.length;
        let index = list.indexOf(activeElement);
        // if the element does not exist in the list return an element
        // depending on the direction and if cycle is allowed
        if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
        index += shouldGetNext ? 1 : -1;
        if (isCycleAllowed) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    const stripNameRegex = /\..*/;
    const stripUidRegex = /::\d+$/;
    const eventRegistry = {}; // Events storage
    let uidEvent = 1;
    const customEvents = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout'
    };
    const nativeEvents = new Set([
        'click',
        'dblclick',
        'mouseup',
        'mousedown',
        'contextmenu',
        'mousewheel',
        'DOMMouseScroll',
        'mouseover',
        'mouseout',
        'mousemove',
        'selectstart',
        'selectend',
        'keydown',
        'keypress',
        'keyup',
        'orientationchange',
        'touchstart',
        'touchmove',
        'touchend',
        'touchcancel',
        'pointerdown',
        'pointermove',
        'pointerup',
        'pointerleave',
        'pointercancel',
        'gesturestart',
        'gesturechange',
        'gestureend',
        'focus',
        'blur',
        'change',
        'reset',
        'select',
        'submit',
        'focusin',
        'focusout',
        'load',
        'unload',
        'beforeunload',
        'resize',
        'move',
        'DOMContentLoaded',
        'readystatechange',
        'error',
        'abort',
        'scroll'
    ]);
    /**
   * Private methods
   */ function makeEventUid(element, uid) {
        return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
    }
    function getElementEvents(element) {
        const uid = makeEventUid(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
    }
    function bootstrapHandler(element, fn) {
        return function handler(event) {
            hydrateObj(event, {
                delegateTarget: element
            });
            if (handler.oneOff) EventHandler.off(element, event.type, fn);
            return fn.apply(element, [
                event
            ]);
        };
    }
    function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
            const domElements = element.querySelectorAll(selector);
            for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
                if (domElement !== target) continue;
                hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        };
    }
    function findHandler(events, callable, delegationSelector = null) {
        return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
    }
    function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
        const isDelegated = typeof handler === 'string';
        // TODO: tooltip passes `false` instead of selector, so we need to check
        const callable = isDelegated ? delegationFunction : handler || delegationFunction;
        let typeEvent = getTypeEvent(originalTypeEvent);
        if (!nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
        return [
            isDelegated,
            callable,
            typeEvent
        ];
    }
    function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        let [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
        // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
        if (originalTypeEvent in customEvents) {
            const wrapFunction = (fn)=>{
                return function(event) {
                    if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
                };
            };
            callable = wrapFunction(callable);
        }
        const events = getElementEvents(element);
        const handlers = events[typeEvent] || (events[typeEvent] = {});
        const previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
        if (previousFunction) {
            previousFunction.oneOff = previousFunction.oneOff && oneOff;
            return;
        }
        const uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ''));
        const fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
        fn.delegationSelector = isDelegated ? handler : null;
        fn.callable = callable;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, isDelegated);
    }
    function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        const fn = findHandler(events[typeEvent], handler, delegationSelector);
        if (!fn) return;
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
    }
    function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        const storeElementEvent = events[typeEvent] || {};
        for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
    }
    function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, '');
        return customEvents[event] || event;
    }
    const EventHandler = {
        on (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, false);
        },
        one (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, true);
        },
        off (element, originalTypeEvent, handler, delegationFunction) {
            if (typeof originalTypeEvent !== 'string' || !element) return;
            const [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
            const inNamespace = typeEvent !== originalTypeEvent;
            const events = getElementEvents(element);
            const storeElementEvent = events[typeEvent] || {};
            const isNamespace = originalTypeEvent.startsWith('.');
            if (typeof callable !== 'undefined') {
                // Simplest case: handler is passed, remove that listener ONLY.
                if (!Object.keys(storeElementEvent).length) return;
                removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
                return;
            }
            if (isNamespace) for (const elementEvent of Object.keys(events))removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
                const handlerKey = keyHandlers.replace(stripUidRegex, '');
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        },
        trigger (element, event, args) {
            if (typeof event !== 'string' || !element) return null;
            const $ = getjQuery();
            const typeEvent = getTypeEvent(event);
            const inNamespace = event !== typeEvent;
            let jQueryEvent = null;
            let bubbles = true;
            let nativeDispatch = true;
            let defaultPrevented = false;
            if (inNamespace && $) {
                jQueryEvent = $.Event(event, args);
                $(element).trigger(jQueryEvent);
                bubbles = !jQueryEvent.isPropagationStopped();
                nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
                defaultPrevented = jQueryEvent.isDefaultPrevented();
            }
            const evt = hydrateObj(new Event(event, {
                bubbles: bubbles,
                cancelable: true
            }), args);
            if (defaultPrevented) evt.preventDefault();
            if (nativeDispatch) element.dispatchEvent(evt);
            if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
            return evt;
        }
    };
    function hydrateObj(obj, meta = {}) {
        for (const [key, value] of Object.entries(meta))try {
            obj[key] = value;
        } catch (_unused) {
            Object.defineProperty(obj, key, {
                configurable: true,
                get () {
                    return value;
                }
            });
        }
        return obj;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ function normalizeData(value) {
        if (value === 'true') return true;
        if (value === 'false') return false;
        if (value === Number(value).toString()) return Number(value);
        if (value === '' || value === 'null') return null;
        if (typeof value !== 'string') return value;
        try {
            return JSON.parse(decodeURIComponent(value));
        } catch (_unused) {
            return value;
        }
    }
    function normalizeDataKey(key) {
        return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
    }
    const Manipulator = {
        setDataAttribute (element, key, value) {
            element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
        },
        removeDataAttribute (element, key) {
            element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
        },
        getDataAttributes (element) {
            if (!element) return {};
            const attributes = {};
            const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
            for (const key of bsKeys){
                let pureKey = key.replace(/^bs/, '');
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
                attributes[pureKey] = normalizeData(element.dataset[key]);
            }
            return attributes;
        },
        getDataAttribute (element, key) {
            return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/config.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Class definition
   */ class Config {
        // Getters
        static get Default() {
            return {};
        }
        static get DefaultType() {
            return {};
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!');
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            return config;
        }
        _mergeConfigObj(config, element) {
            const jsonConfig = isElement$1(element) ? Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
            return {
                ...this.constructor.Default,
                ...typeof jsonConfig === 'object' ? jsonConfig : {},
                ...isElement$1(element) ? Manipulator.getDataAttributes(element) : {},
                ...typeof config === 'object' ? config : {}
            };
        }
        _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
            for (const [property, expectedTypes] of Object.entries(configTypes)){
                const value = config[property];
                const valueType = isElement$1(value) ? 'element' : toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
            }
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const VERSION = '5.3.7';
    /**
   * Class definition
   */ class BaseComponent extends Config {
        // Public
        dispose() {
            Data.remove(this._element, this.constructor.DATA_KEY);
            EventHandler.off(this._element, this.constructor.EVENT_KEY);
            for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
        }
        // Private
        _queueCallback(callback, element, isAnimated = true) {
            executeAfterTransition(callback, element, isAnimated);
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config, this._element);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        // Static
        static getInstance(element) {
            return Data.get(getElement(element), this.DATA_KEY);
        }
        static getOrCreateInstance(element, config = {}) {
            return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
        }
        static get VERSION() {
            return VERSION;
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`;
        }
        static eventName(name) {
            return `${name}${this.EVENT_KEY}`;
        }
        constructor(element, config){
            super();
            element = getElement(element);
            if (!element) return;
            this._element = element;
            this._config = this._getConfig(config);
            Data.set(this._element, this.constructor.DATA_KEY, this);
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const getSelector = (element)=>{
        let selector = element.getAttribute('data-bs-target');
        if (!selector || selector === '#') {
            let hrefAttribute = element.getAttribute('href');
            // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
            // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
            selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
        }
        return selector ? selector.split(',').map((sel)=>parseSelector(sel)).join(',') : null;
    };
    const SelectorEngine = {
        find (selector, element = document.documentElement) {
            return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
        },
        findOne (selector, element = document.documentElement) {
            return Element.prototype.querySelector.call(element, selector);
        },
        children (element, selector) {
            return [].concat(...element.children).filter((child)=>child.matches(selector));
        },
        parents (element, selector) {
            const parents = [];
            let ancestor = element.parentNode.closest(selector);
            while(ancestor){
                parents.push(ancestor);
                ancestor = ancestor.parentNode.closest(selector);
            }
            return parents;
        },
        prev (element, selector) {
            let previous = element.previousElementSibling;
            while(previous){
                if (previous.matches(selector)) return [
                    previous
                ];
                previous = previous.previousElementSibling;
            }
            return [];
        },
        // TODO: this is now unused; remove later along with prev()
        next (element, selector) {
            let next = element.nextElementSibling;
            while(next){
                if (next.matches(selector)) return [
                    next
                ];
                next = next.nextElementSibling;
            }
            return [];
        },
        focusableChildren (element) {
            const focusables = [
                'a',
                'button',
                'input',
                'textarea',
                'select',
                'details',
                '[tabindex]',
                '[contenteditable="true"]'
            ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
            return this.find(focusables, element).filter((el)=>!isDisabled(el) && isVisible(el));
        },
        getSelectorFromElement (element) {
            const selector = getSelector(element);
            if (selector) return SelectorEngine.findOne(selector) ? selector : null;
            return null;
        },
        getElementFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.findOne(selector) : null;
        },
        getMultipleElementsFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.find(selector) : [];
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/component-functions.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const enableDismissTrigger = (component, method = 'hide')=>{
        const clickEvent = `click.dismiss${component.EVENT_KEY}`;
        const name = component.NAME;
        EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
            if ([
                'A',
                'AREA'
            ].includes(this.tagName)) event.preventDefault();
            if (isDisabled(this)) return;
            const target = SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
            const instance = component.getOrCreateInstance(target);
            // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
            instance[method]();
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap alert.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$f = 'alert';
    const DATA_KEY$a = 'bs.alert';
    const EVENT_KEY$b = `.${DATA_KEY$a}`;
    const EVENT_CLOSE = `close${EVENT_KEY$b}`;
    const EVENT_CLOSED = `closed${EVENT_KEY$b}`;
    const CLASS_NAME_FADE$5 = 'fade';
    const CLASS_NAME_SHOW$8 = 'show';
    /**
   * Class definition
   */ class Alert extends BaseComponent {
        // Getters
        static get NAME() {
            return NAME$f;
        }
        // Public
        close() {
            const closeEvent = EventHandler.trigger(this._element, EVENT_CLOSE);
            if (closeEvent.defaultPrevented) return;
            this._element.classList.remove(CLASS_NAME_SHOW$8);
            const isAnimated = this._element.classList.contains(CLASS_NAME_FADE$5);
            this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
        }
        // Private
        _destroyElement() {
            this._element.remove();
            EventHandler.trigger(this._element, EVENT_CLOSED);
            this.dispose();
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Alert.getOrCreateInstance(this);
                if (typeof config !== 'string') return;
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            });
        }
    }
    /**
   * Data API implementation
   */ enableDismissTrigger(Alert, 'close');
    /**
   * jQuery
   */ defineJQueryPlugin(Alert);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap button.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$e = 'button';
    const DATA_KEY$9 = 'bs.button';
    const EVENT_KEY$a = `.${DATA_KEY$9}`;
    const DATA_API_KEY$6 = '.data-api';
    const CLASS_NAME_ACTIVE$3 = 'active';
    const SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
    const EVENT_CLICK_DATA_API$6 = `click${EVENT_KEY$a}${DATA_API_KEY$6}`;
    /**
   * Class definition
   */ class Button extends BaseComponent {
        // Getters
        static get NAME() {
            return NAME$e;
        }
        // Public
        toggle() {
            // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
            this._element.setAttribute('aria-pressed', this._element.classList.toggle(CLASS_NAME_ACTIVE$3));
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Button.getOrCreateInstance(this);
                if (config === 'toggle') data[config]();
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$5, (event)=>{
        event.preventDefault();
        const button = event.target.closest(SELECTOR_DATA_TOGGLE$5);
        const data = Button.getOrCreateInstance(button);
        data.toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Button);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/swipe.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$d = 'swipe';
    const EVENT_KEY$9 = '.bs.swipe';
    const EVENT_TOUCHSTART = `touchstart${EVENT_KEY$9}`;
    const EVENT_TOUCHMOVE = `touchmove${EVENT_KEY$9}`;
    const EVENT_TOUCHEND = `touchend${EVENT_KEY$9}`;
    const EVENT_POINTERDOWN = `pointerdown${EVENT_KEY$9}`;
    const EVENT_POINTERUP = `pointerup${EVENT_KEY$9}`;
    const POINTER_TYPE_TOUCH = 'touch';
    const POINTER_TYPE_PEN = 'pen';
    const CLASS_NAME_POINTER_EVENT = 'pointer-event';
    const SWIPE_THRESHOLD = 40;
    const Default$c = {
        endCallback: null,
        leftCallback: null,
        rightCallback: null
    };
    const DefaultType$c = {
        endCallback: '(function|null)',
        leftCallback: '(function|null)',
        rightCallback: '(function|null)'
    };
    /**
   * Class definition
   */ class Swipe extends Config {
        // Getters
        static get Default() {
            return Default$c;
        }
        static get DefaultType() {
            return DefaultType$c;
        }
        static get NAME() {
            return NAME$d;
        }
        // Public
        dispose() {
            EventHandler.off(this._element, EVENT_KEY$9);
        }
        // Private
        _start(event) {
            if (!this._supportPointerEvents) {
                this._deltaX = event.touches[0].clientX;
                return;
            }
            if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
        }
        _end(event) {
            if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
            this._handleSwipe();
            execute(this._config.endCallback);
        }
        _move(event) {
            this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
        }
        _handleSwipe() {
            const absDeltaX = Math.abs(this._deltaX);
            if (absDeltaX <= SWIPE_THRESHOLD) return;
            const direction = absDeltaX / this._deltaX;
            this._deltaX = 0;
            if (!direction) return;
            execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
        }
        _initEvents() {
            if (this._supportPointerEvents) {
                EventHandler.on(this._element, EVENT_POINTERDOWN, (event)=>this._start(event));
                EventHandler.on(this._element, EVENT_POINTERUP, (event)=>this._end(event));
                this._element.classList.add(CLASS_NAME_POINTER_EVENT);
            } else {
                EventHandler.on(this._element, EVENT_TOUCHSTART, (event)=>this._start(event));
                EventHandler.on(this._element, EVENT_TOUCHMOVE, (event)=>this._move(event));
                EventHandler.on(this._element, EVENT_TOUCHEND, (event)=>this._end(event));
            }
        }
        _eventIsPointerPenTouch(event) {
            return this._supportPointerEvents && (event.pointerType === POINTER_TYPE_PEN || event.pointerType === POINTER_TYPE_TOUCH);
        }
        // Static
        static isSupported() {
            return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
        }
        constructor(element, config){
            super();
            this._element = element;
            if (!element || !Swipe.isSupported()) return;
            this._config = this._getConfig(config);
            this._deltaX = 0;
            this._supportPointerEvents = Boolean(window.PointerEvent);
            this._initEvents();
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap carousel.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$c = 'carousel';
    const DATA_KEY$8 = 'bs.carousel';
    const EVENT_KEY$8 = `.${DATA_KEY$8}`;
    const DATA_API_KEY$5 = '.data-api';
    const ARROW_LEFT_KEY$1 = 'ArrowLeft';
    const ARROW_RIGHT_KEY$1 = 'ArrowRight';
    const TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
    const ORDER_NEXT = 'next';
    const ORDER_PREV = 'prev';
    const DIRECTION_LEFT = 'left';
    const DIRECTION_RIGHT = 'right';
    const EVENT_SLIDE = `slide${EVENT_KEY$8}`;
    const EVENT_SLID = `slid${EVENT_KEY$8}`;
    const EVENT_KEYDOWN$1 = `keydown${EVENT_KEY$8}`;
    const EVENT_MOUSEENTER$1 = `mouseenter${EVENT_KEY$8}`;
    const EVENT_MOUSELEAVE$1 = `mouseleave${EVENT_KEY$8}`;
    const EVENT_DRAG_START = `dragstart${EVENT_KEY$8}`;
    const EVENT_LOAD_DATA_API$3 = `load${EVENT_KEY$8}${DATA_API_KEY$5}`;
    const EVENT_CLICK_DATA_API$5 = `click${EVENT_KEY$8}${DATA_API_KEY$5}`;
    const CLASS_NAME_CAROUSEL = 'carousel';
    const CLASS_NAME_ACTIVE$2 = 'active';
    const CLASS_NAME_SLIDE = 'slide';
    const CLASS_NAME_END = 'carousel-item-end';
    const CLASS_NAME_START = 'carousel-item-start';
    const CLASS_NAME_NEXT = 'carousel-item-next';
    const CLASS_NAME_PREV = 'carousel-item-prev';
    const SELECTOR_ACTIVE = '.active';
    const SELECTOR_ITEM = '.carousel-item';
    const SELECTOR_ACTIVE_ITEM = SELECTOR_ACTIVE + SELECTOR_ITEM;
    const SELECTOR_ITEM_IMG = '.carousel-item img';
    const SELECTOR_INDICATORS = '.carousel-indicators';
    const SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
    const SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
    const KEY_TO_DIRECTION = {
        [ARROW_LEFT_KEY$1]: DIRECTION_RIGHT,
        [ARROW_RIGHT_KEY$1]: DIRECTION_LEFT
    };
    const Default$b = {
        interval: 5000,
        keyboard: true,
        pause: 'hover',
        ride: false,
        touch: true,
        wrap: true
    };
    const DefaultType$b = {
        interval: '(number|boolean)',
        // TODO:v6 remove boolean support
        keyboard: 'boolean',
        pause: '(string|boolean)',
        ride: '(boolean|string)',
        touch: 'boolean',
        wrap: 'boolean'
    };
    /**
   * Class definition
   */ class Carousel extends BaseComponent {
        // Getters
        static get Default() {
            return Default$b;
        }
        static get DefaultType() {
            return DefaultType$b;
        }
        static get NAME() {
            return NAME$c;
        }
        // Public
        next() {
            this._slide(ORDER_NEXT);
        }
        nextWhenVisible() {
            // FIXME TODO use `document.visibilityState`
            // Don't call next when the page isn't visible
            // or the carousel or its parent isn't visible
            if (!document.hidden && isVisible(this._element)) this.next();
        }
        prev() {
            this._slide(ORDER_PREV);
        }
        pause() {
            if (this._isSliding) triggerTransitionEnd(this._element);
            this._clearInterval();
        }
        cycle() {
            this._clearInterval();
            this._updateInterval();
            this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
        }
        _maybeEnableCycle() {
            if (!this._config.ride) return;
            if (this._isSliding) {
                EventHandler.one(this._element, EVENT_SLID, ()=>this.cycle());
                return;
            }
            this.cycle();
        }
        to(index) {
            const items = this._getItems();
            if (index > items.length - 1 || index < 0) return;
            if (this._isSliding) {
                EventHandler.one(this._element, EVENT_SLID, ()=>this.to(index));
                return;
            }
            const activeIndex = this._getItemIndex(this._getActive());
            if (activeIndex === index) return;
            const order = index > activeIndex ? ORDER_NEXT : ORDER_PREV;
            this._slide(order, items[index]);
        }
        dispose() {
            if (this._swipeHelper) this._swipeHelper.dispose();
            super.dispose();
        }
        // Private
        _configAfterMerge(config) {
            config.defaultInterval = config.interval;
            return config;
        }
        _addEventListeners() {
            if (this._config.keyboard) EventHandler.on(this._element, EVENT_KEYDOWN$1, (event)=>this._keydown(event));
            if (this._config.pause === 'hover') {
                EventHandler.on(this._element, EVENT_MOUSEENTER$1, ()=>this.pause());
                EventHandler.on(this._element, EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
            }
            if (this._config.touch && Swipe.isSupported()) this._addTouchEventListeners();
        }
        _addTouchEventListeners() {
            for (const img of SelectorEngine.find(SELECTOR_ITEM_IMG, this._element))EventHandler.on(img, EVENT_DRAG_START, (event)=>event.preventDefault());
            const endCallBack = ()=>{
                if (this._config.pause !== 'hover') return;
                // If it's a touch-enabled device, mouseenter/leave are fired as
                // part of the mouse compatibility events on first tap - the carousel
                // would stop cycling until user tapped out of it;
                // here, we listen for touchend, explicitly pause the carousel
                // (as if it's the second time we tap on it, mouseenter compat event
                // is NOT fired) and after a timeout (to allow for mouse compatibility
                // events to fire) we explicitly restart cycling
                this.pause();
                if (this.touchTimeout) clearTimeout(this.touchTimeout);
                this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), TOUCHEVENT_COMPAT_WAIT + this._config.interval);
            };
            const swipeConfig = {
                leftCallback: ()=>this._slide(this._directionToOrder(DIRECTION_LEFT)),
                rightCallback: ()=>this._slide(this._directionToOrder(DIRECTION_RIGHT)),
                endCallback: endCallBack
            };
            this._swipeHelper = new Swipe(this._element, swipeConfig);
        }
        _keydown(event) {
            if (/input|textarea/i.test(event.target.tagName)) return;
            const direction = KEY_TO_DIRECTION[event.key];
            if (direction) {
                event.preventDefault();
                this._slide(this._directionToOrder(direction));
            }
        }
        _getItemIndex(element) {
            return this._getItems().indexOf(element);
        }
        _setActiveIndicatorElement(index) {
            if (!this._indicatorsElement) return;
            const activeIndicator = SelectorEngine.findOne(SELECTOR_ACTIVE, this._indicatorsElement);
            activeIndicator.classList.remove(CLASS_NAME_ACTIVE$2);
            activeIndicator.removeAttribute('aria-current');
            const newActiveIndicator = SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
            if (newActiveIndicator) {
                newActiveIndicator.classList.add(CLASS_NAME_ACTIVE$2);
                newActiveIndicator.setAttribute('aria-current', 'true');
            }
        }
        _updateInterval() {
            const element = this._activeElement || this._getActive();
            if (!element) return;
            const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
            this._config.interval = elementInterval || this._config.defaultInterval;
        }
        _slide(order, element = null) {
            if (this._isSliding) return;
            const activeElement = this._getActive();
            const isNext = order === ORDER_NEXT;
            const nextElement = element || getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
            if (nextElement === activeElement) return;
            const nextElementIndex = this._getItemIndex(nextElement);
            const triggerEvent = (eventName)=>{
                return EventHandler.trigger(this._element, eventName, {
                    relatedTarget: nextElement,
                    direction: this._orderToDirection(order),
                    from: this._getItemIndex(activeElement),
                    to: nextElementIndex
                });
            };
            const slideEvent = triggerEvent(EVENT_SLIDE);
            if (slideEvent.defaultPrevented) return;
            if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
            // TODO: change tests that use empty divs to avoid this check
            return;
            const isCycling = Boolean(this._interval);
            this.pause();
            this._isSliding = true;
            this._setActiveIndicatorElement(nextElementIndex);
            this._activeElement = nextElement;
            const directionalClassName = isNext ? CLASS_NAME_START : CLASS_NAME_END;
            const orderClassName = isNext ? CLASS_NAME_NEXT : CLASS_NAME_PREV;
            nextElement.classList.add(orderClassName);
            reflow(nextElement);
            activeElement.classList.add(directionalClassName);
            nextElement.classList.add(directionalClassName);
            const completeCallBack = ()=>{
                nextElement.classList.remove(directionalClassName, orderClassName);
                nextElement.classList.add(CLASS_NAME_ACTIVE$2);
                activeElement.classList.remove(CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                this._isSliding = false;
                triggerEvent(EVENT_SLID);
            };
            this._queueCallback(completeCallBack, activeElement, this._isAnimated());
            if (isCycling) this.cycle();
        }
        _isAnimated() {
            return this._element.classList.contains(CLASS_NAME_SLIDE);
        }
        _getActive() {
            return SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);
        }
        _getItems() {
            return SelectorEngine.find(SELECTOR_ITEM, this._element);
        }
        _clearInterval() {
            if (this._interval) {
                clearInterval(this._interval);
                this._interval = null;
            }
        }
        _directionToOrder(direction) {
            if (isRTL()) return direction === DIRECTION_LEFT ? ORDER_PREV : ORDER_NEXT;
            return direction === DIRECTION_LEFT ? ORDER_NEXT : ORDER_PREV;
        }
        _orderToDirection(order) {
            if (isRTL()) return order === ORDER_PREV ? DIRECTION_LEFT : DIRECTION_RIGHT;
            return order === ORDER_PREV ? DIRECTION_RIGHT : DIRECTION_LEFT;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Carousel.getOrCreateInstance(this, config);
                if (typeof config === 'number') {
                    data.to(config);
                    return;
                }
                if (typeof config === 'string') {
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
        constructor(element, config){
            super(element, config);
            this._interval = null;
            this._activeElement = null;
            this._isSliding = false;
            this.touchTimeout = null;
            this._swipeHelper = null;
            this._indicatorsElement = SelectorEngine.findOne(SELECTOR_INDICATORS, this._element);
            this._addEventListeners();
            if (this._config.ride === CLASS_NAME_CAROUSEL) this.cycle();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$5, SELECTOR_DATA_SLIDE, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) return;
        event.preventDefault();
        const carousel = Carousel.getOrCreateInstance(target);
        const slideIndex = this.getAttribute('data-bs-slide-to');
        if (slideIndex) {
            carousel.to(slideIndex);
            carousel._maybeEnableCycle();
            return;
        }
        if (Manipulator.getDataAttribute(this, 'slide') === 'next') {
            carousel.next();
            carousel._maybeEnableCycle();
            return;
        }
        carousel.prev();
        carousel._maybeEnableCycle();
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$3, ()=>{
        const carousels = SelectorEngine.find(SELECTOR_DATA_RIDE);
        for (const carousel of carousels)Carousel.getOrCreateInstance(carousel);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Carousel);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$b = 'collapse';
    const DATA_KEY$7 = 'bs.collapse';
    const EVENT_KEY$7 = `.${DATA_KEY$7}`;
    const DATA_API_KEY$4 = '.data-api';
    const EVENT_SHOW$6 = `show${EVENT_KEY$7}`;
    const EVENT_SHOWN$6 = `shown${EVENT_KEY$7}`;
    const EVENT_HIDE$6 = `hide${EVENT_KEY$7}`;
    const EVENT_HIDDEN$6 = `hidden${EVENT_KEY$7}`;
    const EVENT_CLICK_DATA_API$4 = `click${EVENT_KEY$7}${DATA_API_KEY$4}`;
    const CLASS_NAME_SHOW$7 = 'show';
    const CLASS_NAME_COLLAPSE = 'collapse';
    const CLASS_NAME_COLLAPSING = 'collapsing';
    const CLASS_NAME_COLLAPSED = 'collapsed';
    const CLASS_NAME_DEEPER_CHILDREN = `:scope .${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`;
    const CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
    const WIDTH = 'width';
    const HEIGHT = 'height';
    const SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
    const SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
    const Default$a = {
        parent: null,
        toggle: true
    };
    const DefaultType$a = {
        parent: '(null|element)',
        toggle: 'boolean'
    };
    /**
   * Class definition
   */ class Collapse extends BaseComponent {
        // Getters
        static get Default() {
            return Default$a;
        }
        static get DefaultType() {
            return DefaultType$a;
        }
        static get NAME() {
            return NAME$b;
        }
        // Public
        toggle() {
            if (this._isShown()) this.hide();
            else this.show();
        }
        show() {
            if (this._isTransitioning || this._isShown()) return;
            let activeChildren = [];
            // find active children
            if (this._config.parent) activeChildren = this._getFirstLevelChildren(SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>Collapse.getOrCreateInstance(element, {
                    toggle: false
                }));
            if (activeChildren.length && activeChildren[0]._isTransitioning) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_SHOW$6);
            if (startEvent.defaultPrevented) return;
            for (const activeInstance of activeChildren)activeInstance.hide();
            const dimension = this._getDimension();
            this._element.classList.remove(CLASS_NAME_COLLAPSE);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            this._addAriaAndCollapsedClass(this._triggerArray, true);
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
                this._element.style[dimension] = '';
                EventHandler.trigger(this._element, EVENT_SHOWN$6);
            };
            const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            const scrollSize = `scroll${capitalizedDimension}`;
            this._queueCallback(complete, this._element, true);
            this._element.style[dimension] = `${this._element[scrollSize]}px`;
        }
        hide() {
            if (this._isTransitioning || !this._isShown()) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_HIDE$6);
            if (startEvent.defaultPrevented) return;
            const dimension = this._getDimension();
            this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
            for (const trigger of this._triggerArray){
                const element = SelectorEngine.getElementFromSelector(trigger);
                if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                    trigger
                ], false);
            }
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE);
                EventHandler.trigger(this._element, EVENT_HIDDEN$6);
            };
            this._element.style[dimension] = '';
            this._queueCallback(complete, this._element, true);
        }
        // Private
        _isShown(element = this._element) {
            return element.classList.contains(CLASS_NAME_SHOW$7);
        }
        _configAfterMerge(config) {
            config.toggle = Boolean(config.toggle); // Coerce string values
            config.parent = getElement(config.parent);
            return config;
        }
        _getDimension() {
            return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
        }
        _initializeChildren() {
            if (!this._config.parent) return;
            const children = this._getFirstLevelChildren(SELECTOR_DATA_TOGGLE$4);
            for (const element of children){
                const selected = SelectorEngine.getElementFromSelector(element);
                if (selected) this._addAriaAndCollapsedClass([
                    element
                ], this._isShown(selected));
            }
        }
        _getFirstLevelChildren(selector) {
            const children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
            // remove children if greater depth
            return SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
        }
        _addAriaAndCollapsedClass(triggerArray, isOpen) {
            if (!triggerArray.length) return;
            for (const element of triggerArray){
                element.classList.toggle(CLASS_NAME_COLLAPSED, !isOpen);
                element.setAttribute('aria-expanded', isOpen);
            }
        }
        // Static
        static jQueryInterface(config) {
            const _config = {};
            if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
            return this.each(function() {
                const data = Collapse.getOrCreateInstance(this, _config);
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
        constructor(element, config){
            super(element, config);
            this._isTransitioning = false;
            this._triggerArray = [];
            const toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$4);
            for (const elem of toggleList){
                const selector = SelectorEngine.getSelectorFromElement(elem);
                const filterElement = SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
                if (selector !== null && filterElement.length) this._triggerArray.push(elem);
            }
            this._initializeChildren();
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
            if (this._config.toggle) this.toggle();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$4, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
        for (const element of SelectorEngine.getMultipleElementsFromSelector(this))Collapse.getOrCreateInstance(element, {
            toggle: false
        }).toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Collapse);
    var top = 'top';
    var bottom = 'bottom';
    var right = 'right';
    var left = 'left';
    var auto = 'auto';
    var basePlacements = [
        top,
        bottom,
        right,
        left
    ];
    var start = 'start';
    var end = 'end';
    var clippingParents = 'clippingParents';
    var viewport = 'viewport';
    var popper = 'popper';
    var reference = 'reference';
    var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + start,
            placement + "-" + end
        ]);
    }, []);
    var placements = /*#__PURE__*/ [].concat(basePlacements, [
        auto
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + start,
            placement + "-" + end
        ]);
    }, []); // modifiers that need to read the DOM
    var beforeRead = 'beforeRead';
    var read = 'read';
    var afterRead = 'afterRead'; // pure-logic modifiers
    var beforeMain = 'beforeMain';
    var main = 'main';
    var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
    var beforeWrite = 'beforeWrite';
    var write = 'write';
    var afterWrite = 'afterWrite';
    var modifierPhases = [
        beforeRead,
        read,
        afterRead,
        beforeMain,
        main,
        afterMain,
        beforeWrite,
        write,
        afterWrite
    ];
    function getNodeName(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
    function getWindow(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
    function isElement(node) {
        var OwnElement = getWindow(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function isHTMLElement(node) {
        var OwnElement = getWindow(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function isShadowRoot(node) {
        // IE 11 has no ShadowRoot
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = getWindow(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
    // and applies them to the HTMLElements such as popper and arrow
    function applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name]; // arrow is optional + virtual elements
            if (!isHTMLElement(element) || !getNodeName(element)) return;
             // Flow doesn't support to extend this property, but it's the most
            // effective way to apply styles to an HTMLElement
            // $FlowFixMe[cannot-write]
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function effect$2(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {}); // arrow is optional + virtual elements
                if (!isHTMLElement(element) || !getNodeName(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    } // eslint-disable-next-line import/no-unused-modules
    const applyStyles$1 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: applyStyles,
        effect: effect$2,
        requires: [
            'computeStyles'
        ]
    };
    function getBasePlacement(placement) {
        return placement.split('-')[0];
    }
    var max = Math.max;
    var min = Math.min;
    var round = Math.round;
    function getUAString() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
    function isLayoutViewport() {
        return !/^((?!chrome|android).)*safari/i.test(getUAString());
    }
    function getBoundingClientRect(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && isHTMLElement(element)) {
            scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = isElement(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
    // means it doesn't take into account transforms.
    function getLayoutRect(element) {
        var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
        // Fixes https://github.com/popperjs/popper-core/issues/1223
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
    function contains(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
        if (parent.contains(child)) return true;
        else if (rootNode && isShadowRoot(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                 // $FlowFixMe[prop-missing]: need a better way to handle this...
                next = next.parentNode || next.host;
            }while (next);
        } // Give up, the result is false
        return false;
    }
    function getComputedStyle$1(element) {
        return getWindow(element).getComputedStyle(element);
    }
    function isTableElement(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf(getNodeName(element)) >= 0;
    }
    function getDocumentElement(element) {
        // $FlowFixMe[incompatible-return]: assume body is always available
        return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
    function getParentNode(element) {
        if (getNodeName(element) === 'html') return element;
        return(// $FlowFixMe[incompatible-return]
        // $FlowFixMe[prop-missing]
        element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
        element.parentNode || (isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
        // $FlowFixMe[incompatible-call]: HTMLElement is a Node
        getDocumentElement(element) // fallback
        );
    }
    function getTrueOffsetParent(element) {
        if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
        getComputedStyle$1(element).position === 'fixed') return null;
        return element.offsetParent;
    } // `.offsetParent` reports `null` for fixed elements, while absolute elements
    // return the containing block
    function getContainingBlock(element) {
        var isFirefox = /firefox/i.test(getUAString());
        var isIE = /Trident/i.test(getUAString());
        if (isIE && isHTMLElement(element)) {
            // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
            var elementCss = getComputedStyle$1(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = getParentNode(element);
        if (isShadowRoot(currentNode)) currentNode = currentNode.host;
        while(isHTMLElement(currentNode) && [
            'html',
            'body'
        ].indexOf(getNodeName(currentNode)) < 0){
            var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
            // create a containing block.
            // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    } // Gets the closest ancestor positioned element. Handles some edge cases,
    // such as table ancestors and cross browser bugs.
    function getOffsetParent(element) {
        var window1 = getWindow(element);
        var offsetParent = getTrueOffsetParent(element);
        while(offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
        if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) return window1;
        return offsetParent || getContainingBlock(element) || window1;
    }
    function getMainAxisFromPlacement(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
    function within(min$1, value, max$1) {
        return max(min$1, min(value, max$1));
    }
    function withinMaxClamp(min, value, max) {
        var v = within(min, value, max);
        return v > max ? max : v;
    }
    function getFreshSideObject() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
    function mergePaddingObject(paddingObject) {
        return Object.assign({}, getFreshSideObject(), paddingObject);
    }
    function expandToHashMap(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
    var toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    };
    function arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = getBasePlacement(state.placement);
        var axis = getMainAxisFromPlacement(basePlacement);
        var isVertical = [
            left,
            right
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = toPaddingObject(options.padding, state);
        var arrowRect = getLayoutRect(arrowElement);
        var minProp = axis === 'y' ? top : left;
        var maxProp = axis === 'y' ? bottom : right;
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = getOffsetParent(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
        // outside of the popper bounds
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = within(min, center, max); // Prevents breaking syntax highlighting...
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function effect$1(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
         // CSS selector
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!contains(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    } // eslint-disable-next-line import/no-unused-modules
    const arrow$1 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: arrow,
        effect: effect$1,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
    function getVariation(placement) {
        return placement.split('-')[1];
    }
    var unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    }; // Round the offsets to the nearest suitable subpixel based on the DPR.
    // Zooming can change the DPR, but it seems to report a value that will
    // cleanly divide the values into the appropriate subpixels.
    function roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: round(x * dpr) / dpr || 0,
            y: round(y * dpr) / dpr || 0
        };
    }
    function mapToStyles(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = left;
        var sideY = top;
        var win = window;
        if (adaptive) {
            var offsetParent = getOffsetParent(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === getWindow(popper)) {
                offsetParent = getDocumentElement(popper);
                if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
            offsetParent;
            if (placement === top || (placement === left || placement === right) && variation === end) {
                sideY = bottom;
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === left || (placement === top || placement === bottom) && variation === end) {
                sideX = right;
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && unsetSides);
        var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
            x: x,
            y: y
        }, getWindow(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: getBasePlacement(state.placement),
            variation: getVariation(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    } // eslint-disable-next-line import/no-unused-modules
    const computeStyles$1 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: computeStyles,
        data: {}
    };
    var passive = {
        passive: true
    };
    function effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window1 = getWindow(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, passive);
        });
        if (resize) window1.addEventListener('resize', instance.update, passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, passive);
            });
            if (resize) window1.removeEventListener('resize', instance.update, passive);
        };
    } // eslint-disable-next-line import/no-unused-modules
    const eventListeners = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: effect,
        data: {}
    };
    var hash$1 = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function getOppositePlacement(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return hash$1[matched];
        });
    }
    var hash = {
        start: 'end',
        end: 'start'
    };
    function getOppositeVariationPlacement(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return hash[matched];
        });
    }
    function getWindowScroll(node) {
        var win = getWindow(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
    function getWindowScrollBarX(element) {
        // If <html> has a CSS width greater than the viewport, then this will be
        // incorrect for RTL.
        // Popper 1 is broken in this case and never had a bug report so let's assume
        // it's not an issue. I don't think anyone ever specifies width on <html>
        // anyway.
        // Browsers where the left scrollbar doesn't cause an issue report `0` for
        // this (e.g. Edge 2019, IE11, Safari)
        return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
    }
    function getViewportRect(element, strategy) {
        var win = getWindow(element);
        var html = getDocumentElement(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = isLayoutViewport();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + getWindowScrollBarX(element),
            y: y
        };
    }
    // of the `<html>` and `<body>` rect bounds if horizontally scrollable
    function getDocumentRect(element) {
        var _element$ownerDocumen;
        var html = getDocumentElement(element);
        var winScroll = getWindowScroll(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
        var y = -winScroll.scrollTop;
        if (getComputedStyle$1(body || html).direction === 'rtl') x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function isScrollParent(element) {
        // Firefox wants us to check `-x` and `-y` variations as well
        var _getComputedStyle = getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
    function getScrollParent(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf(getNodeName(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
        return node.ownerDocument.body;
        if (isHTMLElement(node) && isScrollParent(node)) return node;
        return getScrollParent(getParentNode(node));
    }
    /*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the
  reference element's position.
  */ function listScrollParents(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = getScrollParent(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = getWindow(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
    }
    function rectToClientRect(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
    function getInnerBoundingClientRect(element, strategy) {
        var rect = getBoundingClientRect(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
    } // A "clipping parent" is an overflowable container with the characteristic of
    // clipping (or hiding) overflowing elements with a position different from
    // `initial`
    function getClippingParents(element) {
        var clippingParents = listScrollParents(getParentNode(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf(getComputedStyle$1(element).position) >= 0;
        var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
        if (!isElement(clipperElement)) return [];
         // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
        return clippingParents.filter(function(clippingParent) {
            return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
        });
    } // Gets the maximum area that the element is visible in due to any number of
    // clipping parents
    function getClippingRect(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = max(rect.top, accRect.top);
            accRect.right = min(rect.right, accRect.right);
            accRect.bottom = min(rect.bottom, accRect.bottom);
            accRect.left = max(rect.left, accRect.left);
            return accRect;
        }, getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
    function computeOffsets(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? getBasePlacement(placement) : null;
        var variation = placement ? getVariation(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
            }
        }
        return offsets;
    }
    function detectOverflow(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
        var altContext = elementContext === popper ? reference : popper;
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = getBoundingClientRect(state.elements.reference);
        var popperOffsets = computeOffsets({
            reference: referenceClientRect,
            element: popperRect,
            placement: placement
        });
        var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
        // 0 or negative = within the clipping rect
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
        if (elementContext === popper && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    right,
                    bottom
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    top,
                    bottom
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
    function computeAutoPlacement(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
        var variation = getVariation(placement);
        var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement) {
            return getVariation(placement) === variation;
        }) : basePlacements;
        var allowedPlacements = placements$1.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements$1;
         // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = detectOverflow(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[getBasePlacement(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
    function getExpandedFallbackPlacements(placement) {
        if (getBasePlacement(placement) === auto) return [];
        var oppositePlacement = getOppositePlacement(placement);
        return [
            getOppositeVariationPlacement(placement),
            oppositePlacement,
            getOppositeVariationPlacement(oppositePlacement)
        ];
    }
    function flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = getBasePlacement(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            getOppositePlacement(preferredPlacement)
        ] : getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = getBasePlacement(placement);
            var isStartVariation = getVariation(placement) === start;
            var isVertical = [
                top,
                bottom
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = detectOverflow(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
            if (referenceRect[len] > popperRect[len]) mainVariationSide = getOppositePlacement(mainVariationSide);
            var altVariationSide = getOppositePlacement(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            // `2` may be desired in some cases – research later
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    } // eslint-disable-next-line import/no-unused-modules
    const flip$1 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
    function getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function isAnySideFullyClipped(overflow) {
        return [
            top,
            right,
            bottom,
            left
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = detectOverflow(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = detectOverflow(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    } // eslint-disable-next-line import/no-unused-modules
    const hide$1 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: hide
    };
    function distanceAndSkiddingToXY(placement, rects, offset) {
        var basePlacement = getBasePlacement(placement);
        var invertDistance = [
            left,
            top
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            left,
            right
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = placements.reduce(function(acc, placement) {
            acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules
    const offset$1 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: offset
    };
    function popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        // Offsets are the actual position the popper needs to have to be
        // properly positioned near its reference element
        // This is the most basic placement, and will be adjusted by
        // the modifiers in the next step
        state.modifiersData[name] = computeOffsets({
            reference: state.rects.reference,
            element: state.rects.popper,
            placement: state.placement
        });
    } // eslint-disable-next-line import/no-unused-modules
    const popperOffsets$1 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: popperOffsets,
        data: {}
    };
    function getAltAxis(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = detectOverflow(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = getBasePlacement(state.placement);
        var variation = getVariation(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = getMainAxisFromPlacement(basePlacement);
        var altAxis = getAltAxis(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? top : left;
            var altSide = mainAxis === 'y' ? bottom : right;
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min$1 = offset + overflow[mainSide];
            var max$1 = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === start ? referenceRect[len] : popperRect[len];
            var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
            // outside the reference bounds
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
            // to include its full size in the calculation. If the reference is small
            // and near the edge of a boundary, the popper can overflow even if the
            // reference is not overflowing as well (e.g. virtual elements with no
            // width or height)
            var arrowLen = within(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? top : left;
            var _altSide = mainAxis === 'x' ? bottom : right;
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                top,
                left
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules
    const preventOverflow$1 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
    function getHTMLElementScroll(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
    function getNodeScroll(node) {
        if (node === getWindow(node) || !isHTMLElement(node)) return getWindowScroll(node);
        else return getHTMLElementScroll(node);
    }
    function isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = round(rect.width) / element.offsetWidth || 1;
        var scaleY = round(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    } // Returns the composite rect of an element relative to its offsetParent.
    // Composite means it takes into account transforms as well as layout.
    function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = isHTMLElement(offsetParent);
        var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
        var documentElement = getDocumentElement(offsetParent);
        var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
            isScrollParent(documentElement)) scroll = getNodeScroll(offsetParent);
            if (isHTMLElement(offsetParent)) {
                offsets = getBoundingClientRect(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
    function order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        }); // On visiting object, check for its dependencies and visit them recursively
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) // check for visited object
            sort(modifier);
        });
        return result;
    }
    function orderModifiers(modifiers) {
        // order based on dependencies
        var orderedModifiers = order(modifiers); // order based on phase
        return modifierPhases.reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
    function debounce(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
    function mergeByName(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {}); // IE11 does not support Object.values
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
    var DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function popperGenerator(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
                        popper: listScrollParents(popper)
                    }; // Orders the modifiers based on their dependencies and `phase`
                    // properties
                    var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                // Sync update – it will always be executed, even if not necessary. This
                // is useful for low frequency updates where sync behavior simplifies the
                // logic.
                // For high frequency updates (e.g. `resize` and `scroll` events), always
                // prefer the async Popper#update method
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                    // anymore
                    if (!areValidElements(reference, popper)) return;
                     // Store the reference and popper rects to be read by modifiers
                    state.rects = {
                        reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
                        popper: getLayoutRect(popper)
                    }; // Modifiers have the ability to reset the current update cycle. The
                    // most common use case for this is the `flip` modifier changing the
                    // placement, which then needs to re-run all the modifiers, because the
                    // logic was previously ran for the previous placement and is therefore
                    // stale/incorrect
                    state.reset = false;
                    state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                    // is filled with the initial data specified by the modifier. This means
                    // it doesn't persist and is fresh on each update.
                    // To ensure persistent data, use `${name}#persistent`
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                // Async and optimistically optimized update – it will not be executed if
                // not necessary (debounced to run at most once-per-tick)
                update: debounce(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            }); // Modifiers have the ability to execute arbitrary code before the first
            // update cycle runs. They will be executed in the same order as the update
            // cycle. This is useful when a modifier adds some persistent data that
            // other modifiers need to use, but the modifier is run after the dependent
            // one.
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var createPopper$2 = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules
    var defaultModifiers$1 = [
        eventListeners,
        popperOffsets$1,
        computeStyles$1,
        applyStyles$1
    ];
    var createPopper$1 = /*#__PURE__*/ popperGenerator({
        defaultModifiers: defaultModifiers$1
    }); // eslint-disable-next-line import/no-unused-modules
    var defaultModifiers = [
        eventListeners,
        popperOffsets$1,
        computeStyles$1,
        applyStyles$1,
        offset$1,
        flip$1,
        preventOverflow$1,
        arrow$1,
        hide$1
    ];
    var createPopper = /*#__PURE__*/ popperGenerator({
        defaultModifiers: defaultModifiers
    }); // eslint-disable-next-line import/no-unused-modules
    const Popper = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.defineProperty({
        __proto__: null,
        afterMain: afterMain,
        afterRead: afterRead,
        afterWrite: afterWrite,
        applyStyles: applyStyles$1,
        arrow: arrow$1,
        auto: auto,
        basePlacements: basePlacements,
        beforeMain: beforeMain,
        beforeRead: beforeRead,
        beforeWrite: beforeWrite,
        bottom: bottom,
        clippingParents: clippingParents,
        computeStyles: computeStyles$1,
        createPopper: createPopper,
        createPopperBase: createPopper$2,
        createPopperLite: createPopper$1,
        detectOverflow: detectOverflow,
        end: end,
        eventListeners: eventListeners,
        flip: flip$1,
        hide: hide$1,
        left: left,
        main: main,
        modifierPhases: modifierPhases,
        offset: offset$1,
        placements: placements,
        popper: popper,
        popperGenerator: popperGenerator,
        popperOffsets: popperOffsets$1,
        preventOverflow: preventOverflow$1,
        read: read,
        reference: reference,
        right: right,
        start: start,
        top: top,
        variationPlacements: variationPlacements,
        viewport: viewport,
        write: write
    }, Symbol.toStringTag, {
        value: 'Module'
    }));
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$a = 'dropdown';
    const DATA_KEY$6 = 'bs.dropdown';
    const EVENT_KEY$6 = `.${DATA_KEY$6}`;
    const DATA_API_KEY$3 = '.data-api';
    const ESCAPE_KEY$2 = 'Escape';
    const TAB_KEY$1 = 'Tab';
    const ARROW_UP_KEY$1 = 'ArrowUp';
    const ARROW_DOWN_KEY$1 = 'ArrowDown';
    const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
    const EVENT_HIDE$5 = `hide${EVENT_KEY$6}`;
    const EVENT_HIDDEN$5 = `hidden${EVENT_KEY$6}`;
    const EVENT_SHOW$5 = `show${EVENT_KEY$6}`;
    const EVENT_SHOWN$5 = `shown${EVENT_KEY$6}`;
    const EVENT_CLICK_DATA_API$3 = `click${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const EVENT_KEYDOWN_DATA_API = `keydown${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const EVENT_KEYUP_DATA_API = `keyup${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const CLASS_NAME_SHOW$6 = 'show';
    const CLASS_NAME_DROPUP = 'dropup';
    const CLASS_NAME_DROPEND = 'dropend';
    const CLASS_NAME_DROPSTART = 'dropstart';
    const CLASS_NAME_DROPUP_CENTER = 'dropup-center';
    const CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
    const SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
    const SELECTOR_DATA_TOGGLE_SHOWN = `${SELECTOR_DATA_TOGGLE$3}.${CLASS_NAME_SHOW$6}`;
    const SELECTOR_MENU = '.dropdown-menu';
    const SELECTOR_NAVBAR = '.navbar';
    const SELECTOR_NAVBAR_NAV = '.navbar-nav';
    const SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
    const PLACEMENT_TOP = isRTL() ? 'top-end' : 'top-start';
    const PLACEMENT_TOPEND = isRTL() ? 'top-start' : 'top-end';
    const PLACEMENT_BOTTOM = isRTL() ? 'bottom-end' : 'bottom-start';
    const PLACEMENT_BOTTOMEND = isRTL() ? 'bottom-start' : 'bottom-end';
    const PLACEMENT_RIGHT = isRTL() ? 'left-start' : 'right-start';
    const PLACEMENT_LEFT = isRTL() ? 'right-start' : 'left-start';
    const PLACEMENT_TOPCENTER = 'top';
    const PLACEMENT_BOTTOMCENTER = 'bottom';
    const Default$9 = {
        autoClose: true,
        boundary: 'clippingParents',
        display: 'dynamic',
        offset: [
            0,
            2
        ],
        popperConfig: null,
        reference: 'toggle'
    };
    const DefaultType$9 = {
        autoClose: '(boolean|string)',
        boundary: '(string|element)',
        display: 'string',
        offset: '(array|string|function)',
        popperConfig: '(null|object|function)',
        reference: '(string|element|object)'
    };
    /**
   * Class definition
   */ class Dropdown extends BaseComponent {
        // Getters
        static get Default() {
            return Default$9;
        }
        static get DefaultType() {
            return DefaultType$9;
        }
        static get NAME() {
            return NAME$a;
        }
        // Public
        toggle() {
            return this._isShown() ? this.hide() : this.show();
        }
        show() {
            if (isDisabled(this._element) || this._isShown()) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$5, relatedTarget);
            if (showEvent.defaultPrevented) return;
            this._createPopper();
            // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ('ontouchstart' in document.documentElement && !this._parent.closest(SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))EventHandler.on(element, 'mouseover', noop);
            this._element.focus();
            this._element.setAttribute('aria-expanded', true);
            this._menu.classList.add(CLASS_NAME_SHOW$6);
            this._element.classList.add(CLASS_NAME_SHOW$6);
            EventHandler.trigger(this._element, EVENT_SHOWN$5, relatedTarget);
        }
        hide() {
            if (isDisabled(this._element) || !this._isShown()) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            this._completeHide(relatedTarget);
        }
        dispose() {
            if (this._popper) this._popper.destroy();
            super.dispose();
        }
        update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper) this._popper.update();
        }
        // Private
        _completeHide(relatedTarget) {
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$5, relatedTarget);
            if (hideEvent.defaultPrevented) return;
            // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, 'mouseover', noop);
            if (this._popper) this._popper.destroy();
            this._menu.classList.remove(CLASS_NAME_SHOW$6);
            this._element.classList.remove(CLASS_NAME_SHOW$6);
            this._element.setAttribute('aria-expanded', 'false');
            Manipulator.removeDataAttribute(this._menu, 'popper');
            EventHandler.trigger(this._element, EVENT_HIDDEN$5, relatedTarget);
            // Explicitly return focus to the trigger element
            this._element.focus();
        }
        _getConfig(config) {
            config = super._getConfig(config);
            if (typeof config.reference === 'object' && !isElement$1(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
            throw new TypeError(`${NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
            return config;
        }
        _createPopper() {
            if (typeof Popper === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
            let referenceElement = this._element;
            if (this._config.reference === 'parent') referenceElement = this._parent;
            else if (isElement$1(this._config.reference)) referenceElement = getElement(this._config.reference);
            else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
            const popperConfig = this._getPopperConfig();
            this._popper = createPopper(referenceElement, this._menu, popperConfig);
        }
        _isShown() {
            return this._menu.classList.contains(CLASS_NAME_SHOW$6);
        }
        _getPlacement() {
            const parentDropdown = this._parent;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) return PLACEMENT_RIGHT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) return PLACEMENT_LEFT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP_CENTER)) return PLACEMENT_TOPCENTER;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPDOWN_CENTER)) return PLACEMENT_BOTTOMCENTER;
            // We need to trim the value because custom properties can also include spaces
            const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
        }
        _detectNavbar() {
            return this._element.closest(SELECTOR_NAVBAR) !== null;
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
            if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _getPopperConfig() {
            const defaultBsPopperConfig = {
                placement: this._getPlacement(),
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: this._getOffset()
                        }
                    }
                ]
            };
            // Disable Popper if we have a static display or Dropdown is in Navbar
            if (this._inNavbar || this._config.display === 'static') {
                Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
                defaultBsPopperConfig.modifiers = [
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ];
            }
            return {
                ...defaultBsPopperConfig,
                ...execute(this._config.popperConfig, [
                    undefined,
                    defaultBsPopperConfig
                ])
            };
        }
        _selectMenuItem({ key: key, target: target }) {
            const items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>isVisible(element));
            if (!items.length) return;
            // if target isn't included in items (e.g. when expanding the dropdown)
            // allow cycling to get the last item in case key equals ARROW_UP_KEY
            getNextActiveElement(items, target, key === ARROW_DOWN_KEY$1, !items.includes(target)).focus();
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Dropdown.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        static clearMenus(event) {
            if (event.button === RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== TAB_KEY$1) return;
            const openToggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE_SHOWN);
            for (const toggle of openToggles){
                const context = Dropdown.getInstance(toggle);
                if (!context || context._config.autoClose === false) continue;
                const composedPath = event.composedPath();
                const isMenuTarget = composedPath.includes(context._menu);
                if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
                // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                const relatedTarget = {
                    relatedTarget: context._element
                };
                if (event.type === 'click') relatedTarget.clickEvent = event;
                context._completeHide(relatedTarget);
            }
        }
        static dataApiKeydownHandler(event) {
            // If not an UP | DOWN | ESCAPE key => not a dropdown command
            // If input/textarea && if key is other than ESCAPE => not a dropdown command
            const isInput = /input|textarea/i.test(event.target.tagName);
            const isEscapeEvent = event.key === ESCAPE_KEY$2;
            const isUpOrDownEvent = [
                ARROW_UP_KEY$1,
                ARROW_DOWN_KEY$1
            ].includes(event.key);
            if (!isUpOrDownEvent && !isEscapeEvent) return;
            if (isInput && !isEscapeEvent) return;
            event.preventDefault();
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE$3) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.next(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.findOne(SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
            const instance = Dropdown.getOrCreateInstance(getToggleButton);
            if (isUpOrDownEvent) {
                event.stopPropagation();
                instance.show();
                instance._selectMenuItem(event);
                return;
            }
            if (instance._isShown()) {
                // else is escape and we check if it is shown
                event.stopPropagation();
                instance.hide();
                getToggleButton.focus();
            }
        }
        constructor(element, config){
            super(element, config);
            this._popper = null;
            this._parent = this._element.parentNode; // dropdown wrapper
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            this._menu = SelectorEngine.next(this._element, SELECTOR_MENU)[0] || SelectorEngine.prev(this._element, SELECTOR_MENU)[0] || SelectorEngine.findOne(SELECTOR_MENU, this._parent);
            this._inNavbar = this._detectNavbar();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$3, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function(event) {
        event.preventDefault();
        Dropdown.getOrCreateInstance(this).toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Dropdown);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/backdrop.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$9 = 'backdrop';
    const CLASS_NAME_FADE$4 = 'fade';
    const CLASS_NAME_SHOW$5 = 'show';
    const EVENT_MOUSEDOWN = `mousedown.bs.${NAME$9}`;
    const Default$8 = {
        className: 'modal-backdrop',
        clickCallback: null,
        isAnimated: false,
        isVisible: true,
        // if false, we use the backdrop helper without adding any element to the dom
        rootElement: 'body' // give the choice to place backdrop under different elements
    };
    const DefaultType$8 = {
        className: 'string',
        clickCallback: '(function|null)',
        isAnimated: 'boolean',
        isVisible: 'boolean',
        rootElement: '(element|string)'
    };
    /**
   * Class definition
   */ class Backdrop extends Config {
        // Getters
        static get Default() {
            return Default$8;
        }
        static get DefaultType() {
            return DefaultType$8;
        }
        static get NAME() {
            return NAME$9;
        }
        // Public
        show(callback) {
            if (!this._config.isVisible) {
                execute(callback);
                return;
            }
            this._append();
            const element = this._getElement();
            if (this._config.isAnimated) reflow(element);
            element.classList.add(CLASS_NAME_SHOW$5);
            this._emulateAnimation(()=>{
                execute(callback);
            });
        }
        hide(callback) {
            if (!this._config.isVisible) {
                execute(callback);
                return;
            }
            this._getElement().classList.remove(CLASS_NAME_SHOW$5);
            this._emulateAnimation(()=>{
                this.dispose();
                execute(callback);
            });
        }
        dispose() {
            if (!this._isAppended) return;
            EventHandler.off(this._element, EVENT_MOUSEDOWN);
            this._element.remove();
            this._isAppended = false;
        }
        // Private
        _getElement() {
            if (!this._element) {
                const backdrop = document.createElement('div');
                backdrop.className = this._config.className;
                if (this._config.isAnimated) backdrop.classList.add(CLASS_NAME_FADE$4);
                this._element = backdrop;
            }
            return this._element;
        }
        _configAfterMerge(config) {
            // use getElement() with the default "body" to get a fresh Element on each instantiation
            config.rootElement = getElement(config.rootElement);
            return config;
        }
        _append() {
            if (this._isAppended) return;
            const element = this._getElement();
            this._config.rootElement.append(element);
            EventHandler.on(element, EVENT_MOUSEDOWN, ()=>{
                execute(this._config.clickCallback);
            });
            this._isAppended = true;
        }
        _emulateAnimation(callback) {
            executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
        }
        constructor(config){
            super();
            this._config = this._getConfig(config);
            this._isAppended = false;
            this._element = null;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/focustrap.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$8 = 'focustrap';
    const DATA_KEY$5 = 'bs.focustrap';
    const EVENT_KEY$5 = `.${DATA_KEY$5}`;
    const EVENT_FOCUSIN$2 = `focusin${EVENT_KEY$5}`;
    const EVENT_KEYDOWN_TAB = `keydown.tab${EVENT_KEY$5}`;
    const TAB_KEY = 'Tab';
    const TAB_NAV_FORWARD = 'forward';
    const TAB_NAV_BACKWARD = 'backward';
    const Default$7 = {
        autofocus: true,
        trapElement: null // The element to trap focus inside of
    };
    const DefaultType$7 = {
        autofocus: 'boolean',
        trapElement: 'element'
    };
    /**
   * Class definition
   */ class FocusTrap extends Config {
        // Getters
        static get Default() {
            return Default$7;
        }
        static get DefaultType() {
            return DefaultType$7;
        }
        static get NAME() {
            return NAME$8;
        }
        // Public
        activate() {
            if (this._isActive) return;
            if (this._config.autofocus) this._config.trapElement.focus();
            EventHandler.off(document, EVENT_KEY$5); // guard against infinite focus loop
            EventHandler.on(document, EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
            EventHandler.on(document, EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
            this._isActive = true;
        }
        deactivate() {
            if (!this._isActive) return;
            this._isActive = false;
            EventHandler.off(document, EVENT_KEY$5);
        }
        // Private
        _handleFocusin(event) {
            const { trapElement: trapElement } = this._config;
            if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
            const elements = SelectorEngine.focusableChildren(trapElement);
            if (elements.length === 0) trapElement.focus();
            else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
            else elements[0].focus();
        }
        _handleKeydown(event) {
            if (event.key !== TAB_KEY) return;
            this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
        }
        constructor(config){
            super();
            this._config = this._getConfig(config);
            this._isActive = false;
            this._lastTabNavDirection = null;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/scrollBar.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
    const SELECTOR_STICKY_CONTENT = '.sticky-top';
    const PROPERTY_PADDING = 'padding-right';
    const PROPERTY_MARGIN = 'margin-right';
    /**
   * Class definition
   */ class ScrollBarHelper {
        // Public
        getWidth() {
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
            const documentWidth = document.documentElement.clientWidth;
            return Math.abs(window.innerWidth - documentWidth);
        }
        hide() {
            const width = this.getWidth();
            this._disableOverFlow();
            // give padding to element to balance the hidden scrollbar width
            this._setElementAttributes(this._element, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
            // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
            this._setElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
            this._setElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
        }
        reset() {
            this._resetElementAttributes(this._element, 'overflow');
            this._resetElementAttributes(this._element, PROPERTY_PADDING);
            this._resetElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING);
            this._resetElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN);
        }
        isOverflowing() {
            return this.getWidth() > 0;
        }
        // Private
        _disableOverFlow() {
            this._saveInitialAttribute(this._element, 'overflow');
            this._element.style.overflow = 'hidden';
        }
        _setElementAttributes(selector, styleProperty, callback) {
            const scrollbarWidth = this.getWidth();
            const manipulationCallBack = (element)=>{
                if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                this._saveInitialAttribute(element, styleProperty);
                const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
            };
            this._applyManipulationCallback(selector, manipulationCallBack);
        }
        _saveInitialAttribute(element, styleProperty) {
            const actualValue = element.style.getPropertyValue(styleProperty);
            if (actualValue) Manipulator.setDataAttribute(element, styleProperty, actualValue);
        }
        _resetElementAttributes(selector, styleProperty) {
            const manipulationCallBack = (element)=>{
                const value = Manipulator.getDataAttribute(element, styleProperty);
                // We only want to remove the property if the value is `null`; the value can also be zero
                if (value === null) {
                    element.style.removeProperty(styleProperty);
                    return;
                }
                Manipulator.removeDataAttribute(element, styleProperty);
                element.style.setProperty(styleProperty, value);
            };
            this._applyManipulationCallback(selector, manipulationCallBack);
        }
        _applyManipulationCallback(selector, callBack) {
            if (isElement$1(selector)) {
                callBack(selector);
                return;
            }
            for (const sel of SelectorEngine.find(selector, this._element))callBack(sel);
        }
        constructor(){
            this._element = document.body;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap modal.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$7 = 'modal';
    const DATA_KEY$4 = 'bs.modal';
    const EVENT_KEY$4 = `.${DATA_KEY$4}`;
    const DATA_API_KEY$2 = '.data-api';
    const ESCAPE_KEY$1 = 'Escape';
    const EVENT_HIDE$4 = `hide${EVENT_KEY$4}`;
    const EVENT_HIDE_PREVENTED$1 = `hidePrevented${EVENT_KEY$4}`;
    const EVENT_HIDDEN$4 = `hidden${EVENT_KEY$4}`;
    const EVENT_SHOW$4 = `show${EVENT_KEY$4}`;
    const EVENT_SHOWN$4 = `shown${EVENT_KEY$4}`;
    const EVENT_RESIZE$1 = `resize${EVENT_KEY$4}`;
    const EVENT_CLICK_DISMISS = `click.dismiss${EVENT_KEY$4}`;
    const EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${EVENT_KEY$4}`;
    const EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${EVENT_KEY$4}`;
    const EVENT_CLICK_DATA_API$2 = `click${EVENT_KEY$4}${DATA_API_KEY$2}`;
    const CLASS_NAME_OPEN = 'modal-open';
    const CLASS_NAME_FADE$3 = 'fade';
    const CLASS_NAME_SHOW$4 = 'show';
    const CLASS_NAME_STATIC = 'modal-static';
    const OPEN_SELECTOR$1 = '.modal.show';
    const SELECTOR_DIALOG = '.modal-dialog';
    const SELECTOR_MODAL_BODY = '.modal-body';
    const SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
    const Default$6 = {
        backdrop: true,
        focus: true,
        keyboard: true
    };
    const DefaultType$6 = {
        backdrop: '(boolean|string)',
        focus: 'boolean',
        keyboard: 'boolean'
    };
    /**
   * Class definition
   */ class Modal extends BaseComponent {
        // Getters
        static get Default() {
            return Default$6;
        }
        static get DefaultType() {
            return DefaultType$6;
        }
        static get NAME() {
            return NAME$7;
        }
        // Public
        toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        }
        show(relatedTarget) {
            if (this._isShown || this._isTransitioning) return;
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4, {
                relatedTarget: relatedTarget
            });
            if (showEvent.defaultPrevented) return;
            this._isShown = true;
            this._isTransitioning = true;
            this._scrollBar.hide();
            document.body.classList.add(CLASS_NAME_OPEN);
            this._adjustDialog();
            this._backdrop.show(()=>this._showElement(relatedTarget));
        }
        hide() {
            if (!this._isShown || this._isTransitioning) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4);
            if (hideEvent.defaultPrevented) return;
            this._isShown = false;
            this._isTransitioning = true;
            this._focustrap.deactivate();
            this._element.classList.remove(CLASS_NAME_SHOW$4);
            this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
        }
        dispose() {
            EventHandler.off(window, EVENT_KEY$4);
            EventHandler.off(this._dialog, EVENT_KEY$4);
            this._backdrop.dispose();
            this._focustrap.deactivate();
            super.dispose();
        }
        handleUpdate() {
            this._adjustDialog();
        }
        // Private
        _initializeBackDrop() {
            return new Backdrop({
                isVisible: Boolean(this._config.backdrop),
                // 'static' option will be translated to true, and booleans will keep their value,
                isAnimated: this._isAnimated()
            });
        }
        _initializeFocusTrap() {
            return new FocusTrap({
                trapElement: this._element
            });
        }
        _showElement(relatedTarget) {
            // try to append dynamic modal
            if (!document.body.contains(this._element)) document.body.append(this._element);
            this._element.style.display = 'block';
            this._element.removeAttribute('aria-hidden');
            this._element.setAttribute('aria-modal', true);
            this._element.setAttribute('role', 'dialog');
            this._element.scrollTop = 0;
            const modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);
            if (modalBody) modalBody.scrollTop = 0;
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOW$4);
            const transitionComplete = ()=>{
                if (this._config.focus) this._focustrap.activate();
                this._isTransitioning = false;
                EventHandler.trigger(this._element, EVENT_SHOWN$4, {
                    relatedTarget: relatedTarget
                });
            };
            this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
        }
        _addEventListeners() {
            EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS$1, (event)=>{
                if (event.key !== ESCAPE_KEY$1) return;
                if (this._config.keyboard) {
                    this.hide();
                    return;
                }
                this._triggerBackdropTransition();
            });
            EventHandler.on(window, EVENT_RESIZE$1, ()=>{
                if (this._isShown && !this._isTransitioning) this._adjustDialog();
            });
            EventHandler.on(this._element, EVENT_MOUSEDOWN_DISMISS, (event)=>{
                // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                EventHandler.one(this._element, EVENT_CLICK_DISMISS, (event2)=>{
                    if (this._element !== event.target || this._element !== event2.target) return;
                    if (this._config.backdrop === 'static') {
                        this._triggerBackdropTransition();
                        return;
                    }
                    if (this._config.backdrop) this.hide();
                });
            });
        }
        _hideModal() {
            this._element.style.display = 'none';
            this._element.setAttribute('aria-hidden', true);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            this._isTransitioning = false;
            this._backdrop.hide(()=>{
                document.body.classList.remove(CLASS_NAME_OPEN);
                this._resetAdjustments();
                this._scrollBar.reset();
                EventHandler.trigger(this._element, EVENT_HIDDEN$4);
            });
        }
        _isAnimated() {
            return this._element.classList.contains(CLASS_NAME_FADE$3);
        }
        _triggerBackdropTransition() {
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED$1);
            if (hideEvent.defaultPrevented) return;
            const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            const initialOverflowY = this._element.style.overflowY;
            // return if the following background transition hasn't yet completed
            if (initialOverflowY === 'hidden' || this._element.classList.contains(CLASS_NAME_STATIC)) return;
            if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
            this._element.classList.add(CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.classList.remove(CLASS_NAME_STATIC);
                this._queueCallback(()=>{
                    this._element.style.overflowY = initialOverflowY;
                }, this._dialog);
            }, this._dialog);
            this._element.focus();
        }
        /**
     * The following methods are used to handle overflowing modals
     */ _adjustDialog() {
            const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            const scrollbarWidth = this._scrollBar.getWidth();
            const isBodyOverflowing = scrollbarWidth > 0;
            if (isBodyOverflowing && !isModalOverflowing) {
                const property = isRTL() ? 'paddingLeft' : 'paddingRight';
                this._element.style[property] = `${scrollbarWidth}px`;
            }
            if (!isBodyOverflowing && isModalOverflowing) {
                const property = isRTL() ? 'paddingRight' : 'paddingLeft';
                this._element.style[property] = `${scrollbarWidth}px`;
            }
        }
        _resetAdjustments() {
            this._element.style.paddingLeft = '';
            this._element.style.paddingRight = '';
        }
        // Static
        static jQueryInterface(config, relatedTarget) {
            return this.each(function() {
                const data = Modal.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](relatedTarget);
            });
        }
        constructor(element, config){
            super(element, config);
            this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, this._element);
            this._backdrop = this._initializeBackDrop();
            this._focustrap = this._initializeFocusTrap();
            this._isShown = false;
            this._isTransitioning = false;
            this._scrollBar = new ScrollBarHelper();
            this._addEventListeners();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        EventHandler.one(target, EVENT_SHOW$4, (showEvent)=>{
            if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
            return;
            EventHandler.one(target, EVENT_HIDDEN$4, ()=>{
                if (isVisible(this)) this.focus();
            });
        });
        // avoid conflict when clicking modal toggler while another one is open
        const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR$1);
        if (alreadyOpen) Modal.getInstance(alreadyOpen).hide();
        const data = Modal.getOrCreateInstance(target);
        data.toggle(this);
    });
    enableDismissTrigger(Modal);
    /**
   * jQuery
   */ defineJQueryPlugin(Modal);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap offcanvas.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$6 = 'offcanvas';
    const DATA_KEY$3 = 'bs.offcanvas';
    const EVENT_KEY$3 = `.${DATA_KEY$3}`;
    const DATA_API_KEY$1 = '.data-api';
    const EVENT_LOAD_DATA_API$2 = `load${EVENT_KEY$3}${DATA_API_KEY$1}`;
    const ESCAPE_KEY = 'Escape';
    const CLASS_NAME_SHOW$3 = 'show';
    const CLASS_NAME_SHOWING$1 = 'showing';
    const CLASS_NAME_HIDING = 'hiding';
    const CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
    const OPEN_SELECTOR = '.offcanvas.show';
    const EVENT_SHOW$3 = `show${EVENT_KEY$3}`;
    const EVENT_SHOWN$3 = `shown${EVENT_KEY$3}`;
    const EVENT_HIDE$3 = `hide${EVENT_KEY$3}`;
    const EVENT_HIDE_PREVENTED = `hidePrevented${EVENT_KEY$3}`;
    const EVENT_HIDDEN$3 = `hidden${EVENT_KEY$3}`;
    const EVENT_RESIZE = `resize${EVENT_KEY$3}`;
    const EVENT_CLICK_DATA_API$1 = `click${EVENT_KEY$3}${DATA_API_KEY$1}`;
    const EVENT_KEYDOWN_DISMISS = `keydown.dismiss${EVENT_KEY$3}`;
    const SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
    const Default$5 = {
        backdrop: true,
        keyboard: true,
        scroll: false
    };
    const DefaultType$5 = {
        backdrop: '(boolean|string)',
        keyboard: 'boolean',
        scroll: 'boolean'
    };
    /**
   * Class definition
   */ class Offcanvas extends BaseComponent {
        // Getters
        static get Default() {
            return Default$5;
        }
        static get DefaultType() {
            return DefaultType$5;
        }
        static get NAME() {
            return NAME$6;
        }
        // Public
        toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        }
        show(relatedTarget) {
            if (this._isShown) return;
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
                relatedTarget: relatedTarget
            });
            if (showEvent.defaultPrevented) return;
            this._isShown = true;
            this._backdrop.show();
            if (!this._config.scroll) new ScrollBarHelper().hide();
            this._element.setAttribute('aria-modal', true);
            this._element.setAttribute('role', 'dialog');
            this._element.classList.add(CLASS_NAME_SHOWING$1);
            const completeCallBack = ()=>{
                if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
                this._element.classList.add(CLASS_NAME_SHOW$3);
                this._element.classList.remove(CLASS_NAME_SHOWING$1);
                EventHandler.trigger(this._element, EVENT_SHOWN$3, {
                    relatedTarget: relatedTarget
                });
            };
            this._queueCallback(completeCallBack, this._element, true);
        }
        hide() {
            if (!this._isShown) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$3);
            if (hideEvent.defaultPrevented) return;
            this._focustrap.deactivate();
            this._element.blur();
            this._isShown = false;
            this._element.classList.add(CLASS_NAME_HIDING);
            this._backdrop.hide();
            const completeCallback = ()=>{
                this._element.classList.remove(CLASS_NAME_SHOW$3, CLASS_NAME_HIDING);
                this._element.removeAttribute('aria-modal');
                this._element.removeAttribute('role');
                if (!this._config.scroll) new ScrollBarHelper().reset();
                EventHandler.trigger(this._element, EVENT_HIDDEN$3);
            };
            this._queueCallback(completeCallback, this._element, true);
        }
        dispose() {
            this._backdrop.dispose();
            this._focustrap.deactivate();
            super.dispose();
        }
        // Private
        _initializeBackDrop() {
            const clickCallback = ()=>{
                if (this._config.backdrop === 'static') {
                    EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
                    return;
                }
                this.hide();
            };
            // 'static' option will be translated to true, and booleans will keep their value
            const isVisible = Boolean(this._config.backdrop);
            return new Backdrop({
                className: CLASS_NAME_BACKDROP,
                isVisible: isVisible,
                isAnimated: true,
                rootElement: this._element.parentNode,
                clickCallback: isVisible ? clickCallback : null
            });
        }
        _initializeFocusTrap() {
            return new FocusTrap({
                trapElement: this._element
            });
        }
        _addEventListeners() {
            EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, (event)=>{
                if (event.key !== ESCAPE_KEY) return;
                if (this._config.keyboard) {
                    this.hide();
                    return;
                }
                EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
            });
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Offcanvas.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            });
        }
        constructor(element, config){
            super(element, config);
            this._isShown = false;
            this._backdrop = this._initializeBackDrop();
            this._focustrap = this._initializeFocusTrap();
            this._addEventListeners();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        EventHandler.one(target, EVENT_HIDDEN$3, ()=>{
            // focus on trigger when it is closed
            if (isVisible(this)) this.focus();
        });
        // avoid conflict when clicking a toggler of an offcanvas, while another is open
        const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);
        if (alreadyOpen && alreadyOpen !== target) Offcanvas.getInstance(alreadyOpen).hide();
        const data = Offcanvas.getOrCreateInstance(target);
        data.toggle(this);
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$2, ()=>{
        for (const selector of SelectorEngine.find(OPEN_SELECTOR))Offcanvas.getOrCreateInstance(selector).show();
    });
    EventHandler.on(window, EVENT_RESIZE, ()=>{
        for (const element of SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') Offcanvas.getOrCreateInstance(element).hide();
    });
    enableDismissTrigger(Offcanvas);
    /**
   * jQuery
   */ defineJQueryPlugin(Offcanvas);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ // js-docs-start allow-list
    const ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    const DefaultAllowlist = {
        // Global attributes allowed on any supplied element below.
        '*': [
            'class',
            'dir',
            'id',
            'lang',
            'role',
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            'target',
            'href',
            'title',
            'rel'
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        dd: [],
        div: [],
        dl: [],
        dt: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            'src',
            'srcset',
            'alt',
            'title',
            'width',
            'height'
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    // js-docs-end allow-list
    const uriAttributes = new Set([
        'background',
        'cite',
        'href',
        'itemtype',
        'longdesc',
        'poster',
        'src',
        'xlink:href'
    ]);
    /**
   * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
   * contexts.
   *
   * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
   */ const SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
    const allowedAttribute = (attribute, allowedAttributeList)=>{
        const attributeName = attribute.nodeName.toLowerCase();
        if (allowedAttributeList.includes(attributeName)) {
            if (uriAttributes.has(attributeName)) return Boolean(SAFE_URL_PATTERN.test(attribute.nodeValue));
            return true;
        }
        // Check if a regular expression validates the attribute.
        return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
    };
    function sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
        if (!unsafeHtml.length) return unsafeHtml;
        if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
        const domParser = new window.DOMParser();
        const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
        const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
        for (const element of elements){
            const elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            const attributeList = [].concat(...element.attributes);
            const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
            for (const attribute of attributeList)if (!allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
        }
        return createdDocument.body.innerHTML;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/template-factory.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$5 = 'TemplateFactory';
    const Default$4 = {
        allowList: DefaultAllowlist,
        content: {},
        // { selector : text ,  selector2 : text2 , }
        extraClass: '',
        html: false,
        sanitize: true,
        sanitizeFn: null,
        template: '<div></div>'
    };
    const DefaultType$4 = {
        allowList: 'object',
        content: 'object',
        extraClass: '(string|function)',
        html: 'boolean',
        sanitize: 'boolean',
        sanitizeFn: '(null|function)',
        template: 'string'
    };
    const DefaultContentType = {
        entry: '(string|element|function|null)',
        selector: '(string|element)'
    };
    /**
   * Class definition
   */ class TemplateFactory extends Config {
        // Getters
        static get Default() {
            return Default$4;
        }
        static get DefaultType() {
            return DefaultType$4;
        }
        static get NAME() {
            return NAME$5;
        }
        // Public
        getContent() {
            return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
        }
        hasContent() {
            return this.getContent().length > 0;
        }
        changeContent(content) {
            this._checkContent(content);
            this._config.content = {
                ...this._config.content,
                ...content
            };
            return this;
        }
        toHtml() {
            const templateWrapper = document.createElement('div');
            templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
            for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
            const template = templateWrapper.children[0];
            const extraClass = this._resolvePossibleFunction(this._config.extraClass);
            if (extraClass) template.classList.add(...extraClass.split(' '));
            return template;
        }
        // Private
        _typeCheckConfig(config) {
            super._typeCheckConfig(config);
            this._checkContent(config.content);
        }
        _checkContent(arg) {
            for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
                selector: selector,
                entry: content
            }, DefaultContentType);
        }
        _setContent(template, content, selector) {
            const templateElement = SelectorEngine.findOne(selector, template);
            if (!templateElement) return;
            content = this._resolvePossibleFunction(content);
            if (!content) {
                templateElement.remove();
                return;
            }
            if (isElement$1(content)) {
                this._putElementInTemplate(getElement(content), templateElement);
                return;
            }
            if (this._config.html) {
                templateElement.innerHTML = this._maybeSanitize(content);
                return;
            }
            templateElement.textContent = content;
        }
        _maybeSanitize(arg) {
            return this._config.sanitize ? sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
        }
        _resolvePossibleFunction(arg) {
            return execute(arg, [
                undefined,
                this
            ]);
        }
        _putElementInTemplate(element, templateElement) {
            if (this._config.html) {
                templateElement.innerHTML = '';
                templateElement.append(element);
                return;
            }
            templateElement.textContent = element.textContent;
        }
        constructor(config){
            super();
            this._config = this._getConfig(config);
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tooltip.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$4 = 'tooltip';
    const DISALLOWED_ATTRIBUTES = new Set([
        'sanitize',
        'allowList',
        'sanitizeFn'
    ]);
    const CLASS_NAME_FADE$2 = 'fade';
    const CLASS_NAME_MODAL = 'modal';
    const CLASS_NAME_SHOW$2 = 'show';
    const SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
    const SELECTOR_MODAL = `.${CLASS_NAME_MODAL}`;
    const EVENT_MODAL_HIDE = 'hide.bs.modal';
    const TRIGGER_HOVER = 'hover';
    const TRIGGER_FOCUS = 'focus';
    const TRIGGER_CLICK = 'click';
    const TRIGGER_MANUAL = 'manual';
    const EVENT_HIDE$2 = 'hide';
    const EVENT_HIDDEN$2 = 'hidden';
    const EVENT_SHOW$2 = 'show';
    const EVENT_SHOWN$2 = 'shown';
    const EVENT_INSERTED = 'inserted';
    const EVENT_CLICK$1 = 'click';
    const EVENT_FOCUSIN$1 = 'focusin';
    const EVENT_FOCUSOUT$1 = 'focusout';
    const EVENT_MOUSEENTER = 'mouseenter';
    const EVENT_MOUSELEAVE = 'mouseleave';
    const AttachmentMap = {
        AUTO: 'auto',
        TOP: 'top',
        RIGHT: isRTL() ? 'left' : 'right',
        BOTTOM: 'bottom',
        LEFT: isRTL() ? 'right' : 'left'
    };
    const Default$3 = {
        allowList: DefaultAllowlist,
        animation: true,
        boundary: 'clippingParents',
        container: false,
        customClass: '',
        delay: 0,
        fallbackPlacements: [
            'top',
            'right',
            'bottom',
            'left'
        ],
        html: false,
        offset: [
            0,
            6
        ],
        placement: 'top',
        popperConfig: null,
        sanitize: true,
        sanitizeFn: null,
        selector: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        title: '',
        trigger: 'hover focus'
    };
    const DefaultType$3 = {
        allowList: 'object',
        animation: 'boolean',
        boundary: '(string|element)',
        container: '(string|element|boolean)',
        customClass: '(string|function)',
        delay: '(number|object)',
        fallbackPlacements: 'array',
        html: 'boolean',
        offset: '(array|string|function)',
        placement: '(string|function)',
        popperConfig: '(null|object|function)',
        sanitize: 'boolean',
        sanitizeFn: '(null|function)',
        selector: '(string|boolean)',
        template: 'string',
        title: '(string|element|function)',
        trigger: 'string'
    };
    /**
   * Class definition
   */ class Tooltip extends BaseComponent {
        // Getters
        static get Default() {
            return Default$3;
        }
        static get DefaultType() {
            return DefaultType$3;
        }
        static get NAME() {
            return NAME$4;
        }
        // Public
        enable() {
            this._isEnabled = true;
        }
        disable() {
            this._isEnabled = false;
        }
        toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        }
        toggle() {
            if (!this._isEnabled) return;
            if (this._isShown()) {
                this._leave();
                return;
            }
            this._enter();
        }
        dispose() {
            clearTimeout(this._timeout);
            EventHandler.off(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
            if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
            this._disposePopper();
            super.dispose();
        }
        show() {
            if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
            if (!(this._isWithContent() && this._isEnabled)) return;
            const showEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOW$2));
            const shadowRoot = findShadowRoot(this._element);
            const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
            if (showEvent.defaultPrevented || !isInTheDom) return;
            // TODO: v6 remove this or make it optional
            this._disposePopper();
            const tip = this._getTipElement();
            this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
            const { container: container } = this._config;
            if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                container.append(tip);
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_INSERTED));
            }
            this._popper = this._createPopper(tip);
            tip.classList.add(CLASS_NAME_SHOW$2);
            // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.on(element, 'mouseover', noop);
            const complete = ()=>{
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOWN$2));
                if (this._isHovered === false) this._leave();
                this._isHovered = false;
            };
            this._queueCallback(complete, this.tip, this._isAnimated());
        }
        hide() {
            if (!this._isShown()) return;
            const hideEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDE$2));
            if (hideEvent.defaultPrevented) return;
            const tip = this._getTipElement();
            tip.classList.remove(CLASS_NAME_SHOW$2);
            // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, 'mouseover', noop);
            this._activeTrigger[TRIGGER_CLICK] = false;
            this._activeTrigger[TRIGGER_FOCUS] = false;
            this._activeTrigger[TRIGGER_HOVER] = false;
            this._isHovered = null; // it is a trick to support manual triggering
            const complete = ()=>{
                if (this._isWithActiveTrigger()) return;
                if (!this._isHovered) this._disposePopper();
                this._element.removeAttribute('aria-describedby');
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDDEN$2));
            };
            this._queueCallback(complete, this.tip, this._isAnimated());
        }
        update() {
            if (this._popper) this._popper.update();
        }
        // Protected
        _isWithContent() {
            return Boolean(this._getTitle());
        }
        _getTipElement() {
            if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
            return this.tip;
        }
        _createTipElement(content) {
            const tip = this._getTemplateFactory(content).toHtml();
            // TODO: remove this check in v6
            if (!tip) return null;
            tip.classList.remove(CLASS_NAME_FADE$2, CLASS_NAME_SHOW$2);
            // TODO: v6 the following can be achieved with CSS only
            tip.classList.add(`bs-${this.constructor.NAME}-auto`);
            const tipId = getUID(this.constructor.NAME).toString();
            tip.setAttribute('id', tipId);
            if (this._isAnimated()) tip.classList.add(CLASS_NAME_FADE$2);
            return tip;
        }
        setContent(content) {
            this._newContent = content;
            if (this._isShown()) {
                this._disposePopper();
                this.show();
            }
        }
        _getTemplateFactory(content) {
            if (this._templateFactory) this._templateFactory.changeContent(content);
            else this._templateFactory = new TemplateFactory({
                ...this._config,
                content: // the `content` var has to be after `this._config`
                // to override config.content in case of popover
                content,
                extraClass: this._resolvePossibleFunction(this._config.customClass)
            });
            return this._templateFactory;
        }
        _getContentForTemplate() {
            return {
                [SELECTOR_TOOLTIP_INNER]: this._getTitle()
            };
        }
        _getTitle() {
            return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
        }
        // Private
        _initializeOnDelegatedTarget(event) {
            return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
        }
        _isAnimated() {
            return this._config.animation || this.tip && this.tip.classList.contains(CLASS_NAME_FADE$2);
        }
        _isShown() {
            return this.tip && this.tip.classList.contains(CLASS_NAME_SHOW$2);
        }
        _createPopper(tip) {
            const placement = execute(this._config.placement, [
                this,
                tip,
                this._element
            ]);
            const attachment = AttachmentMap[placement.toUpperCase()];
            return createPopper(this._element, tip, this._getPopperConfig(attachment));
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
            if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _resolvePossibleFunction(arg) {
            return execute(arg, [
                this._element,
                this._element
            ]);
        }
        _getPopperConfig(attachment) {
            const defaultBsPopperConfig = {
                placement: attachment,
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: this._config.fallbackPlacements
                        }
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: this._getOffset()
                        }
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: 'arrow',
                        options: {
                            element: `.${this.constructor.NAME}-arrow`
                        }
                    },
                    {
                        name: 'preSetPlacement',
                        enabled: true,
                        phase: 'beforeMain',
                        fn: (data)=>{
                            // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                            // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                            this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                        }
                    }
                ]
            };
            return {
                ...defaultBsPopperConfig,
                ...execute(this._config.popperConfig, [
                    undefined,
                    defaultBsPopperConfig
                ])
            };
        }
        _setListeners() {
            const triggers = this._config.trigger.split(' ');
            for (const trigger of triggers){
                if (trigger === 'click') EventHandler.on(this._element, this.constructor.eventName(EVENT_CLICK$1), this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[TRIGGER_CLICK]);
                    context.toggle();
                });
                else if (trigger !== TRIGGER_MANUAL) {
                    const eventIn = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSEENTER) : this.constructor.eventName(EVENT_FOCUSIN$1);
                    const eventOut = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSELEAVE) : this.constructor.eventName(EVENT_FOCUSOUT$1);
                    EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                        const context = this._initializeOnDelegatedTarget(event);
                        context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
                        context._enter();
                    });
                    EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                        const context = this._initializeOnDelegatedTarget(event);
                        context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                        context._leave();
                    });
                }
            }
            this._hideModalHandler = ()=>{
                if (this._element) this.hide();
            };
            EventHandler.on(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
        }
        _fixTitle() {
            const title = this._element.getAttribute('title');
            if (!title) return;
            if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
            this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
            this._element.removeAttribute('title');
        }
        _enter() {
            if (this._isShown() || this._isHovered) {
                this._isHovered = true;
                return;
            }
            this._isHovered = true;
            this._setTimeout(()=>{
                if (this._isHovered) this.show();
            }, this._config.delay.show);
        }
        _leave() {
            if (this._isWithActiveTrigger()) return;
            this._isHovered = false;
            this._setTimeout(()=>{
                if (!this._isHovered) this.hide();
            }, this._config.delay.hide);
        }
        _setTimeout(handler, timeout) {
            clearTimeout(this._timeout);
            this._timeout = setTimeout(handler, timeout);
        }
        _isWithActiveTrigger() {
            return Object.values(this._activeTrigger).includes(true);
        }
        _getConfig(config) {
            const dataAttributes = Manipulator.getDataAttributes(this._element);
            for (const dataAttribute of Object.keys(dataAttributes))if (DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
            config = {
                ...dataAttributes,
                ...typeof config === 'object' && config ? config : {}
            };
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            config.container = config.container === false ? document.body : getElement(config.container);
            if (typeof config.delay === 'number') config.delay = {
                show: config.delay,
                hide: config.delay
            };
            if (typeof config.title === 'number') config.title = config.title.toString();
            if (typeof config.content === 'number') config.content = config.content.toString();
            return config;
        }
        _getDelegateConfig() {
            const config = {};
            for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
            config.selector = false;
            config.trigger = 'manual';
            // In the future can be replaced with:
            // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
            // `Object.fromEntries(keysWithDifferentValues)`
            return config;
        }
        _disposePopper() {
            if (this._popper) {
                this._popper.destroy();
                this._popper = null;
            }
            if (this.tip) {
                this.tip.remove();
                this.tip = null;
            }
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Tooltip.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        constructor(element, config){
            if (typeof Popper === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
            super(element, config);
            // Private
            this._isEnabled = true;
            this._timeout = 0;
            this._isHovered = null;
            this._activeTrigger = {};
            this._popper = null;
            this._templateFactory = null;
            this._newContent = null;
            // Protected
            this.tip = null;
            this._setListeners();
            if (!this._config.selector) this._fixTitle();
        }
    }
    /**
   * jQuery
   */ defineJQueryPlugin(Tooltip);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap popover.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$3 = 'popover';
    const SELECTOR_TITLE = '.popover-header';
    const SELECTOR_CONTENT = '.popover-body';
    const Default$2 = {
        ...Tooltip.Default,
        content: '',
        offset: [
            0,
            8
        ],
        placement: 'right',
        template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        trigger: 'click'
    };
    const DefaultType$2 = {
        ...Tooltip.DefaultType,
        content: '(null|string|element|function)'
    };
    /**
   * Class definition
   */ class Popover extends Tooltip {
        // Getters
        static get Default() {
            return Default$2;
        }
        static get DefaultType() {
            return DefaultType$2;
        }
        static get NAME() {
            return NAME$3;
        }
        // Overrides
        _isWithContent() {
            return this._getTitle() || this._getContent();
        }
        // Private
        _getContentForTemplate() {
            return {
                [SELECTOR_TITLE]: this._getTitle(),
                [SELECTOR_CONTENT]: this._getContent()
            };
        }
        _getContent() {
            return this._resolvePossibleFunction(this._config.content);
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Popover.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
    }
    /**
   * jQuery
   */ defineJQueryPlugin(Popover);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap scrollspy.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$2 = 'scrollspy';
    const DATA_KEY$2 = 'bs.scrollspy';
    const EVENT_KEY$2 = `.${DATA_KEY$2}`;
    const DATA_API_KEY = '.data-api';
    const EVENT_ACTIVATE = `activate${EVENT_KEY$2}`;
    const EVENT_CLICK = `click${EVENT_KEY$2}`;
    const EVENT_LOAD_DATA_API$1 = `load${EVENT_KEY$2}${DATA_API_KEY}`;
    const CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
    const CLASS_NAME_ACTIVE$1 = 'active';
    const SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
    const SELECTOR_TARGET_LINKS = '[href]';
    const SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
    const SELECTOR_NAV_LINKS = '.nav-link';
    const SELECTOR_NAV_ITEMS = '.nav-item';
    const SELECTOR_LIST_ITEMS = '.list-group-item';
    const SELECTOR_LINK_ITEMS = `${SELECTOR_NAV_LINKS}, ${SELECTOR_NAV_ITEMS} > ${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}`;
    const SELECTOR_DROPDOWN = '.dropdown';
    const SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
    const Default$1 = {
        offset: null,
        // TODO: v6 @deprecated, keep it for backwards compatibility reasons
        rootMargin: '0px 0px -25%',
        smoothScroll: false,
        target: null,
        threshold: [
            0.1,
            0.5,
            1
        ]
    };
    const DefaultType$1 = {
        offset: '(number|null)',
        // TODO v6 @deprecated, keep it for backwards compatibility reasons
        rootMargin: 'string',
        smoothScroll: 'boolean',
        target: 'element',
        threshold: 'array'
    };
    /**
   * Class definition
   */ class ScrollSpy extends BaseComponent {
        // Getters
        static get Default() {
            return Default$1;
        }
        static get DefaultType() {
            return DefaultType$1;
        }
        static get NAME() {
            return NAME$2;
        }
        // Public
        refresh() {
            this._initializeTargetsAndObservables();
            this._maybeEnableSmoothScroll();
            if (this._observer) this._observer.disconnect();
            else this._observer = this._getNewObserver();
            for (const section of this._observableSections.values())this._observer.observe(section);
        }
        dispose() {
            this._observer.disconnect();
            super.dispose();
        }
        // Private
        _configAfterMerge(config) {
            // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
            config.target = getElement(config.target) || document.body;
            // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
            config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
            if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
            return config;
        }
        _maybeEnableSmoothScroll() {
            if (!this._config.smoothScroll) return;
            // unregister any previous listeners
            EventHandler.off(this._config.target, EVENT_CLICK);
            EventHandler.on(this._config.target, EVENT_CLICK, SELECTOR_TARGET_LINKS, (event)=>{
                const observableSection = this._observableSections.get(event.target.hash);
                if (observableSection) {
                    event.preventDefault();
                    const root = this._rootElement || window;
                    const height = observableSection.offsetTop - this._element.offsetTop;
                    if (root.scrollTo) {
                        root.scrollTo({
                            top: height,
                            behavior: 'smooth'
                        });
                        return;
                    }
                    // Chrome 60 doesn't support `scrollTo`
                    root.scrollTop = height;
                }
            });
        }
        _getNewObserver() {
            const options = {
                root: this._rootElement,
                threshold: this._config.threshold,
                rootMargin: this._config.rootMargin
            };
            return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
        }
        // The logic of selection
        _observerCallback(entries) {
            const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
            const activate = (entry)=>{
                this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                this._process(targetElement(entry));
            };
            const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
            const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
            this._previousScrollData.parentScrollTop = parentScrollTop;
            for (const entry of entries){
                if (!entry.isIntersecting) {
                    this._activeTarget = null;
                    this._clearActiveClass(targetElement(entry));
                    continue;
                }
                const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                // if we are scrolling down, pick the bigger offsetTop
                if (userScrollsDown && entryIsLowerThanPrevious) {
                    activate(entry);
                    // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                    if (!parentScrollTop) return;
                    continue;
                }
                // if we are scrolling up, pick the smallest offsetTop
                if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
            }
        }
        _initializeTargetsAndObservables() {
            this._targetLinks = new Map();
            this._observableSections = new Map();
            const targetLinks = SelectorEngine.find(SELECTOR_TARGET_LINKS, this._config.target);
            for (const anchor of targetLinks){
                // ensure that the anchor has an id and is not disabled
                if (!anchor.hash || isDisabled(anchor)) continue;
                const observableSection = SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                // ensure that the observableSection exists & is visible
                if (isVisible(observableSection)) {
                    this._targetLinks.set(decodeURI(anchor.hash), anchor);
                    this._observableSections.set(anchor.hash, observableSection);
                }
            }
        }
        _process(target) {
            if (this._activeTarget === target) return;
            this._clearActiveClass(this._config.target);
            this._activeTarget = target;
            target.classList.add(CLASS_NAME_ACTIVE$1);
            this._activateParents(target);
            EventHandler.trigger(this._element, EVENT_ACTIVATE, {
                relatedTarget: target
            });
        }
        _activateParents(target) {
            // Activate dropdown parents
            if (target.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) {
                SelectorEngine.findOne(SELECTOR_DROPDOWN_TOGGLE$1, target.closest(SELECTOR_DROPDOWN)).classList.add(CLASS_NAME_ACTIVE$1);
                return;
            }
            for (const listGroup of SelectorEngine.parents(target, SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
            // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
            for (const item of SelectorEngine.prev(listGroup, SELECTOR_LINK_ITEMS))item.classList.add(CLASS_NAME_ACTIVE$1);
        }
        _clearActiveClass(parent) {
            parent.classList.remove(CLASS_NAME_ACTIVE$1);
            const activeNodes = SelectorEngine.find(`${SELECTOR_TARGET_LINKS}.${CLASS_NAME_ACTIVE$1}`, parent);
            for (const node of activeNodes)node.classList.remove(CLASS_NAME_ACTIVE$1);
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = ScrollSpy.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        constructor(element, config){
            super(element, config);
            // this._element is the observablesContainer and config.target the menu links wrapper
            this._targetLinks = new Map();
            this._observableSections = new Map();
            this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
            this._activeTarget = null;
            this._observer = null;
            this._previousScrollData = {
                visibleEntryTop: 0,
                parentScrollTop: 0
            };
            this.refresh(); // initialize
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(window, EVENT_LOAD_DATA_API$1, ()=>{
        for (const spy of SelectorEngine.find(SELECTOR_DATA_SPY))ScrollSpy.getOrCreateInstance(spy);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(ScrollSpy);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tab.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$1 = 'tab';
    const DATA_KEY$1 = 'bs.tab';
    const EVENT_KEY$1 = `.${DATA_KEY$1}`;
    const EVENT_HIDE$1 = `hide${EVENT_KEY$1}`;
    const EVENT_HIDDEN$1 = `hidden${EVENT_KEY$1}`;
    const EVENT_SHOW$1 = `show${EVENT_KEY$1}`;
    const EVENT_SHOWN$1 = `shown${EVENT_KEY$1}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY$1}`;
    const EVENT_KEYDOWN = `keydown${EVENT_KEY$1}`;
    const EVENT_LOAD_DATA_API = `load${EVENT_KEY$1}`;
    const ARROW_LEFT_KEY = 'ArrowLeft';
    const ARROW_RIGHT_KEY = 'ArrowRight';
    const ARROW_UP_KEY = 'ArrowUp';
    const ARROW_DOWN_KEY = 'ArrowDown';
    const HOME_KEY = 'Home';
    const END_KEY = 'End';
    const CLASS_NAME_ACTIVE = 'active';
    const CLASS_NAME_FADE$1 = 'fade';
    const CLASS_NAME_SHOW$1 = 'show';
    const CLASS_DROPDOWN = 'dropdown';
    const SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
    const SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
    const NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${SELECTOR_DROPDOWN_TOGGLE})`;
    const SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
    const SELECTOR_OUTER = '.nav-item, .list-group-item';
    const SELECTOR_INNER = `.nav-link${NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${NOT_SELECTOR_DROPDOWN_TOGGLE}`;
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
    const SELECTOR_INNER_ELEM = `${SELECTOR_INNER}, ${SELECTOR_DATA_TOGGLE}`;
    const SELECTOR_DATA_TOGGLE_ACTIVE = `.${CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
    /**
   * Class definition
   */ class Tab extends BaseComponent {
        // Getters
        static get NAME() {
            return NAME$1;
        }
        // Public
        show() {
            // Shows this elem and deactivate the active sibling if exists
            const innerElem = this._element;
            if (this._elemIsActive(innerElem)) return;
            // Search for active tab on same parent to deactivate it
            const active = this._getActiveElem();
            const hideEvent = active ? EventHandler.trigger(active, EVENT_HIDE$1, {
                relatedTarget: innerElem
            }) : null;
            const showEvent = EventHandler.trigger(innerElem, EVENT_SHOW$1, {
                relatedTarget: active
            });
            if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
            this._deactivate(active, innerElem);
            this._activate(innerElem, active);
        }
        // Private
        _activate(element, relatedElem) {
            if (!element) return;
            element.classList.add(CLASS_NAME_ACTIVE);
            this._activate(SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
            const complete = ()=>{
                if (element.getAttribute('role') !== 'tab') {
                    element.classList.add(CLASS_NAME_SHOW$1);
                    return;
                }
                element.removeAttribute('tabindex');
                element.setAttribute('aria-selected', true);
                this._toggleDropDown(element, true);
                EventHandler.trigger(element, EVENT_SHOWN$1, {
                    relatedTarget: relatedElem
                });
            };
            this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
        }
        _deactivate(element, relatedElem) {
            if (!element) return;
            element.classList.remove(CLASS_NAME_ACTIVE);
            element.blur();
            this._deactivate(SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
            const complete = ()=>{
                if (element.getAttribute('role') !== 'tab') {
                    element.classList.remove(CLASS_NAME_SHOW$1);
                    return;
                }
                element.setAttribute('aria-selected', false);
                element.setAttribute('tabindex', '-1');
                this._toggleDropDown(element, false);
                EventHandler.trigger(element, EVENT_HIDDEN$1, {
                    relatedTarget: relatedElem
                });
            };
            this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
        }
        _keydown(event) {
            if (![
                ARROW_LEFT_KEY,
                ARROW_RIGHT_KEY,
                ARROW_UP_KEY,
                ARROW_DOWN_KEY,
                HOME_KEY,
                END_KEY
            ].includes(event.key)) return;
            event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
            event.preventDefault();
            const children = this._getChildren().filter((element)=>!isDisabled(element));
            let nextActiveElement;
            if ([
                HOME_KEY,
                END_KEY
            ].includes(event.key)) nextActiveElement = children[event.key === HOME_KEY ? 0 : children.length - 1];
            else {
                const isNext = [
                    ARROW_RIGHT_KEY,
                    ARROW_DOWN_KEY
                ].includes(event.key);
                nextActiveElement = getNextActiveElement(children, event.target, isNext, true);
            }
            if (nextActiveElement) {
                nextActiveElement.focus({
                    preventScroll: true
                });
                Tab.getOrCreateInstance(nextActiveElement).show();
            }
        }
        _getChildren() {
            // collection of inner elements
            return SelectorEngine.find(SELECTOR_INNER_ELEM, this._parent);
        }
        _getActiveElem() {
            return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
        }
        _setInitialAttributes(parent, children) {
            this._setAttributeIfNotExists(parent, 'role', 'tablist');
            for (const child of children)this._setInitialAttributesOnChild(child);
        }
        _setInitialAttributesOnChild(child) {
            child = this._getInnerElement(child);
            const isActive = this._elemIsActive(child);
            const outerElem = this._getOuterElement(child);
            child.setAttribute('aria-selected', isActive);
            if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
            if (!isActive) child.setAttribute('tabindex', '-1');
            this._setAttributeIfNotExists(child, 'role', 'tab');
            // set attributes to the related panel too
            this._setInitialAttributesOnTargetPanel(child);
        }
        _setInitialAttributesOnTargetPanel(child) {
            const target = SelectorEngine.getElementFromSelector(child);
            if (!target) return;
            this._setAttributeIfNotExists(target, 'role', 'tabpanel');
            if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
        }
        _toggleDropDown(element, open) {
            const outerElem = this._getOuterElement(element);
            if (!outerElem.classList.contains(CLASS_DROPDOWN)) return;
            const toggle = (selector, className)=>{
                const element = SelectorEngine.findOne(selector, outerElem);
                if (element) element.classList.toggle(className, open);
            };
            toggle(SELECTOR_DROPDOWN_TOGGLE, CLASS_NAME_ACTIVE);
            toggle(SELECTOR_DROPDOWN_MENU, CLASS_NAME_SHOW$1);
            outerElem.setAttribute('aria-expanded', open);
        }
        _setAttributeIfNotExists(element, attribute, value) {
            if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
        }
        _elemIsActive(elem) {
            return elem.classList.contains(CLASS_NAME_ACTIVE);
        }
        // Try to get the inner element (usually the .nav-link)
        _getInnerElement(elem) {
            return elem.matches(SELECTOR_INNER_ELEM) ? elem : SelectorEngine.findOne(SELECTOR_INNER_ELEM, elem);
        }
        // Try to get the outer element (usually the .nav-item)
        _getOuterElement(elem) {
            return elem.closest(SELECTOR_OUTER) || elem;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Tab.getOrCreateInstance(this);
                if (typeof config !== 'string') return;
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        constructor(element){
            super(element);
            this._parent = this._element.closest(SELECTOR_TAB_PANEL);
            if (!this._parent) return;
            // Set up initial aria attributes
            this._setInitialAttributes(this._parent, this._getChildren());
            EventHandler.on(this._element, EVENT_KEYDOWN, (event)=>this._keydown(event));
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        Tab.getOrCreateInstance(this).show();
    });
    /**
   * Initialize on focus
   */ EventHandler.on(window, EVENT_LOAD_DATA_API, ()=>{
        for (const element of SelectorEngine.find(SELECTOR_DATA_TOGGLE_ACTIVE))Tab.getOrCreateInstance(element);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Tab);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap toast.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = 'toast';
    const DATA_KEY = 'bs.toast';
    const EVENT_KEY = `.${DATA_KEY}`;
    const EVENT_MOUSEOVER = `mouseover${EVENT_KEY}`;
    const EVENT_MOUSEOUT = `mouseout${EVENT_KEY}`;
    const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;
    const EVENT_FOCUSOUT = `focusout${EVENT_KEY}`;
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const CLASS_NAME_FADE = 'fade';
    const CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
    const CLASS_NAME_SHOW = 'show';
    const CLASS_NAME_SHOWING = 'showing';
    const DefaultType = {
        animation: 'boolean',
        autohide: 'boolean',
        delay: 'number'
    };
    const Default = {
        animation: true,
        autohide: true,
        delay: 5000
    };
    /**
   * Class definition
   */ class Toast extends BaseComponent {
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        show() {
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW);
            if (showEvent.defaultPrevented) return;
            this._clearTimeout();
            if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
            const complete = ()=>{
                this._element.classList.remove(CLASS_NAME_SHOWING);
                EventHandler.trigger(this._element, EVENT_SHOWN);
                this._maybeScheduleHide();
            };
            this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOW, CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        hide() {
            if (!this.isShown()) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE);
            if (hideEvent.defaultPrevented) return;
            const complete = ()=>{
                this._element.classList.add(CLASS_NAME_HIDE); // @deprecated
                this._element.classList.remove(CLASS_NAME_SHOWING, CLASS_NAME_SHOW);
                EventHandler.trigger(this._element, EVENT_HIDDEN);
            };
            this._element.classList.add(CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        dispose() {
            this._clearTimeout();
            if (this.isShown()) this._element.classList.remove(CLASS_NAME_SHOW);
            super.dispose();
        }
        isShown() {
            return this._element.classList.contains(CLASS_NAME_SHOW);
        }
        // Private
        _maybeScheduleHide() {
            if (!this._config.autohide) return;
            if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
            this._timeout = setTimeout(()=>{
                this.hide();
            }, this._config.delay);
        }
        _onInteraction(event, isInteracting) {
            switch(event.type){
                case 'mouseover':
                case 'mouseout':
                    this._hasMouseInteraction = isInteracting;
                    break;
                case 'focusin':
                case 'focusout':
                    this._hasKeyboardInteraction = isInteracting;
                    break;
            }
            if (isInteracting) {
                this._clearTimeout();
                return;
            }
            const nextElement = event.relatedTarget;
            if (this._element === nextElement || this._element.contains(nextElement)) return;
            this._maybeScheduleHide();
        }
        _setListeners() {
            EventHandler.on(this._element, EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
            EventHandler.on(this._element, EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
            EventHandler.on(this._element, EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
            EventHandler.on(this._element, EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
        }
        _clearTimeout() {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Toast.getOrCreateInstance(this, config);
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                    data[config](this);
                }
            });
        }
        constructor(element, config){
            super(element, config);
            this._timeout = null;
            this._hasMouseInteraction = false;
            this._hasKeyboardInteraction = false;
            this._setListeners();
        }
    }
    /**
   * Data API implementation
   */ enableDismissTrigger(Toast);
    /**
   * jQuery
   */ defineJQueryPlugin(Toast);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap index.umd.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const index_umd = {
        Alert: Alert,
        Button: Button,
        Carousel: Carousel,
        Collapse: Collapse,
        Dropdown: Dropdown,
        Modal: Modal,
        Offcanvas: Offcanvas,
        Popover: Popover,
        ScrollSpy: ScrollSpy,
        Tab: Tab,
        Toast: Toast,
        Tooltip: Tooltip
    };
    return index_umd;
});


function $609686fdcc579278$var$Button({ onClick: onClick, tooltipPlacement: tooltipPlacement, tooltip: tooltip, className: className, children: children }) {
    const element = (0, $h96tf.useRef)(null);
    const bootstrapTooltip = (0, $h96tf.useRef)(null);
    (0, $h96tf.useEffect)(()=>{
        if (element.current !== null && Boolean(tooltip)) bootstrapTooltip.current = new (0, (/*@__PURE__*/$parcel$interopDefault($4364ccfa925478a4$exports))).Tooltip(element.current, {
            delay: {
                show: 1500,
                hide: 200
            }
        });
    }, [
        tooltip,
        tooltipPlacement,
        element
    ]);
    const handleClick = (0, $h96tf.useCallback)(()=>{
        if (bootstrapTooltip.current === null) return;
        bootstrapTooltip.current.hide();
        onClick();
    }, [
        onClick,
        bootstrapTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("button", {
        ref: element,
        className: className || 'btn btn-primary m-1',
        type: "button",
        onClick: handleClick,
        "data-bs-toggle": "tooltip",
        "data-bs-placement": tooltipPlacement || "top",
        "data-bs-title": tooltip
    }, children);
}
var $609686fdcc579278$export$2e2bcd8739ae039 = $609686fdcc579278$var$Button;


function $c14df21623acde90$export$1d8ea386a37dfe1c({ children: children }) {
    const resetDefaultSettings = (0, $187864d4e8fb2ec4$export$e1caeacb0a7b57b8)();
    const handleReset = (0, $h96tf.useCallback)(()=>{
        document.activeElement.blur();
        resetDefaultSettings();
    }, [
        resetDefaultSettings
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "row justify-content-start border-top mt-3 pt-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $47bc5cb6c16c6855$export$6d08773d2e66f8f2), {
        name: "Reset",
        description: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "flex-grow-1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $609686fdcc579278$export$2e2bcd8739ae039), {
        className: "btn btn-outline-secondary",
        onClick: handleReset
    }, "Reset Default Settings"))));
}


function $92c553780ac2133e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("button", {
        className: "btn",
        type: "button",
        "data-bs-toggle": "offcanvas",
        "data-bs-target": "#settingsMenu",
        "aria-controls": "settingsMenu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $33e0352a83cf13d2$export$e5cc6136f1e14be3), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "w-100 offcanvas offcanvas-start overflow-y-scroll p-4",
        tabIndex: "-1",
        id: "settingsMenu",
        "aria-labelledby": "settingsMenu",
        "data-bs-theme": "dark"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "offcanvas-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("button", {
        type: "button",
        className: "btn-close",
        "data-bs-dismiss": "offcanvas",
        "aria-label": "Close"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $587e175e58cf5bae$export$218c29f66b0c4e92), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $13d455722ff69500$export$5fedf1aa9280d73d), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $73179dd99861abed$export$d1ec5db8c03397fc), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $ecc2b29d9004ca1f$export$dbc06cd8bcd66e5d), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $16707294d1b36434$export$1645b4b1ea9d52ad), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $c14df21623acde90$export$1d8ea386a37dfe1c), null))));
}



var $h96tf = parcelRequire("h96tf");


function $92d8b8ee6dba49b7$export$2e2bcd8739ae039() {
    const [showDetailsBox] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('showDetailsBox');
    const detailsBox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $283b71f4d1372a4c$export$2e2bcd8739ae039), {
        className: "h3 border-bottom m-2 ms-0",
        style: {
            minWidth: '25vw'
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "d-flex justify-content-start align-items-stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "d-none d-sm-block",
        style: {
            flexGrow: 0.25
        }
    }), showDetailsBox && detailsBox, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "d-none d-sm-block",
        style: {
            flexGrow: 2
        }
    }));
}



var $h96tf = parcelRequire("h96tf");






var $h96tf = parcelRequire("h96tf");


function $08ae6ecd9495f22b$export$2e2bcd8739ae039({ take: take, onInput: onInput }) {
    const [showEmpty, setShowEmpty] = (0, $h96tf.useState)(false);
    const handleInput = (0, $h96tf.useCallback)((input)=>{
        if (input.trim().length === 0) {
            setShowEmpty(true);
            return;
        }
        if (!(0, $d11c9e7ef030e3fc$export$be48fd776273e509)(input)) return;
        setShowEmpty(false);
        onInput((0, $d11c9e7ef030e3fc$export$fc6693e6d6c19a86)(input));
    }, [
        onInput,
        setShowEmpty
    ]);
    const handleOnBlur = (0, $h96tf.useCallback)(()=>{
        setShowEmpty(false);
    }, [
        setShowEmpty
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $565ef684d07fe24b$export$2e2bcd8739ae039), {
        className: "display-1",
        onInput: handleInput,
        display: showEmpty ? '' : take,
        onBlur: handleOnBlur
    });
}



var $h96tf = parcelRequire("h96tf");

var $a15bda0397a1ad9a$export$34e0f9847d4c02dd;
var $a15bda0397a1ad9a$export$3e523c77c1f23f8c;
$a15bda0397a1ad9a$export$34e0f9847d4c02dd = `ZgBs8q_container`;
$a15bda0397a1ad9a$export$3e523c77c1f23f8c = `ZgBs8q_separator`;


function $b3c4135132c7c31f$export$2e2bcd8739ae039() {
    const [counterMode] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('counterMode');
    const [fileWatcherMode] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'mode');
    const [offset] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'offset');
    const [showOffset] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'showOffset');
    const [showModeIndicator] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'showModeIndicator');
    if (counterMode === 'manual') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).Fragment, null);
    const itemClassName = 'text-info fw-bold text-center mx-1';
    const fileWatcherModeName = fileWatcherMode.charAt(0).toUpperCase() + fileWatcherMode.slice(1);
    const modeIndicator = showModeIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("p", {
        className: itemClassName
    }, "Pro Tools ", fileWatcherModeName, " Watcher");
    const offsetIndicator = showOffset && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("p", {
        className: itemClassName
    }, "Offset: ", offset);
    const separator = modeIndicator && offsetIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: $a15bda0397a1ad9a$export$3e523c77c1f23f8c
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: $a15bda0397a1ad9a$export$34e0f9847d4c02dd
    }, modeIndicator, separator, offsetIndicator);
}


function $bf0e9f1bfc1f9c26$var$Counter() {
    const [take, setRawTake] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('currentTake');
    const [mode] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('counterMode');
    const [offset, setOffset] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'offset');
    const [offsetShortcuts] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('ptFileWatcherMode', 'offsetShortcuts');
    const offsetShortcutsEnabled = (0, $h96tf.useCallback)(()=>{
        return mode === "ptFileWatcher" && offsetShortcuts;
    }, [
        offsetShortcuts,
        mode
    ]);
    const setValue = (0, $h96tf.useCallback)((newCount)=>{
        if (offsetShortcutsEnabled()) {
            let value = Number(newCount);
            if (Number.isInteger(value)) setOffset(value);
            return;
        }
        const validatedNewCount = (0, $d11c9e7ef030e3fc$export$fc6693e6d6c19a86)(newCount);
        setRawTake(validatedNewCount);
    }, [
        setRawTake,
        setOffset,
        offsetShortcutsEnabled
    ]);
    if (window.counter !== undefined) window.counter.handleSetCount(setRawTake);
    const [takeTextPrefix] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('takeDisplaySettings', 'takeTextPrefix');
    const [showTakePrefix] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('takeDisplaySettings', 'showTakePrefix');
    const [showTakeButtons] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)('takeDisplaySettings', 'showTakeButtons');
    const incrementCount = (0, $h96tf.useCallback)(()=>{
        let value = offsetShortcutsEnabled() ? offset : take;
        setValue(value + 1);
    }, [
        take,
        setValue,
        offset,
        offsetShortcutsEnabled
    ]);
    const decrementCount = (0, $h96tf.useCallback)(()=>{
        let value = offsetShortcutsEnabled() ? offset : take;
        setValue(value - 1);
    }, [
        take,
        setValue,
        offset,
        offsetShortcutsEnabled
    ]);
    const resetTake = (0, $h96tf.useCallback)(()=>{
        let value = offsetShortcutsEnabled() ? (0, $3c786cb677838e50$export$62680b65e63e14ec).ptFileWatcherMode.offset : 1;
        setValue(value);
    }, [
        setValue,
        offsetShortcutsEnabled
    ]);
    (0, $h96tf.useEffect)(()=>{
        document.title = "Take " + take;
    }, [
        take
    ]);
    const [shortcuts] = (0, $187864d4e8fb2ec4$export$12b0e20ae7d96a25)("keyboardShortcuts");
    (0, $d14c2a87cc1b733c$export$b0ebbe7904d8d94a)(incrementCount, shortcuts.incrementCount, "counter.handleIncrement");
    (0, $d14c2a87cc1b733c$export$b0ebbe7904d8d94a)(decrementCount, shortcuts.decrementCount, "counter.handleDecrement");
    (0, $d14c2a87cc1b733c$export$b0ebbe7904d8d94a)(resetTake, shortcuts.resetCount, "counter.handleReset");
    const buttons = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $609686fdcc579278$export$2e2bcd8739ae039), {
        onClick: decrementCount,
        tooltip: shortcuts.decrementCount,
        tooltipPlacement: "bottom"
    }, "-"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $609686fdcc579278$export$2e2bcd8739ae039), {
        onClick: resetTake,
        tooltip: shortcuts.resetCount,
        tooltipPlacement: "bottom"
    }, "reset"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $609686fdcc579278$export$2e2bcd8739ae039), {
        onClick: incrementCount,
        tooltip: shortcuts.incrementCount,
        tooltipPlacement: "bottom"
    }, "+"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "d-flex flex-column align-items-center justify-content-center",
        style: {
            flexGrow: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        style: {
            flexGrow: mode === "manual" ? 0.75 : 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "d-flex"
    }, showTakePrefix ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("h1", {
        className: "display-1 me-4 me-md-5"
    }, takeTextPrefix) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $08ae6ecd9495f22b$export$2e2bcd8739ae039), {
        take: take,
        onInput: setValue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "",
        style: {
            flexGrow: 0
        }
    }, showTakeButtons && buttons), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        style: {
            flexGrow: 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $b3c4135132c7c31f$export$2e2bcd8739ae039), null));
}
var $bf0e9f1bfc1f9c26$export$2e2bcd8739ae039 = $bf0e9f1bfc1f9c26$var$Counter;


function $78b6de80788e679e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $187864d4e8fb2ec4$export$e134aa690da9cc14), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "d-flex flex-column text-white",
        style: {
            minHeight: "100vh"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement("div", {
        className: "d-flex justify-content-between ms-4 me-4 mt-2 mb-0 m-sm-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $92d8b8ee6dba49b7$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $92c553780ac2133e$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).createElement((0, $bf0e9f1bfc1f9c26$export$2e2bcd8739ae039), null)));
}


function $4f7964ddb4ab5d0b$var$DownloadBanner() {
    const ref = (0, $h96tf.useRef)(null);
    const modal = (0, $h96tf.useRef)(null);
    (0, $h96tf.useEffect)(()=>{
        if (!ref.current) return;
        if (!modal.current) {
            modal.current = new (0, $8c9d2162215f88e6$export$2b77a92f1a5ad772)(ref.current);
            modal.current.show();
        }
    }, [
        ref,
        modal
    ]);
    return /*#__PURE__*/ (0, $039a8d5005718833$exports.jsx)("div", {
        ref: ref,
        className: "modal fade",
        id: "downloadModal",
        tabIndex: "-1",
        "aria-labelledby": "downloadModalLabel",
        "aria-hidden": "true",
        "data-bs-theme": "light",
        children: /*#__PURE__*/ (0, $039a8d5005718833$exports.jsx)("div", {
            className: "modal-dialog",
            children: /*#__PURE__*/ (0, $039a8d5005718833$exports.jsxs)("div", {
                className: "modal-content bg-white",
                children: [
                    /*#__PURE__*/ (0, $039a8d5005718833$exports.jsxs)("div", {
                        className: "modal-header",
                        children: [
                            /*#__PURE__*/ (0, $039a8d5005718833$exports.jsx)("h1", {
                                className: "modal-title fs-5",
                                id: "downloadModalLabel",
                                children: "Download the desktop version"
                            }),
                            /*#__PURE__*/ (0, $039a8d5005718833$exports.jsx)("button", {
                                type: "button",
                                className: "btn-close",
                                "data-bs-dismiss": "modal",
                                "data-bs-theme": "light",
                                "aria-label": "Close"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $039a8d5005718833$exports.jsxs)("div", {
                        className: "modal-body",
                        children: [
                            "Download the MacOS desktop version of Take Counter to take advantage of global keyboard shorcuts and automatic take counting.",
                            /*#__PURE__*/ (0, $039a8d5005718833$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $039a8d5005718833$exports.jsxs)("div", {
                                className: "mx-auto text-center",
                                children: [
                                    "Email:\xa0",
                                    /*#__PURE__*/ (0, $039a8d5005718833$exports.jsx)("a", {
                                        href: "mailto:kyle@widesoftware.co",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "kyle@widesoftware.co"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
const $4f7964ddb4ab5d0b$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($cfd79d02f9a77f3e$exports))).createRoot(document.getElementById('root'));
$4f7964ddb4ab5d0b$var$root.render(/*#__PURE__*/ (0, $039a8d5005718833$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($h96tf))).StrictMode, {
    children: [
        /*#__PURE__*/ (0, $039a8d5005718833$exports.jsx)($4f7964ddb4ab5d0b$var$DownloadBanner, {}),
        /*#__PURE__*/ (0, $039a8d5005718833$exports.jsx)((0, $78b6de80788e679e$export$2e2bcd8739ae039), {})
    ]
}));


//# sourceMappingURL=web.7529dfb1.js.map
